// AUTO-EXTRACTED from SourceSecurity.com via Claude Sonnet 4.6 + Playwright MCP
// Generated: 2026-05-16
// Specs parsed from public product spec sheets; no values invented.
// All entries marked verified: false — reviewer must spot-check before promotion.

import type { BaseEntry, NVRSpec } from '../equipmentCatalogEntry';

type NvrEntry = BaseEntry & { category: 'nvr-recorder'; specs: NVRSpec };

// In parts of 400: one array of 2,544 object literals makes a larger union
// than the compiler can represent. Every entry is still checked against NvrEntry.

const PART_1: NvrEntry[] = [
  {
    id: "ss-hikvision-ds-7216hqhi-f2-n",
    manufacturer: "Hikvision",
    model: "DS-7216HQHI-F2/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HQHI-F2/N 16-channel turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hqhi-f2-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7104hwi-sh",
    manufacturer: "Hikvision",
    model: "DS-7104HWI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HWI-SH 4 channel economic WD1 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104hwi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hvi-sh",
    manufacturer: "Hikvision",
    model: "DS-7216HVI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HVI-SH 16-channel standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hvi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7108hwi-sh",
    manufacturer: "Hikvision",
    model: "DS-7108HWI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108HWI-SH 960H Mini DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108hwi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hwi-sh",
    manufacturer: "Hikvision",
    model: "DS-7216HWI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HWI-SH 16-channel standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hwi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hvi-sh",
    manufacturer: "Hikvision",
    model: "DS-7208HVI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HVI-SH 8-channel standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hvi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hvi-sv-a",
    manufacturer: "Hikvision",
    model: "DS-7204HVI-SV/A",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HVI-SV/A 4 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hvi-sv-a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7104hqhi-f1-n",
    manufacturer: "Hikvision",
    model: "DS-7104HQHI-F1/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HQHI-F1/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104hqhi-f1-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hvi-sv",
    manufacturer: "Hikvision",
    model: "DS-7208HVI-SV",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HVI-SV 960H DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hvi-sv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7108hqhi-f1-n",
    manufacturer: "Hikvision",
    model: "DS-7108HQHI-F1/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108HQHI-F1/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108hqhi-f1-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hwi-sh",
    manufacturer: "Hikvision",
    model: "DS-7208HWI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HWI-SH 8 channel economic WD1 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hwi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7116hqhi-f1-n",
    manufacturer: "Hikvision",
    model: "DS-7116HQHI-F1/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7116HQHI-F1/N 16-channel turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7116hqhi-f1-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hvi-sh",
    manufacturer: "Hikvision",
    model: "DS-7204HVI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HVI-SH 4 channel economic DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hvi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hqhi-f1-n",
    manufacturer: "Hikvision",
    model: "DS-7216HQHI-F1/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HQHI-F1/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hqhi-f1-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7104hwi-sl",
    manufacturer: "Hikvision",
    model: "DS-7104HWI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HWI-SL 4 channel economic WD1 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104hwi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7104hghi-f1",
    manufacturer: "Hikvision",
    model: "DS-7104HGHI-F1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HGHI-F1 Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104hghi-f1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7332hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-7332HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7332HGHI-SH 32-channel hybrid digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7332hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hqhi-f1-n",
    manufacturer: "Hikvision",
    model: "DS-7204HQHI-F1/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HQHI-F1/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hqhi-f1-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-7208HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HQHI-SH 8-channel turbo HD digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7116hwi-sh",
    manufacturer: "Hikvision",
    model: "DS-7116HWI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7116HWI-SH 16-channel 960H mini digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7116hwi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7108hwi-sl",
    manufacturer: "Hikvision",
    model: "DS-7108HWI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108HWI-SL 8-channel 960H mini DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108hwi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hvi-sv",
    manufacturer: "Hikvision",
    model: "DS-7216HVI-SV",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HVI-SV 16-channel 960H digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hvi-sv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7316hqhi-f4-n",
    manufacturer: "Hikvision",
    model: "DS-7316HQHI-F4/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7316HQHI-F4/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7316hqhi-f4-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7108hghi-f1",
    manufacturer: "Hikvision",
    model: "DS-7108HGHI-F1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108HGHI-F1 Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108hghi-f1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216huhi-f2-n",
    manufacturer: "Hikvision",
    model: "DS-7216HUHI-F2/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HUHI-F2/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216huhi-f2-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hfi-sh",
    manufacturer: "Hikvision",
    model: "DS-7216HFI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HFI-SH 16-channel standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hfi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7316hfi-sh",
    manufacturer: "Hikvision",
    model: "DS-7316HFI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7316HFI-SH 16 channel Standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7316hfi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-1004hmi",
    manufacturer: "Hikvision",
    model: "DS-1004HMI",
    category: "nvr-recorder",
    tagline: "Hikvision DS-1004HMI backup device",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-1004hmi-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7204hfi-sh",
    manufacturer: "Hikvision",
    model: "DS-7204HFI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HFI-SH 4 channel standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hfi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hwi-sh",
    manufacturer: "Hikvision",
    model: "DS-7204HWI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HWI-SH standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hwi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208huhi-f1-n",
    manufacturer: "Hikvision",
    model: "DS-7208HUHI-F1/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HUHI-F1/N 8-channel turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208huhi-f1-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hghi-f1",
    manufacturer: "Hikvision",
    model: "DS-7208HGHI-F1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HGHI-F1 Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hghi-f1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hghi-e1",
    manufacturer: "Hikvision",
    model: "DS-7208HGHI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HGHI-E1 Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hghi-e1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208huhi-f2-n",
    manufacturer: "Hikvision",
    model: "DS-7208HUHI-F2/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HUHI-F2/N 8-channel turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208huhi-f2-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-7216HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HQHI-SH turbo HD DVR with LAN network interface",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7108hqhi-m1-s",
    manufacturer: "Hikvision",
    model: "iDS-7108HQHI-M1/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7108HQHI-M1/S 8 channel 1080p mini 1U H.265 AcuSense digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7108hqhi-m1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7208hfi-sh",
    manufacturer: "Hikvision",
    model: "DS-7208HFI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HFI-SH 8-channel standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hfi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr5104h-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5104H-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104H-4KL-I3/T 4CH Penta-brid 4K Value/5MP Mini 1U 1HDD WizSense Digital Video R",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104h-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5116hs-5m-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5116HS-5M-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116HS-5M-I3/T 16CH Penta-brid 5MP Compact 1U 1HDD WizSense Digital Video Record",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116hs-5m-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5208an-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5208AN-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5208AN-4KL-I3/T 8CH Penta-brid 4K Value/5MP 1U 2HDDs WizSense Digital Video Reco",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5208an-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5116he-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5116HE-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116HE-4KL-I3/T 16CH Penta-brid 4K Value/5MP Mini 1U 1HDD WizSense Digital Video",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116he-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5832s-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5832S-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5832S-4KL-I3 32CH Penta-brid 4K Value/5MP 2U 8HDDs WizSense Digital Video Record",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5832s-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5108hs-5m-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5108HS-5M-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HS-5M-I3/T 8CH Penta-brid 5MP Compact 1U 1HDD WizSense Digital Video Recorde",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108hs-5m-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5204a-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5204A-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5204A-4KL-I3/T 4CH Penta-brid 4K Value/5MP 1U 2HDDs WizSense Digital Video Recor",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5204a-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5416l-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5416L-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5416L-4KL-I3 16CH Penta-brid 4K Value/5MP 1.5U 4HDDs WizSense Digital Video Reco",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5416l-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5432l-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5432L-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5432L-4KL-I3 32CH Penta-brid 4K Value/5MP 1.5U 4HDDs WizSense Digital Video Reco",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5432l-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5116h-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5116H-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116H-4KL-I3/T 16CH Penta-brid 4K Value/5MP Mini 1U 1HDD WizSense Digital Video ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116h-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7616hi-st",
    manufacturer: "Hikvision",
    model: "DS-7616HI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616HI-ST 16-channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616hi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204huhi-f1-s",
    manufacturer: "Hikvision",
    model: "DS-7204HUHI-F1/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HUHI-F1/S Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204huhi-f1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8016hfi-st",
    manufacturer: "Hikvision",
    model: "DS-8016HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8016HFI-ST 16-channel hybrid digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8016hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216huhi-f2-s",
    manufacturer: "Hikvision",
    model: "DS-7216HUHI-F2/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HUHI-F2/S 16-channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216huhi-f2-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7116hvi-sl",
    manufacturer: "Hikvision",
    model: "DS-7116HVI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7116HVI-SL 16-channel standalone mini digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7116hvi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7324hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-7324HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7324HGHI-SH DVR connectable to network cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7324hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7232hqhi-m2-s",
    manufacturer: "Hikvision",
    model: "iDS-7232HQHI-M2/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7216HQHI-M2/S 32 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7232hqhi-m2-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7616huhi-f2-n",
    manufacturer: "Hikvision",
    model: "DS-7616HUHI-F2/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616HUHI-F2/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616huhi-f2-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7316hwi-sh",
    manufacturer: "Hikvision",
    model: "DS-7316HWI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7316HWI-SH 16 channel 960H Standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7316hwi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hwi-e1-a",
    manufacturer: "Hikvision",
    model: "DS-7204HWI-E1/A",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HWI-E1/A 4 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hwi-e1-a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hghi-e1",
    manufacturer: "Hikvision",
    model: "DS-7216HGHI- E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HGHI- E1 turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hghi-e1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7608hi-st",
    manufacturer: "Hikvision",
    model: "DS-7608HI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608HI-ST embedded hybrid DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608hi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7116hghi-f1",
    manufacturer: "Hikvision",
    model: "DS-7116HGHI-F1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7116HGHI-F1 turbo HD DVR with H.264 & dual-stream video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7116hghi-f1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7208hqhi-m1-s",
    manufacturer: "Hikvision",
    model: "iDS-7208HQHI-M1/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HQHI-M1/S 8 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7208hqhi-m1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7216hwi-e1",
    manufacturer: "Hikvision",
    model: "DS-7216HWI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HWI-E1 960H Standalone VCA supported DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hwi-e1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7116hwi-sl",
    manufacturer: "Hikvision",
    model: "DS-7116HWI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7116HWI-SL 16-channel H.264 mini digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7116hwi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7108hghi-e1",
    manufacturer: "Hikvision",
    model: "DS-7108HGHI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108HGHI-E1 Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108hghi-e1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7108hqhi-k1",
    manufacturer: "Hikvision",
    model: "DS-7108HQHI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108HQHI-K1 8 channel 1080p mini 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108hqhi-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7208hwi-sl",
    manufacturer: "Hikvision",
    model: "DS-7208HWI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HWI-SL 8 channel economic WD1 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hwi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7104hvi-sh",
    manufacturer: "Hikvision",
    model: "DS-7104HVI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HVI-SH standalone mini DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104hvi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7316huhi-f4-n",
    manufacturer: "Hikvision",
    model: "DS-7316HUHI-F4/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7316HUHI-F4/N TURBO HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7316huhi-f4-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hqhi-f2-n",
    manufacturer: "Hikvision",
    model: "DS-7208HQHI-F2/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HQHI-F2/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hqhi-f2-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hghi-f1",
    manufacturer: "Hikvision",
    model: "DS-7204HGHI-F1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HGHI-F1 Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hghi-f1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7116hvi-sh",
    manufacturer: "Hikvision",
    model: "DS-7116HVI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7116HVI-SH 16-channel standalone mini digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7116hvi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7232hghi-m2",
    manufacturer: "Hikvision",
    model: "DS-7232HGHI-M2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7232HGHI-M2 32 channel 720p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7232hghi-m2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7208hfhi-st",
    manufacturer: "Hikvision",
    model: "DS-7208HFHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HFHI-ST 8-channel HD-SDI DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hfhi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hghi-k1",
    manufacturer: "Hikvision",
    model: "DS-7208HGHI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HGHI-K1 8 channel 1080p lite 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hghi-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7204huhi-f2-n",
    manufacturer: "Hikvision",
    model: "DS-7204HUHI-F2/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HUHI-F2/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204huhi-f2-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hwi-e2",
    manufacturer: "Hikvision",
    model: "DS-7216HWI-E2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HWI-E2 16-channel standalone VCA supported digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hwi-e2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7104hghi-e1",
    manufacturer: "Hikvision",
    model: "DS-7104HGHI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HGHI-E1 turbo HD DVR with LAN network interface",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104hghi-e1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7104hghi-k1",
    manufacturer: "Hikvision",
    model: "DS-7104HGHI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HGHI-K1 4 channel 1080p lite mini 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104hghi-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7332hwi-sh",
    manufacturer: "Hikvision",
    model: "DS-7332HWI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7332HWI-SH 32-channel standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7332hwi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7216hqhi-m1-s",
    manufacturer: "Hikvision",
    model: "iDS-7216HQHI-M1/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7216HQHI-M1/S 16 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7216hqhi-m1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7216huhi-m2-s",
    manufacturer: "Hikvision",
    model: "iDS-7216HUHI-M2/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7216HUHI-M2/S 16 channel 5MP 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7216huhi-m2-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7204hghi-sh-a",
    manufacturer: "Hikvision",
    model: "DS-7204HGHI-SH/A",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HGHI-SH/A 4 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hghi-sh-a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7316hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-7316HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7316HGHI-SH 16-channel turbo HD digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7316hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hqhi-k1",
    manufacturer: "Hikvision",
    model: "DS-7204HQHI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HQHI-K1 4 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hqhi-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9016hfi-st",
    manufacturer: "Hikvision",
    model: "DS-9016HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9016HFI-ST 16-channel hybrid digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9016hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7608huhi-f2-n",
    manufacturer: "Hikvision",
    model: "DS-7608HUHI-F2/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608HUHI-F2/N TURBO HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608huhi-f2-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"],"onvif":true},
  },
  {
    id: "ss-hikvision-ds-7108hghi-k1",
    manufacturer: "Hikvision",
    model: "DS-7108HGHI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108HGHI-K1 8 channel 1080p lite mini 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108hghi-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7204hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-7204HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HQHI-SH turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7316hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-7316HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7316HQHI-SH 16 channel H.264 hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7316hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-7216HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HGHI-SH 16-channel H.264 hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7224hwi-sh",
    manufacturer: "Hikvision",
    model: "DS-7224HWI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7224HWI-SH 24-channel standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7224hwi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hwi-sl",
    manufacturer: "Hikvision",
    model: "DS-7216HWI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HWI-SL economic WD1 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hwi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hghi-k1",
    manufacturer: "Hikvision",
    model: "DS-7216HGHI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HGHI-K1 16 channel 1080p lite 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hghi-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7232hi-sh",
    manufacturer: "Hikvision",
    model: "DS-7232HI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7232HI-SH 32-channel H.264 standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7232hi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hi-sl",
    manufacturer: "Hikvision",
    model: "DS-7204HI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HI-SL 4 channel Standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7324hwi-sh",
    manufacturer: "Hikvision",
    model: "DS-7324HWI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7324HWI-SH standalone DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7324hwi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8132hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-8132HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8132HGHI-SH DVR connectable to HD-TVI and analogue cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8132hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-7208HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HGHI-SH 8- channel H.264 hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7104hqhi-m1-s",
    manufacturer: "Hikvision",
    model: "iDS-7104HQHI-M1/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7104HQHI-M1/S 4 channel 1080p mini 1U H.265 AcuSense digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7104hqhi-m1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7108hvi-sh",
    manufacturer: "Hikvision",
    model: "DS-7108HVI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108HVI-SH 8 channel standalone mini DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108hvi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hghi-m1",
    manufacturer: "Hikvision",
    model: "DS-7204HGHI-M1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HGHI-M1 4 channel 720p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hghi-m1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7208hghi-m1",
    manufacturer: "Hikvision",
    model: "DS-7208HGHI-M1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HGHI-M1 8 channel 720p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hghi-m1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7208hwi-e1",
    manufacturer: "Hikvision",
    model: "DS-7208HWI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HWI-E1 8 channel 960H Standalone VCA supported DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hwi-e1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7204hqhi-m1-xt",
    manufacturer: "Hikvision",
    model: "iDS-7204HQHI-M1/XT",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7204HQHI-M1/XT 4 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7204hqhi-m1-xt-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7208hqhi-m1-fa",
    manufacturer: "Hikvision",
    model: "iDS-7208HQHI-M1/FA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HQHI-M1/FA 8 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7208hqhi-m1-fa-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7116hqhi-m1-s",
    manufacturer: "Hikvision",
    model: "iDS-7116HQHI-M1/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7116HQHI-M1/S 16 channel 1080p mini 1U H.265 AcuSense digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7116hqhi-m1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7108huhi-m1-s",
    manufacturer: "Hikvision",
    model: "iDS-7108HUHI-M1/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7108HUHI-M1/S 8 channel 5MP mini 1U H.265 AcuSense digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7108huhi-m1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7316hfhi-st",
    manufacturer: "Hikvision",
    model: "DS-7316HFHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7316HFHI-ST 16-channel HD-SDI digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7316hfhi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hghi-f2",
    manufacturer: "Hikvision",
    model: "DS-7216HGHI- F2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HGHI- F2 turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hghi-f2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7116hghi-k1",
    manufacturer: "Hikvision",
    model: "DS-7116HGHI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7116HGHI-K1 16 channel 1080p lite mini 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7116hghi-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-8116hfi-st",
    manufacturer: "Hikvision",
    model: "DS-8116HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HFI-ST 16-channel standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204huhi-f1-n",
    manufacturer: "Hikvision",
    model: "DS-7204HUHI-F1/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HUHI-F1/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204huhi-f1-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7332hi-sh",
    manufacturer: "Hikvision",
    model: "DS-7332HI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7332HI-SH 32-channel standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7332hi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hghi-e2",
    manufacturer: "Hikvision",
    model: "DS-7216HGHI- E2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HGHI- E2 turbo HD DVR with HDMI interface",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hghi-e2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-e04hqhi-b",
    manufacturer: "Hikvision",
    model: "DS-E04HQHI-B",
    category: "nvr-recorder",
    tagline: "Hikvision eDVRs maximize storage efficiency and predictability",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-e04hqhi-b-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-hikvision-ds-7308hqhi-f4-n",
    manufacturer: "Hikvision",
    model: "DS-7308HQHI-F4/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7308HQHI-F4/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7308hqhi-f4-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8116hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-8116HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HGHI-SH turbo HD DVR with USB port",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8116hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-8116HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HQHI-SH 16-channel hybrid digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8008hfi-st",
    manufacturer: "Hikvision",
    model: "DS-8008HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8008HFI-ST embedded hybrid DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8008hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7208huhi-m1-fa",
    manufacturer: "Hikvision",
    model: "iDS-7208HUHI-M1/FA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HUHI-M1/FA 8 channel 5MP 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7208huhi-m1-fa-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7204hqhi-sh-a",
    manufacturer: "Hikvision",
    model: "DS-7204HQHI-SH/A",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HQHI-SH/A 4 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hqhi-sh-a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7604hi-st-a",
    manufacturer: "Hikvision",
    model: "DS-7604HI-ST/A",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604HI-ST/A 4 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604hi-st-a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-mp7504",
    manufacturer: "Hikvision",
    model: "DS-MP7504",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP7504 Mobile HDTVI DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp7504-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7116hghi-m1",
    manufacturer: "Hikvision",
    model: "DS-7116HGHI-M1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7116HGHI-M1 16 channel 720p mini 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7116hghi-m1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7304hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-7304HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7304HQHI-SH 4-channel turbo HD digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7304hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7208hthi-m2-s",
    manufacturer: "Hikvision",
    model: "iDS-7208HTHI-M2/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HTHI-M2/S 8 channel 4K 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7208hthi-m2-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7104hqhi-k1",
    manufacturer: "Hikvision",
    model: "DS-7104HQHI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HQHI-K1 4 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104hqhi-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7104hvi-sl",
    manufacturer: "Hikvision",
    model: "DS-7104HVI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HVI-SL 4 channel economic DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104hvi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hfhi-st",
    manufacturer: "Hikvision",
    model: "DS-7204HFHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HFHI-ST economic HD-SDI DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hfhi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7604huhi-f1-n",
    manufacturer: "Hikvision",
    model: "DS-7604HUHI-F1/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604HUHI-F1/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604huhi-f1-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"],"onvif":true},
  },
  {
    id: "ss-hikvision-ds-7204hghi-k1",
    manufacturer: "Hikvision",
    model: "DS-7204HGHI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HGHI-K1 4 channel 1080p lite 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hghi-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7308hqhi-k4",
    manufacturer: "Hikvision",
    model: "DS-7308HQHI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7308HQHI-K4 8 channel 1080p 1.5U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7308hqhi-k4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7116hghi-e1",
    manufacturer: "Hikvision",
    model: "DS-7116HGHI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7116HGHI-E1 Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7116hghi-e1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7104huhi-k1",
    manufacturer: "Hikvision",
    model: "DS-7104HUHI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HUHI-K1 4 channel 5 MP mini 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104huhi-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7332huhi-k4",
    manufacturer: "Hikvision",
    model: "DS-7332HUHI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7332HUHI-K4 32 channel 5 MP 1.5U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7332huhi-k4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-m5504hmi",
    manufacturer: "Hikvision",
    model: "DS-M5504HMI",
    category: "nvr-recorder",
    tagline: "Hikvision DS-M5504HMI mobile DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-m5504hmi-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hghi-f1",
    manufacturer: "Hikvision",
    model: "DS-7216HGHI-F1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HGHI-F1 turbo HD DVR with H.264 & dual-stream video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hghi-f1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8116hqhi-f8-n",
    manufacturer: "Hikvision",
    model: "DS-8116HQHI-F8/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HQHI-F8/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116hqhi-f8-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hi-sl",
    manufacturer: "Hikvision",
    model: "DS-7208HI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HI-SL 8-channel standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7332hfi-sh",
    manufacturer: "Hikvision",
    model: "DS-7332HFI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7332HFI-SH 32-channel H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7332hfi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-e04hghi-b",
    manufacturer: "Hikvision",
    model: "DS-E04HGHI-B",
    category: "nvr-recorder",
    tagline: "Hikvision DS-E04HGHI-B 4-ch 1080p Lite 1U H.265 eSSD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-e04hghi-b-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-9016hwi-st",
    manufacturer: "Hikvision",
    model: "DS-9016HWI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9016HWI-ST 32-ch, BNC Hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9016hwi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7332hqhi-k4",
    manufacturer: "Hikvision",
    model: "DS-7332HQHI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7332HQHI-K4 32 channel 1080p 1.5U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7332hqhi-k4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9016hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-9016HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9016HQHI-SH Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9016hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hi-sl",
    manufacturer: "Hikvision",
    model: "DS-7216HI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HI-SL 16-channel H.264 standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7324hi-sh",
    manufacturer: "Hikvision",
    model: "DS-7324HI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7324HI-SH standalone DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7324hi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8116hqhi-k8",
    manufacturer: "Hikvision",
    model: "DS-8116HQHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HQHI-K8 16 channel 5 MP 2U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116hqhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ids-7216hqhi-m1-fa",
    manufacturer: "Hikvision",
    model: "iDS-7216HQHI-M1/FA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7216HQHI-M1/FA 16 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7216hqhi-m1-fa-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7108huhi-k1",
    manufacturer: "Hikvision",
    model: "DS-7108HUHI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108HUHI-K1 8 channel 5 MP mini 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108huhi-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-e08hghi-b",
    manufacturer: "Hikvision",
    model: "DS-E08HGHI-B",
    category: "nvr-recorder",
    tagline: "Hikvision DS-E08HGHI-B 8-ch 1080p Lite 1U H.265 eSSD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-e08hghi-b-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7204huhi-m1-s",
    manufacturer: "Hikvision",
    model: "iDS-7204HUHI-M1/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7204HUHI-M1/S 4 channel 5MP 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7204huhi-m1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7204huhi-f2-s",
    manufacturer: "Hikvision",
    model: "DS-7204HUHI-F2/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HUHI-F2/S 4 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204huhi-f2-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8132hwsi-sh",
    manufacturer: "Hikvision",
    model: "DS-8132HWSI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8132HWSI-SH 32 channel standalone 960H DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8132hwsi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-mp7508",
    manufacturer: "Hikvision",
    model: "DS-MP7508",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP7508 mobile DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp7508-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7308hfhi-st",
    manufacturer: "Hikvision",
    model: "DS-7308HFHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7308HFHI-ST HD-SDI DVR with 1080P real-time recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7308hfhi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7216hqhi-m2-xt",
    manufacturer: "Hikvision",
    model: "iDS-7216HQHI-M2/XT",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7216HQHI-M2/XT 16 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7216hqhi-m2-xt-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-e16hghi-b",
    manufacturer: "Hikvision",
    model: "DS-E16HGHI-B",
    category: "nvr-recorder",
    tagline: "Hikvision DS-E16HGHI-B 16 channel 1080p Lite 1U H.265 eSSD digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-e16hghi-b-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-9008hwi-st",
    manufacturer: "Hikvision",
    model: "DS-9008HWI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9008HWI-ST 8 Channel Hybrid Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9008hwi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7308hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-7308HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7308HGHI-SH turbo HD DVR connectable to TVI and analogue cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7308hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hwi-e2-c",
    manufacturer: "Hikvision",
    model: "DS-7208HWI-E2/C",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HWI-E2/C 8-channel standalone VCA & UTC supported digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hwi-e2-c-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7308hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-7308HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7308HQHI-SH 8 channel hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7308hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-m5504hm-t",
    manufacturer: "Hikvision",
    model: "DS-M5504HM-T",
    category: "nvr-recorder",
    tagline: "Hikvision DS-M5504HM-T Mobile DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-m5504hm-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"],"onvif":true},
  },
  {
    id: "ss-hikvision-ids-7208huhi-m1-e",
    manufacturer: "Hikvision",
    model: "iDS-7208HUHI-M1/E",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HUHI-M1/E 8 channel 5MP 1U H.265 AcuSense digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7208huhi-m1-e-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7208huhi-k2-p",
    manufacturer: "Hikvision",
    model: "DS-7208HUHI-K2/P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HUHI-K2/P 8 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208huhi-k2-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7104hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-7104HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HQHI-SH turbo HD DVR with HDMI & VGA interface",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hfhi-sl",
    manufacturer: "Hikvision",
    model: "DS-7208HFHI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HFHI-SL 8-channel H.264 HD-SDI digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hfhi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-e08hghi-d",
    manufacturer: "Hikvision",
    model: "DS-E08HGHI-D",
    category: "nvr-recorder",
    tagline: "Hikvision DS-E08HGHI-D 8 channel 1080p Lite 1U H.265 eSSD digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-e08hghi-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7216hqhi-m2-fa",
    manufacturer: "Hikvision",
    model: "iDS-7216HQHI-M2/FA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7216HQHI-M2/FA 16 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7216hqhi-m2-fa-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-8132hfsi-sh",
    manufacturer: "Hikvision",
    model: "DS-8132HFSI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8132HFSI-SH 32-channel standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8132hfsi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hwi-e2-c",
    manufacturer: "Hikvision",
    model: "DS-7216HWI-E2/C",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HWI-E2/C 960H Standalone VCA&UTC supported DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hwi-e2-c-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7216hqhi-m2-s",
    manufacturer: "Hikvision",
    model: "iDS-7216HQHI-M2/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7216HQHI-M2/S 16 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7216hqhi-m2-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-8116hwi-st",
    manufacturer: "Hikvision",
    model: "DS-8116HWI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HWI-ST 16-channel standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116hwi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9116hfi-rt",
    manufacturer: "Hikvision",
    model: "DS-9116HFI-RT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9116HFI-RT standalone DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9116hfi-rt-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-8104hmi-m",
    manufacturer: "Hikvision",
    model: "DS-8104HMI-M",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104HMI-M 4-channel mobile digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104hmi-m-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7304hwi-sh",
    manufacturer: "Hikvision",
    model: "DS-7304HWI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7304HWI-SH standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7304hwi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7204hqhi-m1-s",
    manufacturer: "Hikvision",
    model: "iDS-7204HQHI-M1/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7204HQHI-M1/S 4 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7204hqhi-m1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7316huhi-k4",
    manufacturer: "Hikvision",
    model: "DS-7316HUHI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7316HUHI-K4 16 channel 5 MP 1.5U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7316huhi-k4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9032huhi-k8",
    manufacturer: "Hikvision",
    model: "DS-9032HUHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9032HUHI-K8 32 channel 5 MP 2U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9032huhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-7108hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-7108HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108HGHI-SH turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hqhi-k2",
    manufacturer: "Hikvision",
    model: "DS-7208HQHI-K2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HQHI-K2 8 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hqhi-k2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9116hfi-st",
    manufacturer: "Hikvision",
    model: "DS-9116HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9116HFI-ST standalone DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9116hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216hqhi-k2-p",
    manufacturer: "Hikvision",
    model: "DS-7216HQHI-K2/P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HQHI-K2/P 16 channel 1080p 1U H.265 PoC digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hqhi-k2-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7316hthi-k4",
    manufacturer: "Hikvision",
    model: "DS-7316HTHI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7316HTHI-K4 16 channel 4K 1.5U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7316hthi-k4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7104huhi-m1-s",
    manufacturer: "Hikvision",
    model: "iDS-7104HUHI-M1/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7104HUHI-M1/S 4 channel 5MP mini 1U H.265 AcuSense digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7104huhi-m1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-e04hghi-d",
    manufacturer: "Hikvision",
    model: "DS-E04HGHI-D",
    category: "nvr-recorder",
    tagline: "Hikvision eDVRs deliver stable performance and sustainable value to customers",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-e04hghi-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-hikvision-ds-7208hqhi-e1",
    manufacturer: "Hikvision",
    model: "DS-7208HQHI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HQHI-E1 turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hqhi-e1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9016hfi-rt",
    manufacturer: "Hikvision",
    model: "DS-9016HFI-RT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9016HFI-RT 16-channel hybrid digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9016hfi-rt-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7204hthi-m1-s",
    manufacturer: "Hikvision",
    model: "iDS-7204HTHI-M1/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7204HTHI-M1/S 4 channel 4K 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7204hthi-m1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7208hfhi-se",
    manufacturer: "Hikvision",
    model: "DS-7208HFHI-SE",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HFHI-SE 8-channel HD-SDI digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hfhi-se-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7216huhi-k2-p",
    manufacturer: "Hikvision",
    model: "DS-7216HUHI-K2/P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HUHI-K2/P 16 channel 5 MP 1U H.265 PoC digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216huhi-k2-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7008huhi-k2",
    manufacturer: "Hikvision",
    model: "DS-7008HUHI-K2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7008HUHI-K2 8 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7008huhi-k2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7208huhi-m1-s",
    manufacturer: "Hikvision",
    model: "iDS-7208HUHI-M1/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HUHI-M1/S 8 channel 5MP 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7208huhi-m1-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7208hqhi-m2-s",
    manufacturer: "Hikvision",
    model: "iDS-7208HQHI-M2/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HQHI-M2/S 8 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7208hqhi-m2-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7204hqhi-m1-fa",
    manufacturer: "Hikvision",
    model: "iDS-7204HQHI-M1/FA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7204HQHI-M1/FA 4 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7204hqhi-m1-fa-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7204huhi-m1-fa",
    manufacturer: "Hikvision",
    model: "iDS-7204HUHI-M1/FA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7204HUHI-M1/FA 4 channel 5MP 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7204huhi-m1-fa-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7208huhi-m2-fa",
    manufacturer: "Hikvision",
    model: "iDS-7208HUHI-M2/FA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HUHI-M2/FA 8 channel 5MP 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7208huhi-m2-fa-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-8104ahghli-e4",
    manufacturer: "Hikvision",
    model: "DS-8104AHGHLI-E4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104AHGHLI-E4 4 channel 720p H.264 ATM DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104ahghli-e4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hfhi-se",
    manufacturer: "Hikvision",
    model: "DS-7204HFHI-SE",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HFHI-SE 4 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hfhi-se-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hfhi-sl",
    manufacturer: "Hikvision",
    model: "DS-7204HFHI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HFHI-SL economic HD-SDI DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hfhi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7324hfi-sh",
    manufacturer: "Hikvision",
    model: "DS-7324HFI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7324HFI-SH standalone DVR H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7324hfi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hfhi-st-a",
    manufacturer: "Hikvision",
    model: "DS-7204HFHI-ST/A",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HFHI-ST/A 4 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hfhi-st-a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hqhi-k2-p",
    manufacturer: "Hikvision",
    model: "DS-7208HQHI-K2/P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HQHI-K2/P 8 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hqhi-k2-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7104hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-7104HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104HGHI-SH Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-mp7608",
    manufacturer: "Hikvision",
    model: "DS-MP7608",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP7608 8 channel 1080p H.265 mobile HDVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp7608-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-8132hqhi-k8",
    manufacturer: "Hikvision",
    model: "DS-8132HQHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8132HQHI-K8 32 channel 1080p 2U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8132hqhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-8104ahli-st",
    manufacturer: "Hikvision",
    model: "DS-8104AHLI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104AHLI-ST 4-channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104ahli-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-mp7516",
    manufacturer: "Hikvision",
    model: "DS-MP7516",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP7516 Mobile DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp7516-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8116hfhi-st",
    manufacturer: "Hikvision",
    model: "DS-8116HFHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HFHI-ST 16-channel 1080P HD-SDI 2U DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116hfhi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-mp5604-sd-gw-wi58",
    manufacturer: "Hikvision",
    model: "DS-MP5604-SD/GW/WI58",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP5604-SD/GW/WI58 4 channel 1080p H.265 mobile digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp5604-sd-gw-wi58-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ids-e04hqhi-d",
    manufacturer: "Hikvision",
    model: "iDS-E04HQHI-D",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-E04HQHI-D 4 channel 2MP 1U H.265 eSSD AcuSense digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-e04hqhi-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7304hfi-sh",
    manufacturer: "Hikvision",
    model: "DS-7304HFI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7304HFI-SH standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7304hfi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7324hqhi-k4",
    manufacturer: "Hikvision",
    model: "DS-7324HQHI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7324HQHI-K4 24 channel 1080p 1.5U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7324hqhi-k4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-8108hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-8108HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8108HQHI-SH turbo HD DVR with USB port",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8108hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8116huhi-f8-n",
    manufacturer: "Hikvision",
    model: "DS-8116HUHI-F8/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HUHI-F8/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116huhi-f8-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8108hfi-st",
    manufacturer: "Hikvision",
    model: "DS-8108HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8108HFI-ST 8 channel Standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8108hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7324huhi-k4",
    manufacturer: "Hikvision",
    model: "DS-7324HUHI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7324HUHI-K4 24 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7324huhi-k4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7308huhi-k4",
    manufacturer: "Hikvision",
    model: "DS-7308HUHI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7308HUHI-K4 8 channel 5 MP 1.5U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7308huhi-k4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7216hqhi-m1-e",
    manufacturer: "Hikvision",
    model: "iDS-7216HQHI-M1/E",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7216HQHI-M1/E 16 channel 1080p 1U H.265 AcuSense digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7216hqhi-m1-e-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-9008hfi-rt",
    manufacturer: "Hikvision",
    model: "DS-9008HFI-RT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9008HFI-RT embedded hybrid DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9008hfi-rt-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-e04hghi-e",
    manufacturer: "Hikvision",
    model: "DS-E04HGHI-E",
    category: "nvr-recorder",
    tagline: "Hikvision DS-E04HGHI-E 4 channel 1080p Lite 1U H.265 eSSD digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-e04hghi-e-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-9116hwi-st",
    manufacturer: "Hikvision",
    model: "DS-9116HWI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9116HWI-ST 16-channel H.264 standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9116hwi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hghi-f2",
    manufacturer: "Hikvision",
    model: "DS-7208HGHI-F2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HGHI-F2 Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hghi-f2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7308huhi-f4-n",
    manufacturer: "Hikvision",
    model: "DS-7308HUHI-F4/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7308HUHI-F4/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7308huhi-f4-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-e08hqhi-b",
    manufacturer: "Hikvision",
    model: "iDS-E08HQHI-B",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-E08HQHI-B 8 channel 2MP 1U H.265 eSSD AcuSense digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-e08hqhi-b-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-9008hfi-st",
    manufacturer: "Hikvision",
    model: "DS-9008HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9008HFI-ST 8 channel embedded hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9008hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7208hqhi-f2n",
    manufacturer: "Hikvision",
    model: "DS-7208HQHI-F2N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HQHI-F2N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hqhi-f2n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9016huhi-k8",
    manufacturer: "Hikvision",
    model: "DS-9016HUHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9016HUHI-K8 16 channel 5 MP 2U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9016huhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-7304hqhi-k4",
    manufacturer: "Hikvision",
    model: "DS-7304HQHI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7304HQHI-K4 4 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7304hqhi-k4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7208hghi-e2",
    manufacturer: "Hikvision",
    model: "DS-7208HGHI-E2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HGHI-E2 TURBO HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hghi-e2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9116hfi-xt",
    manufacturer: "Hikvision",
    model: "DS-9116HFI-XT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9116HFI-XT 16-channel H.64 standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9116hfi-xt-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8116huhi-k8",
    manufacturer: "Hikvision",
    model: "DS-8116HUHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HUHI-K8 16 channel 5 MP 2U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116huhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-6704-6708-6716huhi-k",
    manufacturer: "Hikvision",
    model: "DS-6704/6708/6716HUHI-K",
    category: "nvr-recorder",
    tagline: "Hikvision DS-6704/6708/6716HUHI-K 4 channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-6704-6708-6716huhi-k-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7304huhi-k4",
    manufacturer: "Hikvision",
    model: "DS-7304HUHI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7304HUHI-K4 4 channel 5 MP 1.5U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7304huhi-k4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7204hthi-k2",
    manufacturer: "Hikvision",
    model: "DS-7204HTHI-K2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HTHI-K2 4 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hthi-k2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-mp5604-sd-glf-wi58",
    manufacturer: "Hikvision",
    model: "DS-MP5604-SD/GLF/WI58",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP5604-SD/GLF/WI58 4 channel 1080p H.265 mobile digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp5604-sd-glf-wi58-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9008hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-9008HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9008HQHI-SH Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9008hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7108hvi-sl",
    manufacturer: "Hikvision",
    model: "DS-7108HVI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108HVI-SL 8-channel standalone mini DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108hvi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-mp3504-sd",
    manufacturer: "Hikvision",
    model: "DS-MP3504-SD",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP3504-SD Mobile DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp3504-sd-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-mp7608h",
    manufacturer: "Hikvision",
    model: "DS-MP7608H",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP7608H 1080p H.265 mobile HDVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp7608h-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-mp5604-sd-gw-wi",
    manufacturer: "Hikvision",
    model: "DS-MP5604-SD/GW/WI",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP5604-SD/GW/WI 4 channel 1080p H.265 mobile digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp5604-sd-gw-wi-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7216huhi-m2-p",
    manufacturer: "Hikvision",
    model: "iDS-7216HUHI-M2/P",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HUHI-M2/P 16 channel 5MP 1U H.265 PoC digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7216huhi-m2-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-8132huhi-k8",
    manufacturer: "Hikvision",
    model: "DS-8132HUHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8132HUHI-K8 32 channel 5 MP 2U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8132huhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-8108hqhi-k8",
    manufacturer: "Hikvision",
    model: "DS-8108HQHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8108HQHI-K8 8 channel 5 MP 2U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8108hqhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-9108hwi-st",
    manufacturer: "Hikvision",
    model: "DS-9108HWI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9108HWI-ST standalone DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9108hwi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-mp5604-sd-gw",
    manufacturer: "Hikvision",
    model: "DS-MP5604-SD/GW",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP5604-SD/GW 4 channel 1080p H.265 mobile digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp5604-sd-gw-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9016hfi-sh",
    manufacturer: "Hikvision",
    model: "DS-9016HFI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9016HFI-SH embedded hybrod digital video recorder with advanced motion detection",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9016hfi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-e04huhi-b",
    manufacturer: "Hikvision",
    model: "iDS-E04HUHI-B",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-E04HUHI-B 4 channel 5MP 1U H.265 eSSD AcuSense digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-e04huhi-b-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-8104ahfi-st",
    manufacturer: "Hikvision",
    model: "DS-8104AHFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104AHFI-ST ATM/POS DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104ahfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9104hfhi-st",
    manufacturer: "Hikvision",
    model: "DS-9104HFHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9104HFHI-ST HD-SDI DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9104hfhi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8132hci-sh",
    manufacturer: "Hikvision",
    model: "DS-8132HCI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8132HCI-SH 32-channel standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8132hci-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-7204HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HGHI-SH 4 channel turbo HD hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-mp5604-sd",
    manufacturer: "Hikvision",
    model: "DS-MP5604-SD",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP5604-SD 4 channel 1080p H.265 mobile digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp5604-sd-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9008huhi-k8",
    manufacturer: "Hikvision",
    model: "DS-9008HUHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9008HUHI-K8 8 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9008huhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7204huhi-m2-fa",
    manufacturer: "Hikvision",
    model: "iDS-7204HUHI-M2/FA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7204HUHI-M2/FA 4 channel 5MP 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7204huhi-m2-fa-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-8108hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-8108HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8108HGHI-SH Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8108hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8124huhi-k8",
    manufacturer: "Hikvision",
    model: "DS-8124HUHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8124HUHI-K8 24 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8124huhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9004hwi-st",
    manufacturer: "Hikvision",
    model: "DS-9004HWI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9004HWI-ST embedded hybrid DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9004hwi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9004huhi-f8-n",
    manufacturer: "Hikvision",
    model: "DS-9004HUHI-F8/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9004HUHI-F8/N 4 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9004huhi-f8-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-mp5604-sd-glf",
    manufacturer: "Hikvision",
    model: "DS-MP5604-SD/GLF",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP5604-SD/GLF 4 channel 1080p H.265 mobile digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp5604-sd-glf-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ids-6716huhi-m",
    manufacturer: "Hikvision",
    model: "iDS-6716HUHI-M",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-6716HUHI-M 16 channel 5MP 1U H.265 AcuSense DVS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-6716huhi-m-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-8124hfsi-sh",
    manufacturer: "Hikvision",
    model: "DS-8124HFSI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8124HFSI-SH standalone DVR with H.264 video compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8124hfsi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7304hfhi-st",
    manufacturer: "Hikvision",
    model: "DS-7304HFHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7304HFHI-ST 4 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7304hfhi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8100hqhi-f8-n",
    manufacturer: "Hikvision",
    model: "DS-8100HQHI-F8/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8100HQHI-F8/N 4 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8100hqhi-f8-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8104ahghi-e4",
    manufacturer: "Hikvision",
    model: "DS-8104AHGHI-E4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104AHGHI-E4 4 channel 720p H.264 ATM DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104ahghi-e4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8124hqhi-k8",
    manufacturer: "Hikvision",
    model: "DS-8124HQHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8124HQHI-K8 24 channel 1080p 2U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8124hqhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-9016hthi-k8",
    manufacturer: "Hikvision",
    model: "DS-9016HTHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9016HTHI-K8 16 channel 4K 2U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9016hthi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-8116hthi-k8",
    manufacturer: "Hikvision",
    model: "DS-8116HTHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HTHI-K8 16 channel 4K 2U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116hthi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-7204hqhi-e1",
    manufacturer: "Hikvision",
    model: "DS-7204HQHI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HQHI-E1 Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hqhi-e1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8124hci-sh",
    manufacturer: "Hikvision",
    model: "DS-8124HCI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8124HCI-SH 24-channel standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8124hci-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8108ahli-st",
    manufacturer: "Hikvision",
    model: "DS-8108AHLI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8108AHLI-ST ATM/POS DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8108ahli-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8116hqhi-f8n",
    manufacturer: "Hikvision",
    model: "DS-8116HQHI-F8N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HQHI-F8N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116hqhi-f8n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9024huhi-k8",
    manufacturer: "Hikvision",
    model: "DS-9024HUHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9024HUHI-K8 24 channel Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9024huhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7208hqhi-m2-fa",
    manufacturer: "Hikvision",
    model: "iDS-7208HQHI-M2/FA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HQHI-M2/FA 8 channel 1080p 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7208hqhi-m2-fa-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7204huhi-m2-s",
    manufacturer: "Hikvision",
    model: "iDS-7204HUHI-M2/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7204HUHI-M2/S 4 channel 5MP 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7204huhi-m2-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7208huhi-m2-s",
    manufacturer: "Hikvision",
    model: "iDS-7208HUHI-M2/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HUHI-M2/S 8 channel 5MP 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7208huhi-m2-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7204huhi-m1-p",
    manufacturer: "Hikvision",
    model: "iDS-7204HUHI-M1/P",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7204HUHI-M1/P 4 channel 5MP 1U H.265 PoC digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7204huhi-m1-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7208huhi-m2-p",
    manufacturer: "Hikvision",
    model: "iDS-7208HUHI-M2/P",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7208HUHI-M2/P 8 channel 5MP 1U H.265 PoC digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7208huhi-m2-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-8108hwi-st",
    manufacturer: "Hikvision",
    model: "DS-8108HWI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8108HWI-ST 8 channel 960H Standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8108hwi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9016hfi-xt",
    manufacturer: "Hikvision",
    model: "DS-9016HFI-XT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9016HFI-XT 16-channel hybrid digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9016hfi-xt-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-7204hthi-m2-s",
    manufacturer: "Hikvision",
    model: "iDS-7204HTHI-M2/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7204HTHI-M2/S 4 channel 4K 1U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7204hthi-m2-s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-8104ahfli-st",
    manufacturer: "Hikvision",
    model: "DS-8104AHFLI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104AHFLI-ST ATM/POS DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104ahfli-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9008hfi-sh",
    manufacturer: "Hikvision",
    model: "DS-9008HFI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9008HFI-SH embedded hybrid digital video recorder with up to 8 SATA hard disk drives",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9008hfi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9004hfi-sh",
    manufacturer: "Hikvision",
    model: "DS-9004HFI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9004HFI-SH embedded hybrid digital video recorder with dual stream support",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9004hfi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8104hfi-st",
    manufacturer: "Hikvision",
    model: "DS-8104HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104HFI-ST standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8108huhi-k8",
    manufacturer: "Hikvision",
    model: "DS-8108HUHI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8108HUHI-K8 8 channel 5 MP 2U H.265 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8108huhi-k8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-9108hfi-st",
    manufacturer: "Hikvision",
    model: "DS-9108HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9108HFI-ST H.264 video compression standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9108hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-7316hfhi-sl",
    manufacturer: "Hikvision",
    model: "DS-7316HFHI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7316HFHI-SL 4-channel HD-SDI digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7316hfhi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hwi-e1-c",
    manufacturer: "Hikvision",
    model: "DS-7204HWI-E1/C",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HWI-E1/C 4 channel 960H Standalone VCA&UTC supported DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hwi-e1-c-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9004hfi-st",
    manufacturer: "Hikvision",
    model: "DS-9004HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9004HFI-ST embedded hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9004hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8124hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-8124HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8124HGHI-SH Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8124hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9016huhi-f8-n",
    manufacturer: "Hikvision",
    model: "DS-9016HUHI-F8/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9016HUHI-F8/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9016huhi-f8-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-5504hmi",
    manufacturer: "Hikvision",
    model: "DS-5504HMI",
    category: "nvr-recorder",
    tagline: "Hikvision DS-5504HMI Mobile DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-5504hmi-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8108ahfi-st",
    manufacturer: "Hikvision",
    model: "DS-8108AHFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8108AHFI-ST 8-channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8108ahfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8124hwsi-sh",
    manufacturer: "Hikvision",
    model: "DS-8124HWSI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8124HWSI-SH standalone 960H DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8124hwsi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8104ahi-st",
    manufacturer: "Hikvision",
    model: "DS-8104AHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104AHI-ST 4-channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104ahi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-6708huhi-m",
    manufacturer: "Hikvision",
    model: "iDS-6708HUHI-M",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-6708HUHI-M 8 channel 5MP 1U H.265 AcuSense DVS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-6708huhi-m-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7216hqhi-e2",
    manufacturer: "Hikvision",
    model: "DS-7216HQHI-E2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7216HQHI-E2 Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7216hqhi-e2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9016hfi-rh",
    manufacturer: "Hikvision",
    model: "DS-9016HFI-RH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9016HFI-RH 16-channel hybrid digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9016hfi-rh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"raidLevels":["0","1","5","10"]},
  },
  {
    id: "ss-hikvision-ds-8104hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-8104HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104HGHI-SH Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8108ahfli-st",
    manufacturer: "Hikvision",
    model: "DS-8108AHFLI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8108AHFLI-ST 8-channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8108ahfli-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8104hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-8104HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104HQHI-SH Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9108hfi-rt",
    manufacturer: "Hikvision",
    model: "DS-9108HFI-RT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9108HFI-RT H.264 video compression DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9108hfi-rt-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-7224hi-sh",
    manufacturer: "Hikvision",
    model: "DS-7224HI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7224HI-SH economic WD1 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7224hi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8108hfhi-st",
    manufacturer: "Hikvision",
    model: "DS-8108HFHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8108HFHI-ST 8-channel HD-SDI 2U digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8108hfhi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ids-6704huhi-m",
    manufacturer: "Hikvision",
    model: "iDS-6704HUHI-M",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-6704HUHI-M 4 channel 5MP 1U H.265 AcuSense DVS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-6704huhi-m-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7208hqhi-e2",
    manufacturer: "Hikvision",
    model: "DS-7208HQHI-E2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7208HQHI-E2 turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7208hqhi-e2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7308hfhi-sl",
    manufacturer: "Hikvision",
    model: "DS-7308HFHI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7308HFHI-SL HD-SDI DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7308hfhi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9108hfhi-st",
    manufacturer: "Hikvision",
    model: "DS-9108HFHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9108HFHI-ST 8-channel HD-SDI digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9108hfhi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8116hfhi-sl",
    manufacturer: "Hikvision",
    model: "DS-8116HFHI-SL",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8116HFHI-SL HD-SDI DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8116hfhi-sl-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9004hfi-rt",
    manufacturer: "Hikvision",
    model: "DS-9004HFI-RT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9004HFI-RT 4 channel embedded hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9004hfi-rt-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9004hqhi-sh",
    manufacturer: "Hikvision",
    model: "DS-9004HQHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9004HQHI-SH Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9004hqhi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8004hfi-st",
    manufacturer: "Hikvision",
    model: "DS-8004HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8004HFI-ST 4 channel embedded hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8004hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8104hwi-st",
    manufacturer: "Hikvision",
    model: "DS-8104HWI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104HWI-ST standalone 960H DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104hwi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8104hfhi-st",
    manufacturer: "Hikvision",
    model: "DS-8104HFHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104HFHI-ST 4 Channel 1080P HD-SDI 2U DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104hfhi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-9008hfi-rh",
    manufacturer: "Hikvision",
    model: "DS-9008HFI-RH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9008HFI-RH 8 channel embedded hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9008hfi-rh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"],"raidLevels":["0","1","5","10"]},
  },
  {
    id: "ss-hikvision-ds-9104hfi-st",
    manufacturer: "Hikvision",
    model: "DS-9104HFI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9104HFI-ST standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9104hfi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9004hfi-rh",
    manufacturer: "Hikvision",
    model: "DS-9004HFI-RH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9004HFI-RH embedded hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9004hfi-rh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"],"raidLevels":["0","1","5","10"]},
  },
  {
    id: "ss-hikvision-ds-8108ahi-st",
    manufacturer: "Hikvision",
    model: "DS-8108AHI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8108AHI-ST ATM/POS DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8108ahi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7304hghi-sh",
    manufacturer: "Hikvision",
    model: "DS-7304HGHI-SH",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7304HGHI-SH Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7304hghi-sh-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9104hfi-rt",
    manufacturer: "Hikvision",
    model: "DS-9104HFI-RT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9104HFI-RT standalone DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9104hfi-rt-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8112hmfi-t",
    manufacturer: "Hikvision",
    model: "DS-8112HMFI-T",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8112HMFI-T 12-channel mobile digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8112hmfi-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":12,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9008huhi-f8-n",
    manufacturer: "Hikvision",
    model: "DS-9008HUHI-F8/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9008HUHI-F8/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9008huhi-f8-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-8104huhi-f8-n",
    manufacturer: "Hikvision",
    model: "DS-8104HUHI-F8/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8104HUHI-F8/N Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8104huhi-f8-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-9104hwi-st",
    manufacturer: "Hikvision",
    model: "DS-9104HWI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9104HWI-ST standalone digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9104hwi-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7204hghi-e",
    manufacturer: "Hikvision",
    model: "DS-7204HGHI-E",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7204HGHI-E Turbo HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7204hghi-e-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-dh-xvr5108hs-x",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5108HS-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5108HS-X 8 Channel Penta-brid 1080P Compact 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5108hs-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5116hs-x",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5116HS-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5116HS-X 16 Channel Penta-brid 1080P Compact 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5116hs-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr1a04-08",
    manufacturer: "Dahua Technology",
    model: "XVR1A04/08",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR1A04/08 4/8 Channel Penta-brid 1080N/720P Cooper 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr1a04-08-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5408-16l-x",
    manufacturer: "Dahua Technology",
    model: "XVR5408/16L-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5408/16L-X 8/16 Channel Penta-brid 1080P 1.5U DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5408-16l-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr4108hs-x1",
    manufacturer: "Dahua Technology",
    model: "XVR4108HS-X1",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR4108HS-X1 8 Channel Penta-brid 720P Compact 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr4108hs-x1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr1b16-i",
    manufacturer: "Dahua Technology",
    model: "XVR1B16-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR1B16-I 16 Channel Penta-brid 1080N/720p Compact 1U 1HDD WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr1b16-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5108h-4kl-x-8p",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5108H-4KL-X-8P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5108H-4KL-X-8P",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5108h-4kl-x-8p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-dh-xvr5116h-x",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5116H-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5116H-X 16 Channel Penta-brid 1080P Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5116h-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5116he-x",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5116HE-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5116HE-X 16 Channel Penta-brid 1080P Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5116he-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr4116hs-x",
    manufacturer: "Dahua Technology",
    model: "XVR4116HS-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR4116HS-X 16 Channel Penta-brid 720P Compact 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr4116hs-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104hs-x1",
    manufacturer: "Dahua Technology",
    model: "XVR5104HS-X1",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HS-X1 4 Channel Penta-brid 1080P Compact 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104hs-x1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr1b16h-i",
    manufacturer: "Dahua Technology",
    model: "XVR1B16H-I",
    category: "nvr-recorder",
    tagline: "Dahua XVR1B16H-I 16 Channel Penta-brid 5M-N/1080P Compact 1U 1HDD WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr1b16h-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5216an-4kl-x",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5216AN-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5216AN-4KL-X 16 Channel Penta-brid 4K 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5216an-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5108h-x",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5108H-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5108H-X 8 Channel Penta-brid 1080P Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5108h-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5232an-x",
    manufacturer: "Dahua Technology",
    model: "XVR5232AN-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5232AN-X 32 Channel Penta-brid 1080P Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5232an-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5208a-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5208A-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua XVR5208A-4KL-I3 8 Channel Penta-brid 4K-N/5MP 1U 2HDDs WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5208a-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108hs-4kl-x",
    manufacturer: "Dahua Technology",
    model: "XVR5108HS-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HS-4KL-X 8 Channel Penta-brid 4K Compact 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108hs-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr1b04-i",
    manufacturer: "Dahua Technology",
    model: "XVR1B04-I",
    category: "nvr-recorder",
    tagline: "Dahua WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr1b04-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5104c-x1",
    manufacturer: "Dahua Technology",
    model: "XVR5104C-X1",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104C-X1 4 Channel Penta-brid 1080P Smart 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104c-x1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr1b04-i-t",
    manufacturer: "Dahua Technology",
    model: "DH-XVR1B04-I/T",
    category: "nvr-recorder",
    tagline: "Dahua 4CH 1080N WizSense DVR (Cooper Series)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr1b04-i-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5116hs-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5116HS-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116HS-I3 16 channel Penta-brid 5M-N/1080p compact 1U 1HDD digital video recorde",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116hs-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr1b04h-i",
    manufacturer: "Dahua Technology",
    model: "XVR1B04H-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR1B04H-I 4 Channel Penta-brid 5M-N/1080p Cooper 1U 1HDD WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr1b04h-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5108he-x",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5108HE-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5108HE-X 8 Channel Penta-brid 1080P Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5108he-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5432l-x",
    manufacturer: "Dahua Technology",
    model: "XVR5432L-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5432L-X 32 Channel Penta-brid 1080P 1.5U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5432l-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5104h-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5104H-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104H-4KL-I3 4 Channel Penta-brid 5MP Mini 1U 1HDD WizSense",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104h-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr1b16h",
    manufacturer: "Dahua Technology",
    model: "XVR1B16H",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR1B16H 16 Channel Penta-brid 4M-N/1080P Cooper 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr1b16h-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108hs-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5108HS-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HS-I2 8 Channel Penta-brid 5M-N/1080P Compact 1U WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108hs-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5104hs-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5104HS-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua DH-XVR5104HS-4KL-I3 4CH Penta-brid 4K-N/5MP Compact 1U 1HDD WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5104hs-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5208an-4kl-x",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5208AN-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5208AN-4KL-X 8 Channel Penta-brid 4K 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5208an-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr4104hs-x1",
    manufacturer: "Dahua Technology",
    model: "XVR4104HS-X1",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR4104HS-X1 4 Channel Penta-brid 720P Compact 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr4104hs-x1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104hs-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5104HS-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HS-4KL-I3 4 Channel Penta-brid 4K-N/5MP Compact 1U 1HDD WizSense Digital Vid",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104hs-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5232an-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5232AN-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5232AN-I3 32 Channels Penta-brid 5M-N/1080P 1U 2HDDs WizSense Digital Video Reco",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5232an-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5216a-x",
    manufacturer: "Dahua Technology",
    model: "XVR5216A-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216A-X 16 Channel Penta-brid 1080P Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216a-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr1b16",
    manufacturer: "Dahua Technology",
    model: "XVR1B16",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR1B16 16 Channel Penta-brid 1080N/720P Compact 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr1b16-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr1b04-i-512g",
    manufacturer: "Dahua Technology",
    model: "DH-XVR1B04-I(512G)",
    category: "nvr-recorder",
    tagline: "Dahua DH-XVR1B04-I(512G) 4 Channels Penta-brid 1080N/720p Cooper 1U 1SSD 512G WizSense Digital Video",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr1b04-i-512g-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5104h-x-4p",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5104H-X-4P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5104H-X-4P 4 Channel Penta-brid 1080P Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5104h-x-4p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5116h-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5116H-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116H-4KL-I3 16 Channel Penta-brid 4K-N/5MP Mini 1U 1HDD WizSense Digital Video ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116h-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr7208-16a-4kl-i",
    manufacturer: "Dahua Technology",
    model: "DH-XVR7208/16A-4KL-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology AI XVR with SMD Plus",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr7208-16a-4kl-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5216an-x",
    manufacturer: "Dahua Technology",
    model: "XVR5216AN-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216AN-X 16 Channel Penta-brid 1080P Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216an-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr1b04-08",
    manufacturer: "Dahua Technology",
    model: "XVR1B04/08",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR1B04/08 4/8 Channel Penta-brid 1080N/720P Cooper 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr1b04-08-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108c-x",
    manufacturer: "Dahua Technology",
    model: "XVR5108C-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108C-X 8 Channel Penta-brid 1080P Smart 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108c-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5108h-i3",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5108H-I3",
    category: "nvr-recorder",
    tagline: "Dahua DH-XVR5108H-I3 8CH Penta-brid 5MP Value/1080P Mini 1U 1HDD WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5108h-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr1b08h",
    manufacturer: "Dahua Technology",
    model: "DH-XVR1B08H",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR1B08H 8 Channel Penta-brid 4M-N/1080P Cooper 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr1b08h-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr1b08h-ii",
    manufacturer: "Dahua Technology",
    model: "XVR1B08H-Ii",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR1B08H-I 8 Channel Penta-brid 5M-N/1080P Cooper 1U 1HDD WizSense Digital Video Re",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr1b08h-ii-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7108-16he-4kl-x",
    manufacturer: "Dahua Technology",
    model: "XVR7108/16HE-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7108/16HE-4KL-X 8/16 Channel Penta-brid 4K Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7108-16he-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108hs-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5108HS-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HS-4KL-I2 8 Channel Penta-brid 4K-N/5MP Compact 1U WizSense Digital Video Re",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108hs-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5216an-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5216AN-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216AN-I3 16 channel Penta-brid 5M-N/1080p 1U 2HDDs digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216an-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr4104c-x1",
    manufacturer: "Dahua Technology",
    model: "XVR4104C-X1",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR4104C-X1 4 Channel Penta-brid 720P Smart 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr4104c-x1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104h-4kl-x",
    manufacturer: "Dahua Technology",
    model: "XVR5104H-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104H-4KL-X 4 Channel Penta-brid 4K Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104h-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5832s-x",
    manufacturer: "Dahua Technology",
    model: "XVR5832S-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5832S-X 32 Channel Penta-brid 1080P 2U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5832s-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5216an-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5216AN-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216AN-4KL-I2 16 Channel Penta-brid 4K-N/5MP 1U 2HDDs WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216an-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr4108c-x1",
    manufacturer: "Dahua Technology",
    model: "XVR4108C-X1",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR4108C-X1 8 Channel Penta-brid 720P Smart 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr4108c-x1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7816s-4kl-x-lp",
    manufacturer: "Dahua Technology",
    model: "XVR7816S-4KL-X-LP",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7816S-4KL-X-LP 16 Channel Penta-brid 4K 2U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7816s-4kl-x-lp-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr1b04-08h",
    manufacturer: "Dahua Technology",
    model: "XVR1B04/08H",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR1B04/08H 4/8 Channel Penta-brid 4M-N/1080P Cooper 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr1b04-08h-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5216an-4kl-x-16p",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5216AN-4KL-X-16P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5216AN-4KL-X-16P 16-Channel Penta-brid 4K 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5216an-4kl-x-16p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108hs-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5108HS-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HS-4KL-I3 8 Channel Penta-brid 4K-N/5MP Compact 1U 1HDD WizSense Digital Vid",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108hs-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5116h-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5116H-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116H-I3 16 channel Penta-brid 5M-N/1080p mini 1U 1HDD digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116h-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104c-4kl-x",
    manufacturer: "Dahua Technology",
    model: "XVR5104C-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104C-4KL-X 4 Channel Penta-brid 4K Smart 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104c-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m44166",
    manufacturer: "Dahua Technology",
    model: "M44166",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44166 16-channel 6 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44166-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr5216an-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5216AN-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216AN-4KL-I3 16 Channels Penta-brid 4K-N/5MP 1U 2HDDs WizSense Digital Video Re",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216an-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5208-16an-4kl-x-8-16p",
    manufacturer: "Dahua Technology",
    model: "XVR5208/16AN-4KL-X-8/16P",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5208/16AN-4KL-X-8/16P 8/16 Channel Penta-brid 4K 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5208-16an-4kl-x-8-16p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5116hs-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5116HS-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116HS-I2 16 Channel Penta-brid 5M-N/1080P Compact 1U 1HDD WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116hs-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104he-x1",
    manufacturer: "Dahua Technology",
    model: "XVR5104HE-X1",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HE-X1 4 Channel Penta-brid 1080P Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104he-x1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-x51a1e-x51a2e-x51a3e",
    manufacturer: "Dahua Technology",
    model: "X51A1E/X51A2E/X51A3E",
    category: "nvr-recorder",
    tagline: "Dahua Technology X51A1E/X51A2E/X51A3E 1080p H.265 4/8/16CH Mini 1U Penta-brid",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-x51a1e-x51a2e-x51a3e-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7208a-4k-x",
    manufacturer: "Dahua Technology",
    model: "XVR7208A-4K-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7208A-4K-X 8 Channel Penta-brid 4K 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7208a-4k-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104hs-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5104HS-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HS-4KL-I2 4 Channel Penta-brid 4K-N/5MP Compact 1U WizSense Digital Video Re",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104hs-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5216a-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5216A-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216A-I2 16 Channel Penta-brid 5M-N/1080P 1U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216a-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104hs-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5104HS-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HS-I3 4 Channel Penta-brid 5M-N/1080p Compact 1U 1HDD WizSense",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104hs-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104h-x1",
    manufacturer: "Dahua Technology",
    model: "XVR5104H-X1",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104H-X1 4 Channel Penta-brid 1080P Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104h-x1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-x72a3a",
    manufacturer: "Dahua Technology",
    model: "X72A3A",
    category: "nvr-recorder",
    tagline: "Dahua Technology X72A3A 4K 16+16CH 1U Penta-brid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-x72a3a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104h-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5104H-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104H-I3 4 Channel Penta-brid 5M-N/1080P Mini 1U 1HDD WizSense Digital Video Rec",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104h-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108h-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5108H-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108H-I3 8 Channel Penta-brid 5M-N/1080P Mini 1U 1HDD WizSense Digital Video Rec",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108h-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104hs-4kl-x",
    manufacturer: "Dahua Technology",
    model: "XVR5104HS-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HS-4KL-X 4 Channel Penta-brid 4K Compact 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104hs-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr1b08h-i",
    manufacturer: "Dahua Technology",
    model: "XVR1B08H-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR1B08H-I 8 Channel Penta-brid 5M-N/1080p Cooper 1U 1HDD WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr1b08h-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-x72a2a",
    manufacturer: "Dahua Technology",
    model: "X72A2A",
    category: "nvr-recorder",
    tagline: "Dahua Technology X72A2A 4K 8+8CH 1U Penta-brid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-x72a2a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
];

const PART_2: NvrEntry[] = [
  {
    id: "ss-dahua-technology-xvr8816s-4kl-i",
    manufacturer: "Dahua Technology",
    model: "XVR8816S-4KL-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR8816S-4KL-I 16 Channel Penta-brid 4K 2U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr8816s-4kl-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5116he-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5116HE-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116HE-I3 16 channel Penta-brid 5M-N/1080p mini 1U 1HDD digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116he-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr4216-32an-x",
    manufacturer: "Dahua Technology",
    model: "XVR4216/32AN-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR4216/32AN-X 16/32 Channel Penta-brid 720P Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr4216-32an-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5216a-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5216A-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216A-I3 16 channel Penta-brid 5M-N/1080p 1U 2HDDs digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216a-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5208an-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5208AN-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5208AN-4KL-I3 8 Channel Penta-brid 4K-N/5MP 1U 2HDDs WizSense Digital Video Reco",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5208an-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr8216a-4kl-i",
    manufacturer: "Dahua Technology",
    model: "XVR8216A-4KL-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR8216A-4KL-I 16 Channel Penta-brid 4K 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr8216a-4kl-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m32164",
    manufacturer: "Dahua Technology",
    model: "M32164",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32164 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32164-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-d32161t",
    manufacturer: "Dahua Technology",
    model: "D32161T",
    category: "nvr-recorder",
    tagline: "Dahua Technology D32161T 16-channel 1 TB digital video surveillance recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-d32161t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7108h-4k-i2",
    manufacturer: "Dahua Technology",
    model: "XVR7108H-4K-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7108H-4K-I2 8 Channel Penta-brid 4K Mini 1U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7108h-4k-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-x58a5s",
    manufacturer: "Dahua Technology",
    model: "X58A5S",
    category: "nvr-recorder",
    tagline: "Dahua Technology X58A5S 1080p H.265 32 CH 2U Penta-brid",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-x58a5s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr5208an-4kl-x-8p",
    manufacturer: "Dahua Technology",
    model: "DH-XVR5208AN-4KL-X-8P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR5208AN-4KL-X-8P 8-Channel Penta-brid 4K 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr5208an-4kl-x-8p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108h-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5108H-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108H-4KL-I3 8 Channel Penta-brid 4K-N/5MP Mini 1U 1HDD WizSense Digital Video R",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108h-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dh-xvr1b04h",
    manufacturer: "Dahua Technology",
    model: "DH-XVR1B04H",
    category: "nvr-recorder",
    tagline: "Dahua Technology DH-XVR1B04H 4 Channel Penta-brid 4M-N/1080P Cooper 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dh-xvr1b04h-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108hs-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5108HS-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HS-I3 8 Channel Penta-brid 5M-N/1080p Compact 1U 1HDD WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108hs-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5116h-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5116H-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116H-4KL-I2 16 Channel Penta-brid 4K-N/5MP Mini 1U 1HDD WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116h-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108he-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5108HE-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HE-I3 8 Channel Penta-brid 5M-N/1080P Mini 1U 1HDD WizSense Digital Video Re",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108he-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104hs-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5104HS-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HS-I2 4 Channel Penta-brid 5M-N/1080P Compact 1U WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104hs-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr4216an-ii",
    manufacturer: "Dahua Technology",
    model: "XVR4216AN-Ii",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR4216AN-I 16 Channel Penta-brid 720P 1U 2HDDs WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr4216an-ii-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108he-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5108HE-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HE-4KL-I3 8 Channel Penta-brid 4K-N/5MP Mini 1U 1HDD WizSense Digital Video ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108he-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108-16h-4kl-x",
    manufacturer: "Dahua Technology",
    model: "XVR5108/16H-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108/16H-4KL-X 8/16 Channel Penta-brid 4K Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108-16h-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-d3332",
    manufacturer: "Dahua Technology",
    model: "D3332",
    category: "nvr-recorder",
    tagline: "Dahua Technology D3332 32 channel 960 H digital video surveillance recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-d3332-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-d33045g",
    manufacturer: "Dahua Technology",
    model: "D33045G",
    category: "nvr-recorder",
    tagline: "Dahua Technology D33045G 4-channel 500 GB HDD digital video surveillance recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-d33045g-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7108he-4k-x",
    manufacturer: "Dahua Technology",
    model: "XVR7108HE-4K-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7108HE-4K-X 8 Channel Penta-brid 4K Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7108he-4k-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m32081",
    manufacturer: "Dahua Technology",
    model: "M32081",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32081 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32081-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32161p",
    manufacturer: "Dahua Technology",
    model: "M32161P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32161P 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32161p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-d33081t",
    manufacturer: "Dahua Technology",
    model: "D33081T",
    category: "nvr-recorder",
    tagline: "Dahua Technology D33081T 8-channel 1 TB digital video surveillance recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-d33081t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr5216a-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5216A-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216A-4KL-I3 16 Channels Penta-brid 4K-N/5MP 1U 2HDDs WizSense Digital Video Rec",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216a-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7104he-4k-i2",
    manufacturer: "Dahua Technology",
    model: "XVR7104HE-4K-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7104HE-4K-I2 4 Channel Penta-brid 4K Mini 1U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7104he-4k-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-d33121t",
    manufacturer: "Dahua Technology",
    model: "D33121T",
    category: "nvr-recorder",
    tagline: "Dahua Technology D33121T 12-channel 1 TB digital video surveillance recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-d33121t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":12,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-d33161t",
    manufacturer: "Dahua Technology",
    model: "D33161T",
    category: "nvr-recorder",
    tagline: "Dahua Technology D33161T 16-channel 1 TB digital video surveillance recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-d33161t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-d33041t",
    manufacturer: "Dahua Technology",
    model: "D33041T",
    category: "nvr-recorder",
    tagline: "Dahua Technology D33041T 4-channel 1 TB digital video surveillance recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-d33041t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7104-08e-4kl-b-x",
    manufacturer: "Dahua Technology",
    model: "XVR7104/08E-4KL-B-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7104/08E-4KL-B-X 4/8 Channel Penta-brid 4K Elegant 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7104-08e-4kl-b-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr8208a-4k-i",
    manufacturer: "Dahua Technology",
    model: "XVR8208A-4K-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR8208A-4K-I 8 Channel Penta-brid 4K 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr8208a-4k-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108h-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5108H-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108H-4KL-I2 8 Channel Penta-brid 4K-N/5MP Mini 1U 1HDD WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108h-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5216a-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5216A-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216A-4KL-I2 16 Channel Penta-brid 4K-N/5MP 1U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216a-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m32041",
    manufacturer: "Dahua Technology",
    model: "M32041",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32041 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32041-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32084p",
    manufacturer: "Dahua Technology",
    model: "M32084P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32084P 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32084p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7104h-4k-i2",
    manufacturer: "Dahua Technology",
    model: "XVR7104H-4K-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7104H-4K-I2 4 Channel Penta-brid 4K Mini 1U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7104h-4k-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-mxvr1004",
    manufacturer: "Dahua Technology",
    model: "MXVR1004",
    category: "nvr-recorder",
    tagline: "Dahua Technology's MXVR1004",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-mxvr1004-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr8208a-4kl-i",
    manufacturer: "Dahua Technology",
    model: "XVR8208A-4KL-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR8208A-4KL-I 8 Channel Penta-brid 4K 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr8208a-4kl-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5816s-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5816S-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5816S-4KL-I2 16 Channel Penta-brid 4K-N/5MP 2U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5816s-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5116he-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5116HE-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116HE-4KL-I3 16 Channel Penta-brid 4K-N/5MP Mini 1U 1HDD WizSense Digital Video",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116he-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m32082",
    manufacturer: "Dahua Technology",
    model: "M32082",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32082 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32082-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32162p",
    manufacturer: "Dahua Technology",
    model: "M32162P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32162P 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32162p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32162",
    manufacturer: "Dahua Technology",
    model: "M32162",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32162 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32162-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32042",
    manufacturer: "Dahua Technology",
    model: "M32042",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32042 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32042-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32044",
    manufacturer: "Dahua Technology",
    model: "M32044",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32044 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32044-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32082p",
    manufacturer: "Dahua Technology",
    model: "M32082P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32082P 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32082p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32168p",
    manufacturer: "Dahua Technology",
    model: "M32168P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32168P 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32168p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32043p",
    manufacturer: "Dahua Technology",
    model: "M32043P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32043P 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32043p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr5116h-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5116H-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116H-I2 16 Channel Penta-brid 5M-N/1080P Mini 1U WizSense Digital Video Recorde",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116h-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108hs-i31",
    manufacturer: "Dahua Technology",
    model: "XVR5108HS-I31",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HS-I3 8 Channel Penta-brid 5M-N/1080P Compact 1U 1HDD WizSense Digital Video",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108hs-i31-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104he-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5104HE-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HE-4KL-I3 4 Channel Penta-brid 4K-N/5MP Mini 1U 1HDD WizSense Digital Video ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104he-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m32164p",
    manufacturer: "Dahua Technology",
    model: "M32164P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32164P 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32164p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32084",
    manufacturer: "Dahua Technology",
    model: "M32084",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32084 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32084-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32163p",
    manufacturer: "Dahua Technology",
    model: "M32163P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32163P 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32163p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32161",
    manufacturer: "Dahua Technology",
    model: "M32161",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32161 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32161-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32088p",
    manufacturer: "Dahua Technology",
    model: "M32088P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32088P 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32088p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32086p",
    manufacturer: "Dahua Technology",
    model: "M32086P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32086P 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32086p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32083p",
    manufacturer: "Dahua Technology",
    model: "M32083P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32083P 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32083p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32081p",
    manufacturer: "Dahua Technology",
    model: "M32081P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32081P 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32081p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32041p",
    manufacturer: "Dahua Technology",
    model: "M32041P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32041P 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32041p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32042p",
    manufacturer: "Dahua Technology",
    model: "M32042P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32042P 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32042p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32044p",
    manufacturer: "Dahua Technology",
    model: "M32044P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32044P 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32044p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32046p",
    manufacturer: "Dahua Technology",
    model: "M32046P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32046P 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32046p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32048p",
    manufacturer: "Dahua Technology",
    model: "M32048P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32048P 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32048p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32166p",
    manufacturer: "Dahua Technology",
    model: "M32166P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32166P 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32166p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr4116hs-i1",
    manufacturer: "Dahua Technology",
    model: "XVR4116HS-I1",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR4116HS-I 16 Channel Penta-brid 720P Compact 1U 1HDD WizSense Digital Video Recor",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr4116hs-i1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108h-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5108H-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108H-I2 8 Channel Penta-brid 5M-N/1080P Mini 1U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108h-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7104-08e-4kl-x",
    manufacturer: "Dahua Technology",
    model: "XVR7104/08E-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7104/08E-4KL-X 4/8 Channel Penta-brid 4K Elegant 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7104-08e-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104he-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5104HE-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HE-I3 4 Channel Penta-brid 5M-N/1080P Mini 1U 1HDD WizSense Digital Video Re",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104he-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7816s-4k-i2",
    manufacturer: "Dahua Technology",
    model: "XVR7816S-4K-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7816S-4K-I2 16 Channel Penta-brid 4K 2U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7816s-4k-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5832s-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5832S-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5832S-I2 32 Channel Penta-brid 5M-N/1080P 2U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5832s-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr8808-16s",
    manufacturer: "Dahua Technology",
    model: "XVR8808/16S",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR8808/16S 8/16 Channel Penta-brid 4MP 2U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr8808-16s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr7104he-4kl-x",
    manufacturer: "Dahua Technology",
    model: "XVR7104HE-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7104HE-4KL-X 4 Channel Penta-brid 4K Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7104he-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7216an-4k-i2",
    manufacturer: "Dahua Technology",
    model: "XVR7216AN-4K-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7216AN-4K-I2 16 Channel Penta-brid 4K 1U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7216an-4k-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m44168",
    manufacturer: "Dahua Technology",
    model: "M44168",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44168 16-channel 8 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44168-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m44163p",
    manufacturer: "Dahua Technology",
    model: "M44163P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44163P 16-channel 3 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44163p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-x54a5l",
    manufacturer: "Dahua Technology",
    model: "X54A5L",
    category: "nvr-recorder",
    tagline: "Dahua Technology X54A5L 1080p H.265 32 CH 1.5U Penta-brid",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-x54a5l-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5208a-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5208A-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5208A-4KL-I2 8 Channel Penta-brid 4K-N/5MP 1U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5208a-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108c-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5108C-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108C-I3 8 Channel Penta-brid 5M-N/1080P Smart 1U 1HDD WizSense Digital Video Re",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108c-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5208an-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5208AN-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5208AN-4KL-I2 8 Channel Penta-brid 4K-N/5MP 1U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5208an-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m44162",
    manufacturer: "Dahua Technology",
    model: "M44162",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44162 16-channel 2 TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44162-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m44163",
    manufacturer: "Dahua Technology",
    model: "M44163",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44163 16-channel 3 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44163-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m44164",
    manufacturer: "Dahua Technology",
    model: "M44164",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44164 16-channel 4 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44164-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m441612",
    manufacturer: "Dahua Technology",
    model: "M441612",
    category: "nvr-recorder",
    tagline: "Dahua Technology M441612 16-channel 12 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m441612-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7808s-4k-i2",
    manufacturer: "Dahua Technology",
    model: "XVR7808S-4K-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7808S-4K-I2 8 Channel Penta-brid 4K 2U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7808s-4k-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5432l-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5432L-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5432L-4KL-I2 32 Channel Penta-brid 4K-N/5MP 1.5U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5432l-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-m44164p",
    manufacturer: "Dahua Technology",
    model: "M44164P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44164P 16-channel 4 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44164p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m441612p",
    manufacturer: "Dahua Technology",
    model: "M441612P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M441612P 16-channel 12 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m441612p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m44168p",
    manufacturer: "Dahua Technology",
    model: "M44168P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44168P 16-channel 8 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44168p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m441616p",
    manufacturer: "Dahua Technology",
    model: "M441616P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M441616P 16-channel 16 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m441616p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m44166p",
    manufacturer: "Dahua Technology",
    model: "M44166P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44166P 16-channel 6 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44166p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m44162p",
    manufacturer: "Dahua Technology",
    model: "M44162P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44162P 16-channel 2 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44162p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m441616",
    manufacturer: "Dahua Technology",
    model: "M441616",
    category: "nvr-recorder",
    tagline: "Dahua Technology M441616 16-channel 16 TB megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m441616-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32160",
    manufacturer: "Dahua Technology",
    model: "M32160",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32160 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32160-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7816s-4kl-x",
    manufacturer: "Dahua Technology",
    model: "XVR7816S-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7816S-4KL-X 16 Channel Penta-brid 4K 2U Digital Video RecorderSeriesPro",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7816s-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5116he-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5116HE-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116HE-4KL-I2 16 Channel Penta-brid 4K-N/5MP Mini 1U WizSense Digital Video Reco",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116he-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104he-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5104HE-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HE-4KL-I2 4 Channel Penta-brid 4K-N/5MP Mini 1U WizSense Digital Video Recor",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104he-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7416l-4k-i2",
    manufacturer: "Dahua Technology",
    model: "XVR7416L-4K-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7416L-4K-I2 16 Channel Penta-brid 4K 1.5U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7416l-4k-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5816s-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5816S-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5816S-I2 16 Channel Penta-brid 5M-N/1080P 2U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5816s-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5416l-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5416L-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5416L-4KL-I2 16 Channel Penta-brid 4K-N/5MP 1.5U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5416l-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5432l-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5432L-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5432L-I2 32 Channel Penta-brid 5M-N/1080P 1.5U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5432l-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5416l-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5416L-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5416L-I2 16 Channel Penta-brid 5M-N/1080P 1.5U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5416l-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr7208-16a-4kl-x",
    manufacturer: "Dahua Technology",
    model: "XVR7208/16A-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7208/16A-4KL-X 8/16 Channel Penta-brid 4K 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7208-16a-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108h-4kl-x-8p",
    manufacturer: "Dahua Technology",
    model: "XVR5108H-4KL-X-8P",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108H-4KL-X-8P 8 Channel Penta-brid 4K Mini 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108h-4kl-x-8p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5116he-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5116HE-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5116HE-I2 16 Channel Penta-brid 5M-N/1080P Mini 1U WizSense Digital Video Record",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5116he-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5232an-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5232AN-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5232AN-4KL-I2 32 Channel Penta-brid 4K-N/5MP 1U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5232an-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m32080p",
    manufacturer: "Dahua Technology",
    model: "M32080P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32080P 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32080p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3104e2",
    manufacturer: "Dahua Technology",
    model: "M3104E2",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3104E2 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3104e2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-hcvr8408-16l-s3",
    manufacturer: "Dahua Technology",
    model: "HCVR8408/16L-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology HCVR8408/16L-S3 8/16 Channel 1080P 1.5U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-hcvr8408-16l-s3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32160p",
    manufacturer: "Dahua Technology",
    model: "M32160P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32160P 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32160p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32040",
    manufacturer: "Dahua Technology",
    model: "M32040",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32040 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32040-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m32040p",
    manufacturer: "Dahua Technology",
    model: "M32040P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32040P 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32040p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr5104c-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5104C-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104C-I3 4 Channel Penta-brid 5M-N/1080P Smart 1U 1HDD WizSense Digital Video Re",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104c-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m32080",
    manufacturer: "Dahua Technology",
    model: "M32080",
    category: "nvr-recorder",
    tagline: "Dahua Technology M32080 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m32080-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42042",
    manufacturer: "Dahua Technology",
    model: "M42042",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42042 4 channel megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42042-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr5216an-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5216AN-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216AN-I2 16 Channel Penta-brid 5M-N/1080P 1U 2HDDs WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216an-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7408l-4k-i2",
    manufacturer: "Dahua Technology",
    model: "XVR7408L-4K-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7408L-4K-I2 8 Channel Penta-brid 4K 1.5U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7408l-4k-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5832s-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5832S-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5832S-4KL-I2 32 Channel Penta-brid 4K-N/5MP 2U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5832s-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-m42048",
    manufacturer: "Dahua Technology",
    model: "M42048",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42048 4 channel megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42048-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42048p",
    manufacturer: "Dahua Technology",
    model: "M42048P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42048P 4 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42048p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7416l-4kl-x",
    manufacturer: "Dahua Technology",
    model: "XVR7416L-4KL-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7416L-4KL-X 16 Channel Penta-brid 4K 1.5U Digital Video RecorderSeriesPro",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7416l-4kl-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5108he-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5108HE-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HE-4KL-I2 8 Channel Penta-brid 4K-N/5MP Mini 1U WizSense Digital Video Recor",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108he-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108he-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5108HE-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HE-I2 8 Channel Penta-brid 5M-N/1080P Mini 1U WizSense Digital Video Recorde",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108he-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5808s-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5808S-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5808S-I2 8 Channel Penta-brid 5M-N/1080P 2U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5808s-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-x52a3a-x52a3n",
    manufacturer: "Dahua Technology",
    model: "X52A3A/X52A3N",
    category: "nvr-recorder",
    tagline: "Dahua Technology X52A3A/X52A3N 1080p H.265 16+8 CH 1U Penta-brid",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-x52a3a-x52a3n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-hcvr8808-16s-urh-s3",
    manufacturer: "Dahua Technology",
    model: "HCVR8808/16S-URH-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology HCVR8808/16S-URH-S3 8/16 Channel Quadri-brid 1080P-Ultra 2U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-hcvr8808-16s-urh-s3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5216an-x-16p",
    manufacturer: "Dahua Technology",
    model: "XVR5216AN-X-16P",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216AN-X-16P 16 Channel Penta-brid 1080P Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216an-x-16p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr4216an-i",
    manufacturer: "Dahua Technology",
    model: "XVR4216AN-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR4216AN-I 16 Channel Penta-brid 720P 1U 2HDDs WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr4216an-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m42088p",
    manufacturer: "Dahua Technology",
    model: "M42088P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42088P 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42088p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7108he-4k-i2",
    manufacturer: "Dahua Technology",
    model: "XVR7108HE-4K-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7108HE-4K-I2 8 Channel Penta-brid 4K Mini 1U 1HDD WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7108he-4k-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104he-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5104HE-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HE-I2 4 Channel Penta-brid 5M-N/1080P Mini 1U WizSense Digital Video Recorde",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104he-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7104he-4k-i3",
    manufacturer: "Dahua Technology",
    model: "XVR7104HE-4K-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7104HE-4K-I3 4CH Penta-brid 4K Mini 1U 1HDD WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7104he-4k-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr4116hs-i",
    manufacturer: "Dahua Technology",
    model: "XVR4116HS-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR4116HS-I 16 Channel Penta-brid 720p Compact 1U 1HDD WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr4116hs-i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m42086",
    manufacturer: "Dahua Technology",
    model: "M42086",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42086 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42086-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr5232an-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5232AN-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5232AN-I2 32 Channel Penta-brid 5M-N/1080P 1U 2HDDs WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5232an-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m3108e0p",
    manufacturer: "Dahua Technology",
    model: "M3108E0P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3108E0P 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3108e0p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3116e2p",
    manufacturer: "Dahua Technology",
    model: "M3116E2P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3116E2P 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3116e2p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3108e1",
    manufacturer: "Dahua Technology",
    model: "M3108E1",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3108E1 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3108e1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3104e2p",
    manufacturer: "Dahua Technology",
    model: "M3104E2P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3104E2P 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3104e2p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7816s-4k-i3",
    manufacturer: "Dahua Technology",
    model: "XVR7816S-4K-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7816S-4K-I3 16CH Penta-brid 4K 2U 8HDDs WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7816s-4k-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-hcvr8208-16a-s3",
    manufacturer: "Dahua Technology",
    model: "HCVR8208/16A-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology HCVR8208/16A-S3 8/16 Channel 1080P 1U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-hcvr8208-16a-s3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m42041",
    manufacturer: "Dahua Technology",
    model: "M42041",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42041 4 channel megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42041-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42082",
    manufacturer: "Dahua Technology",
    model: "M42082",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42082 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42082-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42084",
    manufacturer: "Dahua Technology",
    model: "M42084",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42084 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42084-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42088",
    manufacturer: "Dahua Technology",
    model: "M42088",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42088 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42088-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42084p",
    manufacturer: "Dahua Technology",
    model: "M42084P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42084P 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42084p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7108he-4k-i3",
    manufacturer: "Dahua Technology",
    model: "XVR7108HE-4K-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7108HE-4K-I3 8CH Penta-brid 4K Mini 1U 1HDD WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7108he-4k-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104c-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5104C-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104C-4KL-I3 4 Channel Penta-brid 4K-N/5MP Smart 1U 1HDD WizSense Digital Video ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104c-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7416l-4k-i3",
    manufacturer: "Dahua Technology",
    model: "XVR7416L-4K-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7416L-4K-I3 16CH Penta-brid 4K 1.5U 4HDDs WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7416l-4k-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr5104h-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5104H-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104H-I2 4 Channel Penta-brid 5M-N/1080P Mini 1U WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104h-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104h-4kl-i3i",
    manufacturer: "Dahua Technology",
    model: "XVR5104H-4KL-I3i",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104H-4KL-I3 4 Channel Penta-brid 4K-N/5MP Mini 1U 1HDD WizSense Digital Video R",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104h-4kl-i3i-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m42081",
    manufacturer: "Dahua Technology",
    model: "M42081",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42081 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42081-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42044",
    manufacturer: "Dahua Technology",
    model: "M42044",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42044 4 channel megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42044-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42042p",
    manufacturer: "Dahua Technology",
    model: "M42042P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42042P 4 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42042p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42043p",
    manufacturer: "Dahua Technology",
    model: "M42043P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42043P 4 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42043p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42046p",
    manufacturer: "Dahua Technology",
    model: "M42046P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42046P 4 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42046p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42082p",
    manufacturer: "Dahua Technology",
    model: "M42082P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42082P 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42082p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42083p",
    manufacturer: "Dahua Technology",
    model: "M42083P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42083P 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42083p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42044p",
    manufacturer: "Dahua Technology",
    model: "M42044P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42044P 4 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42044p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42086p",
    manufacturer: "Dahua Technology",
    model: "M42086P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42086P 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42086p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3108e2",
    manufacturer: "Dahua Technology",
    model: "M3108E2",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3108E2 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3108e2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr5104hs-i31",
    manufacturer: "Dahua Technology",
    model: "XVR5104HS-I31",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HS-I3 4 Channel Penta-brid 5M-N/1080P Compact 1U 1HDD WizSense Digital Video",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104hs-i31-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-mcvr5104",
    manufacturer: "Dahua Technology",
    model: "DHI-MCVR5104",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-MCVR5104 four-channel Mobile HDCVI DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-mcvr5104-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-dahua-technology-hcvr8808-16s-s3",
    manufacturer: "Dahua Technology",
    model: "HCVR8808/16S-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology HCVR8808/16S-S3 8/16 Channel 1080P 2U Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-hcvr8808-16s-s3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-d33322t",
    manufacturer: "Dahua Technology",
    model: "D33322T",
    category: "nvr-recorder",
    tagline: "Dahua Technology D33322T 32 channel 960H digital video surveillance recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-d33322t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3104e1",
    manufacturer: "Dahua Technology",
    model: "M3104E1",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3104E1 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3104e1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3116e2",
    manufacturer: "Dahua Technology",
    model: "M3116E2",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3116E2 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3116e2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr5104h-4kl-i2",
    manufacturer: "Dahua Technology",
    model: "XVR5104H-4KL-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104H-4KL-I2 4 Channel Penta-brid 4K-N/5MP Mini 1U WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104h-4kl-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7208a-4k-i3",
    manufacturer: "Dahua Technology",
    model: "XVR7208A-4K-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7208A-4K-I3 8CH Penta-brid 4K 1U 2HDDs WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7208a-4k-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m3104e1a4-p",
    manufacturer: "Dahua Technology",
    model: "M3104E1A4/P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3104E1A4/P 4 cameras, 4 channels, 1TB HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3104e1a4-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3104e2c4-p",
    manufacturer: "Dahua Technology",
    model: "M3104E2C4/P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3104E2C4/P megapixel over coax security systems with zero latency",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3104e2c4-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7104h-4k-i3",
    manufacturer: "Dahua Technology",
    model: "XVR7104H-4K-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7104H-4K-I3 4CH Penta-brid 4K Mini 1U 1HDD WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7104h-4k-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5808-16s-x",
    manufacturer: "Dahua Technology",
    model: "XVR5808/16S-X",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5808/16S-X 8/16 Channel Penta-brid 1080P 2U DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5808-16s-x-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr7208a-4k-i2",
    manufacturer: "Dahua Technology",
    model: "XVR7208A-4K-I2",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7208A-4K-I2 8 Channel Penta-brid 4K 1U 2HDDs WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7208a-4k-i2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-m44160p",
    manufacturer: "Dahua Technology",
    model: "M44160P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44160P 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44160p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3104e0",
    manufacturer: "Dahua Technology",
    model: "M3104E0",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3104E0 4-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3104e0-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3108e0",
    manufacturer: "Dahua Technology",
    model: "M3108E0",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3108E0 8-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3108e0-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3116e0p",
    manufacturer: "Dahua Technology",
    model: "M3116E0P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3116E0P 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3116e0p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3104e0p",
    manufacturer: "Dahua Technology",
    model: "M3104E0P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3104E0P 4-channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3104e0p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42040",
    manufacturer: "Dahua Technology",
    model: "M42040",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42040 4 channel megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42040-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m316e3c12",
    manufacturer: "Dahua Technology",
    model: "M316E3C12",
    category: "nvr-recorder",
    tagline: "Dahua Technology M316E3C12 12 cameras, 16 channels, 3TB HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m316e3c12-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42080",
    manufacturer: "Dahua Technology",
    model: "M42080",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42080 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42080-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m42080p",
    manufacturer: "Dahua Technology",
    model: "M42080P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42080P 8 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42080p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-dhi-mcvr6208-g",
    manufacturer: "Dahua Technology",
    model: "DHI-MCVR6208-G",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-MCVR6208-G eight-channel Mobile HDCVI DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-mcvr6208-g-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m44160",
    manufacturer: "Dahua Technology",
    model: "M44160",
    category: "nvr-recorder",
    tagline: "Dahua Technology M44160 megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m44160-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3108e2p",
    manufacturer: "Dahua Technology",
    model: "M3108E2P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3108E2P 8ch, 2TB HDD megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3108e2p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m3116e0",
    manufacturer: "Dahua Technology",
    model: "M3116E0",
    category: "nvr-recorder",
    tagline: "Dahua Technology M3116E0 16-channel megapixel over coax digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m3116e0-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-dhi-mxvr1004",
    manufacturer: "Dahua Technology",
    model: "DHI-MXVR1004",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-MXVR1004 4 Channels H.265 Penta-brid 2 SD Mobile Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-mxvr1004-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-dahua-technology-xvr7408l-4k-i3",
    manufacturer: "Dahua Technology",
    model: "XVR7408L-4K-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7408L-4K-I3 8CH Penta-brid 4K 1.5U 4HDDs WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7408l-4k-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-m42040p",
    manufacturer: "Dahua Technology",
    model: "M42040P",
    category: "nvr-recorder",
    tagline: "Dahua Technology M42040P 4 channel MPX megapixel over coax DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m42040p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-m31041c4",
    manufacturer: "Dahua Technology",
    model: "M31041C4",
    category: "nvr-recorder",
    tagline: "Dahua Technology M31041C4 megapixel over coax security systems with multisite viewing",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-m31041c4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dahua-technology-xvr7216an-4k-i3",
    manufacturer: "Dahua Technology",
    model: "XVR7216AN-4K-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7216AN-4K-I3 16CH Penta-brid 4K 1U 2HDDs WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7216an-4k-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5216a-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5216A-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216A-4KL-I3/T 16CH Penta-brid 4K Value/5MP 1U 2HDDs WizSense Digital Video Reco",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216a-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7808s-4k-i3",
    manufacturer: "Dahua Technology",
    model: "XVR7808S-4K-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7808S-4K-I3 8CH Penta-brid 4K 2U 8HDDs WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7808s-4k-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5108he-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5108HE-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HE-4KL-I3/T 8CH Penta-brid 4K Value/5MP Mini 1U 1HDD WizSense Digital Video ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108he-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr7108h-4k-i3",
    manufacturer: "Dahua Technology",
    model: "XVR7108H-4K-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR7108H-4K-I3 8CH Penta-brid 4K Mini 1U 1HDD WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr7108h-4k-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5216an-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5216AN-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216AN-4KL-I3/T 16CH Penta-brid 4K Value/5MP 1U 2HDDs WizSense Digital Video Rec",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216an-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5232an-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5232AN-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5232AN-4KL-I3 32CH Penta-brid 4K Value/5MP 1U 2HDDs WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5232an-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5232an-5m-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5232AN-5M-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5232AN-5M-I3/T 32CH Penta-brid 5MP 1U 2HDDs WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5232an-5m-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104hs-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5104HS-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HS-4KL-I3/T 4CH Penta-brid 4K Value/5MP Compact 1U 1HDD WizSense Digital Vid",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104hs-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5816s-4kl-i3",
    manufacturer: "Dahua Technology",
    model: "XVR5816S-4KL-I3",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5816S-4KL-I3 16CH Penta-brid 4K Value/5MP 2U 8HDDs WizSense Digital Video Record",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5816s-4kl-i3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5816s-4kl-i3-lp",
    manufacturer: "Dahua Technology",
    model: "XVR5816S-4KL-I3-LP",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5816S-4KL-I3-LP 16CH Penta-brid 4K Value/5MP Mini 2U 8HDDs WizSense Digital Vide",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5816s-4kl-i3-lp-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-xvr5108h-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5108H-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108H-4KL-I3/T 8CH Penta-brid 4K Value/5MP Mini 1U 1HDD WizSense Digital Video R",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108h-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104he-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5104HE-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HE-4KL-I3/T 4CH Penta-brid 4K Value/5MP Mini 1U 1HDD WizSense Digital Video ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104he-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5208a-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5208A-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5208A-4KL-I3/T 8CH Penta-brid 4K Value/5MP 1U 2HDDs WizSense DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5208a-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104c-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5104C-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104C-4KL-I3/T 4CH Penta-brid 4K Value/5MP Smart 1U 1HDD WizSense Digital Video ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104c-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5108hs-4kl-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5108HS-4KL-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5108HS-4KL-I3/T 8CH Penta-brid 4K Value/5MP Compact 1U 1HDD WizSense Digital Vid",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5108hs-4kl-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5104hs-5m-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5104HS-5M-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5104HS-5M-I3/T 4CH Penta-brid 5MP Compact 1U 1HDD WizSense Digital Video Recorde",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5104hs-5m-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-xvr5216an-5m-i3-t",
    manufacturer: "Dahua Technology",
    model: "XVR5216AN-5M-I3/T",
    category: "nvr-recorder",
    tagline: "Dahua Technology XVR5216AN-5M-I3/T 16CH Penta-brid 5MP 1U 2HDDs WizSense Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-xvr5216an-5m-i3-t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-network-digital-video-recorder",
    manufacturer: "Dahua Technology",
    model: "Network Digital Video Recorder",
    category: "nvr-recorder",
    tagline: "Dahua Technology Network Digital Video Recorder with web interface for system administration",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-network-digital-video-recorder-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-advanced-pos-interface-module",
    manufacturer: "Dedicated Micros",
    model: "Advanced POS Interface Module",
    category: "nvr-recorder",
    tagline: "Dedicated Micros Advanced POS Interface Module for targeting, detecting and reducing theft",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-advanced-pos-interface-module-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-legacy-interface-module",
    manufacturer: "Dedicated Micros",
    model: "Legacy Interface Module",
    category: "nvr-recorder",
    tagline: "Dedicated Micros Legacy Interface Module for CCTV end-users",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-legacy-interface-module-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-atm-interface-module",
    manufacturer: "Dedicated Micros",
    model: "ATM Interface Module",
    category: "nvr-recorder",
    tagline: "Dedicated Micros ATM Interface Module for integration between ATMs and DVRs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-atm-interface-module-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-transvu-status-module",
    manufacturer: "Dedicated Micros",
    model: "TransVu Status Module",
    category: "nvr-recorder",
    tagline: "Dedicated Micros TransVu Status Module accessory for TransVu digital recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-transvu-status-module-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-c101-16-ram",
    manufacturer: "Dedicated Micros",
    model: "C101/16 (RAM)",
    category: "nvr-recorder",
    tagline: "Dedicated Micros C101/16 (RAM) 16 alarm input",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-c101-16-ram-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-cacdy600gb",
    manufacturer: "Dedicated Micros",
    model: "CACDY600GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros CACDY600GB 600 GB caddies",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-cacdy600gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-transvu-media",
    manufacturer: "Dedicated Micros",
    model: "TransVu Media",
    category: "nvr-recorder",
    tagline: "Dedicated Micros TransVu Media mobile digital recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-transvu-media-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-transvu-express",
    manufacturer: "Dedicated Micros",
    model: "TransVu Express",
    category: "nvr-recorder",
    tagline: "Dedicated Micros TransVu Express mobile video recorder and server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-transvu-express-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["MJPEG"]},
  },
  {
    id: "ss-dedicated-micros-eco4-cd-160gb",
    manufacturer: "Dedicated Micros",
    model: "ECO4 CD-160GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros ECO4 CD-160GB 4 camera DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-eco4-cd-160gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-sdav16max",
    manufacturer: "Dedicated Micros",
    model: "SDAV16MAX",
    category: "nvr-recorder",
    tagline: "Dedicated Micros introduces the Closed IPTV SD Advanced model",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-sdav16max-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-ecs2-2t0-16",
    manufacturer: "Dedicated Micros",
    model: "DM/ECS2/2T0/16",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/ECS2/2T0/16 16 channel 2TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ecs2-2t0-16-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-sdexc16ma",
    manufacturer: "Dedicated Micros",
    model: "DM/SDEXC16MA",
    category: "nvr-recorder",
    tagline: "Dedicated Micros SD Excel a premium enterprise, hybrid DVR/NVR with Closed IPTV capability",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdexc16ma-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-ecs2-1t0-08",
    manufacturer: "Dedicated Micros",
    model: "DM/ECS2/1T0/08",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/ECS2/1T0/08 entry level DVR with 200 IPS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ecs2-1t0-08-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-eco4-500",
    manufacturer: "Dedicated Micros",
    model: "DM/ECO4/500",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/ECO4/500 4-channel 500GB DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-eco4-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-sdacp16min",
    manufacturer: "Dedicated Micros",
    model: "DM/SDACP16MIN",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SDACP16MIN digital video recorder with high performance embedded network video r",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdacp16min-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-dvpe-08x30",
    manufacturer: "Dedicated Micros",
    model: "DM/DVPE/08X30",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DVPE/08X30 8 channel real time DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-dvpe-08x30-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["MJPEG"]},
  },
  {
    id: "ss-dedicated-micros-dm-dvip-nv8-max",
    manufacturer: "Dedicated Micros",
    model: "DM/DVIP/NV8/MAX",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DVIP/NV8/MAX 32-channel, 6TB DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-dvip-nv8-max-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-sdacp32min",
    manufacturer: "Dedicated Micros",
    model: "DM/SDACP32MIN",
    category: "nvr-recorder",
    tagline: "SD Advanced with Closed IPTV from Dedicated Micros",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdacp32min-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-sdav32max",
    manufacturer: "Dedicated Micros",
    model: "SDAV32MAX",
    category: "nvr-recorder",
    tagline: "Dedicated Micros SDAV32MAX 32-channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-sdav32max-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-eco4-cd-80gb",
    manufacturer: "Dedicated Micros",
    model: "ECO4 CD-80GB",
    category: "nvr-recorder",
    tagline: "CD recording for DM's entry-level DVR range",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-eco4-cd-80gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-ds2pd500-16",
    manufacturer: "Dedicated Micros",
    model: "DM/DS2PD500/16",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DS2PD500/16 16-channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ds2pd500-16-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-sdav32min",
    manufacturer: "Dedicated Micros",
    model: "DM/SDAV32MIN",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SDAV32MIN 32 channel hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdav32min-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-transvu-2",
    manufacturer: "Dedicated Micros",
    model: "TransVu 2",
    category: "nvr-recorder",
    tagline: "Dedicated Micros TransVu 2 digital recorder for vehicle surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-transvu-2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-ecs1-1t0-16",
    manufacturer: "Dedicated Micros",
    model: "DM/ECS1/1T0/16",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/ECS1/1T0/16 16 channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ecs1-1t0-16-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-transvu",
    manufacturer: "Dedicated Micros",
    model: "TransVu",
    category: "nvr-recorder",
    tagline: "Dedicated Micros TransVu mobile DVR for transport sector",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-transvu-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-sdacp32max",
    manufacturer: "Dedicated Micros",
    model: "DM/SDACP32MAX",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SDACP32MAX digital video recorder with multimode recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdacp32max-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-eco16-cd-300gb",
    manufacturer: "Dedicated Micros",
    model: "ECO16 CD-300GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros ECO16 CD-300GB 16-camera digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-eco16-cd-300gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-sdav32max",
    manufacturer: "Dedicated Micros",
    model: "DM/SDAV32MAX",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SDAV32MAX 32 channel hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdav32max-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-sdacp08min",
    manufacturer: "Dedicated Micros",
    model: "DM/SDACP08MIN",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SDACP08MIN digital video recorders with multiple channels of IP and analogue vid",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdacp08min-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-eco4-cd-300gb",
    manufacturer: "Dedicated Micros",
    model: "ECO4 CD-300GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros ECO4 CD-300GB 4 camera dvr with 300GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-eco4-cd-300gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dv-ip-atm-advance",
    manufacturer: "Dedicated Micros",
    model: "DV-IP ATM ADVANCE",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DV-IP ATM ADVANCE 4 channel hybrid DVR/NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dv-ip-atm-advance-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-sdacp16max",
    manufacturer: "Dedicated Micros",
    model: "DM/SDACP16MAX",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SDACP16MAX digital video recorder with HD IP camera recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdacp16max-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-dvip-nv4-max",
    manufacturer: "Dedicated Micros",
    model: "DM/DVIP/NV4/MAX",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DVIP/NV4/MAX 32-channel Enterprise Class DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-dvip-nv4-max-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-sdav16min",
    manufacturer: "Dedicated Micros",
    model: "SDAV16MIN",
    category: "nvr-recorder",
    tagline: "Dedicated Micros SDAV16MIN digital video recorders",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-sdav16min-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-sdav16max",
    manufacturer: "Dedicated Micros",
    model: "DM/SDAV16MAX",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SDAV16MAX 16 channel hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdav16max-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dv-ip-nv8",
    manufacturer: "Dedicated Micros",
    model: "DV-IP NV8",
    category: "nvr-recorder",
    tagline: "Dedicated Micros adds the DV-IP NV8 to its flagship DV-IP product range",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dv-ip-nv8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-sd16med",
    manufacturer: "Dedicated Micros",
    model: "DM/SD16MED",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SD16MED 16 channel DVR with 1TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sd16med-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-ds2pd500-06",
    manufacturer: "Dedicated Micros",
    model: "DM/DS2PD500/06",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DS2PD500/06 500GB DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ds2pd500-06-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":6,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-sdav08min",
    manufacturer: "Dedicated Micros",
    model: "DM/SDAV08MIN",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SDAV08MIN 8 channel hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdav08min-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-ds2pd500-09",
    manufacturer: "Dedicated Micros",
    model: "DM/DS2PD500/09",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DS2PD500/09 9-channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ds2pd500-09-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":9,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-sd08min",
    manufacturer: "Dedicated Micros",
    model: "DM/SD08MIN",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SD08MIN digital video recorders with front panel control",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sd08min-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-ds2pd250-16",
    manufacturer: "Dedicated Micros",
    model: "DM/DS2PD250/16",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DS2PD250/16 16-channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ds2pd250-16-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-ds2pd250-09",
    manufacturer: "Dedicated Micros",
    model: "DM/DS2PD250/09",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DS2PD250/09 9-channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ds2pd250-09-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":9,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-ds2pd750-06",
    manufacturer: "Dedicated Micros",
    model: "DM/DS2PD750/06",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DS2PD750/06 6-channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ds2pd750-06-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":6,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-ds2pd250-06",
    manufacturer: "Dedicated Micros",
    model: "DM/DS2PD250/06",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DS2PD250/06 6-channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ds2pd250-06-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":6,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-sdexc16max",
    manufacturer: "Dedicated Micros",
    model: "DM/SDEXC16MAX",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SDEXC16MAX digital video recorders with 4TB local storage and expanable using MS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdexc16max-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-eco4-cd-320gb",
    manufacturer: "Dedicated Micros",
    model: "ECO4 CD-320GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros ECO4 CD-320GB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-eco4-cd-320gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-sd16min",
    manufacturer: "Dedicated Micros",
    model: "DM-SD16MIN",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM-SD16MIN digital video recorders with front panel control",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sd16min-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-ds2p16dvd-250gb",
    manufacturer: "Dedicated Micros",
    model: "DS2P16DVD-250GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DS2P16DVD-250GB 16 channel DVR with 250GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-ds2p16dvd-250gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-eco16-cd-500gb",
    manufacturer: "Dedicated Micros",
    model: "ECO16 CD-500GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros ECO16 CD-500GB 16 camera DVR with 500GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-eco16-cd-500gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-sdav32min",
    manufacturer: "Dedicated Micros",
    model: "SDAV32MIN",
    category: "nvr-recorder",
    tagline: "Dedicated Micros SDAV32MIN digital video recorders with 32 camera connections",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-sdav32min-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-sd08med",
    manufacturer: "Dedicated Micros",
    model: "DM/SD08MED",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SD08MED DVR with 1 TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sd08med-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-ds2p16dvd-1tb",
    manufacturer: "Dedicated Micros",
    model: "DS2P16DVD-1TB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DS2P16DVD-1TB 16 channel DVR with 1TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-ds2p16dvd-1tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-ds2p16dvd-750gb",
    manufacturer: "Dedicated Micros",
    model: "DS2P16DVD-750GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DS2P16DVD-750GB 16 channel DVR with 750GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-ds2p16dvd-750gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-ds2p9dvd-250gb",
    manufacturer: "Dedicated Micros",
    model: "DS2P9DVD-250GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DS2P9DVD-250GB 9 channel DVR with 250GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-ds2p9dvd-250gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":9,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-ds2p9dvd-750gb",
    manufacturer: "Dedicated Micros",
    model: "DS2P9DVD-750GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DS2P9DVD-750GB 9 channel DVR with 750GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-ds2p9dvd-750gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":9,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-ds2p16dvd-1-5tb",
    manufacturer: "Dedicated Micros",
    model: "DS2P16DVD-1.5TB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DS2P16DVD-1.5TB 16 channel DVR with 1.5TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-ds2p16dvd-1-5tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-ds2p16dvd-500gb",
    manufacturer: "Dedicated Micros",
    model: "DS2P16DVD-500GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DS2P16DVD-500GB 16 channel DVR with 500GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-ds2p16dvd-500gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-ds2p9dvd-500gb",
    manufacturer: "Dedicated Micros",
    model: "DS2P9DVD-500GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DS2P9DVD-500GB 9 channel DVR with 500GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-ds2p9dvd-500gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":9,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-sdex16max",
    manufacturer: "Dedicated Micros",
    model: "DM/SDEX16MAX",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/SDEX16MAX 16 channel hybrid DVR/NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-sdex16max-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-ds2p6dvd-250gb",
    manufacturer: "Dedicated Micros",
    model: "DS2P6DVD-250GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DS2P6DVD-250GB 6 channel DVR with 250GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-ds2p6dvd-250gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":6,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-ds2p6dvd-500gb",
    manufacturer: "Dedicated Micros",
    model: "DS2P6DVD-500GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DS2P6DVD-500GB 6 channel DVR with 500GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-ds2p6dvd-500gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":6,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-ds2p6dvd-750gb",
    manufacturer: "Dedicated Micros",
    model: "DS2P6DVD-750GB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DS2P6DVD-750GB 6 channel DVR with 750GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-ds2p6dvd-750gb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":6,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dv-ip-nv4",
    manufacturer: "Dedicated Micros",
    model: "DV-IP NV4",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DV-IP NV4 Enterprise class NVR/DVR with 32 channels and 6 TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dv-ip-nv4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-jbod-1t",
    manufacturer: "Dedicated Micros",
    model: "DM/JBOD/1T",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/JBOD/1T additional high capacity SCSI hard disk",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-jbod-1t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1,"raidLevels":["JBOD"]},
  },
  {
    id: "ss-dedicated-micros-dm-ds2pd750-09",
    manufacturer: "Dedicated Micros",
    model: "DM/DS2PD750/09",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DS2PD750/09 9-channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ds2pd750-09-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":9,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-ds2pd750-16",
    manufacturer: "Dedicated Micros",
    model: "DM/DS2PD750/16",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/DS2PD750/16 16 channel CCTV security solution",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-ds2pd750-16-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-dedicated-micros-dm-eco4-usb",
    manufacturer: "Dedicated Micros",
    model: "DM/ECO4/USB",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/ECO4/USB analogue 4 channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-eco4-usb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dedicated-micros-dm-raid5-r8-4t0",
    manufacturer: "Dedicated Micros",
    model: "DM/RAID5/R8/4T0",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/RAID5/R8/4T0 digital video recorder with ability to recover data",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-raid5-r8-4t0-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1,"raidLevels":["5"]},
  },
  {
    id: "ss-dedicated-micros-dm-raid5-r8-2t4",
    manufacturer: "Dedicated Micros",
    model: "DM/RAID5/R8/2T4",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/RAID5/R8/2T4 digital video recorder with increased storage capacity",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-raid5-r8-2t4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1,"raidLevels":["5"]},
  },
  {
    id: "ss-dedicated-micros-dm-raid5-r8-6t0",
    manufacturer: "Dedicated Micros",
    model: "DM/RAID5/R8/6T0",
    category: "nvr-recorder",
    tagline: "Dedicated Micros DM/RAID5/R8/6T0 digital video recorder with dual hot swap power supplies",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dedicated-micros-dm-raid5-r8-6t0-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1,"raidLevels":["5"]},
  },
  {
    id: "ss-mobileview-mvh-1002-01-00",
    manufacturer: "MobileView",
    model: "MVH-1002-01-00",
    category: "nvr-recorder",
    tagline: "MobileView MVH-1002-01-00 flex drive caddy",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-1002-01-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvq-7100-00-03",
    manufacturer: "MobileView",
    model: "MVQ-7100-00-03",
    category: "nvr-recorder",
    tagline: "MobileView MVQ-7100-00-03 MobileView PENTA 3 Axis-Accelerometer, 6 ft. Serial Cable",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvq-7100-00-03-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-usb-08-rd",
    manufacturer: "MobileView",
    model: "MVP-USB-08-RD",
    category: "nvr-recorder",
    tagline: "MobileView MVP-USB-08-RD PENTA Factory Restore USB Image Drive",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-usb-08-rd-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mss-4030-zz-01",
    manufacturer: "MobileView",
    model: "MSS-4030-zz-01",
    category: "nvr-recorder",
    tagline: "MobileView MSS-4030-zz-01 camera video cable",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mss-4030-zz-01-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-4037-08-j4",
    manufacturer: "MobileView",
    model: "MVP-4037-08-J4",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4037-08-J4 PENTA J4 Camera Power Harness (8 CH)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4037-08-j4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4037-j5-00",
    manufacturer: "MobileView",
    model: "MVH-4037-J5-00",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4037-J5-00 relay output harness",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4037-j5-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4002a300",
    manufacturer: "MobileView",
    model: "MVH-4002A300",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4002A300 rear panel shield",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4002a300-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4037-j2-00e",
    manufacturer: "MobileView",
    model: "MVH-4037-J2-00E",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4037-J2-00E audio, status, accel., J6-12E harness",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4037-j2-00e-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-1002-08-00",
    manufacturer: "MobileView",
    model: "MVP-1002-08-00",
    category: "nvr-recorder",
    tagline: "MobileView MVP-1002-08-00 1TB HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-1002-08-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mss-5014-00-00",
    manufacturer: "MobileView",
    model: "MSS-5014-00-00",
    category: "nvr-recorder",
    tagline: "MobileView MSS-5014-00-00 Ethernet Cat5 cable",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mss-5014-00-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4037-j6-08a",
    manufacturer: "MobileView",
    model: "MVH-4037-J6-08A",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4037-J6-08A power harness",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4037-j6-08a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-1002-08-ky",
    manufacturer: "MobileView",
    model: "MVP-1002-08-KY",
    category: "nvr-recorder",
    tagline: "MobileView MVP-1002-08-KY spare key",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-1002-08-ky-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-4004-08-00",
    manufacturer: "MobileView",
    model: "MVP-4004-08-00",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4004-08-00 docking station",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4004-08-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-4037-16-j6",
    manufacturer: "MobileView",
    model: "MVP-4037-16-J6",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4037-16-J6 PENTA J6 Video Input Harness Cable (16 CH)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4037-16-j6-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvq-4005-mp-00",
    manufacturer: "MobileView",
    model: "MVQ-4005-MP-00",
    category: "nvr-recorder",
    tagline: "MobileView MVQ-4005-MP-00 PENTA Maintenance Plug",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvq-4005-mp-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4004-00-00",
    manufacturer: "MobileView",
    model: "MVH-4004-00-00",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4004-00-00 docking station",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4004-00-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-1001-03-10",
    manufacturer: "MobileView",
    model: "MVH-1001-03-10",
    category: "nvr-recorder",
    tagline: "MobileView MVH-1001-03-10 1TB SATA HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-1001-03-10-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-1002-ky-00",
    manufacturer: "MobileView",
    model: "MVH-1002-KY-00",
    category: "nvr-recorder",
    tagline: "MobileView MVH-1002-KY-00 key set",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-1002-ky-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4037-j1-00",
    manufacturer: "MobileView",
    model: "MVH-4037-J1-00",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4037-J1-00 power harness",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4037-j1-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4037-j6-04a",
    manufacturer: "MobileView",
    model: "MVH-4037-J6-04A",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4037-J6-04A power harness",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4037-j6-04a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-7100-00-08",
    manufacturer: "MobileView",
    model: "MVH-7100-00-08",
    category: "nvr-recorder",
    tagline: "MobileView MVH-7100-00-08 Acceleration and Impact Sensor",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-7100-00-08-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-3301-10-00",
    manufacturer: "MobileView",
    model: "MVP-3301-10-00",
    category: "nvr-recorder",
    tagline: "MobileView MVP-3301-10-00 PENTA GPS Antenna, 10 m Cable",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-3301-10-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-4037-08-j3",
    manufacturer: "MobileView",
    model: "MVP-4037-08-J3",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4037-08-J3 MobileView PENTA J3 Digital Input Harness Cable",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4037-08-j3-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-4005-kt-00",
    manufacturer: "MobileView",
    model: "MVP-4005-KT-00",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4005-KT-00 PENTA Spare Harness Cable Connectors & Fuse Kit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4005-kt-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-enc-08-00",
    manufacturer: "MobileView",
    model: "MVP-ENC-08-00",
    category: "nvr-recorder",
    tagline: "MobileView MVP-ENC-08-00 PENTA Locking Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-enc-08-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-4037-16-j4",
    manufacturer: "MobileView",
    model: "MVP-4037-16-J4",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4037-16-J4 PENTA J4 camera power harness",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4037-16-j4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-1002-03-20",
    manufacturer: "MobileView",
    model: "MVH-1002-03-20",
    category: "nvr-recorder",
    tagline: "MobileView MVH-1002-03-20 2TB SATA HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-1002-03-20-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4039-00-00",
    manufacturer: "MobileView",
    model: "MVH-4039-00-00",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4039-00-00 harness connection kit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4039-00-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4037-j3-00",
    manufacturer: "MobileView",
    model: "MVH-4037-J3-00",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4037-J3-00 digital input harness",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4037-j3-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4037-j6-12ea",
    manufacturer: "MobileView",
    model: "MVH-4037-J6-12EA",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4037-J6-12EA power extension harness",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4037-j6-12ea-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":12,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-1002-00-20",
    manufacturer: "MobileView",
    model: "MVP-1002-00-20",
    category: "nvr-recorder",
    tagline: "MobileView MVP-1002-00-20 2TB HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-1002-00-20-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-4039-00-00",
    manufacturer: "MobileView",
    model: "MVP-4039-00-00",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4039-00-00 harness connection kit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4039-00-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4037-j7-00",
    manufacturer: "MobileView",
    model: "MVH-4037-J7-00",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4037-J7-00 audio output harness, 15 in. cable",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4037-j7-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-4037-08-j1",
    manufacturer: "MobileView",
    model: "MVP-4037-08-J1",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4037-08-J1 MobileView PENTA J1 Power Harness Cable",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4037-08-j1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-4037-08-j2",
    manufacturer: "MobileView",
    model: "MVP-4037-08-J2",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4037-08-J2 MobileView PENTA J2 Audio & Status Harness Cable",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4037-08-j2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-4037-08-j5",
    manufacturer: "MobileView",
    model: "MVP-4037-08-J5",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4037-08-J5 MobileView PENTA J5 Analogue & Relay Harness Cable (8CH)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4037-08-j5-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvp-4037-08-j6",
    manufacturer: "MobileView",
    model: "MVP-4037-08-J6",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4037-08-J6 PENTA J6 Video Input Harness Cable (8 CH)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4037-08-j6-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-mobileview-mvh-4350-08-k1",
    manufacturer: "MobileView",
    model: "MVH-4350-08-K1",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4350-08-K1 3008 8 channel digital video recorder with mounting plates",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4350-08-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvp-4500-08-20",
    manufacturer: "MobileView",
    model: "MVP-4500-08-20",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4500-08-20 8 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4500-08-20-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvp-4500-08-00",
    manufacturer: "MobileView",
    model: "MVP-4500-08-00",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4500-08-00 8 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4500-08-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvp-4500-08-01",
    manufacturer: "MobileView",
    model: "MVP-4500-08-01",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4500-08-01 8 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4500-08-01-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvp-4500-08-21",
    manufacturer: "MobileView",
    model: "MVP-4500-08-21",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4500-08-21 8 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4500-08-21-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvp-4500-16-20",
    manufacturer: "MobileView",
    model: "MVP-4500-16-20",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4500-16-20 16 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4500-16-20-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvp-4500-16-00",
    manufacturer: "MobileView",
    model: "MVP-4500-16-00",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4500-16-00 16 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4500-16-00-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvp-4500-16-01",
    manufacturer: "MobileView",
    model: "MVP-4500-16-01",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4500-16-01 16 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4500-16-01-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvp-4500-16-21",
    manufacturer: "MobileView",
    model: "MVP-4500-16-21",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4500-16-21 16 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4500-16-21-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvp-4500-08-nc",
    manufacturer: "MobileView",
    model: "MVP-4500-08-NC",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4500-08-NC 8 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4500-08-nc-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvp-4500-16-nc",
    manufacturer: "MobileView",
    model: "MVP-4500-16-NC",
    category: "nvr-recorder",
    tagline: "MobileView MVP-4500-16-NC 16 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvp-4500-16-nc-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvh-4350-04-k1",
    manufacturer: "MobileView",
    model: "MVH-4350-04-K1",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4350-04-K1 4 channel digital videor recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4350-04-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvh-4350-08-01",
    manufacturer: "MobileView",
    model: "MVH-4350-08-01",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4350-08-01 8 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4350-08-01-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvh-4350-12-k1",
    manufacturer: "MobileView",
    model: "MVH-4350-12-K1",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4350-12-K1 12 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4350-12-k1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":12,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvh-4350-04-01",
    manufacturer: "MobileView",
    model: "MVH-4350-04-01",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4350-04-01 4 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4350-04-01-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvh-4350-12-01",
    manufacturer: "MobileView",
    model: "MVH-4350-12-01",
    category: "nvr-recorder",
    tagline: "MobileView MVH-4350-12-01 12 channel digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-4350-12-01-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":12,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvh-1002-k3-20",
    manufacturer: "MobileView",
    model: "MVH-1002-K3-20",
    category: "nvr-recorder",
    tagline: "MobileView MVH-1002-K3-20 2TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-1002-k3-20-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvh-1002-k3-10",
    manufacturer: "MobileView",
    model: "MVH-1002-K3-10",
    category: "nvr-recorder",
    tagline: "MobileView MVH-1002-K3-10 1TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-1002-k3-10-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-mobileview-mvh-3301-m0-04",
    manufacturer: "MobileView",
    model: "MVH-3301-M0-04",
    category: "nvr-recorder",
    tagline: "MobileView MVH-3301-M0-04 GPS module and antenna, 15' cable",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/mobileview-mvh-3301-m0-04-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-lilin-pdr-6160a",
    manufacturer: "LILIN",
    model: "PDR-6160A",
    category: "nvr-recorder",
    tagline: "LILIN PDR-6160A 16 channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-pdr-6160a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-dvr716",
    manufacturer: "LILIN",
    model: "DVR716",
    category: "nvr-recorder",
    tagline: "LILIN DVR716 960H H.264 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr716-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-pdr-6080a",
    manufacturer: "LILIN",
    model: "PDR-6080A",
    category: "nvr-recorder",
    tagline: "LILIN PDR-6080A 8 channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-pdr-6080a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-lilin-dhd216a",
    manufacturer: "LILIN",
    model: "DHD216A",
    category: "nvr-recorder",
    tagline: "LILIN DHD216A 16-channel HD analogue digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd216a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr216b",
    manufacturer: "LILIN",
    model: "DVR216B",
    category: "nvr-recorder",
    tagline: "LILIN DVR216B H.264 DVR surveillance recording system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr216b-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-pdr-6040a",
    manufacturer: "LILIN",
    model: "PDR-6040A",
    category: "nvr-recorder",
    tagline: "LILIN PDR-6040A 4 channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-pdr-6040a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1},
  },
  {
    id: "ss-lilin-dvr316",
    manufacturer: "LILIN",
    model: "DVR316",
    category: "nvr-recorder",
    tagline: "LILIN DVR316 H.264 real-time digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr316-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dhd6104",
    manufacturer: "LILIN",
    model: "DHD6104",
    category: "nvr-recorder",
    tagline: "LILIN DHD6104 4 channel hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd6104-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-lilin-dvr204b",
    manufacturer: "LILIN",
    model: "DVR204B",
    category: "nvr-recorder",
    tagline: "LILIN DVR204B H.264 DVR surveillance recording system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr204b-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dhd208a",
    manufacturer: "LILIN",
    model: "DHD208A",
    category: "nvr-recorder",
    tagline: "LILIN DHD208A 8-channel HD analogue digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd208a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr208b",
    manufacturer: "LILIN",
    model: "DVR208B",
    category: "nvr-recorder",
    tagline: "LILIN DVR208B H.264 DVR surveillance recording system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr208b-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dhd6108",
    manufacturer: "LILIN",
    model: "DHD6108",
    category: "nvr-recorder",
    tagline: "LILIN DHD6108 8 channel hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd6108-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-lilin-dhd6216a",
    manufacturer: "LILIN",
    model: "DHD6216A",
    category: "nvr-recorder",
    tagline: "LILIN DHD6216A 16 channel hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd6216a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-lilin-psh-100",
    manufacturer: "LILIN",
    model: "PSH-100",
    category: "nvr-recorder",
    tagline: "PSH-100 Stand-alone e-SATA RAID hard disk storage system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-psh-100-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-lilin-dvr708",
    manufacturer: "LILIN",
    model: "DVR708",
    category: "nvr-recorder",
    tagline: "LILIN DVR708 960H H.264 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr708-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dhd208",
    manufacturer: "LILIN",
    model: "DHD208",
    category: "nvr-recorder",
    tagline: "LILIN DHD208 8-channel HD analogue digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd208-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr516",
    manufacturer: "LILIN",
    model: "DVR516",
    category: "nvr-recorder",
    tagline: "DVR516 16CH H.264 Real-time Full D1 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr516-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dhd216",
    manufacturer: "LILIN",
    model: "DHD216",
    category: "nvr-recorder",
    tagline: "LILIN DHD216 16-channel HD analogue digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd216-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr304",
    manufacturer: "LILIN",
    model: "DVR304",
    category: "nvr-recorder",
    tagline: "LILIN DVR304 real-time full D1 recording and playback digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr304-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dhd204a",
    manufacturer: "LILIN",
    model: "DHD204A",
    category: "nvr-recorder",
    tagline: "LILIN DHD204A 4-channel HD analogue digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd204a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-ndr-104-2tb",
    manufacturer: "LILIN",
    model: "NDR-104-2TB",
    category: "nvr-recorder",
    tagline: "LILIN launches IP hybrid network digital recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-ndr-104-2tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"],"onvif":true},
  },
  {
    id: "ss-lilin-dhd5216",
    manufacturer: "LILIN",
    model: "DHD5216",
    category: "nvr-recorder",
    tagline: "Lilin DHD5216 16 Channel Hybrid Standalone Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd5216-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-lilin-dvr816",
    manufacturer: "LILIN",
    model: "DVR816",
    category: "nvr-recorder",
    tagline: "LILIN DVR816 960H H.264 touch screen interface DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr816-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nvr-104d-2tb",
    manufacturer: "LILIN",
    model: "NVR-104D-2TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-104D-2TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-104d-2tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"],"onvif":true},
  },
  {
    id: "ss-lilin-nvr-104d-6tb",
    manufacturer: "LILIN",
    model: "NVR-104D-6TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-104D-6TB IP hybrid network digital recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-104d-6tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"],"onvif":true},
  },
  {
    id: "ss-lilin-dhd204",
    manufacturer: "LILIN",
    model: "DHD204",
    category: "nvr-recorder",
    tagline: "LILIN DHD204 4-channel 720P HD analogue digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd204-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr-304-1tb",
    manufacturer: "LILIN",
    model: "DVR-304-1TB",
    category: "nvr-recorder",
    tagline: "LILIN DVR-304 1TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr-304-1tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr-316-1tb",
    manufacturer: "LILIN",
    model: "DVR-316-1TB",
    category: "nvr-recorder",
    tagline: "LILIN DVR-316-1TB H.264 Full D1 real-time digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr-316-1tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr308",
    manufacturer: "LILIN",
    model: "DVR308",
    category: "nvr-recorder",
    tagline: "LILIN DVR308 H.264 real-time digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr308-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dhd5108",
    manufacturer: "LILIN",
    model: "DHD5108",
    category: "nvr-recorder",
    tagline: "Lilin DHD5108 8 Channel Hybrid Standalone Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd5108-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-lilin-dvr816d",
    manufacturer: "LILIN",
    model: "DVR816D",
    category: "nvr-recorder",
    tagline: "LILIN DVR816D 960H H.264 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr816d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr216a",
    manufacturer: "LILIN",
    model: "DVR216A",
    category: "nvr-recorder",
    tagline: "LILIN DVR216A 16 channel DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr216a-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dhd5104",
    manufacturer: "LILIN",
    model: "DHD5104",
    category: "nvr-recorder",
    tagline: "Lilin DHD5104 4 Channel Hybrid Standalone Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dhd5104-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-lilin-dvr-308-1tb",
    manufacturer: "LILIN",
    model: "DVR-308-1TB",
    category: "nvr-recorder",
    tagline: "LILIN DVR-308-1TB DVR with LCD power saving design",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr-308-1tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr508d",
    manufacturer: "LILIN",
    model: "DVR508D",
    category: "nvr-recorder",
    tagline: "LILIN DVR508D real-time full D1 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr508d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr-516d-2tb",
    manufacturer: "LILIN",
    model: "DVR-516D-2TB",
    category: "nvr-recorder",
    tagline: "LILIN DVR-516D-2TB H.264 real time full D1 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr-516d-2tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-ndr-104",
    manufacturer: "LILIN",
    model: "NDR 104",
    category: "nvr-recorder",
    tagline: "LILIN NDR 104 real time Full D1 pure Hybrid NDR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-ndr-104-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr508",
    manufacturer: "LILIN",
    model: "DVR508",
    category: "nvr-recorder",
    tagline: "LILIN DVR508 H.264 Real-Time Full D1 Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr508-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr516d",
    manufacturer: "LILIN",
    model: "DVR516D",
    category: "nvr-recorder",
    tagline: "LILIN DVR516D real-time full D1 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr516d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr-508d-1tb",
    manufacturer: "LILIN",
    model: "DVR-508D-1TB",
    category: "nvr-recorder",
    tagline: "LILIN DVR-508D-1TB H.264 real-time Full D1 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr-508d-1tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"],"formFactor":"2U"},
  },
  {
    id: "ss-lilin-dvr-516d-1tb",
    manufacturer: "LILIN",
    model: "DVR-516D-1TB",
    category: "nvr-recorder",
    tagline: "LILIN DVR-516D H.264 real-time full D1 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr-516d-1tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-dvr-508d-2tb",
    manufacturer: "LILIN",
    model: "DVR-508D-2TB",
    category: "nvr-recorder",
    tagline: "LILIN DVR-508D-2TB H.264 real-time DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-dvr-508d-2tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"],"formFactor":"2U"},
  },
  {
    id: "ss-lilin-ndr104",
    manufacturer: "LILIN",
    model: "NDR104",
    category: "nvr-recorder",
    tagline: "LILIN NDR104 real-time full D1 pure hybrid digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-ndr104-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-cmx1072",
    manufacturer: "LILIN",
    model: "CMX1072",
    category: "nvr-recorder",
    tagline: "LILIN CMX1072 72 Channel Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-cmx1072-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":72,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-lilin-cmx1036",
    manufacturer: "LILIN",
    model: "CMX1036",
    category: "nvr-recorder",
    tagline: "LILIN CMX1036 36 Channel Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-cmx1036-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":36,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-lilin-cmx1108",
    manufacturer: "LILIN",
    model: "CMX1108",
    category: "nvr-recorder",
    tagline: "LILIN CMX1108 108 Channel Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-cmx1108-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":108,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-lilin-pmh-poe08130wat",
    manufacturer: "LILIN",
    model: "PMH-POE08130WAT",
    category: "nvr-recorder",
    tagline: "LILIN PMH-POE08130WAT full power 8 port",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-pmh-poe08130wat-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-lilin-pmh-poe08260wat",
    manufacturer: "LILIN",
    model: "PMH-POE08260WAT",
    category: "nvr-recorder",
    tagline: "LILIN PMH-POE08260WAT with fast ethernet switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-pmh-poe08260wat-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-eneo-dlr-2008-1000v",
    manufacturer: "eneo",
    model: "DLR-2008/1000V",
    category: "nvr-recorder",
    tagline: "eneo DLR-2008/1000V 8-channel, H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr-2008-1000v-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4b-16-500dv",
    manufacturer: "eneo",
    model: "DLR4B-16/500DV",
    category: "nvr-recorder",
    tagline: "eneo DLR4B-16/500DV 16-channel, H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4b-16-500dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dmr-5016-10",
    manufacturer: "eneo",
    model: "DMR-5016/10",
    category: "nvr-recorder",
    tagline: "eneo DMR-5016/10 16-channel, H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dmr-5016-10-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr-2016-500v",
    manufacturer: "eneo",
    model: "DLR-2016/500V",
    category: "nvr-recorder",
    tagline: "eneo DLR-2016/500V 16-channel, 500 GB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr-2016-500v-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr-2004-1000v",
    manufacturer: "eneo",
    model: "DLR-2004/1000V",
    category: "nvr-recorder",
    tagline: "eneo DLR-2004/1000V 4-channel, 1 TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr-2004-1000v-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr-1004-1000v",
    manufacturer: "eneo",
    model: "DLR-1004/1000V",
    category: "nvr-recorder",
    tagline: "eneo DLR-1004/1000V 4-channel, 1 TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr-1004-1000v-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr-2016-1000v",
    manufacturer: "eneo",
    model: "DLR-2016/1000V",
    category: "nvr-recorder",
    tagline: "eneo DLR-2016/1000V 16-channel, 1 TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr-2016-1000v-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dmr-5016-500",
    manufacturer: "eneo",
    model: "DMR-5016/500",
    category: "nvr-recorder",
    tagline: "eneo DMR-5016/500 digital video recorder with watermark digital signature",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dmr-5016-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4b-16-1-5tbdv",
    manufacturer: "eneo",
    model: "DLR4B-16/1.5TBDV",
    category: "nvr-recorder",
    tagline: "eneo DLR4B-16/1.5TBDV 16-channel, H.264, 1.5TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4b-16-1-5tbdv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr-2008-500v",
    manufacturer: "eneo",
    model: "DLR-2008/500V",
    category: "nvr-recorder",
    tagline: "eneo DLR-2008/500V 8-channel, 500 GB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr-2008-500v-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr-2004-500v",
    manufacturer: "eneo",
    model: "DLR-2004/500V",
    category: "nvr-recorder",
    tagline: "eneo DLR-2004/500V 4-channel, 500 GB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr-2004-500v-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-blr-3004-500dv",
    manufacturer: "eneo",
    model: "BLR-3004/500DV",
    category: "nvr-recorder",
    tagline: "eneo BLR-3004/500DV 4-channel, 500 GB DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-blr-3004-500dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dmr-5008-2-5",
    manufacturer: "eneo",
    model: "DMR-5008/2.5",
    category: "nvr-recorder",
    tagline: "eneo DMR-5008/2.5 digital video recorder with alarm notification",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dmr-5008-2-5-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
];

const PART_3: NvrEntry[] = [
  {
    id: "ss-eneo-blr-3016-2-5dv",
    manufacturer: "eneo",
    model: "BLR-3016/2.5DV",
    category: "nvr-recorder",
    tagline: "Digital video recorders in the new BLR Series: entry-level models at outstanding value for money",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-blr-3016-2-5dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dmr-5016-1-5",
    manufacturer: "eneo",
    model: "DMR-5016/1.5",
    category: "nvr-recorder",
    tagline: "eneo DMR-5016/1.5 digital video recorder with motion detection",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dmr-5016-1-5-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4b-08-500dv",
    manufacturer: "eneo",
    model: "DLR4B-08/500DV",
    category: "nvr-recorder",
    tagline: "eneo DLR4B-08/500DV 8 channels, H.264, 500GB, 200fps DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4b-08-500dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr-2016-2000v",
    manufacturer: "eneo",
    model: "DLR-2016/2000V",
    category: "nvr-recorder",
    tagline: "eneo DLR-2016/2000V 16-channel, 2 TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr-2016-2000v-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr-1004-500v",
    manufacturer: "eneo",
    model: "DLR-1004/500V",
    category: "nvr-recorder",
    tagline: "eneo DLR-1004/500V 4-channel, 500 GB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr-1004-500v-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-hdr-4004ae1-0",
    manufacturer: "eneo",
    model: "HDR-4004AE1.0",
    category: "nvr-recorder",
    tagline: "eneo HDR-4004AE1.0 HD-SDI, 4 channels, 1TB DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-hdr-4004ae1-0-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4b-04-2-5tbd",
    manufacturer: "eneo",
    model: "DLR4B-04/2.5TBD",
    category: "nvr-recorder",
    tagline: "eneo DLR4B-04/2.5TBD 4 channels, 2.5 TB DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4b-04-2-5tbd-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-blr-3008-500dv",
    manufacturer: "eneo",
    model: "BLR-3008/500DV",
    category: "nvr-recorder",
    tagline: "eneo BLR-3008/500DV 8-channel, 500GB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-blr-3008-500dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dmr-5016-2-5",
    manufacturer: "eneo",
    model: "DMR-5016/2.5",
    category: "nvr-recorder",
    tagline: "eneo DMR series: High end digital video recorder with full HD monitor support",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dmr-5016-2-5-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-blr-3016-1-5dv",
    manufacturer: "eneo",
    model: "BLR-3016/1.5DV",
    category: "nvr-recorder",
    tagline: "eneo BLR-3016/1.5DV 16-channel, 1.5 TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-blr-3016-1-5dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-hdr-4004am1-0",
    manufacturer: "eneo",
    model: "HDR-4004AM1.0",
    category: "nvr-recorder",
    tagline: "eneo HDR-4004AM1.0 HD-SDI, 4 channels, 1TB DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-hdr-4004am1-0-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dmr-5008-500",
    manufacturer: "eneo",
    model: "DMR-5008/500",
    category: "nvr-recorder",
    tagline: "eneo DMR-5008/500 digital video recorder with 5 sensitivity levels",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dmr-5008-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4-04-2-5tbd",
    manufacturer: "eneo",
    model: "DLR4-04/2.5TBD",
    category: "nvr-recorder",
    tagline: "eneo DLR4-04/2.5TBD 4-channel digital video recorder with 2.5 TB, H.264, 100fps, 704x576, DVD, Audio",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4-04-2-5tbd-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4b-16-2-5tbdv",
    manufacturer: "eneo",
    model: "DLR4B-16/2.5TBDV",
    category: "nvr-recorder",
    tagline: "eneo DLR4B-16/2.5TBDV 16-channel, H.264, 2.5TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4b-16-2-5tbdv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4b-16-4-5tbdv",
    manufacturer: "eneo",
    model: "DLR4B-16/4.5TBDV",
    category: "nvr-recorder",
    tagline: "eneo DLR4B-16/4.5TBDV 16-channel, H.264, 4.5TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4b-16-4-5tbdv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4-04-500d",
    manufacturer: "eneo",
    model: "DLR4-04/500D",
    category: "nvr-recorder",
    tagline: "eneo DLR4-04/500D 4-channel, 500 GB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4-04-500d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-hdr-4082ah1-0",
    manufacturer: "eneo",
    model: "HDR-4082AH1.0",
    category: "nvr-recorder",
    tagline: "eneo creates new system design options with hybrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-hdr-4082ah1-0-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-blr-3016-500dv",
    manufacturer: "eneo",
    model: "BLR-3016/500DV",
    category: "nvr-recorder",
    tagline: "eneo BLR-3016/500DV 16-channel, 500 GB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-blr-3016-500dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-blr-3004-1-5dv",
    manufacturer: "eneo",
    model: "BLR-3004/1.5DV",
    category: "nvr-recorder",
    tagline: "eneo BLR-3004/1.5DV 4-channel 1.5 TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-blr-3004-1-5dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-blr-3008-1-5dv",
    manufacturer: "eneo",
    model: "BLR-3008/1.5DV",
    category: "nvr-recorder",
    tagline: "eneo BLR-3008/1.5DV 8-channel 1.5 TB DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-blr-3008-1-5dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4b-04-500d",
    manufacturer: "eneo",
    model: "DLR4B-04/500D",
    category: "nvr-recorder",
    tagline: "eneo DLR4B-04/500D 4 channels, 500 GB, H.264 DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4b-04-500d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-blr-3004-2-5dv",
    manufacturer: "eneo",
    model: "BLR-3004/2.5DV",
    category: "nvr-recorder",
    tagline: "eneo BLR-3004/2.5DV 4-channel, 2.5 TB DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-blr-3004-2-5dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4-04-1-5tbd",
    manufacturer: "eneo",
    model: "DLR4-04/1.5TBD",
    category: "nvr-recorder",
    tagline: "eneo DLR4-04/1.5TBD 4-channel, 1.5 TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4-04-1-5tbd-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4b-08-1-5tbdv",
    manufacturer: "eneo",
    model: "DLR4B-08/1.5TBDV",
    category: "nvr-recorder",
    tagline: "eneo DLR4B-08/1.5TBDV 8 Channels, H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4b-08-1-5tbdv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4b-08-2-5tbdv",
    manufacturer: "eneo",
    model: "DLR4B-08/2.5TBDV",
    category: "nvr-recorder",
    tagline: "eneo DLR4B-08/2.5TBDV 8-channel, H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4b-08-2-5tbdv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-blr-3008-2-5dv",
    manufacturer: "eneo",
    model: "BLR-3008/2.5DV",
    category: "nvr-recorder",
    tagline: "eneo BLR-3008/2.5DV 8-channel, 2.5 TB digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-blr-3008-2-5dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dlr4b-04-1-5tbd",
    manufacturer: "eneo",
    model: "DLR4B-04/1.5TBD",
    category: "nvr-recorder",
    tagline: "eneo DLR4B-04/1.5TBD 4 channels, 1.5 TB DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dlr4b-04-1-5tbd-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-dmr-5008-1-5",
    manufacturer: "eneo",
    model: "DMR-5008/1.5",
    category: "nvr-recorder",
    tagline: "eneo DMR-5008/1.5 digital video recorder with 5 internal harddisks",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-dmr-5008-1-5-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-eneo-blr-3016-4-0dv",
    manufacturer: "eneo",
    model: "BLR-3016/4.0DV",
    category: "nvr-recorder",
    tagline: "eneo BLR-3016/4.0DV Digital video recorder (16 channels), H.264, 4TB, 400fps, 704x576, DVD, 230 V AC",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eneo-blr-3016-4-0dv-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-geutebruck-geviraid-ii-16",
    manufacturer: "Geutebruck",
    model: "GeViRAID II/16",
    category: "nvr-recorder",
    tagline: "Geutebruck GeViRAID II/16 digital video recorder accessory with network messages in case of an error",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-geviraid-ii-16-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-hdd-1tb-s-ata",
    manufacturer: "Geutebruck",
    model: "HDD/1TB/S-ATA",
    category: "nvr-recorder",
    tagline: "Geutebruck HDD/1TB/S-ATA 1 TB hard disk drive",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-hdd-1tb-s-ata-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-geviraid-ii-8",
    manufacturer: "Geutebruck",
    model: "GeViRAID II/8",
    category: "nvr-recorder",
    tagline: "Geutebruck GeViRAID II/8 digital video recorder accessory with security alarm relay",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-geviraid-ii-8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-hdd-1tb-s-ata-raid-ht",
    manufacturer: "Geutebruck",
    model: "HDD/1TB/S-ATA-Raid-HT",
    category: "nvr-recorder",
    tagline: "Geutebruck HDD/1TB/S-ATA-Raid-HT 1 TB internal hard disk",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-hdd-1tb-s-ata-raid-ht-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-hdd-2tb-s-ata",
    manufacturer: "Geutebruck",
    model: "HDD/2TB/S-ATA",
    category: "nvr-recorder",
    tagline: "Geutebruck HDD/2TB/S-ATA 2 TB hard disk",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-hdd-2tb-s-ata-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-hdd-500gb-s-ata",
    manufacturer: "Geutebruck",
    model: "HDD/500GB/S-ATA",
    category: "nvr-recorder",
    tagline: "Geutebruck HDD/500GB/S-ATA 500 GB hard disk drive",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-hdd-500gb-s-ata-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-g-scope-1044",
    manufacturer: "Geutebruck",
    model: "G-Scope/1044",
    category: "nvr-recorder",
    tagline: "The G-Scope/1000 NVR - one of many new Geutebruck products introduced at Security 2012",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-g-scope-1044-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":6,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-geutebruck-re-porter-16",
    manufacturer: "Geutebruck",
    model: "re_porter-16+",
    category: "nvr-recorder",
    tagline: "Geutebruck pictures a world with less data and higher service standards",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-re-porter-16-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-geutebruck-re-porter-ip-xrdb",
    manufacturer: "Geutebruck",
    model: "re_porter-IP/XRdB",
    category: "nvr-recorder",
    tagline: "Geutebruck’s new re_porter model with hot swap HDD for image evaluation outside the network",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-re-porter-ip-xrdb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1,"codecs":["H.264"],"raidLevels":["1"]},
  },
  {
    id: "ss-geutebruck-g-scope-1006",
    manufacturer: "Geutebruck",
    model: "G-Scope/1006",
    category: "nvr-recorder",
    tagline: "Geutebruck’s new G-Scope/1000 series of compact NVRs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-g-scope-1006-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-geutebruck-g-vraid",
    manufacturer: "Geutebruck",
    model: "G-VRaid",
    category: "nvr-recorder",
    tagline: "Geutebruck’s new G-VRaid range for high security monitoring",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-g-vraid-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-re-porter-8",
    manufacturer: "Geutebruck",
    model: "re_porter-8+",
    category: "nvr-recorder",
    tagline: "Geutebruck re_porter-8+ digital video recorder with Omnibrid technology",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-re-porter-8-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-geutebruck-gevistation-w7-r",
    manufacturer: "Geutebruck",
    model: "GeViStation-W7/R+",
    category: "nvr-recorder",
    tagline: "Geutebruck GeViStation-W7/R+ system management platform",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-gevistation-w7-r-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-re-porter-4",
    manufacturer: "Geutebruck",
    model: "re_porter-4+",
    category: "nvr-recorder",
    tagline: "Geutebruck re_porter-4+ digital video recorder with video management functionality",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-re-porter-4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-geutebruck-gscspeedview-st",
    manufacturer: "Geutebruck",
    model: "GSCSpeedView-ST",
    category: "nvr-recorder",
    tagline: "Geutebruck GSCSpeedView-ST 40 GB high speed evaluation and playback station",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-gscspeedview-st-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-re-porter-12",
    manufacturer: "Geutebruck",
    model: "re_porter-12+",
    category: "nvr-recorder",
    tagline: "Geutebruck pictures a world with less data and higher service standards",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-re-porter-12-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":12,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-geutebruck-gscspeedview-xrdb",
    manufacturer: "Geutebruck",
    model: "GSCSpeedView-XRdB",
    category: "nvr-recorder",
    tagline: "Geutebruck GSCSpeedView-XRdB evaluation and playback station",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-gscspeedview-xrdb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-gscspeedview-ap",
    manufacturer: "Geutebruck",
    model: "GSCSpeedView-AP",
    category: "nvr-recorder",
    tagline: "Geutebruck’s new high speed evaluation and display stations",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-gscspeedview-ap-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-50vce-1",
    manufacturer: "ADPRO",
    model: "AFT-50VCE-1",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-50VCE-1 spare VCE card for Fasttrace unit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-50vce-1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-50hdd-500",
    manufacturer: "ADPRO",
    model: "AFT-50HDD-500",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-50HDD-500 hard drive upgrade",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-50hdd-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-50hdd-320",
    manufacturer: "ADPRO",
    model: "AFT-50HDD-320",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-50HDD-320 hard drive upgrade",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-50hdd-320-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5020-2-2",
    manufacturer: "ADPRO",
    model: "AFT-5020-2-2",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5020-2-2 DVR 10CH 50IPS 2 HDD FASTTRACE DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5020-2-2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5020-4-4-d",
    manufacturer: "ADPRO",
    model: "AFT-5020-4-4-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5020-4-4-D multi-site video security recording system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5020-4-4-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":20,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5020-1-2-d",
    manufacturer: "ADPRO",
    model: "AFT-5020-1-2-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5020-1-2-D 10CH 50IPS 1 HDD FASTTRACE DVR + DTCT",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5020-1-2-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5020-2-2-d",
    manufacturer: "ADPRO",
    model: "AFT-5020-2-2-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5020-2-2-D 10CH 50IPS 2 HDD FASTTRACE DVR + DTCT",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5020-2-2-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5020-2-4",
    manufacturer: "ADPRO",
    model: "AFT-5020-2-4",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5020-2-4 multi-site video security recording system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5020-2-4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":20,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5020-4-2-d",
    manufacturer: "ADPRO",
    model: "AFT-5020-4-2-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5020-4-2-D multi-site video security recording system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5020-4-2-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":20,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5020-2-4-d",
    manufacturer: "ADPRO",
    model: "AFT-5020-2-4-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5020-2-4-D multi-site video security recording system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5020-2-4-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":20,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5020-4-4",
    manufacturer: "ADPRO",
    model: "AFT-5020-4-4",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5020-4-4 multi-site video security recording system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5020-4-4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":20,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5020-4-2",
    manufacturer: "ADPRO",
    model: "AFT-5020-4-2",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5020-4-2 multi-site video security recording system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5020-4-2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":20,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5020-3-2-d",
    manufacturer: "ADPRO",
    model: "AFT-5020-3-2-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5020-3-2-D multi-site video security recording system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5020-3-2-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":20,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5020-3-2",
    manufacturer: "ADPRO",
    model: "AFT-5020-3-2",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5020-3-2 multi-site video security recording system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5020-3-2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":20,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-1-1",
    manufacturer: "ADPRO",
    model: "AFT-5010-1-1",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-1-1 10 video inputs, 25 IPS, 1 HDD FastTrace digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-1-1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-2-2",
    manufacturer: "ADPRO",
    model: "AFT-5010-2-2",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-2-2 10 channel, 50 images per second, 2 HDD FastTrace DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-2-2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-1-2",
    manufacturer: "ADPRO",
    model: "AFT-5010-1-2",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-1-2 10 channel, 50 images per second, 1 HDD FastTrace digital video recoder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-1-2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-2-2-d",
    manufacturer: "ADPRO",
    model: "AFT-5010-2-2-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-2-2-D - 10CH 50IPS 2 HDD FastTrace DVR + DTCT",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-2-2-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-2-4-d",
    manufacturer: "ADPRO",
    model: "AFT-5010-2-4-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-2-4-D recorder 10CH 100IPS 2 HDD FASTTRACE DVR + DTCT",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-2-4-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-4-2",
    manufacturer: "ADPRO",
    model: "AFT-5010-4-2",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-4-2 10CH 50IPS 4 HDD FASTTRACE DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-4-2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-1-1-d",
    manufacturer: "ADPRO",
    model: "AFT-5010-1-1-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-1-1-D 10 channel, 25 images per second, 1 HDD FastTrace Digital video recorder and DT",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-1-1-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-1-2-d",
    manufacturer: "ADPRO",
    model: "AFT-5010-1-2-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-1-2-D 10 channel . 50 images per second, 1 HDD FastTrace DVR and DTCT",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-1-2-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-3-2",
    manufacturer: "ADPRO",
    model: "AFT-5010-3-2",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-3-2 10CH 50IPS 3 HDD FASTTRACE DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-3-2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-3-2-d",
    manufacturer: "ADPRO",
    model: "AFT-5010-3-2-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-3-2-D 10CH 50IPS 3 HDD FASTTRACE DVR + DTCT",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-3-2-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-4-2-d",
    manufacturer: "ADPRO",
    model: "AFT-5010-4-2-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-4-2-D 10CH 50IPS 4 HDD FASTTRACE DVR + DTCT",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-4-2-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-4-4",
    manufacturer: "ADPRO",
    model: "AFT-5010-4-4",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-4-4 10CH 100IPS 4 HDD FASTTRACE DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-4-4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-4-4-d",
    manufacturer: "ADPRO",
    model: "AFT-5010-4-4-D",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-4-4-D 10CH 100IPS 4 HDD FASTTRACE DVR + DTCT",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-4-4-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-adpro-aft-5010-2-4",
    manufacturer: "ADPRO",
    model: "AFT-5010-2-4",
    category: "nvr-recorder",
    tagline: "ADPRO AFT-5010-2-4 - 10CH 100IPS 2 HDD FastTrace digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-aft-5010-2-4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":10,"hddBays":1},
  },
  {
    id: "ss-truvision-dvr-11",
    manufacturer: "TruVision",
    model: "DVR 11",
    category: "nvr-recorder",
    tagline: "Truvsion DVR 11- H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-dvr-11-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4216-8t",
    manufacturer: "TruVision",
    model: "TVR-4216-8T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4216-8T 16 channel 8TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4216-8t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-truvision-dvr-41",
    manufacturer: "TruVision",
    model: "TruVision DVR 41",
    category: "nvr-recorder",
    tagline: "TruVision DVR 41 - H.264 digital video recorder with 8 / 16-channel capabilities",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-truvision-dvr-41-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1108-1t",
    manufacturer: "TruVision",
    model: "TVR-1108-1T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1108-1T 8 channel 1 TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1108-1t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1004-1t",
    manufacturer: "TruVision",
    model: "TVR-1004-1T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1004-1T 4-Channel H.264 Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1004-1t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1116-1t",
    manufacturer: "TruVision",
    model: "TVR-1116-1T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1116-1T 16-Channels Digital Video Recorder With 1TB Storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1116-1t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1116-4t",
    manufacturer: "TruVision",
    model: "TVR-1116-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1116-4T 16 channel 4TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1116-4t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-6016-8t",
    manufacturer: "TruVision",
    model: "TVR-6016-8T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-6016-8T 16 channel 8TB H.264 hybrid digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-6016-8t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1104c-1t",
    manufacturer: "TruVision",
    model: "TVR-1104C-1T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1104C-1T 4 channel 1 TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1104c-1t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4216-4t",
    manufacturer: "TruVision",
    model: "TVR-4216-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4216-4T 16 channel 4TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4216-4t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4116-4t",
    manufacturer: "TruVision",
    model: "TVR-4116-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4116-4T 16 channel 4TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4116-4t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1104c-500",
    manufacturer: "TruVision",
    model: "TVR-1104C-500",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1104C-500 4-Channels H.264 Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1104c-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1108-2t",
    manufacturer: "TruVision",
    model: "TVR-1108-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1108-2T 8-Channels Digital Video Recorder With 2TB Storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1108-2t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1116d-2t",
    manufacturer: "TruVision",
    model: "TVR-1116D-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1116D-2T 16 channel 2TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1116d-2t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4108-2t",
    manufacturer: "TruVision",
    model: "TVR-4108-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4108-2T 8 channel 2TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4108-2t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1116-2t",
    manufacturer: "TruVision",
    model: "TVR-1116-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1116-2T 16 channel 2TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1116-2t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4208-4t",
    manufacturer: "TruVision",
    model: "TVR-4208-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4208-4T 8 channel 4TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4208-4t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4208-2t",
    manufacturer: "TruVision",
    model: "TVR-4208-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4208-2T 8 channel 2TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4208-2t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1108d-2t",
    manufacturer: "TruVision",
    model: "TVR-1108D-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1108D-2T 8 channel 2TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1108d-2t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4216-12t",
    manufacturer: "TruVision",
    model: "TVR-4216-12T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4216-12T 16 channel 12TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4216-12t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-6016-4t",
    manufacturer: "TruVision",
    model: "TVR-6016-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-6016-4T 16 channel 4TB H.264 hybrid digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-6016-4t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4108-4t",
    manufacturer: "TruVision",
    model: "TVR-4108-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4108-4T 8-Channels Digital Video Recorder With 4TB Storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4108-4t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4116-12t",
    manufacturer: "TruVision",
    model: "TVR-4116-12T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4116-12T 16 channel 12TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4116-12t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4116-8t",
    manufacturer: "TruVision",
    model: "TVR-4116-8T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4116-8T 16 channel 8TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4116-8t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1108d-1t",
    manufacturer: "TruVision",
    model: "TVR-1108D-1T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1108D-1T 8-Channels H.264 Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1108d-1t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4216-2t",
    manufacturer: "TruVision",
    model: "TVR-4216-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4216-2T 16 channel 2TB H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4216-2t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-1116d-1t",
    manufacturer: "TruVision",
    model: "TVR-1116D-1T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-1116D-1T 16-Channel Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-1116d-1t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-4116-2t",
    manufacturer: "TruVision",
    model: "TVR-4116-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-4116-2T Digital video recorder (DVR)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-4116-2t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-6016-2t",
    manufacturer: "TruVision",
    model: "TVR-6016-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-6016-2T Digital video recorder (DVR)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-6016-2t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvr-6016-12t",
    manufacturer: "TruVision",
    model: "TVR-6016-12T",
    category: "nvr-recorder",
    tagline: "TruVision TVR-6016-12T real-time H.264 hybrid digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvr-6016-12t-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx8108-aud",
    manufacturer: "Pelco",
    model: "DX8108-AUD",
    category: "nvr-recorder",
    tagline: "Pelco DX8108-AUD 8-channel audio input card",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx8108-aud-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-pelco-dx4716-1000",
    manufacturer: "Pelco",
    model: "DX4716-1000",
    category: "nvr-recorder",
    tagline: "Pelco DX4716-1000 hybrid video recorder with DVD and 1000 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4716-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx4816-1000",
    manufacturer: "Pelco",
    model: "DX4816-1000",
    category: "nvr-recorder",
    tagline: "Pelco DX4816-1000 hybrid video recorder with DVD and 1000 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4816-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx8116-1000",
    manufacturer: "Pelco",
    model: "DX8116-1000",
    category: "nvr-recorder",
    tagline: "Pelco DX8116-1000 hybrid video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx8116-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-pelco-dx8116-2000",
    manufacturer: "Pelco",
    model: "DX8116-2000",
    category: "nvr-recorder",
    tagline: "Pelco DX8116-2000 hybrid video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx8116-2000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-pelco-dx4708-1000",
    manufacturer: "Pelco",
    model: "DX4708-1000",
    category: "nvr-recorder",
    tagline: "Pelco DX4708-1000 HVR with DVD and 1000 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4708-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx4104dvd-1000",
    manufacturer: "Pelco",
    model: "DX4104DVD-1000",
    category: "nvr-recorder",
    tagline: "Pelco DX4104DVD-1000 DVR with DVD and 1000 GB storage (1 HDD)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4104dvd-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx8132-1000",
    manufacturer: "Pelco",
    model: "DX8132-1000",
    category: "nvr-recorder",
    tagline: "Pelco DX8132-1000 hybrid video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx8132-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1},
  },
  {
    id: "ss-pelco-dx4808-1000",
    manufacturer: "Pelco",
    model: "DX4808-1000",
    category: "nvr-recorder",
    tagline: "Pelco DX4808-1000 HVR with DVD and 1000 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4808-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx4816-4000",
    manufacturer: "Pelco",
    model: "DX4816-4000",
    category: "nvr-recorder",
    tagline: "Pelco DX4816-4000 hybrid digital recorder with DVD and 4000 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4816-4000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx4716-500",
    manufacturer: "Pelco",
    model: "DX4716-500",
    category: "nvr-recorder",
    tagline: "Pelco DX4716-500 hybrid video recorder with DVD and 500 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4716-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx8132-4000",
    manufacturer: "Pelco",
    model: "DX8132-4000",
    category: "nvr-recorder",
    tagline: "Pelco DX8132-4000 hybrid video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx8132-4000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1},
  },
  {
    id: "ss-pelco-dx4816-500",
    manufacturer: "Pelco",
    model: "DX4816-500",
    category: "nvr-recorder",
    tagline: "Pelco DX4816-500 HVR with DVD and 500 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4816-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx8132-2000",
    manufacturer: "Pelco",
    model: "DX8132-2000",
    category: "nvr-recorder",
    tagline: "Pelco DX8132-2000 hybrid video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx8132-2000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1},
  },
  {
    id: "ss-pelco-dx8124-1000",
    manufacturer: "Pelco",
    model: "DX8124-1000",
    category: "nvr-recorder",
    tagline: "Pelco DX8124-1000 hybrid video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx8124-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1},
  },
  {
    id: "ss-pelco-dx4104dvd-500",
    manufacturer: "Pelco",
    model: "DX4104DVD-500",
    category: "nvr-recorder",
    tagline: "Pelco DX4104DVD-500 DVR with DVD and 500 GB storage (1 HDD)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4104dvd-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx8124-2000",
    manufacturer: "Pelco",
    model: "DX8124-2000",
    category: "nvr-recorder",
    tagline: "Pelco DX8124-2000 hybrid video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx8124-2000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1},
  },
  {
    id: "ss-pelco-dx8108-1000",
    manufacturer: "Pelco",
    model: "DX8108-1000",
    category: "nvr-recorder",
    tagline: "Pelco DX8108-1000 hybrid video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx8108-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-pelco-dx4716-4000",
    manufacturer: "Pelco",
    model: "DX4716-4000",
    category: "nvr-recorder",
    tagline: "Pelco DX4716-4000 hybrid digital recorder with DVD and 4000 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4716-4000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx4816-2000",
    manufacturer: "Pelco",
    model: "DX4816-2000",
    category: "nvr-recorder",
    tagline: "Pelco DX4816-2000 hybrid video recorder with DVD and 2000 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4816-2000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx8108-2000",
    manufacturer: "Pelco",
    model: "DX8108-2000",
    category: "nvr-recorder",
    tagline: "Pelco DX8108-2000 hybrid video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx8108-2000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-pelco-dx4808-500",
    manufacturer: "Pelco",
    model: "DX4808-500",
    category: "nvr-recorder",
    tagline: "Pelco DX4808-500 HVR with DVD and 500 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4808-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx4808-4000",
    manufacturer: "Pelco",
    model: "DX4808-4000",
    category: "nvr-recorder",
    tagline: "Pelco DX4808-4000 HVR with DVD and 4000 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4808-4000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx4808-2000",
    manufacturer: "Pelco",
    model: "DX4808-2000",
    category: "nvr-recorder",
    tagline: "Pelco DX4808-2000 HVR with DVD and 2000 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4808-2000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx4708-4000",
    manufacturer: "Pelco",
    model: "DX4708-4000",
    category: "nvr-recorder",
    tagline: "Pelco DX4708-4000 HVR with DVD and 4000 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4708-4000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-pelco-dx4708-500",
    manufacturer: "Pelco",
    model: "DX4708-500",
    category: "nvr-recorder",
    tagline: "Pelco DX4708-500 HVR with DVD and 500 GB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dx4708-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-4116",
    manufacturer: "IDIS",
    model: "TR-4116",
    category: "nvr-recorder",
    tagline: "IDIS TR-4116 HD-TVI 16 channel full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4116-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-4316",
    manufacturer: "IDIS",
    model: "TR-4316",
    category: "nvr-recorder",
    tagline: "IDIS TR-4316 DirectCX 16channel Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4316-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-1204",
    manufacturer: "IDIS",
    model: "TR-1204",
    category: "nvr-recorder",
    tagline: "IDIS TR-1204 DirectCX 4channel Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-1204-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-2104",
    manufacturer: "IDIS",
    model: "TR-2104",
    category: "nvr-recorder",
    tagline: "IDIS TR-2104 HD-TVI 4 channel full HD real-time recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-2104-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-1208",
    manufacturer: "IDIS",
    model: "TR-1208",
    category: "nvr-recorder",
    tagline: "IDIS TR-1208 DirectCX 8channel Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-1208-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-1104",
    manufacturer: "IDIS",
    model: "TR-1104",
    category: "nvr-recorder",
    tagline: "IDIS TR-1104 HD-TVI 4 channel full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-1104-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-4216",
    manufacturer: "IDIS",
    model: "TR-4216",
    category: "nvr-recorder",
    tagline: "IDIS TR-4216 HD-TVI 16-channel Full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4216-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"raidLevels":["1"]},
  },
  {
    id: "ss-idis-tr-4108",
    manufacturer: "IDIS",
    model: "TR-4108",
    category: "nvr-recorder",
    tagline: "IDIS TR-4108 HD-TVI 8 channel full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4108-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-3116",
    manufacturer: "IDIS",
    model: "TR-3116",
    category: "nvr-recorder",
    tagline: "IDIS TR-3116 HD-TVI 16 channel full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-3116-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-4208r",
    manufacturer: "IDIS",
    model: "TR-4208R",
    category: "nvr-recorder",
    tagline: "IDIS TR-4208R HD-TVI 8-channel Full HD Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4208r-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"],"raidLevels":["1"]},
  },
  {
    id: "ss-idis-tr-2204",
    manufacturer: "IDIS",
    model: "TR-2204",
    category: "nvr-recorder",
    tagline: "IDIS TR-2204 HD-TVI 4-channel Full HD real-time recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-2204-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-4316r",
    manufacturer: "IDIS",
    model: "TR-4316R",
    category: "nvr-recorder",
    tagline: "IDIS TR-4316R DirectCX 16channel Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4316r-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"raidLevels":["1"]},
  },
  {
    id: "ss-idis-tr-3108",
    manufacturer: "IDIS",
    model: "TR-3108",
    category: "nvr-recorder",
    tagline: "IDIS TR-3108 HD-TVI 8 channel full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-3108-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-4216r",
    manufacturer: "IDIS",
    model: "TR-4216R",
    category: "nvr-recorder",
    tagline: "IDIS TR-4216R HD-TVI 16-channel Full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4216r-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"raidLevels":["1"]},
  },
  {
    id: "ss-idis-tr-4308",
    manufacturer: "IDIS",
    model: "TR-4308",
    category: "nvr-recorder",
    tagline: "IDIS TR-4308 DirectCX 8channel Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4308-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-4208",
    manufacturer: "IDIS",
    model: "TR-4208",
    category: "nvr-recorder",
    tagline: "IDIS TR-4208 HD-TVI 8-channel Full HD Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4208-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-2208",
    manufacturer: "IDIS",
    model: "TR-2208",
    category: "nvr-recorder",
    tagline: "IDIS TR-2208 HD-TVI 8channel Full HD Real-time Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-2208-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-idis-tr-4308r",
    manufacturer: "IDIS",
    model: "TR-4308R",
    category: "nvr-recorder",
    tagline: "IDIS TR-4308R DirectCX 8channel Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4308r-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"],"raidLevels":["1"]},
  },
  {
    id: "ss-idis-tr-1204c",
    manufacturer: "IDIS",
    model: "TR-1204C",
    category: "nvr-recorder",
    tagline: "IDIS TR-1204C DirectCX 4channel Compact Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-1204c-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hanwha-vision-srd-1650-d",
    manufacturer: "Hanwha Vision",
    model: "SRD-1650(D)",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin America Techwin SRD-1650(D) 16-channel premium DVR with full D1 resolution",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-srd-1650-d-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1},
  },
  {
    id: "ss-hanwha-vision-svr-3200",
    manufacturer: "Hanwha Vision",
    model: "SVR-3200",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin America Techwin SVR-3200 32-channel Super Vision DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-svr-3200-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":32,"hddBays":1},
  },
  {
    id: "ss-hanwha-vision-hrx-434",
    manufacturer: "Hanwha Vision",
    model: "HRX 434",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin HRX-434 4CH AHD, TVI, CVI, CVBS, IP Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-hrx-434-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-hrx-435",
    manufacturer: "Hanwha Vision",
    model: "HRX 435",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin HRX-435 4CH AHD, TVI, CVI, CVBS, IP Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-hrx-435-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-srd-850d-dc",
    manufacturer: "Hanwha Vision",
    model: "SRD-850D/DC",
    category: "nvr-recorder",
    tagline: "Coaxial control equipped additions to Hanwha Techwin America H.264 SRD series of DVRs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-srd-850d-dc-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hanwha-vision-hrx-1632",
    manufacturer: "Hanwha Vision",
    model: "HRX-1632",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin HRX-1632 16CH Pentabrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-hrx-1632-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-hanwha-vision-hrx-1620",
    manufacturer: "Hanwha Vision",
    model: "HRX-1620",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin HRX-1620 16CH Pentabrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-hrx-1620-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-hanwha-vision-svr-480",
    manufacturer: "Hanwha Vision",
    model: "SVR-480",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin America Techwin SVR-480 4-channel high resolution digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-svr-480-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1},
  },
  {
    id: "ss-hanwha-vision-hrx-835",
    manufacturer: "Hanwha Vision",
    model: "HRX-835",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin HRX-835 8CH Pentabrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-hrx-835-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-hanwha-vision-hrx-1621",
    manufacturer: "Hanwha Vision",
    model: "HRX-1621",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin HRX-1621 16CH Pentabrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-hrx-1621-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-hanwha-vision-hrx-821",
    manufacturer: "Hanwha Vision",
    model: "HRX-821",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin HRX-821 8CH Pentabrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-hrx-821-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-hanwha-vision-hrx-820",
    manufacturer: "Hanwha Vision",
    model: "HRX-820",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin HRX-820 8CH Pentabrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-hrx-820-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-hanwha-vision-hrx-421",
    manufacturer: "Hanwha Vision",
    model: "HRX-421",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin HRX-421 4CH Pentabrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-hrx-421-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-hanwha-vision-hrx-420",
    manufacturer: "Hanwha Vision",
    model: "HRX-420",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin HRX-420 4CH Pentabrid DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-hrx-420-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-hanwha-vision-srd-1694",
    manufacturer: "Hanwha Vision",
    model: "SRD-1694",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin America SRD-1694 16CH 1080p Analogue HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-srd-1694-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hanwha-vision-srd-1684",
    manufacturer: "Hanwha Vision",
    model: "SRD-1684",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin America SRD-1684 16CH 1080p Analogue HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-srd-1684-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hanwha-vision-srd-893",
    manufacturer: "Hanwha Vision",
    model: "SRD-893",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin America SRD-893 8CH 1080p Analogue HD DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-srd-893-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-wavestore-diamond",
    manufacturer: "Wavestore",
    model: "Diamond",
    category: "nvr-recorder",
    tagline: "Wavestore Diamond analogue - embedded netwrok DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-diamond-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-wavestore-slate",
    manufacturer: "Wavestore",
    model: "Slate",
    category: "nvr-recorder",
    tagline: "Wavestore Slate 1U Rack-Mountable Hybrid Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-slate-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"],"formFactor":"1U"},
  },
  {
    id: "ss-wavestore-flint",
    manufacturer: "Wavestore",
    model: "Flint",
    category: "nvr-recorder",
    tagline: "Wavestore Flint compact Hybrid Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-flint-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-wavestore-quartz",
    manufacturer: "Wavestore",
    model: "Quartz",
    category: "nvr-recorder",
    tagline: "Wavestore Quartz compact ‘hybrid’ digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-quartz-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-messoa-dvr100-008-n",
    manufacturer: "Messoa",
    model: "DVR100-008-N",
    category: "nvr-recorder",
    tagline: "Messoa DVR100-008-N 8 channel H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr100-008-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr200-008",
    manufacturer: "Messoa",
    model: "DVR200-008",
    category: "nvr-recorder",
    tagline: "Messoa DVR200-008 Digital video recorder (DVR)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr200-008-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr100-008-p",
    manufacturer: "Messoa",
    model: "DVR100-008-P",
    category: "nvr-recorder",
    tagline: "Messoa DVR100-008-P 8 Channel H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr100-008-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr100-016-n",
    manufacturer: "Messoa",
    model: "DVR100-016-N",
    category: "nvr-recorder",
    tagline: "Messoa DVR100-016-N 16 channel H.264 digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr100-016-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr200-008-n",
    manufacturer: "Messoa",
    model: "DVR200-008-N",
    category: "nvr-recorder",
    tagline: "Messoa DVR200-008-N 8 channel D1 H.264 real-time digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr200-008-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr200-016-p",
    manufacturer: "Messoa",
    model: "DVR200-016-P",
    category: "nvr-recorder",
    tagline: "Messoa DVR200-016-P 16 channel H.264 D1 real-time digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr200-016-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr200-016",
    manufacturer: "Messoa",
    model: "DVR200-016",
    category: "nvr-recorder",
    tagline: "Messoa DVR200-016 Digital video recorder (DVR)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr200-016-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr100-016",
    manufacturer: "Messoa",
    model: "DVR100-016",
    category: "nvr-recorder",
    tagline: "Messoa DVR100-016 Digital video recorder (DVR)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr100-016-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr200-004-n",
    manufacturer: "Messoa",
    model: "DVR200-004-N",
    category: "nvr-recorder",
    tagline: "Messoa DVR200-004-N 4 channel quadplex real-time digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr200-004-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr200-016-n",
    manufacturer: "Messoa",
    model: "DVR200-016-N",
    category: "nvr-recorder",
    tagline: "Messoa DVR200-016-N 16 channel H.264 real-time digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr200-016-n-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr100-008",
    manufacturer: "Messoa",
    model: "DVR100-008",
    category: "nvr-recorder",
    tagline: "Messoa DVR100-008 Digital video recorder (DVR)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr100-008-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr200-004",
    manufacturer: "Messoa",
    model: "DVR200-004",
    category: "nvr-recorder",
    tagline: "Messoa DVR200-004 Digital video recorder (DVR)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr200-004-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr200-008-p",
    manufacturer: "Messoa",
    model: "DVR200-008-P",
    category: "nvr-recorder",
    tagline: "Messoa DVR200-006-P 8 channel H.264 D1 real-time digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr200-008-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-messoa-dvr200-004-p",
    manufacturer: "Messoa",
    model: "DVR200-004-P",
    category: "nvr-recorder",
    tagline: "Messoa DVR200-004-P 4 channel H.264 D1 real-time digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/messoa-dvr200-004-p-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-360-vision-avalon-h4-16-channel",
    manufacturer: "360 Vision",
    model: "Avalon H4 16 Channel",
    category: "nvr-recorder",
    tagline: "360 Vision presents its Avalon H digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/360-vision-avalon-h4-16-channel-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-360-vision-avalon-h-16-channel",
    manufacturer: "360 Vision",
    model: "Avalon H 16 Channel",
    category: "nvr-recorder",
    tagline: "360 Vision Avalon H 16 Channel 16-channel high performance digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/360-vision-avalon-h-16-channel-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-360-vision-avalon-h-8-channel",
    manufacturer: "360 Vision",
    model: "Avalon H 8 Channel",
    category: "nvr-recorder",
    tagline: "360 Vision Avalon H 8 Channel 8-channel high performance digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/360-vision-avalon-h-8-channel-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-360-vision-avalon-h-4-channel",
    manufacturer: "360 Vision",
    model: "Avalon H 4 Channel",
    category: "nvr-recorder",
    tagline: "360 Vision Avalon H 4 Channel high performance digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/360-vision-avalon-h-4-channel-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1},
  },
  {
    id: "ss-genie-cctv-limited-hddvr8-2000",
    manufacturer: "Genie CCTV Limited",
    model: "HDDVR8/2000",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited HDDVR8/2000 - 2TB HD-SDI professional series digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-hddvr8-2000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-genie-cctv-limited-hdvrq8-6",
    manufacturer: "Genie CCTV Limited",
    model: "HDVRQ8/6",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited HDVRQ8/6 - 8 channel HD-SDI commercial series digital video recorder with 6TB sto",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-hdvrq8-6-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-genie-cctv-limited-hdvrq8-2",
    manufacturer: "Genie CCTV Limited",
    model: "HDVRQ8/2",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited HDVRQ8/2 - 2TB HD-SDI commercial series digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-hdvrq8-2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1},
  },
  {
    id: "ss-genie-cctv-limited-bdvr8-1000",
    manufacturer: "Genie CCTV Limited",
    model: "BDVR8/1000",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited BDVR8/1000 - 8 Channel Triplex DVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-bdvr8-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-genie-cctv-limited-gdvrh608-1000",
    manufacturer: "Genie CCTV Limited",
    model: "GDVRH608/1000",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited GDVRH608/1000 8 Channel Quadraplex DVR with DVD-RW (H.264 Compression)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-gdvrh608-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-genie-cctv-limited-bdvr4-500",
    manufacturer: "Genie CCTV Limited",
    model: "BDVR4/500",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited BDVR4/500 touch panel embedded linux operating system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-bdvr4-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-genie-cctv-limited-edvrh4-500",
    manufacturer: "Genie CCTV Limited",
    model: "EDVRH4/500",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited EDVRH4/500 - 4 Channel Touch Panel Triplex DVR with DVD-RW",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-edvrh4-500-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-genie-cctv-limited-gdvrh608-2000",
    manufacturer: "Genie CCTV Limited",
    model: "GDVRH608/2000",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited GDVRH608/2000 - 8 Channel Quadraplex DVR with DVD-RW (H.264 Compression)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-gdvrh608-2000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-genie-cctv-limited-edvrh8-1000",
    manufacturer: "Genie CCTV Limited",
    model: "EDVRH8/1000",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited EDVRH8/1000 - 8 Channel Touch Panel Triplex DVR with DVD-RW",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-edvrh8-1000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-genie-cctv-limited-hdvrq8-4",
    manufacturer: "Genie CCTV Limited",
    model: "HDVRQ8/4",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited HDVRQ8/4 - 4 Channel HD-SDI Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-hdvrq8-4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-genie-cctv-limited-lthdvr4-4",
    manufacturer: "Genie CCTV Limited",
    model: "LTHDVR4/4",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited LTHDVR4/4 - 4 Channel HD-SDI Pentaplex Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-lthdvr4-4-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-genie-cctv-limited-hddvr4-4000",
    manufacturer: "Genie CCTV Limited",
    model: "HDDVR4/4000",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited HDDVR4/4000 - 4 Channel HD-SDI Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-hddvr4-4000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-genie-cctv-limited-lthdvr4-2",
    manufacturer: "Genie CCTV Limited",
    model: "LTHDVR4/2",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited LTHDVR4/2 - 4 channel pentaplex digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-lthdvr4-2-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-genie-cctv-limited-hddvr4-2000",
    manufacturer: "Genie CCTV Limited",
    model: "HDDVR4/2000",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited HDDVR4/2000 - 4 Channel HD-SDI Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-hddvr4-2000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-genie-cctv-limited-lthdvr4-1",
    manufacturer: "Genie CCTV Limited",
    model: "LTHDVR4/1",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited LTHDVR4/1 - 4 channel digital video recorder with 6TB internal storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-lthdvr4-1-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-genie-cctv-limited-hddvr4-6000",
    manufacturer: "Genie CCTV Limited",
    model: "HDDVR4/6000",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited HDDVR4/6000 - 4 Channel HD-SDI Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-hddvr4-6000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-genie-cctv-limited-hddvr8-6000",
    manufacturer: "Genie CCTV Limited",
    model: "HDDVR8/6000",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited HDDVR8/6000 - 8 Channel HD-SDI Pentaplex Digital Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-hddvr8-6000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-genie-cctv-limited-hddvr8-4000",
    manufacturer: "Genie CCTV Limited",
    model: "HDDVR8/4000",
    category: "nvr-recorder",
    tagline: "Genie CCTV Limited HDDVR8/4000 - 8 Channel HD-SDI Pentaplex Digital Video Recorders",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genie-cctv-limited-hddvr8-4000-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-nuuo-scb-7108",
    manufacturer: "NUUO",
    model: "SCB-7108",
    category: "nvr-recorder",
    tagline: "NUUO SCB-7108 8 channel DVR card",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/nuuo-scb-7108-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-nuuo-scb-7116",
    manufacturer: "NUUO",
    model: "SCB-7116",
    category: "nvr-recorder",
    tagline: "NUUO SCB-7116 DVR card with 16 video inputs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/nuuo-scb-7116-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-nuuo-scb-6004",
    manufacturer: "NUUO",
    model: "SCB-6004",
    category: "nvr-recorder",
    tagline: "NUUO SCB-6004 DVR card with 4 video inputs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/nuuo-scb-6004-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-nuuo-scb-1004",
    manufacturer: "NUUO",
    model: "SCB-1004",
    category: "nvr-recorder",
    tagline: "NUUO SCB-1004 4 input digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/nuuo-scb-1004-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-nuuo-scb-6008",
    manufacturer: "NUUO",
    model: "SCB-6008",
    category: "nvr-recorder",
    tagline: "NUUO SCB-6008 DVR card with 8 video inputs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/nuuo-scb-6008-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-nuuo-scb-6016",
    manufacturer: "NUUO",
    model: "SCB-6016",
    category: "nvr-recorder",
    tagline: "NUUO SCB-6016 DVR card with 16 video inputs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/nuuo-scb-6016-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-nuuo-scb-1008",
    manufacturer: "NUUO",
    model: "SCB-1008",
    category: "nvr-recorder",
    tagline: "NUUO SCB-1008 8 input digital video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/nuuo-scb-1008-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-panasonic-wj-hde400",
    manufacturer: "Panasonic",
    model: "WJ-HDE400",
    category: "nvr-recorder",
    tagline: "Panasonic WJ-HDE400 expansion bay",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/panasonic-wj-hde400-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":0,"hddBays":1},
  },
  {
    id: "ss-ganz-dr16h-dvd-2tb",
    manufacturer: "Ganz",
    model: "DR16H-DVD/2TB",
    category: "nvr-recorder",
    tagline: "Ganz DR16H-DVD/2TB digital video recorder with PTZ control",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-dr16h-dvd-2tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-ganz-dr8h-dvd-2tb",
    manufacturer: "Ganz",
    model: "DR8H-DVD/2TB",
    category: "nvr-recorder",
    tagline: "Ganz DR8H-DVD/2TB digital video recorder with high resolution recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-dr8h-dvd-2tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-ganz-dr16h-dvd-1tb",
    manufacturer: "Ganz",
    model: "DR16H-DVD/1TB",
    category: "nvr-recorder",
    tagline: "Ganz DR16H-DVD/1TB digital video recorder with archive to CD, DVD, USB drive",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-dr16h-dvd-1tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-ganz-dr8h-dvd-1tb",
    manufacturer: "Ganz",
    model: "DR8H-DVD/1TB",
    category: "nvr-recorder",
    tagline: "Ganz DR8H-DVD/1TB digital video recorder with efficient H.264 compression",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-dr8h-dvd-1tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-ganz-dr16h-dvd-3tb",
    manufacturer: "Ganz",
    model: "DR16H-DVD/3TB",
    category: "nvr-recorder",
    tagline: "Ganz DR16H-DVD/3TB digital video recorder with remote access via network",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-dr16h-dvd-3tb-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-verint-mdvr-6s",
    manufacturer: "Verint",
    model: "mDVR-6S",
    category: "nvr-recorder",
    tagline: "Verint Nextiva mDVR-6S Mobile Digital video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verint-mdvr-6s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":6,"hddBays":1},
  },
  {
    id: "ss-verint-nextiva-m-dvr-12s",
    manufacturer: "Verint",
    model: "Nextiva m-DVR-12S",
    category: "nvr-recorder",
    tagline: "Verint Nextiva mDVR-12S Mobile Digital Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verint-nextiva-m-dvr-12s-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":12,"hddBays":1},
  },
  {
    id: "ss-dallmeier-dms-2400-smavia",
    manufacturer: "Dallmeier",
    model: "DMS 2400 SMAVIA",
    category: "nvr-recorder",
    tagline: "Dallmeier DMS 2400 SMAVIA",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dallmeier-dms-2400-smavia-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dallmeier-videonetbox-ii",
    manufacturer: "Dallmeier",
    model: "VideoNetBox II",
    category: "nvr-recorder",
    tagline: "Compact, flexible, future-proof: The new VideoNetBox II from Dallmeier",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dallmeier-videonetbox-ii-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-dallmeier-dmx-2400",
    manufacturer: "Dallmeier",
    model: "DMX 2400",
    category: "nvr-recorder",
    tagline: "Dallmeier DMX 2400 24 Channels 1080p hybrid videoIP appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dallmeier-dmx-2400-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":24,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-dallmeier-dls-1600",
    manufacturer: "Dallmeier",
    model: "DLS 1600",
    category: "nvr-recorder",
    tagline: "SMAVIA loyalty bonus for DLS 1600",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dallmeier-dls-1600-digital-video-recorder-dvr-technical-details.html",
    specs: {"hybrid":true,"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7604nxi-k1-4p-vpro",
    manufacturer: "Hikvision",
    model: "DS-7604NXI-K1/4P/VPro",
    category: "nvr-recorder",
    tagline: "Hikvision AcuSeek NVR with AI-Powered Video Search and AcuSense Technology",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604nxi-k1-4p-vpro-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7608nxi-i2-8p-vpro",
    manufacturer: "Hikvision",
    model: "DS-7608NXI-I2/8P/Vpro",
    category: "nvr-recorder",
    tagline: "Hikvision AI-Powered AcuSeek NVR with Smart Video Search and Mobile Access",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608nxi-i2-8p-vpro-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7732ni-e4",
    manufacturer: "Hikvision",
    model: "DS-7732NI-E4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-E4 embedded plug & play NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-e4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7616ni-e2",
    manufacturer: "Hikvision",
    model: "DS-7616NI-E2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-E2 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-e2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7732ni-st",
    manufacturer: "Hikvision",
    model: "DS-7732NI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-ST 32-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-st-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7608ni-e1",
    manufacturer: "Hikvision",
    model: "DS-7608NI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-E1 embedded NVR with up to 6 MP resolution recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-e1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7616ni-se-p",
    manufacturer: "Hikvision",
    model: "DS-7616NI-SE/P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-SE/P 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-se-p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7716ni-st",
    manufacturer: "Hikvision",
    model: "DS-7716NI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-ST 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-st-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7608ni-e2-8p",
    manufacturer: "Hikvision",
    model: "DS-7608NI-E2/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-E2/8P embedded plug & play NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-e2-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7732ni-sp",
    manufacturer: "Hikvision",
    model: "DS-7732NI-SP",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-SP 32-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-sp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7632ni-st",
    manufacturer: "Hikvision",
    model: "DS-7632NI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7632NI-ST 32-channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7632ni-st-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7616ni-e2-8p",
    manufacturer: "Hikvision",
    model: "DS-7616NI-E2/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-E2/8P 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-e2-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7716nxi-i4-16p-vpro",
    manufacturer: "Hikvision",
    model: "DS-7716NXI-I4/16P/VPro",
    category: "nvr-recorder",
    tagline: "Hikvision AcuSeek NVR with AI",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716nxi-i4-16p-vpro-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-e08ni-q1-8p-ssd-nvr",
    manufacturer: "Hikvision",
    model: "DS-E08NI-Q1/8P SSD NVR",
    category: "nvr-recorder",
    tagline: "Hikvision eSSD technology - Small in size, powerful in design",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-e08ni-q1-8p-ssd-nvr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7616ni-e1",
    manufacturer: "Hikvision",
    model: "DS-7616NI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-E1 embedded NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-e1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7608ni-se-p",
    manufacturer: "Hikvision",
    model: "DS-7608NI-SE/P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-SE/P economic PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-se-p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-8632ni-st",
    manufacturer: "Hikvision",
    model: "DS-8632NI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8632NI-ST 32-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8632ni-st-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7616ni-e2-16p",
    manufacturer: "Hikvision",
    model: "DS-7616NI-E2/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-E2/16P embedded plug & play NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-e2-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-9632nxi-m8r-vpro",
    manufacturer: "Hikvision",
    model: "DS-9632NXI-M8R/VPro",
    category: "nvr-recorder",
    tagline: "Hikvision launches the latest NVR 5.0 to revolutionize the product experience",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9632nxi-m8r-vpro-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":2,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9632ni-xt",
    manufacturer: "Hikvision",
    model: "DS-9632NI-XT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9632NI-XT 32-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9632ni-xt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-7616ni-k1",
    manufacturer: "Hikvision",
    model: "DS-7616NI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-K1 16-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-k1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7108ni-q1-8p",
    manufacturer: "Hikvision",
    model: "DS-7108NI-Q1/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108NI-Q1/8P 8-ch mini 1U 8 PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108ni-q1-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7616ni-sp",
    manufacturer: "Hikvision",
    model: "DS-7616NI-SP",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-SP 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-sp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-9664ni-i16",
    manufacturer: "Hikvision",
    model: "DS-9664NI-I16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9664NI-I16 64 channel embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9664ni-i16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-hikvision-ds-9664nxi-i8-s-c",
    manufacturer: "Hikvision",
    model: "DS-9664NXI-I8/S(C)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9664NXI-I8/S(C) 64-ch 2U 4K AcuSense NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9664nxi-i8-s-c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-7608ni-k1",
    manufacturer: "Hikvision",
    model: "DS-7608NI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-K1 8-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-k1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7616ni-st",
    manufacturer: "Hikvision",
    model: "DS-7616NI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-ST 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-st-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7732ni-k4",
    manufacturer: "Hikvision",
    model: "DS-7732NI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-K4 Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-k4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9632nxi-i8-s-c",
    manufacturer: "Hikvision",
    model: "DS-9632NXI-I8/S(C)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9632NXI-I8/S(C) 32-ch 2U 4K AcuSense NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9632nxi-i8-s-c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-7716ni-sp-16",
    manufacturer: "Hikvision",
    model: "DS-7716NI-SP/16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-SP/16 16 channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-sp-16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-96128ni-f16",
    manufacturer: "Hikvision",
    model: "DS-96128NI-F16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96128NI-F16 128 channel Super NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96128ni-f16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"raidLevels":["0","1","5","10"]},
  },
  {
    id: "ss-hikvision-ds-7108ni-q1-m",
    manufacturer: "Hikvision",
    model: "DS-7108NI-Q1/M",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108NI-Q1/M 8-ch Mini 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108ni-q1-m-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7616ni-q1",
    manufacturer: "Hikvision",
    model: "DS-7616NI-Q1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-Q1 16-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-q1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7716ni-e4-16p",
    manufacturer: "Hikvision",
    model: "DS-7716NI-E4/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-E4/16P embedded plug & play NVR with up to 6 MP resolution",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-e4-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-hikvision-ids-9632nxi-i8-x",
    manufacturer: "Hikvision",
    model: "iDS-9632NXI-I8/X",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-9632NXI-I8/X 32-ch 3U 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9632nxi-i8-x-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"3U"},
  },
  {
    id: "ss-hikvision-ae-mn7083-rj45",
    manufacturer: "Hikvision",
    model: "AE-MN7083(RJ45)",
    category: "nvr-recorder",
    tagline: "Hikvision AE-MN7083(RJ45) Mobile Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ae-mn7083-rj45-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7632ni-k2",
    manufacturer: "Hikvision",
    model: "DS-7632NI-K2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7632NI-K2 32-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7632ni-k2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-exacqvision-ip01-08t-2aw-e",
    manufacturer: "exacqVision",
    model: "IP01-08T-2AW-E",
    category: "nvr-recorder",
    tagline: "exacqVision IP01-08T-2AW-E 8TB 2U rackmount network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/exacqvision-ip01-08t-2aw-e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-exacqvision-ip01-48t-2aw",
    manufacturer: "exacqVision",
    model: "IP01-48T-2AW",
    category: "nvr-recorder",
    tagline: "exacqVision IP01-48T-2AW 48TB 2U rackmount network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/exacqvision-ip01-48t-2aw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-exacqvision-ip01-12t-2aw",
    manufacturer: "exacqVision",
    model: "IP01-12T-2AW",
    category: "nvr-recorder",
    tagline: "exacqVision IP01-12T-2AW 12TB 2U rackmount network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/exacqvision-ip01-12t-2aw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-exacqvision-ip16-04t-gpl-e",
    manufacturer: "exacqVision",
    model: "IP16-04T-GPL-E",
    category: "nvr-recorder",
    tagline: "exacqVision IP16-04T-GPL-E 16 port PoE+ network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/exacqvision-ip16-04t-gpl-e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-exacqvision-ip01-08t-2aw",
    manufacturer: "exacqVision",
    model: "IP01-08T-2AW",
    category: "nvr-recorder",
    tagline: "exacqVision IP01-08T-2AW 8TB 2U rackmount network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/exacqvision-ip01-08t-2aw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-exacqvision-ip01-12t-2al-e",
    manufacturer: "exacqVision",
    model: "IP01-12T-2AL-E",
    category: "nvr-recorder",
    tagline: "exacqVision IP01-12T-2AL-E 12TB 2U rackmount network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/exacqvision-ip01-12t-2al-e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-exacqvision-ip01-24t-2al-e",
    manufacturer: "exacqVision",
    model: "IP01-24T-2AL-E",
    category: "nvr-recorder",
    tagline: "exacqVision IP01-24T-2AL-E 24TB 2U rackmount network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/exacqvision-ip01-24t-2al-e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-exacqvision-ip01-72t-2aw",
    manufacturer: "exacqVision",
    model: "IP01-72T-2AW",
    category: "nvr-recorder",
    tagline: "exacqVision IP01-72T-2AW 72TB 2U rackmount network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/exacqvision-ip01-72t-2aw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-exacqvision-ip01-24t-2aw",
    manufacturer: "exacqVision",
    model: "IP01-24T-2AW",
    category: "nvr-recorder",
    tagline: "exacqVision IP01-24T-2AW 24TB 2U rackmount network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/exacqvision-ip01-24t-2aw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-exacqvision-ip16-08t-gpl-e",
    manufacturer: "exacqVision",
    model: "IP16-08T-GPL-E",
    category: "nvr-recorder",
    tagline: "exacqVision IP16-08T-GPL-E 16 port PoE+ network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/exacqvision-ip16-08t-gpl-e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-6700ni-s",
    manufacturer: "Hikvision",
    model: "DS-6700NI-S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-6700NI-S Hik-ProConnect Box",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-6700ni-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-8632ni-k8",
    manufacturer: "Hikvision",
    model: "DS-8632NI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8632NI-K8 32-ch 2U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8632ni-k8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ae-mh0408-rj45",
    manufacturer: "Hikvision",
    model: "AE-MH0408(RJ45)",
    category: "nvr-recorder",
    tagline: "Hikvision AE-MH0408(RJ45) 12-ch, H.264/H.265, 2 x HDD/SSD Mobile HDVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ae-mh0408-rj45-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":12,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7608ni-q1-8p",
    manufacturer: "Hikvision",
    model: "DS-7608NI-Q1/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-Q1/8P 8-ch 1U 8 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-q1-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7632nxi-i2-s-e",
    manufacturer: "Hikvision",
    model: "DS-7632NXI-I2/S (E)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7632NXI-I2/S (E) 32-ch 1U AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7632nxi-i2-s-e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-9632ni-st",
    manufacturer: "Hikvision",
    model: "DS-9632NI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9632NI-ST 32-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9632ni-st-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7608ni-q1",
    manufacturer: "Hikvision",
    model: "DS-7608NI-Q1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-Q1 8-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-q1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7608ni-g2-4p",
    manufacturer: "Hikvision",
    model: "DS-7608NI-G2/4P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-G2/4P Embedded NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-g2-4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-hikvision-ds-9664ni-i8",
    manufacturer: "Hikvision",
    model: "DS-9664NI-I8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9664NI-I8 embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9664ni-i8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["0","1","5","10"]},
  },
  {
    id: "ss-hikvision-ds-9664ni-st",
    manufacturer: "Hikvision",
    model: "DS-9664NI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9664NI-ST 64-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9664ni-st-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7p08ni-e1",
    manufacturer: "Hikvision",
    model: "DS-7P08NI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7P08NI-E1 8 channel Embedded NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7p08ni-e1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7616ni-k2-16p",
    manufacturer: "Hikvision",
    model: "DS-7616NI-K2/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-K2/16P embedded plug & play 4K NVR with up to 8 MP resolution",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-k2-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-96128ni-i16",
    manufacturer: "Hikvision",
    model: "DS-96128NI-I16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96128NI-I16 128 Channel New Super 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96128ni-i16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-9616ni-i8",
    manufacturer: "Hikvision",
    model: "DS-9616NI-I8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9616NI-I8 Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9616ni-i8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-9632ni-m8",
    manufacturer: "Hikvision",
    model: "DS-9632NI-M8",
    category: "nvr-recorder",
    tagline: "Hikvision unveils the industry's first \"True 8K\" NVRs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9632ni-m8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-96128ni-i24",
    manufacturer: "Hikvision",
    model: "DS-96128NI-I24",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96128NI-I24 New Super 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96128ni-i24-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-hikvision-ds-7716ni-e4",
    manufacturer: "Hikvision",
    model: "DS-7716NI-E4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-E4 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-e4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7608ni-k1-8p",
    manufacturer: "Hikvision",
    model: "DS-7608NI-K1/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-K1/8P 8-ch 1U 8 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-k1-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-96128ni-i16-h",
    manufacturer: "Hikvision",
    model: "DS-96128NI-I16/H",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96128NI-I16/H new super 4K NVR with upto 12 MP resolution recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96128ni-i16-h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":20,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-7108ni-k1-w-m-c",
    manufacturer: "Hikvision",
    model: "DS-7108NI-K1/W/M(C)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108NI-K1/W/M(C) 8-ch Mini 1U Wi-Fi NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108ni-k1-w-m-c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-9664ni-m8",
    manufacturer: "Hikvision",
    model: "DS-9664NI-M8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9664NI-M8 64-ch 2U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9664ni-m8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-9608ni-i8",
    manufacturer: "Hikvision",
    model: "DS-9608NI-I8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9608NI-I8 8-ch 2U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9608ni-i8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-9616ni-xt",
    manufacturer: "Hikvision",
    model: "DS-9616NI-XT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9616NI-XT high-end NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9616ni-xt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-9616ni-st",
    manufacturer: "Hikvision",
    model: "DS-9616NI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9616NI-ST 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9616ni-st-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7108ni-q1-8p-m",
    manufacturer: "Hikvision",
    model: "DS-7108NI-Q1/8P/M",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108NI-Q1/8P/M 8-ch Mini 1U 8 PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108ni-q1-8p-m-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-9664ni-i8-8-8t-seagate",
    manufacturer: "Hikvision",
    model: "DS-9664NI-I8(8*8T Seagate)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9664NI-I8(8*8T Seagate) 64-ch 2U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9664ni-i8-8-8t-seagate-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-7716ni-k4",
    manufacturer: "Hikvision",
    model: "DS-7716NI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-K4 embedded 4K NVR with upto 8 Megapixels resolution",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-k4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7632ni-m2",
    manufacturer: "Hikvision",
    model: "DS-7632NI-M2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7632NI-M2 32-ch 1U 8K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7632ni-m2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7108ni-sn-p",
    manufacturer: "Hikvision",
    model: "DS-7108NI-SN/P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108NI-SN/P embedded mini plug & play NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108ni-sn-p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-m7508hni",
    manufacturer: "Hikvision",
    model: "DS-M7508HNI",
    category: "nvr-recorder",
    tagline: "Hikvision DS-M7508HNI Mobile NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-m7508hni-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":3,"hddBays":1,"codecs":["H.264"],"onvif":true},
  },
  {
    id: "ss-hikvision-ds-9664ni-m16",
    manufacturer: "Hikvision",
    model: "DS-9664NI-M16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9664NI-M16 64-ch 3U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9664ni-m16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-hikvision-ds-9632ni-i8-8-8t-seagate",
    manufacturer: "Hikvision",
    model: "DS-9632NI-I8(8*8T Seagate)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9632NI-I8(8*8T Seagate) 32-ch 2U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9632ni-i8-8-8t-seagate-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-7608ni-sp",
    manufacturer: "Hikvision",
    model: "DS-7608NI-SP",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-SP 8-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-sp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7108ni-e1-v-w",
    manufacturer: "Hikvision",
    model: "DS-7108NI-E1/V/W",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108NI-E1/V/W embedded mini wifi NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108ni-e1-v-w-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":6,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-9664ni-xt",
    manufacturer: "Hikvision",
    model: "DS-9664NI-XT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9664NI-XT 64-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9664ni-xt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-7732ni-k4-16p",
    manufacturer: "Hikvision",
    model: "DS-7732NI-K4/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-K4/16P embedded plug & play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-k4-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7104ni-sn-p",
    manufacturer: "Hikvision",
    model: "DS-7104NI-SN/P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104NI-SN/P embedded mini plug & play NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104ni-sn-p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-96128ni-m8",
    manufacturer: "Hikvision",
    model: "DS-96128NI-M8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96128NI-M8 128-ch 2U 8K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96128ni-m8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-7104ni-q1-m",
    manufacturer: "Hikvision",
    model: "DS-7104NI-Q1/M",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104NI-Q1/M 4-ch mini 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104ni-q1-m-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7108ni-sn",
    manufacturer: "Hikvision",
    model: "DS-7108NI-SN",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108NI-SN embedded mIni NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108ni-sn-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-96256ni-i16",
    manufacturer: "Hikvision",
    model: "DS-96256NI-I16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96256NI-I16 256-ch 3U 4K Super NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96256ni-i16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-hikvision-ds-7732ni-q4-16p",
    manufacturer: "Hikvision",
    model: "DS-7732NI-Q4/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-Q4/16P 32-ch 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-q4-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7616ni-q2",
    manufacturer: "Hikvision",
    model: "DS-7616NI-Q2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-Q2 16-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-q2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-96256ni-i24-h",
    manufacturer: "Hikvision",
    model: "DS-96256NI-I24/H",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96256NI-I24/H New Super 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96256ni-i24-h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":20,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-7616ni-vp",
    manufacturer: "Hikvision",
    model: "DS-7616NI-VP",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-VP 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-vp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-mp7608hn",
    manufacturer: "Hikvision",
    model: "DS-MP7608HN",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP7608HN Mobile NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp7608hn-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7732ni-i4-b",
    manufacturer: "Hikvision",
    model: "DS-7732NI-I4(B)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-I4(B) 32-ch 1.5U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-i4-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7116ni-sn",
    manufacturer: "Hikvision",
    model: "DS-7116NI-SN",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7116NI-SN 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7116ni-sn-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7632ni-k2-16p",
    manufacturer: "Hikvision",
    model: "DS-7632NI-K2/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7632NI-K2/16P 32-ch 1U 16 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7632ni-k2-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ae-mn5043-rj45",
    manufacturer: "Hikvision",
    model: "AE-MN5043(RJ45)",
    category: "nvr-recorder",
    tagline: "Hikvision AE-MN5043(RJ45) 4-ch , H.264/H.265, 2 x HDD/SSD Mobile NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ae-mn5043-rj45-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7732nxi-i4-16p-s-e",
    manufacturer: "Hikvision",
    model: "DS-7732NXI-I4/16P/S (E)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NXI-I4/16P/S (E) 32-ch 1U 16 POE AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732nxi-i4-16p-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7616ni-k2",
    manufacturer: "Hikvision",
    model: "DS-7616NI-K2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-K2 embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-k2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-96128ni-i24-h",
    manufacturer: "Hikvision",
    model: "DS-96128NI-I24/H",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96128NI-I24/H New Super 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96128ni-i24-h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":20,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-9632ni-i16",
    manufacturer: "Hikvision",
    model: "DS-9632NI-I16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9632NI-I16 NVR with embedded 4K",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9632ni-i16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":2,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-9616ni-m8",
    manufacturer: "Hikvision",
    model: "DS-9616NI-M8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9616NI-M8 16-ch 2U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9616ni-m8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-7608ni-s",
    manufacturer: "Hikvision",
    model: "DS-7608NI-S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-S 8-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7616ni-m2",
    manufacturer: "Hikvision",
    model: "DS-7616NI-M2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-M2 16-ch 1U 8K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-m2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-96256ni-i24",
    manufacturer: "Hikvision",
    model: "DS-96256NI-I24",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96256NI-I24 256 channel 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96256ni-i24-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-hikvision-ds-7708ni-i4-8p",
    manufacturer: "Hikvision",
    model: "DS-7708NI-I4/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7708NI-I4/8P 8-ch 1.5U 8 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7708ni-i4-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7116ni-sn-p",
    manufacturer: "Hikvision",
    model: "DS-7116NI-SN/P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7116NI-SN/P 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7116ni-sn-p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7708ni-k4-8p",
    manufacturer: "Hikvision",
    model: "DS-7708NI-K4/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7708NI-K4/8P Embedded Plug & Play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7708ni-k4-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-mp5504",
    manufacturer: "Hikvision",
    model: "DS-MP5504",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP5504 Mobile Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp5504-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-96064ni-i16",
    manufacturer: "Hikvision",
    model: "DS-96064NI-I16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96064NI-I16 New Super 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96064ni-i16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":20,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-mp1803",
    manufacturer: "Hikvision",
    model: "DS-MP1803",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP1803 Intelligent Analyzer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp1803-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-mp3516-rs",
    manufacturer: "Hikvision",
    model: "DS-MP3516-RS",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP3516-RS train NVR with built-in 3G (WCDMA) and Wi-Fi module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp3516-rs-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7604ni-e1-4p-a",
    manufacturer: "Hikvision",
    model: "DS-7604NI-E1/4P/A",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-E1/4P/A 4-channel plug & play network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-e1-4p-a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-9632ni-m16",
    manufacturer: "Hikvision",
    model: "DS-9632NI-M16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9632NI-M16 32-ch 3U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9632ni-m16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-hikvision-ids-9632nxi-i8-ba",
    manufacturer: "Hikvision",
    model: "iDS-9632NXI-I8/BA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-9632NXI-I8/BA 32-ch 2U 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9632nxi-i8-ba-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.265+","H.265"],"raidLevels":["0","1","5","6","10"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-7104ni-k1-w-m-c",
    manufacturer: "Hikvision",
    model: "DS-7104NI-K1/W/M(C)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104NI-K1/W/M(C) 4-ch Mini 1U WiFi NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104ni-k1-w-m-c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7708ni-i4",
    manufacturer: "Hikvision",
    model: "DS-7708NI-I4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7708NI-I4 8-ch 1.5U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7708ni-i4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-hikvision-ae-mn5043-m12",
    manufacturer: "Hikvision",
    model: "AE-MN5043(M12)",
    category: "nvr-recorder",
    tagline: "Hikvision AE-MN5043(M12) 4-ch , H.264/H.265, 2 x HDD/SSD Mobile NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ae-mn5043-m12-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7604ni-k1-4p-b",
    manufacturer: "Hikvision",
    model: "DS-7604NI-K1/4P(B)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-K1/4P(B) Embedded Plug & Play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-k1-4p-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7632ni-i2",
    manufacturer: "Hikvision",
    model: "DS-7632NI-I2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7632NI-I2 32-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7632ni-i2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-hikcentral-storage-256-16h",
    manufacturer: "Hikvision",
    model: "Hikcentral-Storage/256/16H",
    category: "nvr-recorder",
    tagline: "Hikvision Hikcentral-Storage/256/16H central security system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-hikcentral-storage-256-16h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7616ni-se-n",
    manufacturer: "Hikvision",
    model: "DS-7616NI-SE/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-SE/N economic NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-se-n-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7632ni-i2-16p",
    manufacturer: "Hikvision",
    model: "DS-7632NI-I2/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7632NI-I2/16P 32-ch 1U 16 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7632ni-i2-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7716ni-q4-16p",
    manufacturer: "Hikvision",
    model: "DS-7716NI-Q4/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-Q4/16P 16-ch 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-q4-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7608ni-k2",
    manufacturer: "Hikvision",
    model: "DS-7608NI-K2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-K2 embedded 4K NVR up to 8 MP resolution",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-k2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7608ni-v",
    manufacturer: "Hikvision",
    model: "DS-7608NI-V",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-V embedded vertical NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-v-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7600ni-e1-a",
    manufacturer: "Hikvision",
    model: "DS-7600NI-E1/A",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7600NI-E1/A all-in-one NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7600ni-e1-a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-8616ni-k8",
    manufacturer: "Hikvision",
    model: "DS-8616NI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8616NI-K8 16-ch 2U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8616ni-k8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-9616ni-i16",
    manufacturer: "Hikvision",
    model: "DS-9616NI-I16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9616NI-I16 16-ch 3U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9616ni-i16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-hikvision-ds-7616ni-k2-4g",
    manufacturer: "Hikvision",
    model: "DS-7616NI-K2/4G",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-K2/4G 16-ch 1U 4G NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-k2-4g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-6704nxi-i-ba",
    manufacturer: "Hikvision",
    model: "iDS-6704NXI-I/BA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-6704NXI-I/BA DeepinMind NVS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-6704nxi-i-ba-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-hikvision-ds-7104ni-sn-n",
    manufacturer: "Hikvision",
    model: "DS-7104NI-SN/N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104NI-SN/N embedded mini NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104ni-sn-n-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-m5504hni-m12",
    manufacturer: "Hikvision",
    model: "DS-M5504HNI-M12",
    category: "nvr-recorder",
    tagline: "Hikvision DS-M5504HNI-M12 Mobile NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-m5504hni-m12-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"],"onvif":true},
  },
  {
    id: "ss-hikvision-ds-7608ni-st",
    manufacturer: "Hikvision",
    model: "DS-7608NI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-ST 8-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-st-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7732ni-m4",
    manufacturer: "Hikvision",
    model: "DS-7732NI-M4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-M4 32-ch 1.5U 8K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-m4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-nvr-208mh-c-8p",
    manufacturer: "Hikvision",
    model: "NVR-208MH-C/8P",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-208MH-C/8P 8-ch 1U 8 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-208mh-c-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7604ni-k1",
    manufacturer: "Hikvision",
    model: "DS-7604NI-K1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-K1 embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-k1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-nvr-108mh-c",
    manufacturer: "Hikvision",
    model: "NVR-108MH-C",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-108MH-C 8-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-108mh-c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-9616nxi-i8-8f-b",
    manufacturer: "Hikvision",
    model: "iDS-9616NXI-I8/8F(B)",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-9616NXI-I8/8F(B) 16-channel DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9616nxi-i8-8f-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.265+","H.265"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-7604ni-k1-4p-4g",
    manufacturer: "Hikvision",
    model: "DS-7604NI-K1/4P/4G",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-K1/4P/4G 4-ch Mini 1U 4 POE 4G NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-k1-4p-4g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7608ni-m2-8p",
    manufacturer: "Hikvision",
    model: "DS-7608NI-M2/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-M2/8P 8-ch 1U 8 PoE 8K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-m2-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7716ni-i4-16p-b",
    manufacturer: "Hikvision",
    model: "DS-7716NI-I4/16P(B)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-I4/16P(B) 16-ch 1.5U 16 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-i4-16p-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7608ni-k2-8p-4g",
    manufacturer: "Hikvision",
    model: "DS-7608NI-K2/8P/4G",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-K2/8P/4G 8-ch 1U 8 POE 4G NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-k2-8p-4g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7616ni-i2-16p",
    manufacturer: "Hikvision",
    model: "DS-7616NI-I2/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-I2/16P embedded plug & play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-i2-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7708ni-e4-8p",
    manufacturer: "Hikvision",
    model: "DS-7708NI-E4/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7708NI-E4/8P embedded plug & play NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7708ni-e4-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-wseli-t2",
    manufacturer: "Hikvision",
    model: "DS-WSELI-T2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-WSELI-T2 Eco Series 2-Slot Workstation for Linux",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-wseli-t2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-9600ni-h8",
    manufacturer: "Hikvision",
    model: "DS-9600NI-H8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9600NI-H8 24-channel H.265, 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9600ni-h8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1,"codecs":["H.265"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-9664ni-rt",
    manufacturer: "Hikvision",
    model: "DS-9664NI-RT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9664NI-RT 64-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9664ni-rt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-7604ni-k1-4p",
    manufacturer: "Hikvision",
    model: "DS-7604NI-K1/4P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-K1/4P embedded plug & play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-k1-4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7p04ni-e1-4p",
    manufacturer: "Hikvision",
    model: "DS-7P04NI-E1/4P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7P04NI-E1/4P Embedded Plug & Play NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7p04ni-e1-4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7708ni-sp",
    manufacturer: "Hikvision",
    model: "DS-7708NI-SP",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7708NI-SP 8-channel plug & play network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7708ni-sp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-hikvision-nvr-208mh-c",
    manufacturer: "Hikvision",
    model: "NVR-208MH-C",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-208MH-C 8-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-208mh-c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-96256ni-i16-h",
    manufacturer: "Hikvision",
    model: "DS-96256NI-I16/H",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96256NI-I16/H new super 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96256ni-i16-h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":20,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-96128ni-e16",
    manufacturer: "Hikvision",
    model: "DS-96128NI-E16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96128NI-E16 128-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96128ni-e16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-9664ni-i16-16-8t-seagate",
    manufacturer: "Hikvision",
    model: "DS-9664NI-I16(16*8T Seagate)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9664NI-I16(16*8T Seagate) 64-ch 3U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9664ni-i16-16-8t-seagate-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-hikvision-ds-9632ni-i8",
    manufacturer: "Hikvision",
    model: "DS-9632NI-I8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9632NI-I8 embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9632ni-i8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":2,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-96256ni-e16-h",
    manufacturer: "Hikvision",
    model: "DS-96256NI-E16/H",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96256NI-E16/H 256-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96256ni-e16-h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-96128ni-f24",
    manufacturer: "Hikvision",
    model: "DS-96128NI-F24",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96128NI-F24 embedded NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96128ni-f24-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":14,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-9608ni-st",
    manufacturer: "Hikvision",
    model: "DS-9608NI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9608NI-ST 8-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9608ni-st-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-7104ni-slw",
    manufacturer: "Hikvision",
    model: "DS-7104NI-SLW",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104NI-SLW 4-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104ni-slw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7732ni-i4-24p",
    manufacturer: "Hikvision",
    model: "DS-7732NI-I4/24P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-I4/24P Embedded Plug & Play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-i4-24p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":2,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7604ni-k1-4g",
    manufacturer: "Hikvision",
    model: "DS-7604NI-K1/4G",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-K1/4G 4-ch Mini 1U 4G NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-k1-4g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-9632nxi-i8-4f",
    manufacturer: "Hikvision",
    model: "iDS-9632NXI-I8/4F",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-9632NXI-I8/4F 4 channel DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9632nxi-i8-4f-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7604ni-s-m",
    manufacturer: "Hikvision",
    model: "DS-7604NI-S/M",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-S/M 4-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-s-m-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7716ni-i4",
    manufacturer: "Hikvision",
    model: "DS-7716NI-I4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-I4 embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-i4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7732nxi-i4-16p-8s",
    manufacturer: "Hikvision",
    model: "iDS-7732NXI-I4/16P/8S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7732NXI-I4/16P/8S Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7732nxi-i4-16p-8s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9616nxi-i8-s-c",
    manufacturer: "Hikvision",
    model: "DS-9616NXI-I8/S(C)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9616NXI-I8/S(C) 16-ch 2U 4K AcuSense NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9616nxi-i8-s-c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ids-7716nxi-i4-16p-16s-b",
    manufacturer: "Hikvision",
    model: "iDS-7716NXI-I4/16P/16S(B)",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7716NXI-I4/16P/16S(B) Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7716nxi-i4-16p-16s-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-wseli-t2-8p",
    manufacturer: "Hikvision",
    model: "DS-WSELI-T2/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-WSELI-T2/8P Eco Series 2-Slot 8-PoE-Port Workstation for Linux",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-wseli-t2-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7108ni-q1",
    manufacturer: "Hikvision",
    model: "DS-7108NI-Q1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7108NI-Q1 8-ch mini 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7108ni-q1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7604ni-q1-4p",
    manufacturer: "Hikvision",
    model: "DS-7604NI-Q1/4P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-Q1/4P 4-ch 1U 4 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-q1-4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-96256ni-e24-h",
    manufacturer: "Hikvision",
    model: "DS-96256NI-E24/H",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96256NI-E24/H 256-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96256ni-e24-h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-9632ni-rt",
    manufacturer: "Hikvision",
    model: "DS-9632NI-RT",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9632NI-RT 32 channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9632ni-rt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-8608ni-k8",
    manufacturer: "Hikvision",
    model: "DS-8608NI-K8",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8608NI-K8 Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8608ni-k8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
];

const PART_4: NvrEntry[] = [
  {
    id: "ss-hikvision-ds-7608ni-k2-4g",
    manufacturer: "Hikvision",
    model: "DS-7608NI-K2/4G",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-K2/4G 8-ch 1U 4G NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-k2-4g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7104ni-k1-w-m",
    manufacturer: "Hikvision",
    model: "DS-7104NI-K1/W/M",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104NI-K1/W/M 4-ch Mini 1U Wi-Fi NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104ni-k1-w-m-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-9000ai-s16-d",
    manufacturer: "Hikvision",
    model: "DS-9000AI-S16-D",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9000AI-S16-D Dual-Board X86 NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9000ai-s16-d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-mp7608hn-m12",
    manufacturer: "Hikvision",
    model: "DS-MP7608HN/M12",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP7608HN/M12 Mobile Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp7608hn-m12-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7604ni-v",
    manufacturer: "Hikvision",
    model: "DS-7604NI-V",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-V vertical PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-v-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7w00ni-e1-p",
    manufacturer: "Hikvision",
    model: "DS-7W00NI-E1/P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7W00NI-E1/P Embedded MIni Wifi NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7w00ni-e1-p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":2,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-wseli-t4-16p",
    manufacturer: "Hikvision",
    model: "DS-WSELI-T4/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-WSELI-T4/16P Eco Series 4-Slot 16-PoE-Port Workstation for Linux",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-wseli-t4-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-a82024d",
    manufacturer: "Hikvision",
    model: "DS-A82024D",
    category: "nvr-recorder",
    tagline: "Hikvision DS-A82024D 448-channel network storage device",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-a82024d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":448,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ids-9616nxi-i8-s",
    manufacturer: "Hikvision",
    model: "iDS-9616NXI-I8/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-9616NXI-I8/S 16-ch 2U 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9616nxi-i8-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ds-7616ni-m2-16p",
    manufacturer: "Hikvision",
    model: "DS-7616NI-M2/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-M2/16P 16-ch 1U 16 PoE 8K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-m2-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7716ni-k4-16p",
    manufacturer: "Hikvision",
    model: "DS-7716NI-K4/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-K4/16P embedded plug & play 4K NVR with Up to 8 MP resolution",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-k4-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7616ni-i2",
    manufacturer: "Hikvision",
    model: "DS-7616NI-I2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-I2 embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-i2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7608ni-q2",
    manufacturer: "Hikvision",
    model: "DS-7608NI-Q2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-Q2 8-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-q2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-104mh-c",
    manufacturer: "Hikvision",
    model: "NVR-104MH-C",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-104MH-C 4-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-104mh-c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7732ni-k4-16",
    manufacturer: "Hikvision",
    model: "DS-7732NI-K4/16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-K4/16 embedded plug & play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-k4-16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7716ni-m4-16p",
    manufacturer: "Hikvision",
    model: "DS-7716NI-M4/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-M4/16P 16-ch 1.5U 16 PoE 8K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-m4-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7r04ni-k1-4p",
    manufacturer: "Hikvision",
    model: "DS-7R04NI-K1/4P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7R04NI-K1/4P Embedded Plug & Play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7r04ni-k1-4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7616ni-q2-16p",
    manufacturer: "Hikvision",
    model: "DS-7616NI-Q2/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-Q2/16P 16-ch 1U 16 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-q2-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-wseli-t4",
    manufacturer: "Hikvision",
    model: "DS-WSELI-T4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-WSELI-T4 Eco Series 4-Slot Workstation for Linux",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-wseli-t4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-a81016s",
    manufacturer: "Hikvision",
    model: "DS-A81016S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-A81016S 256-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-a81016s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-7716ni-q4",
    manufacturer: "Hikvision",
    model: "DS-7716NI-Q4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-Q4 16-ch 1.5U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-q4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7716nxi-i4-x",
    manufacturer: "Hikvision",
    model: "iDS-7716NXI-I4/X",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7716NXI-I4/X 16-ch 1.5U 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7716nxi-i4-x-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-mp3516-rh-dc48v",
    manufacturer: "Hikvision",
    model: "DS-MP3516-RH(DC48V)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP3516-RH(DC48V) 32-ch 1080p, H.265, 6 x HDD/SSD Mobile NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp3516-rh-dc48v-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-hikvision-ds-7r32ni-k4",
    manufacturer: "Hikvision",
    model: "DS-7R32NI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7R32NI-K4 Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7r32ni-k4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7816nxi-i2-16p-s",
    manufacturer: "Hikvision",
    model: "DS-7816NXI-I2/16P/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7816NXI-I2/16P/S 16-ch 1U 16 POE AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7816nxi-i2-16p-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-9664nxi-i8-s",
    manufacturer: "Hikvision",
    model: "iDS-9664NXI-I8/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-9664NXI-I8/S 64-ch 2U 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9664nxi-i8-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-nvr-108mh-c-8p",
    manufacturer: "Hikvision",
    model: "NVR-108MH-C/8P",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-108MH-C/8P 8-ch 1U 8 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-108mh-c-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-216mh-c-16p",
    manufacturer: "Hikvision",
    model: "NVR-216MH-C/16P",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-216MH-C/16P 16-ch 1U 16 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-216mh-c-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7708ni-k4",
    manufacturer: "Hikvision",
    model: "DS-7708NI-K4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7708NI-K4 Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7708ni-k4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-9632ni-i16-16-8t-seagate",
    manufacturer: "Hikvision",
    model: "DS-9632NI-I16(16*8T Seagate)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-9632NI-I16(16*8T Seagate) 32-ch 3U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-9632ni-i16-16-8t-seagate-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-hikvision-ids-9616nxi-i8-x",
    manufacturer: "Hikvision",
    model: "iDS-9616NXI-I8/X",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-9616NXI-I8/X 16-ch 3U 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9616nxi-i8-x-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"3U"},
  },
  {
    id: "ss-hikvision-ds-7616nxi-i2-16p-s",
    manufacturer: "Hikvision",
    model: "DS-7616NXI-I2/16P/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NXI-I2/16P/S 16-ch 1U 16 POE AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616nxi-i2-16p-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7608ni-e2",
    manufacturer: "Hikvision",
    model: "DS-7608NI-E2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-E2 embedded NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-e2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ids-7716nxi-i4-16p-8s",
    manufacturer: "Hikvision",
    model: "iDS-7716NXI-I4/16P/8S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7716NXI-I4/16P/8S Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7716nxi-i4-16p-8s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ids-9632nxi-i8-8f-b",
    manufacturer: "Hikvision",
    model: "iDS-9632NXI-I8/8F(B)",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-9632NXI-I8/8F(B) 32-channel DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9632nxi-i8-8f-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.265+","H.265"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ds-7716ni-i4-b",
    manufacturer: "Hikvision",
    model: "DS-7716NI-I4(B)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-I4(B) 16-ch 1.5U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-i4-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7732ni-i4",
    manufacturer: "Hikvision",
    model: "DS-7732NI-I4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-I4 embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-i4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7616ni-e2-8n",
    manufacturer: "Hikvision",
    model: "DS-7616NI-E2/8N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-E2/8N 16-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-e2-8n-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7w04ni-e1-4p",
    manufacturer: "Hikvision",
    model: "DS-7W04NI-E1/4P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7W04NI-E1/4P Embedded MIni Wifi NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7w04ni-e1-4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":2,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ds-7732ni-i4-16p",
    manufacturer: "Hikvision",
    model: "DS-7732NI-I4/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-I4/16P Embedded Plug & Play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-i4-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-96256ni-e16",
    manufacturer: "Hikvision",
    model: "DS-96256NI-E16",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96256NI-E16 256-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96256ni-e16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7616ni-k216p",
    manufacturer: "Hikvision",
    model: "DS-7616NI-K216P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-K216P embedded plug & play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-k216p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1},
  },
  {
    id: "ss-hikvision-ids-7716ni-i4-16s-b",
    manufacturer: "Hikvision",
    model: "iDS-7716NI-I4/16S(B)",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7716NI-I4/16S(B) Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7716ni-i4-16s-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-96128ni-e24-h",
    manufacturer: "Hikvision",
    model: "DS-96128NI-E24/H",
    category: "nvr-recorder",
    tagline: "Hikvision DS-96128NI-E24/H 128-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-96128ni-e24-h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1},
  },
  {
    id: "ss-hikvision-ids-7732nxi-i4-16p-16s-b",
    manufacturer: "Hikvision",
    model: "iDS-7732NXI-I4/16P/16S(B)",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7732NXI-I4/16P/16S(B) Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7732nxi-i4-16p-16s-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ids-6716nxi-i-s",
    manufacturer: "Hikvision",
    model: "iDS-6716NXI-I/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-6716NXI-I/S DeepinMind NVS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-6716nxi-i-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7608nxi-i2-x",
    manufacturer: "Hikvision",
    model: "iDS-7608NXI-I2/X",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7608NXI-I2/X 8-ch 1U 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7608nxi-i2-x-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7716ni-m4",
    manufacturer: "Hikvision",
    model: "DS-7716NI-M4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-M4 16-ch 1.5U 8K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-m4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7732ni-m4-16p",
    manufacturer: "Hikvision",
    model: "DS-7732NI-M4/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NI-M4/16P 32-ch 1.5U 16 PoE 8K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732ni-m4-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-mp3516-rh-dc110v",
    manufacturer: "Hikvision",
    model: "DS-MP3516-RH(DC110V)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP3516-RH(DC110V) 32-ch 1080p, H.265, 6 x HDD/SSD Mobile NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp3516-rh-dc110v-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-hikvision-ds-7716ni-i4-16p",
    manufacturer: "Hikvision",
    model: "DS-7716NI-I4/16P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NI-I4/16P Embedded Plug & Play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716ni-i4-16p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7716nxi-i4-16p-x",
    manufacturer: "Hikvision",
    model: "iDS-7716NXI-I4/16P/X",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7716NXI-I4/16P/X 16-ch 1.5U 16 PoE 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7716nxi-i4-16p-x-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7932nxi-i4-16p-s",
    manufacturer: "Hikvision",
    model: "DS-7932NXI-I4/16P/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7932NXI-I4/16P/S 32-ch 1U 16 POE AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7932nxi-i4-16p-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7808nxi-i2-8p-s",
    manufacturer: "Hikvision",
    model: "DS-7808NXI-I2/8P/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7808NXI-I2/8P/S 8-ch 1U 8 POE AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7808nxi-i2-8p-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7608ni-m2",
    manufacturer: "Hikvision",
    model: "DS-7608NI-M2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-M2 8-ch 1U 8K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-m2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7708ni-q4-8p",
    manufacturer: "Hikvision",
    model: "DS-7708NI-Q4/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7708NI-Q4/8P 8-ch 1.5U 8 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7708ni-q4-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ids-6708nxi-i-fa",
    manufacturer: "Hikvision",
    model: "iDS-6708NXI-I/FA",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-6708NXI-I/FA iDS-6708NXI-I/FA",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-6708nxi-i-fa-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7808nxi-i2-s",
    manufacturer: "Hikvision",
    model: "DS-7808NXI-I2/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7808NXI-I2/S 8-ch 1U AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7808nxi-i2-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7732ni-i4-16s-b",
    manufacturer: "Hikvision",
    model: "iDS-7732NI-I4/16S(B)",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7732NI-I4/16S(B) Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7732ni-i4-16s-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-m5504hni",
    manufacturer: "Hikvision",
    model: "DS-M5504HNI",
    category: "nvr-recorder",
    tagline: "Hikvision DS-M5504HNI mobile NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-m5504hni-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ids-9632nxi-i8-16s-b",
    manufacturer: "Hikvision",
    model: "iDS-9632NXI-I8/16S(B)",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-9632NXI-I8/16S(B) 32-ch DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9632nxi-i8-16s-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ids-7616nxi-i2-x",
    manufacturer: "Hikvision",
    model: "iDS-7616NXI-I2/X",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7616NXI-I2/X 16-ch 1U 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7616nxi-i2-x-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7916nxi-i4-s",
    manufacturer: "Hikvision",
    model: "DS-7916NXI-I4/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7916NXI-I4/S 16-ch 1.5U AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7916nxi-i4-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7608nxi-i2-8p-x",
    manufacturer: "Hikvision",
    model: "iDS-7608NXI-I2/8P/X",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7608NXI-I2/8P/X 8-ch 1U 8 PoE 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7608nxi-i2-8p-x-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7732nxi-i4-16p-x",
    manufacturer: "Hikvision",
    model: "iDS-7732NXI-I4/16P/X",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7732NXI-I4/16P/X 32-ch 1.5U 16 PoE 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7732nxi-i4-16p-x-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-mp3516-rh-dc110v-roctec",
    manufacturer: "Hikvision",
    model: "DS-MP3516-RH(DC110V)(Roctec)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-MP3516-RH(DC110V)(Roctec) 32-ch 1080p, H.265, 6 x HDD/SSD Mobile NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-mp3516-rh-dc110v-roctec-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-hikvision-ids-9632nxi-i8-s",
    manufacturer: "Hikvision",
    model: "iDS-9632NXI-I8/S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-9632NXI-I8/S 32-ch 2U 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9632nxi-i8-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-hikvision-ids-7616nxi-i2-16p-x",
    manufacturer: "Hikvision",
    model: "iDS-7616NXI-I2/16P/X",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7616NXI-I2/16P/X 16-ch 1U 16 PoE 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7616nxi-i2-16p-x-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ids-7716ni-i4-8s",
    manufacturer: "Hikvision",
    model: "iDS-7716NI-I4/8S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7716NI-I4/8S Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7716ni-i4-8s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ids-7732ni-i4-8s",
    manufacturer: "Hikvision",
    model: "iDS-7732NI-I4/8S",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7732NI-I4/8S Embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7732ni-i4-8s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7916nxi-i4-16p-s",
    manufacturer: "Hikvision",
    model: "DS-7916NXI-I4/16P/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7916NXI-I4/16P/S 16-ch 1.5U 16 POE AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7916nxi-i4-16p-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7v04ni-e1",
    manufacturer: "Hikvision",
    model: "DS-7V04NI-E1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7V04NI-E1 Embedded MIni Wifi NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7v04ni-e1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":2,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-hikvision-ids-9616nxi-i8-16s-b",
    manufacturer: "Hikvision",
    model: "iDS-9616NXI-I8/16S(B)",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-9616NXI-I8/16S(B) 16-ch DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9616nxi-i8-16s-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"raidLevels":["0"]},
  },
  {
    id: "ss-hikvision-ids-7732nxi-i4-x",
    manufacturer: "Hikvision",
    model: "iDS-7732NXI-I4/X",
    category: "nvr-recorder",
    tagline: "Hikvision iDS-7732NXI-I4/X 32-ch 1.5U 4K DeepinMind NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-7732nxi-i4-x-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7604ni-e1-a",
    manufacturer: "Hikvision",
    model: "DS-7604NI-E1/A",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-E1/A 4-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-e1-a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7708ni-q4",
    manufacturer: "Hikvision",
    model: "DS-7708NI-Q4",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7708NI-Q4 8-ch 1.5U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7708ni-q4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7604ni-q1",
    manufacturer: "Hikvision",
    model: "DS-7604NI-Q1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-Q1 4-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-q1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-8608ni-st",
    manufacturer: "Hikvision",
    model: "DS-8608NI-ST",
    category: "nvr-recorder",
    tagline: "Hikvision DS-8608NI-ST 8-channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-8608ni-st-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7632ni-sp",
    manufacturer: "Hikvision",
    model: "DS-7632NI-SP",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7632NI-SP DS-7600NI-SP series NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7632ni-sp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hikvision-ids-9616nxi-p8r",
    manufacturer: "Hikvision",
    model: "iDS-9616NXI-P8R",
    category: "nvr-recorder",
    tagline: "Hikvision DeepinMind Pro NVR with AcuSeek AI Search",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ids-9616nxi-p8r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":2,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7604ni-e1-4n",
    manufacturer: "Hikvision",
    model: "DS-7604NI-E1/4N",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-E1/4N embedded NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-e1-4n-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-hikvision-ds-7608ni-i2-8p",
    manufacturer: "Hikvision",
    model: "DS-7608NI-I2/8P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-I2/8P embedded plug & play 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-i2-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7608ni-i2",
    manufacturer: "Hikvision",
    model: "DS-7608NI-I2",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-I2 embedded 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-i2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7616nxi-i2-s",
    manufacturer: "Hikvision",
    model: "DS-7616NXI-I2/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NXI-I2/S 16-ch 1U AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616nxi-i2-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7104ni-q1-4p-m",
    manufacturer: "Hikvision",
    model: "DS-7104NI-Q1/4P/M",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104NI-Q1/4P/M 4-ch Mini 1U 4 PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104ni-q1-4p-m-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7732nxi-i4-s",
    manufacturer: "Hikvision",
    model: "DS-7732NXI-I4/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7732NXI-I4/S 32-ch 1U AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7732nxi-i4-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7608nxi-i2-s",
    manufacturer: "Hikvision",
    model: "DS-7608NXI-I2/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NXI-I2/S 8-ch 1U AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608nxi-i2-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7608nxi-i2-8p-s",
    manufacturer: "Hikvision",
    model: "DS-7608NXI-I2/8P/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NXI-I2/8P/S 8-ch 1U 8 POE AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608nxi-i2-8p-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7608ni-k1-8p-4g",
    manufacturer: "Hikvision",
    model: "DS-7608NI-K1/8P/4G",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-K1/8P/4G 8-ch Mini 1U 8 POE 4G NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-k1-8p-4g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7716nxi-i4-s",
    manufacturer: "Hikvision",
    model: "DS-7716NXI-I4/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NXI-I4/S 16-ch 1.5U AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716nxi-i4-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7608ni-k1-b",
    manufacturer: "Hikvision",
    model: "DS-7608NI-K1(B)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-K1(B) 8-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-k1-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-108mh-c-8p-b",
    manufacturer: "Hikvision",
    model: "NVR-108MH-C/8P(B)",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-108MH-C/8P(B) 8-ch Mini 1U 8 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-108mh-c-8p-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7616ni-k2-16p-4g",
    manufacturer: "Hikvision",
    model: "DS-7616NI-K2/16P/4G",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7616NI-K2/16P/4G 16-ch 1U 16 POE 4G NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7616ni-k2-16p-4g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7104ni-q1-4p",
    manufacturer: "Hikvision",
    model: "DS-7104NI-Q1/4P",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104NI-Q1/4P 4-ch Mini 4 PoE 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104ni-q1-4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7716nxi-i4-16p-s",
    manufacturer: "Hikvision",
    model: "DS-7716NXI-I4/16P/S",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7716NXI-I4/16P/S 16-ch 1.5U 16 POE AcuSense 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7716nxi-i4-16p-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-hikvision-ds-7604ni-k1-b",
    manufacturer: "Hikvision",
    model: "DS-7604NI-K1(B)",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7604NI-K1(B) 4-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7604ni-k1-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7608ni-k1-4g",
    manufacturer: "Hikvision",
    model: "DS-7608NI-K1/4G",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7608NI-K1/4G 8-ch Mini 1U 4G NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7608ni-k1-4g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-108h-d",
    manufacturer: "Hikvision",
    model: "NVR-108H-D",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-108H-D 8-ch Mini 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-108h-d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-104h-d",
    manufacturer: "Hikvision",
    model: "NVR-104H-D",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-104H-D 4-ch Mini 1U 4 NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-104h-d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-104h-d-4p",
    manufacturer: "Hikvision",
    model: "NVR-104H-D/4P",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-104H-D/4P 4-ch Mini 1U 4 PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-104h-d-4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-104mh-d-4p",
    manufacturer: "Hikvision",
    model: "NVR-104MH-D/4P",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-104MH-D/4P 4-ch Mini 1U 4 PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-104mh-d-4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-108mh-d-8p",
    manufacturer: "Hikvision",
    model: "NVR-108MH-D/8P",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-108MH-D/8P 8-ch Mini 1U 8 PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-108mh-d-8p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-116mh-c",
    manufacturer: "Hikvision",
    model: "NVR 116MH-C",
    category: "nvr-recorder",
    tagline: "Hikvision NVR 116MH-C 16-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-116mh-c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-108mh-d",
    manufacturer: "Hikvision",
    model: "NVR-108MH-D",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-108MH-D 8-ch Mini 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-108mh-d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-216mh-c",
    manufacturer: "Hikvision",
    model: "NVR-216MH-C",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-216MH-C 16-ch 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-216mh-c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-104mh-d",
    manufacturer: "Hikvision",
    model: "NVR-104MH-D",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-104MH-D 4-ch Mini 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-104mh-d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-ds-7104ni-q1",
    manufacturer: "Hikvision",
    model: "DS-7104NI-Q1",
    category: "nvr-recorder",
    tagline: "Hikvision DS-7104NI-Q1 4-ch Mini 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-7104ni-q1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-104mh-c-4p",
    manufacturer: "Hikvision",
    model: "NVR-104MH-C/4P",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-104MH-C/4P 4-ch Mini 1U 4 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-104mh-c-4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-108mh-c-b",
    manufacturer: "Hikvision",
    model: "NVR-108MH-C(B)",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-108MH-C(B) 8-ch Mini 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-108mh-c-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-hikvision-nvr-104mh-c-b",
    manufacturer: "Hikvision",
    model: "NVR-104MH-C(B)",
    category: "nvr-recorder",
    tagline: "Hikvision NVR-104MH-C(B) 4-ch Mini 1U 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-nvr-104mh-c-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr2108hs-s3",
    manufacturer: "Dahua Technology",
    model: "NVR2108HS-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2108HS-S3 8 Channel Compact 1U 1HDD Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2108hs-s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4232-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4232-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4232-4KS2 32 Channel 1U 4K & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4232-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5216-16p-ei",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5216-16P-EI",
    category: "nvr-recorder",
    tagline: "Dahua DHI-NVR5216-16P-EI 16 Channels 1U 16PoE 2HDDs WizSense NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5216-16p-ei-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5864-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5864-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5864-4KS2 64 Channel 2U 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5864-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-itse0400-ta-g02",
    manufacturer: "Dahua Technology",
    model: "DHI-ITSE0400-TA-G02",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-ITSE0400-TA-G02 Edge Storage Device",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-itse0400-ta-g02-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dhi-ivss7024dr-16i",
    manufacturer: "Dahua Technology",
    model: "DHI-IVSS7024DR-16I",
    category: "nvr-recorder",
    tagline: "Dahua Technology IVSS – AI NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-ivss7024dr-16i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"raidLevels":["0"]},
  },
  {
    id: "ss-dahua-technology-nvr2116hs-s3",
    manufacturer: "Dahua Technology",
    model: "NVR2116HS-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2116HS-S3 16 Channel Compact 1U 1HDD Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2116hs-s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dnr114p0",
    manufacturer: "Dahua Technology",
    model: "DNR114P0",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR114P0 4 channels PoE high definition NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr114p0-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dhi-nvr0804mf",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR0804MF",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR0804MF 8-channel Mobile NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr0804mf-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","MJPEG"],"onvif":true},
  },
  {
    id: "ss-dahua-technology-nvr2116-s3",
    manufacturer: "Dahua Technology",
    model: "NVR2116-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2116-S3 16 Channel Smart 1U 1HDD Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2116-s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5832-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5832-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5832-4KS2 32 Channel 2U 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5832-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4216-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4216-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4216-4KS2 16 Channel 1U 4K & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4216-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr2108hs-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR2108HS-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR2108HS-4KS2 8 Channel Compact 1U Lite 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr2108hs-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr616h-64-xi",
    manufacturer: "Dahua Technology",
    model: "NVR616H-64-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR616H-64-XI 64CH 3U 16HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr616h-64-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-nvr5832-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5832-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5832-XI 32CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5832-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-mnvr4104",
    manufacturer: "Dahua Technology",
    model: "MNVR4104",
    category: "nvr-recorder",
    tagline: "Dahua Technology MNVR4104 4 Channels POE 1 HDD Mobile Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-mnvr4104-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-dahua-technology-nvr5832rh-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5832RH-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5832RH-XI 32CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5832rh-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr2104hs-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR2104HS-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR2104HS-4KS2 4 Channel Compact 1U Lite 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr2104hs-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr5864-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5864-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5864-XI 64CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5864-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr608rh-32-xi",
    manufacturer: "Dahua Technology",
    model: "NVR608RH-32-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR608RH-32-XI 32CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr608rh-32-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr2104hs-p-s3",
    manufacturer: "Dahua Technology",
    model: "NVR2104HS-P-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2104HS-P-S3 4 Channel Compact 1U 1HDD 4PoE Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2104hs-p-s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr5816h-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5816H-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5816H-XI 16CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5816h-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr5432-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5432-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5432-XI 32CH 1.5U 4HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5432-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"]},
  },
  {
    id: "ss-dahua-technology-nvr608h-32-xi",
    manufacturer: "Dahua Technology",
    model: "NVR608H-32-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR608H-32-XI 32CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr608h-32-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr608h-128-xi",
    manufacturer: "Dahua Technology",
    model: "NVR608H-128-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR608H-128-XI 128CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr608h-128-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr5216-16p-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5216-16P-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5216-16P-XI 16CH 1U 16POE 2HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5216-16p-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr5864rh-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5864RH-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5864RH-XI 64CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5864rh-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr5864h-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5864H-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5864H-XI 64CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5864h-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr616h-128-xi",
    manufacturer: "Dahua Technology",
    model: "NVR616H-128-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR616H-128-XI 128CH 3U 16HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr616h-128-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-n52a4p",
    manufacturer: "Dahua Technology",
    model: "N52A4P",
    category: "nvr-recorder",
    tagline: "Dahua Technology N52A4P 4K 24CH 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-n52a4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":24,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr616dr-128-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR616DR-128-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR616DR-128-4KS2 128 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr616dr-128-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-nvr608rh-64-xi",
    manufacturer: "Dahua Technology",
    model: "NVR608RH-64-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR608RH-64-XI 64CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr608rh-64-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4116-8p-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4116-8P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4116-8P-4KS2 8 Channel Smart 1U 8PoE 4K&H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4116-8p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4108-8p-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4108-8P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4108-8P-4KS2 4 Channel Smart 1U 8PoE 4K&H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4108-8p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr5816rh-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5816RH-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5816RH-XI 16CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5816rh-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr2108-s3",
    manufacturer: "Dahua Technology",
    model: "NVR2108-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2108-S3 8 Channel Smart 1U 1HDD Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2108-s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dnr118p0",
    manufacturer: "Dahua Technology",
    model: "DNR118P0",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR118P0 8 channels PoE high definition NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr118p0-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-nvr5416-16p-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5416-16P-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5416-16P-XI 16CH 1.5U 16POE 4HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5416-16p-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"]},
  },
  {
    id: "ss-dahua-technology-nvr5432-16p-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5432-16P-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5432-16P-XI 32CH 1.5U 16POE 4HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5432-16p-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"]},
  },
  {
    id: "ss-dahua-technology-nvr5832h-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5832H-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5832H-XI 32CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5832h-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr608h-64-xi",
    manufacturer: "Dahua Technology",
    model: "NVR608H-64-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR608H-64-XI 64CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr608h-64-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr5416-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5416-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5416-XI 16CH 1.5U 4HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5416-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"]},
  },
  {
    id: "ss-dahua-technology-nvr5216-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5216-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5216-XI 16CH 1U 2HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5216-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr5816-32-64-r-16p-4ks2e",
    manufacturer: "Dahua Technology",
    model: "NVR5816/32/64-R-16P-4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5816/32/64-R-16P-4KS2E 16/32/64 Channel 2U 16PoE 4K&H.265 Pro Network Video Reco",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5816-32-64-r-16p-4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8,"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr608rh-128-xi",
    manufacturer: "Dahua Technology",
    model: "NVR608RH-128-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR608RH-128-XI 128CH 2U 8HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr608rh-128-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4104-p4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4104-P4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4104-P4KS2 4 Channel Smart 1U 4PoE 4K & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4104-p4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":4,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr616h-32-xi",
    manufacturer: "Dahua Technology",
    model: "NVR616H-32-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR616H-32-XI 32CH 3U 16HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr616h-32-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-nvr5208-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5208-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5208-XI 8CH 1U 2HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5208-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-ivss7024-8i",
    manufacturer: "Dahua Technology",
    model: "IVSS7024-8I",
    category: "nvr-recorder",
    tagline: "Dahua Technology IVSS7024-8I 4U 24HDD WizMind Intelligent Video Surveillance Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ivss7024-8i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"raidLevels":["0"],"formFactor":"4U"},
  },
  {
    id: "ss-dahua-technology-ivss7024dr-16i",
    manufacturer: "Dahua Technology",
    model: "IVSS7024DR-16I",
    category: "nvr-recorder",
    tagline: "Dahua Technology IVSS7024DR-16I 4U 24HDD WizMind Intelligent Video Surveillance Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ivss7024dr-16i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"raidLevels":["0"],"formFactor":"4U"},
  },
  {
    id: "ss-dahua-technology-nvr616drh-128-xi",
    manufacturer: "Dahua Technology",
    model: "NVR616DRH-128-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR616DRH-128-XI 128CH 3U 16HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr616drh-128-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-nvr616rh-32-xi",
    manufacturer: "Dahua Technology",
    model: "NVR616RH-32-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR616RH-32-XI 32CH 3U 16HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr616rh-32-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-nvr2104-p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR2104-P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2104-P-4KS2 4 Channel Smart 1U 4PoE Lite 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2104-p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-ivss7016-4i",
    manufacturer: "Dahua Technology",
    model: "IVSS7016-4I",
    category: "nvr-recorder",
    tagline: "Dahua Technology IVSS7016-4I 3U 16HDD WizMind Intelligent Video Surveillance Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ivss7016-4i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4208-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4208-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4208-4KS2 8 Channel 1U 4K & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4208-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr616rh-128-xi",
    manufacturer: "Dahua Technology",
    model: "NVR616RH-128-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR616RH-128-XI 128CH 3U 16HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr616rh-128-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4216-16p4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4216-16P4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4216-16P4KS2 16 Channel 1U 16PoE 4K & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4216-16p4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":16,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-mnvr4208",
    manufacturer: "Dahua Technology",
    model: "DHI-MNVR4208",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-MNVR4208 8 Channels POE H.265 2 HDDs Mobile Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-mnvr4208-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4108-p4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4108-P4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4108-P4KS2 8 Channel Smart 1U 4PoE 4K & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4108-p4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":4,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr616drh-64-xi",
    manufacturer: "Dahua Technology",
    model: "NVR616DRH-64-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR616DRH-64-XI 64CH 3U 16HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr616drh-64-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-nvr616dh-128-xi",
    manufacturer: "Dahua Technology",
    model: "NVR616DH-128-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR616DH-128-XI 128CH 3U 16HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr616dh-128-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4232-16p4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4232-16P4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4232-16P4KS2 32 Channel 1U 16PoE 4K & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4232-16p4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":16,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr616r-64-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR616R-64-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR616R-64-4KS2 64 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr616r-64-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-nvr4208-8p-i",
    manufacturer: "Dahua Technology",
    model: "NVR4208-8P-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4208-8P-I 8Channel 1U 8PoE AI Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4208-8p-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-ivss7024-16i",
    manufacturer: "Dahua Technology",
    model: "IVSS7024-16I",
    category: "nvr-recorder",
    tagline: "Dahua Technology IVSS7024-16I 4U 24HDD WizMind Intelligent Video Surveillance Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ivss7024-16i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"raidLevels":["0"],"formFactor":"4U"},
  },
  {
    id: "ss-dahua-technology-nvr4416-4432-16p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR4416/4432-16P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4416/4432-16P-4KS2 16/32 Channel 1.5U 16PoE 4K & H.265 Lite Network Video Record",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4416-4432-16p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":16},
  },
  {
    id: "ss-dahua-technology-nvr5216-5232-16p-4ks2e",
    manufacturer: "Dahua Technology",
    model: "NVR5216/5232-16P-4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5216/5232-16P-4KS2E 16/32Channel 1U 16PoE 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5216-5232-16p-4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":16,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dnr114p0p",
    manufacturer: "Dahua Technology",
    model: "DNR114P0P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR114P0P 4 channel PoE high definition NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr114p0p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-nvr5832-5864-i",
    manufacturer: "Dahua Technology",
    model: "NVR5832/5864-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5832/5864-I 32/64Channel 2U AI Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5832-5864-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr616dh-64-xi",
    manufacturer: "Dahua Technology",
    model: "NVR616DH-64-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR616DH-64-XI 64CH 3U 16HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr616dh-64-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr616d-128-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR616D-128-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR616D-128-4KS2 128 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr616d-128-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-ivss7008-1i",
    manufacturer: "Dahua Technology",
    model: "IVSS7008-1I",
    category: "nvr-recorder",
    tagline: "Dahua Technology IVSS7008-1I 2U 8HDD WizMind Intelligent Video Surveillance Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ivss7008-1i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr5208-8p-xi",
    manufacturer: "Dahua Technology",
    model: "NVR5208-8P-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5208-8P-XI 8CH 1U 8POE 2HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5208-8p-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr616rh-64-xi",
    manufacturer: "Dahua Technology",
    model: "NVR616RH-64-XI",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR616RH-64-XI 64CH 3U 16HDDs WizMind Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr616rh-64-xi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4116hs8p-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4116HS8P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4116HS8P-4KS2 16 Channel Compact 1U 8PoE 4K & H.265 Lite Network Video Recor",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4116hs8p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4108hs8p-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4108HS8P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4108HS8P-4KS2 8 Channel Compact 1U 8PoE 4K & H.265 Lite Network Video Record",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4108hs8p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dnr118p0p",
    manufacturer: "Dahua Technology",
    model: "DNR118P0P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR118P0P 8 channel PoE high definition NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr118p0p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dhi-nvr616r-128-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR616R-128-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR616R-128-4KS2 128 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr616r-128-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-nvr2104-2108hs-w-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR2104/2108HS-W-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2104/2108HS-W-4KS2 4/8 Channel Compact 1U Lite 4K H.265 Wireless Network Video R",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2104-2108hs-w-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr2104-2108-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR2104/2108-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2104/2108-4KS2 4/8 Channel Smart 1U Lite 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2104-2108-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr4416-4432-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR4416/4432-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4416/4432-4KS2 16/32 Channel 1.5U 4K&H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4416-4432-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5832-16p4ks2e",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5832-16P4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5832-16P4KS2E 32 Channel 2U 16PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5832-16p4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":16,"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr616dr-64-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR616DR-64-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR616DR-64-4KS2 64 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr616dr-64-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-nvr2208-8p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR2208-8P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2208-8P-4KS2 8 Channel 1U 2HDDs 8PoE Lite 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2208-8p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr2108-8p-s3",
    manufacturer: "Dahua Technology",
    model: "NVR2108-8P-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2108-8P-S3 8 Channel Smart 1U 1HDD 8PoE Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2108-8p-s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr2104-p-s3",
    manufacturer: "Dahua Technology",
    model: "NVR2104-P-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2104-P-S3 4 Channel Smart 1U 1HDD 4PoE Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2104-p-s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dn4163e12",
    manufacturer: "Dahua Technology",
    model: "DN4163E12",
    category: "nvr-recorder",
    tagline: "Dahua Technology DN4163E12 12 cameras, 16 channels, 3TB HDD NVR system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dn4163e12-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-nvr2108hs-8p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR2108HS-8P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua NVR2108HS-8P-4KS2 Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2108hs-8p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":1,"hddBays":1,"codecs":["H.264","H.265"],"poeInPorts":8},
  },
  {
    id: "ss-dahua-technology-ivss7016dr-4i",
    manufacturer: "Dahua Technology",
    model: "IVSS7016DR-4I",
    category: "nvr-recorder",
    tagline: "Dahua Technology IVSS7016DR-4I 3U 16HDD WizMind Intelligent Video Surveillance Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ivss7016dr-4i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"raidLevels":["0"],"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-dn408p2e6",
    manufacturer: "Dahua Technology",
    model: "DN408P2E6",
    category: "nvr-recorder",
    tagline: "Dahua Technology DN408P2E6 full HD PoE NVR system with pentaplex operation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dn408p2e6-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-nvr2104-s3",
    manufacturer: "Dahua Technology",
    model: "NVR2104-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2104-S3 4 Channel Smart 1U 1HDD Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2104-s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr2108-8p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR2108-8P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2108-8P-4KS2 8 Channel Smart 1U 8PoE Lite 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2108-8p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5832-r-16p4ks2e",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5832-R-16P4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5832-R-16P4KS2E 32 Channel 2U 16PoE 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5832-r-16p4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8,"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr0404mf",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR0404MF",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR0404MF 4-channel Mobile NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr0404mf-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","MJPEG"],"onvif":true},
  },
  {
    id: "ss-dahua-technology-nvr5216-8p-i",
    manufacturer: "Dahua Technology",
    model: "NVR5216-8P-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5216-8P-I 16Channel 1U 8PoE AI Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5216-8p-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr4216-i",
    manufacturer: "Dahua Technology",
    model: "NVR4216-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4216-I 16Channel 1U AI Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4216-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dnr416p2",
    manufacturer: "Dahua Technology",
    model: "DNR416P2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR416P2 16 channels, 8 PoE+ support, 200 Mbps, 2TB HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr416p2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-nvr5816-5832-5864-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR5816/5832/5864-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5816/5832/5864-4KS2 16/32/64Channel 2U 4K&H.265 Pro Network Video Recorder (V2.0",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5816-5832-5864-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr4216-16p-i",
    manufacturer: "Dahua Technology",
    model: "NVR4216-16P-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4216-16P-I 16Channel 1U 16PoE AI Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4216-16p-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dn4083b84-p",
    manufacturer: "Dahua Technology",
    model: "DN4083B84/P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DN4083B84/P 8 cameras, 8 channels, 3TB HDD NVR system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dn4083b84-p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5816-r-16p4ks2e",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5816-R-16P4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5816-R-16P4KS2E 16 Channel 2U 16PoE 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5816-r-16p4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8,"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr5816-32-64-r-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR5816/32/64-R-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5816/32/64-R-4KS2 16/32/64 Channel 2U 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5816-32-64-r-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr2104hs-p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR2104HS-P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2104HS-P-4KS2 4 Channel Compact 1U 4PoE Lite 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2104hs-p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"poeInPorts":4,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr2204-2208-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR2204/2208-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2204/2208-4KS2 4/8 Channel 1U 2HDDs Lite 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2204-2208-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr4204-p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR4204-P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4204-P-4KS2 4 Channel 1U 2HDDs 4PoE 4K & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4204-p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":16,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-mxvr4104",
    manufacturer: "Dahua Technology",
    model: "DHI-MXVR4104",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-MXVR4104 4 Channels H.265 1 HDD Mobile Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-mxvr4104-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-dahua-technology-dn4083e64-p",
    manufacturer: "Dahua Technology",
    model: "DN4083E64/P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DN4083E64/P 6 cameras, 8 channels, 3TB HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dn4083e64-p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5864-r-16p4ks2e",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5864-R-16P4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5864-R-16P4KS2E 64 Channel 2U 16PoE 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5864-r-16p4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8,"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr5816-5832-5864-16p-4ks2e",
    manufacturer: "Dahua Technology",
    model: "NVR5816/5832/5864-16P-4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5816/5832/5864-16P-4KS2E 16/32/64 Channel 2U 16PoE 4K & H.265 Pro Network Video ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5816-5832-5864-16p-4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":16,"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr2104hs-s3",
    manufacturer: "Dahua Technology",
    model: "NVR2104HS-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2104HS-S3 4 Channel Compact 1U 1HDD Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2104hs-s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr2108hs-8p-s3",
    manufacturer: "Dahua Technology",
    model: "NVR2108HS-8P-S3",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2108HS-8P-S3 8 Channel Compact 1U 1HDD 8PoE Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2108hs-8p-s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr2104-2108-w-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR2104/2108-W-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2104/2108-W-4KS2 4/8 Channel Smart 1U Lite 4K H.265 Wireless Network Video Recor",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2104-2108-w-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dn1142e44",
    manufacturer: "Dahua Technology",
    model: "DN1142E44",
    category: "nvr-recorder",
    tagline: "Dahua Technology DN1142E44 4 cameras, 4 channels, 2TB HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dn1142e44-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-nvr4432-i",
    manufacturer: "Dahua Technology",
    model: "NVR4432-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4432-I 32Channel 1.5U AI Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4432-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"]},
  },
  {
    id: "ss-dahua-technology-nvr2104-i",
    manufacturer: "Dahua Technology",
    model: "NVR2104-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2104-I 4 Channel Smart 1U WizSense Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2104-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dnr408r2",
    manufacturer: "Dahua Technology",
    model: "DNR408R2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR408R2 8 channels, 8 PoE+ support, 200Mbps, 2TB HDD NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr408r2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dhi-nvr6a08-64-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR6A08-64-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR6A08-64-4KS2 4K 64CH 2U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr6a08-64-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5864-16p4ks2e",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5864-16P4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5864-16P4KS2E 64 Channel 2U 16PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5864-16p4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":16,"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5816-16p4ks2e",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5816-16P4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5816-16P4KS2E 16 Channel 2U 16PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5816-16p4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":16,"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr616d-64-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR616D-64-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR616D-64-4KS2 64 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr616d-64-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-nvr5208-5216-5232-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR5208/5216/5232-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5208/5216/5232-4KS2 8/16/32 Channel 1U 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5208-5216-5232-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5208-5216-5232-8p-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5208/5216/5232-8P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5208/5216/5232-8P-4KS2 8/16/32 Channel 1U 8PoE 4K & H.265 Pro Network Video ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5208-5216-5232-8p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dnr408p2",
    manufacturer: "Dahua Technology",
    model: "DNR408P2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR408P2 8 Channels PoE HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr408p2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dnr408p2p",
    manufacturer: "Dahua Technology",
    model: "DNR408P2P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR408P2P 8 channels PoE HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr408p2p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-nvr4816-4832-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR4816/4832-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4816/4832-4KS2 16/32 Channel 2U 4K&H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4816-4832-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dn1142e43",
    manufacturer: "Dahua Technology",
    model: "DN1142E43",
    category: "nvr-recorder",
    tagline: "Dahua Technology DN1142E43 4 cameras, 4 channels, 2TB HDD NVR system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dn1142e43-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-nvr4208-8p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR4208-8P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4208-8P-4KS2 8 Channel 1U 8PoE 4K 2HDDs & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4208-8p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":16,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-ivss7016-8i",
    manufacturer: "Dahua Technology",
    model: "IVSS7016-8I",
    category: "nvr-recorder",
    tagline: "Dahua Technology IVSS7016-8I 3U 16HDD WizMind Intelligent Video Surveillance Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ivss7016-8i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-dnr516p2",
    manufacturer: "Dahua Technology",
    model: "DNR516P2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR516P2 16-channel PoE HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr516p2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-nvr4832-i",
    manufacturer: "Dahua Technology",
    model: "NVR4832-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4832-I 32Channel 2U AI Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4832-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-n42b3p",
    manufacturer: "Dahua Technology",
    model: "N42B3P",
    category: "nvr-recorder",
    tagline: "Dahua Technology N42B3P 4K 16CH 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-n42b3p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"poeInPorts":16,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dn408p28",
    manufacturer: "Dahua Technology",
    model: "DN408P28",
    category: "nvr-recorder",
    tagline: "Dahua Technology DN408P28 full HD PoE NVR system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dn408p28-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dnr516r2",
    manufacturer: "Dahua Technology",
    model: "DNR516R2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR516R2 16 channels, 16 PoE+ support, 200Mbps, 2TB HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr516r2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5864-r4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5864-R4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5864-R4KS2 64 Channel 2U 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5864-r4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dnr416p6p",
    manufacturer: "Dahua Technology",
    model: "DNR416P6P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR416P6P 16 channels PoE HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr416p6p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-nvr5208-16-8p-4ks2e",
    manufacturer: "Dahua Technology",
    model: "NVR5208/16-8P-4KS2E.",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5208/16-8P-4KS2E 8/16 Channel 1U 8PoE 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5208-16-8p-4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-n52b2p",
    manufacturer: "Dahua Technology",
    model: "N52B2P",
    category: "nvr-recorder",
    tagline: "Dahua Technology N52B2P 4K 8CH 1U ePoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-n52b2p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr2104-p-i",
    manufacturer: "Dahua Technology",
    model: "NVR2104-P-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2104-P-I 4 Channel Smart 1U 4PoE WizSense Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2104-p-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr5432-16p-i",
    manufacturer: "Dahua Technology",
    model: "NVR5432-16P-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5432-16P-I 32Channel 1.5U 16PoE AI Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5432-16p-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8},
  },
  {
    id: "ss-dahua-technology-nvr2204-p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR2204-P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2204-P-4KS2 4 Channel 1U 2HDDs 4PoE Lite 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2204-p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":4,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr5216-16p-i",
    manufacturer: "Dahua Technology",
    model: "NVR5216-16P-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5216-16P-I 16Channel 1U 16PoE AI Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5216-16p-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dnr408p4p",
    manufacturer: "Dahua Technology",
    model: "DNR408P4P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR408P4P 8 channels PoE HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr408p4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-nvr4816-4832-16p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR4816/4832-16P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4816/4832-16P-4KS2 16/32 Channel 2U 16PoE 4K&H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4816-4832-16p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":16,"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-nvr4416-16p-i",
    manufacturer: "Dahua Technology",
    model: "NVR4416-16P-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR4416-16P-I 16Channel 1.5U 16PoE AI Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr4416-16p-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"]},
  },
  {
    id: "ss-dahua-technology-dnr516p4p",
    manufacturer: "Dahua Technology",
    model: "DNR516P4P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR516P4P 16 channels PoE HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr516p4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-ivss7024dr-8i",
    manufacturer: "Dahua Technology",
    model: "IVSS7024DR-8I",
    category: "nvr-recorder",
    tagline: "Dahua Technology IVSS7024DR-8I 4U 24HDD WizMind Intelligent Video Surveillance Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ivss7024dr-8i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"formFactor":"4U"},
  },
  {
    id: "ss-dahua-technology-dnr416p4p",
    manufacturer: "Dahua Technology",
    model: "DNR416P4P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR416P4P 16 channels PoE HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr416p4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dnr1181",
    manufacturer: "Dahua Technology",
    model: "DNR1181",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR1181 8 channel PoE high definition NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr1181-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dnr118p2",
    manufacturer: "Dahua Technology",
    model: "DNR118P2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR118P2 8 channel PoE high definition NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr118p2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dnr1182",
    manufacturer: "Dahua Technology",
    model: "DNR1182",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR1182 8 channel PoE high definition NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr1182-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dnr532p2",
    manufacturer: "Dahua Technology",
    model: "DNR532P2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR532P2 32 channels PoE HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr532p2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-ivss7008-2i",
    manufacturer: "Dahua Technology",
    model: "IVSS7008-2I",
    category: "nvr-recorder",
    tagline: "Dahua Technology IVSS7008-2I 2U 8HDD WizMind Intelligent Video Surveillance Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ivss7008-2i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dnr516p2p",
    manufacturer: "Dahua Technology",
    model: "DNR516P2P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR516P2P 16 channel PoE HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr516p2p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dnr532p2p",
    manufacturer: "Dahua Technology",
    model: "DNR532P2P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR532P2P 32 channel PoE HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr532p2p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dnr516p6p",
    manufacturer: "Dahua Technology",
    model: "DNR516P6P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR516P6P 16 channels PoE HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr516p6p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-n42b2p",
    manufacturer: "Dahua Technology",
    model: "N42B2P",
    category: "nvr-recorder",
    tagline: "Dahua Technology N42B2P 4K 8CH 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-n42b2p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5832-r4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5832-R4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5832-R4KS2 32 Channel 2U 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5832-r4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dnr1141",
    manufacturer: "Dahua Technology",
    model: "DNR1141",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR1141 4 channels PoE high definition NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr1141-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dnr118p2p",
    manufacturer: "Dahua Technology",
    model: "DNR118P2P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR118P2P 8 channel PoE high definition NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr118p2p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-ivss7016dr-8i",
    manufacturer: "Dahua Technology",
    model: "IVSS7016DR-8I",
    category: "nvr-recorder",
    tagline: "Dahua Technology IVSS7016DR-8I 3U 16HDD WizMind Intelligent Video Surveillance Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-ivss7016dr-8i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":256,"hddBays":1,"formFactor":"3U"},
  },
  {
    id: "ss-dahua-technology-dnr114p2",
    manufacturer: "Dahua Technology",
    model: "DNR114P2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR114P2 4 channels PoE high definition NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr114p2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dnr114p2p",
    manufacturer: "Dahua Technology",
    model: "DNR114P2P",
    category: "nvr-recorder",
    tagline: "Dahua Technology DNR114P2P 4 channel PoE high definition NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-dnr114p2p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-dahua-technology-dhi-nvr6a08-32-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR6A08-32-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR6A08-32-4KS2 4K 32CH 2U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr6a08-32-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-n54b3p",
    manufacturer: "Dahua Technology",
    model: "N54B3P",
    category: "nvr-recorder",
    tagline: "Dahua Technology N54B3P 4K 16CH 1.5U ePoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-n54b3p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5816-r4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5816-R4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5816-R4KS2 16 Channel 2U 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5816-r4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-n42b1p",
    manufacturer: "Dahua Technology",
    model: "N42B1P",
    category: "nvr-recorder",
    tagline: "Dahua Technology N42B1P 4K 4CH 1U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-n42b1p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"poeInPorts":4,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr5424-24p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR5424-24P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5424-24P-4KS2 24 Channel 1.5U 4HDDs 24PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5424-24p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":24},
  },
  {
    id: "ss-dahua-technology-nvr5224-24p-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR5224-24P-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5224-24P-4KS2 24 Channel 1U 2HDDs 24PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5224-24p-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":24,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-n54a4p",
    manufacturer: "Dahua Technology",
    model: "N54A4P",
    category: "nvr-recorder",
    tagline: "Dahua Technology N54A4P 4K 24CH 1.5U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-n54a4p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":24},
  },
  {
    id: "ss-dahua-technology-n52b3p",
    manufacturer: "Dahua Technology",
    model: "N52B3P",
    category: "nvr-recorder",
    tagline: "Dahua Technology N52B3P 4K 16CH 1U ePoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-n52b3p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr541654325464-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR541654325464-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR541654325464-4KS2 16/32/64Channel 1.5U 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr541654325464-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"]},
  },
  {
    id: "ss-dahua-technology-nvr2204-p-i",
    manufacturer: "Dahua Technology",
    model: "NVR2204-P-I",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR2204-P-I 4 Channel 1U 4PoE WizSense Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr2204-p-i-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr5416-5432-5464-16p-4ks2envr",
    manufacturer: "Dahua Technology",
    model: "NVR5416/5432/5464-16P-4KS2ENVR",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR5416/5432/5464-16P-4KS2ENVR 16/32/64 Channel 1.5U 16PoE 4K & H.265 Pro Network V",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr5416-5432-5464-16p-4ks2envr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":16},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5464-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5464-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5464-4KS2 64 Channel 1.5U 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5464-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5432-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5432-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5432-4KS2 32 Channel 1.5U 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5432-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5232-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5232-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5232-4KS2 32 Channel 1U 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5232-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5216-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5216-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5216-4KS2 16 Channel 1U 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5216-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5208-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5208-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5208-4KS2 8 Channel 1U 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5208-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr616-64-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR616-64- 4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR616-64- 4KS2 64 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr616-64-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr616-128-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR616-128- 4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR616-128- 4KS2 128 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr616-128-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr608-64-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR608-64- 4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR608-64- 4KS2 64 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr608-64-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr608-128-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR608-128- 4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR608-128- 4KS2 128 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr608-128-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4108hs-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4108HS-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4108HS-4KS2 8 Channel Compact 1U 4K&H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4108hs-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4116-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4116-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4116-4KS2 16 Channel Smart 1U 4K & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4116-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4108-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4108-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4108-4KS2 8 Channel Smart 1U 4K & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4108-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5416-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5416-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5416-4KS2 16 Channel 1.5U 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5416-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4104-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4104-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4104-4KS2 4 Channel Smart 1U 4K & H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4104-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-nvr608-32-4ks2",
    manufacturer: "Dahua Technology",
    model: "NVR608-32-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology NVR608-32-4KS2 32 Channel 2U 8HDDs Ultra series Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-nvr608-32-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"raidLevels":["0","1","5","6","10"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5816-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5816-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5816-4KS2 16 Channel 2U 4K&H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5816-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"formFactor":"2U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5464-16p4ks2e",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5464-16P4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5464-16P4KS2E 64 Channel 1.5U 16PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5464-16p4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":16},
  },
  {
    id: "ss-dahua-technology-dhi-nvr608r-64-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR608R-64-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR608R-64-4KS2 64 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr608r-64-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5232-16p4ks2e",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5232-16P4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5232-16P4KS2E 32 Channel 1U 16PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5232-16p4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":16,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5432-16p4ks2e",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5432-16P4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5432-16P4KS2E 32 Channel 1.5U 16PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5432-16p4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":16},
  },
  {
    id: "ss-dahua-technology-dhi-nvr608r-128-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR608R-128-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR608R-128-4KS2 128 Channel Ultra Series 4K H.265 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr608r-128-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1,"codecs":["H.265"],"raidLevels":["0","1","5","6","10"]},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5216-16p4ks2e",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5216-16P4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5216-16P4KS2E 16 Channel 1U 16PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5216-16p4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":16,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5416-16p4ks2e",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5416-16P4KS2E",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5416-16P4KS2E 16 Channel 1.5U 16PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5416-16p4ks2e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":16},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5232-8p4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5232-8P4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5232-8P4KS2 32 Channel 1U 8PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5232-8p4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5216-8p4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5216-8P4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5216-8P4KS2 16 Channel 1U 8PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5216-8p4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr5208-8p4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR5208-8P4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR5208-8P4KS2 8 Channel 1U 8PoE 4K & H.265 Pro Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr5208-8p4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265","MJPEG"],"poeInPorts":8,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4108hsp-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4108HSP-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4108HSP-4KS2 8 Channel Compact 1U 4PoE 4K & H.265 Lite Network Video Recorde",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4108hsp-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":16,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4104hsp-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4104HSP-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4104HSP-4KS2 4 Channel Compact 1U 4PoE 4K & H.265 Lite Network Video Recorde",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4104hsp-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"poeInPorts":16,"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4104hs-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4104HS-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4104HS-4KS2 4 Channel Compact 1U 4K&H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4104hs-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-dahua-technology-dhi-nvr4116hs-4ks2",
    manufacturer: "Dahua Technology",
    model: "DHI-NVR4116HS-4KS2",
    category: "nvr-recorder",
    tagline: "Dahua Technology DHI-NVR4116HS-4KS2 16 Channel Compact 1U 4K&H.265 Lite Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-dhi-nvr4116hs-4ks2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265+","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-avigilon-hd-nvr4-std-48tb",
    manufacturer: "Avigilon",
    model: "HD-NVR4-STD-48TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR4-STD-48TB HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr4-std-48tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr4-std-32tb",
    manufacturer: "Avigilon",
    model: "HD-NVR4-STD-32TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR4-STD-32TB HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr4-std-32tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr3-prm-84tb-na",
    manufacturer: "Avigilon",
    model: "HD-NVR3-PRM-84TB-NA",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-PRM-84TB-NA 84 TB HD NVR Premium with Microsoft Windows Server 2012 R2 for Embedded",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-prm-84tb-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-vma-envr1-8p8",
    manufacturer: "Avigilon",
    model: "VMA-ENVR1-8P8",
    category: "nvr-recorder",
    tagline: "Avigilon VMA-ENVR1-8P8 8TB 8 port appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-vma-envr1-8p8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-avigilon-vma-rpo-4p4",
    manufacturer: "Avigilon",
    model: "VMA-RPO-4P4",
    category: "nvr-recorder",
    tagline: "Avigilon VMA-RPO-4P4 4TB 4 port HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-vma-rpo-4p4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr4-prm-96tb",
    manufacturer: "Avigilon",
    model: "HD-NVR4-PRM-96TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR4-PRM-96TB HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr4-prm-96tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-ainvr-val-12tb",
    manufacturer: "Avigilon",
    model: "AINVR-VAL-12TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-VAL-12TB AI NVR Value 12 TB (16 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-val-12tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-vma-envr1-8p4",
    manufacturer: "Avigilon",
    model: "VMA-ENVR1-8P4",
    category: "nvr-recorder",
    tagline: "Avigilon VMA-ENVR1-8P4 4TB 8 port appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-vma-envr1-8p4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-rmws3-2mn-na",
    manufacturer: "Avigilon",
    model: "HD-RMWS3-2MN-NA",
    category: "nvr-recorder",
    tagline: "AvigilonHD-RMWS3-2MN-NA Avigilon Control Center Professional high performance remote monitoring work",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-rmws3-2mn-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-avigilon-vma-rpo-4p2",
    manufacturer: "Avigilon",
    model: "VMA-RPO-4P2",
    category: "nvr-recorder",
    tagline: "Avigilon VMA-RPO-4P2 2.0 TB storage, 4 Port ACC ES HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-vma-rpo-4p2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr3-std-24tb-na",
    manufacturer: "Avigilon",
    model: "HD-NVR3-STD-24TB-NA",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-STD-24TB-NA 24 TB HD NVR Standard with Microsoft Windows Embedded Standard 7 and Av",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-std-24tb-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-hd-nvr4-std-24tb",
    manufacturer: "Avigilon",
    model: "HD-NVR4-STD-24TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR4-STD-24TB HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr4-std-24tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr3-prm-48tb-na",
    manufacturer: "Avigilon",
    model: "HD-NVR3-PRM-48TB-NA",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-PRM-48TB-NA 48 TB HD NVR Premium with Microsoft Windows Server 2012 R2 for Embedded",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-prm-48tb-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-hd-nvr3-val-12tb-na",
    manufacturer: "Avigilon",
    model: "HD-NVR3-VAL-12TB-NA",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-VAL-12TB-NA HD NVR Value with Microsoft Windows Embedded Standard 7 and Avigilon Co",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-val-12tb-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-avigilon-hd-rmws3-4mn-na",
    manufacturer: "Avigilon",
    model: "HD-RMWS3-4MN-NA",
    category: "nvr-recorder",
    tagline: "Avigilon HD-RMWS3-4MN-NA Avigilon Control Center professional high performance remote monitoring wor",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-rmws3-4mn-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-avigilon-hd-nvr4-prm-128tb",
    manufacturer: "Avigilon",
    model: "HD-NVR4-PRM-128TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR4-PRM-128TB HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr4-prm-128tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-rmws4-4mn",
    manufacturer: "Avigilon",
    model: "HD-RMWS4-4MN",
    category: "nvr-recorder",
    tagline: "Avigilon HD-RMWS4-4MN remote monitoring workstation for up to 4 monitors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-rmws4-4mn-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-avigilon-2mn-hd-rmws",
    manufacturer: "Avigilon",
    model: "2MN-HD-RMWS",
    category: "nvr-recorder",
    tagline: "Avigilon 2MN-HD-RMWS remote monitoring workstation with 72 camera channels support",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-2mn-hd-rmws-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-15-0tb-hd-nvr2",
    manufacturer: "Avigilon",
    model: "15.0TB-HD-NVR2",
    category: "nvr-recorder",
    tagline: "Avigilon 15.0TB-HD-NVR2 15 TB network video recorder server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-15-0tb-hd-nvr2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-21-0tb-hd-nvr2",
    manufacturer: "Avigilon",
    model: "21.0TB-HD-NVR2",
    category: "nvr-recorder",
    tagline: "Avigilon 21.0TB-HD-NVR2 21 TB network video recorder server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-21-0tb-hd-nvr2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr3-val-18tb-na",
    manufacturer: "Avigilon",
    model: "HD-NVR3-VAL-18TB-NA",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-VAL-18TB-NA HD NVR Value with Microsoft Windows Embedded Standard 7 and Avigilon Co",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-val-18tb-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-avigilon-ainvr-prm-64tb",
    manufacturer: "Avigilon",
    model: "AINVR-PRM-64TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-PRM-64TB AI NVR Premium 64 TB (80 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-prm-64tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-ai-appliance",
    manufacturer: "Avigilon",
    model: "AI Appliance",
    category: "nvr-recorder",
    tagline: "Avigilon AI Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ai-appliance-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr4-prm-64tb",
    manufacturer: "Avigilon",
    model: "HD-NVR4-PRM-64TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR4-PRM-64TB HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr4-prm-64tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvrws3-8tb-na",
    manufacturer: "Avigilon",
    model: "HD-NVRWS3-8TB-NA",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVRWS3-8TB-NA NVR Workstation, 8.0 TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvrws3-8tb-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-avigilon-ainvr-val-6tb",
    manufacturer: "Avigilon",
    model: "AINVR-VAL-6TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-VAL-6TB AI NVR Value 6 TB (8 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-val-6tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr4-prm-192tb",
    manufacturer: "Avigilon",
    model: "HD-NVR4-PRM-192TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR4-PRM-192TB HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr4-prm-192tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-10-0tb-hd-nvr2",
    manufacturer: "Avigilon",
    model: "10.0TB-HD-NVR2",
    category: "nvr-recorder",
    tagline: "Avigilon 10.0TB-HD-NVR2 10 TB network video recorder server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-10-0tb-hd-nvr2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr3-prm-32tb-na",
    manufacturer: "Avigilon",
    model: "HD-NVR3-PRM-32TB-NA",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-PRM-32TB-NA 32 TB HD NVR Premium with Microsoft Windows Server 2012 R2 for Embedded",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-prm-32tb-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-hd-nvr3-prm-137tb",
    manufacturer: "Avigilon",
    model: "HD-NVR3-PRM-137TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-PRM-137TB 137 TB HD NVR Premium with Microsoft Windows Server 2012 R2 for Embedded ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-prm-137tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-4mn-hd-rmws",
    manufacturer: "Avigilon",
    model: "4MN-HD-RMWS",
    category: "nvr-recorder",
    tagline: "Avigilon 4MN-HD-RMWS remote monitoring workstation with 144 camera channels support",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-4mn-hd-rmws-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr-exp2-10tb",
    manufacturer: "Avigilon",
    model: "HD-NVR-EXP2-10TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR-EXP2-10TB 10 TB RAID 6 expansion, 2U rack mount",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr-exp2-10tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["6"],"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-ainvr-prm-plus-160tb",
    manufacturer: "Avigilon",
    model: "AINVR-PRM-PLUS-160TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-PRM-PLUS-160TB AI NVR Premium+ 160 TB (192 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-prm-plus-160tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr3-val-6tb",
    manufacturer: "Avigilon",
    model: "HD-NVR3-VAL-6TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-VAL-6TB 6 TB HD NVR Value with Microsoft Windows Embedded Standard 7 and Avigilon C",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-val-6tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-avigilon-hd-nvr4-std-16tb",
    manufacturer: "Avigilon",
    model: "HD-NVR4-STD-16TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR4-STD-16TB HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr4-std-16tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-ainvr-std-24tb",
    manufacturer: "Avigilon",
    model: "AINVR-STD-24TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-STD-24TB AI NVR Standard 24 TB (32 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-std-24tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr4-prm-157tb",
    manufacturer: "Avigilon",
    model: "HD-NVR4-PRM-157TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR4-PRM-157TB HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr4-prm-157tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-3-0tb-hd-nvr2",
    manufacturer: "Avigilon",
    model: "3.0TB-HD-NVR2",
    category: "nvr-recorder",
    tagline: "Avigilon 3.0TB-HD-NVR2 3TB network video recorder server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-3-0tb-hd-nvr2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr3-val-3tb-na",
    manufacturer: "Avigilon",
    model: "HD-NVR3-VAL-3TB-NA",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-VAL-3TB-NA 3 TB HD NVR Value with Microsoft Windows Embedded Standard 7 and Avigilo",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-val-3tb-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-avigilon-ainvr-std-32tb",
    manufacturer: "Avigilon",
    model: "AINVR-STD-32TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-STD-32TB AI NVR Standard 32 TB (48 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-std-32tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-ainvr-prm-96tb",
    manufacturer: "Avigilon",
    model: "AINVR-PRM-96TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-PRM-96TB AI NVR Premium 96 TB (120 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-prm-96tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr3-std-16tb-na",
    manufacturer: "Avigilon",
    model: "HD-NVR3-STD-16TB-NA",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-STD-16TB-NA 16 TB HD NVR Standard with Microsoft Windows Embedded Standard 7 and Av",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-std-16tb-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-ainvr-prm-plus-128tb",
    manufacturer: "Avigilon",
    model: "AINVR-PRM-PLUS-128TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-PRM-PLUS-128TB AI NVR Premium+ 128 TB (160 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-prm-plus-128tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-hd-nvr3-prm-56tb-na",
    manufacturer: "Avigilon",
    model: "HD-NVR3-PRM-56TB-NA",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-PRM-56TB-NA 56 TB HD NVR Premium with Microsoft Windows Server 2012 R2 for Embedded",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-prm-56tb-na-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-ainvr-std-48tb",
    manufacturer: "Avigilon",
    model: "AINVR-STD-48TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-STD-48TB AI NVR Standard 48 TB (64 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-std-48tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-ainvr-prm-plus-96tb",
    manufacturer: "Avigilon",
    model: "AINVR-PRM-PLUS-96TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-PRM-PLUS-96TB AI NVR Premium+ 96 TB (120 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-prm-plus-96tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-aacc-drv-12tb",
    manufacturer: "Avigilon",
    model: "AACC-DRV-12TB",
    category: "nvr-recorder",
    tagline: "Avigilon AACC-DRV-12TB Replacement Drives",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-aacc-drv-12tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-aacc-pwc-uss",
    manufacturer: "Avigilon",
    model: "AACC-PWC-USS",
    category: "nvr-recorder",
    tagline: "Avigilon AACC-PWC-USS Power Cables",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-aacc-pwc-uss-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-rck-1100",
    manufacturer: "Avigilon",
    model: "APP-RCK-1100",
    category: "nvr-recorder",
    tagline: "Avigilon APP-RCK-1100 Mounting rack for A1100",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-rck-1100-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-aacc-drv-20tb",
    manufacturer: "Avigilon",
    model: "AACC-DRV-20TB",
    category: "nvr-recorder",
    tagline: "Avigilon AACC-DRV-20TB Replacement Drives",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-aacc-drv-20tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-aacc-drv-16tb",
    manufacturer: "Avigilon",
    model: "AACC-DRV-16TB",
    category: "nvr-recorder",
    tagline: "Avigilon AACC-DRV-16TB Replacement Drives",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-aacc-drv-16tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-aacc-drv-08tb",
    manufacturer: "Avigilon",
    model: "AACC-DRV-08TB",
    category: "nvr-recorder",
    tagline: "Avigilon AACC-DRV-08TB Replacement Drives",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-aacc-drv-08tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-aacc-drv-04tb",
    manufacturer: "Avigilon",
    model: "AACC-DRV-04TB",
    category: "nvr-recorder",
    tagline: "Avigilon AACC-DRV-04TB Replacement Drives",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-aacc-drv-04tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-aacc-pwc-iecs",
    manufacturer: "Avigilon",
    model: "AACC-PWC-IECS",
    category: "nvr-recorder",
    tagline: "Avigilon AACC-PWC-IECS Power Cables",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-aacc-pwc-iecs-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-aacc-pwc-eus",
    manufacturer: "Avigilon",
    model: "AACC-PWC-EUS",
    category: "nvr-recorder",
    tagline: "Avigilon AACC-PWC-EUS Power Cables",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-aacc-pwc-eus-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-aacc-pwc-uks",
    manufacturer: "Avigilon",
    model: "AACC-PWC-UKS",
    category: "nvr-recorder",
    tagline: "Avigilon AACC-PWC-UKS Single UK Power Cable",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-aacc-pwc-uks-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-ainvr-prm-128tb",
    manufacturer: "Avigilon",
    model: "AINVR-PRM-128TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-PRM-128TB AI NVR Premium 128 TB (160 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-prm-128tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-ainvr-prm-plus-64tb",
    manufacturer: "Avigilon",
    model: "AINVR-PRM-PLUS-64TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-PRM-PLUS-64TB AI NVR Premium+ 64 TB (80 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-prm-plus-64tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-ainvr-prm-160tb",
    manufacturer: "Avigilon",
    model: "AINVR-PRM-160TB",
    category: "nvr-recorder",
    tagline: "Avigilon AINVR-PRM-160TB AI NVR Premium 160 TB (192 TB Raw) with Avigilon Control Center",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-ainvr-prm-160tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-15-0tb-hd-nvr",
    manufacturer: "Avigilon",
    model: "15.0TB-HD-NVR",
    category: "nvr-recorder",
    tagline: "Avigilon 15.0TB-HD-NVR 2U HD network video recorder server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-15-0tb-hd-nvr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-5-0tb-hd-nvr2",
    manufacturer: "Avigilon",
    model: "5.0TB-HD-NVR2",
    category: "nvr-recorder",
    tagline: "Avigilon 5.0TB-HD-NVR2 5TB network video recorder server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-5-0tb-hd-nvr2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-1-0tb-hd-nvrws",
    manufacturer: "Avigilon",
    model: "1.0TB-HD-NVRWS",
    category: "nvr-recorder",
    tagline: "Avigilon 1.0TB-HD-NVRWS network video recorder with 64 channels and 1 TB storage capacity",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-1-0tb-hd-nvrws-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-avigilon-10-0tb-hd-nvr-ec2",
    manufacturer: "Avigilon",
    model: "10.0TB-HD-NVR-EC2",
    category: "nvr-recorder",
    tagline: "Avigilon 10.0TB-HD-NVR- HD Network Video Recorder Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-10-0tb-hd-nvr-ec2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-1100-48-bt",
    manufacturer: "Avigilon",
    model: "APP-1100-48-BT",
    category: "nvr-recorder",
    tagline: "Avigilon APP-1100-48-BT Alta Workstation Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-1100-48-bt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-800-32-dg",
    manufacturer: "Avigilon",
    model: "APP-800-32-DG",
    category: "nvr-recorder",
    tagline: "Avigilon APP-800-32-DG Alta Workstation Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-800-32-dg-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-200-8-dg",
    manufacturer: "Avigilon",
    model: "APP-200-8-DG",
    category: "nvr-recorder",
    tagline: "Avigilon APP-200-8-DG Alta Workstation Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-200-8-dg-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-200-4-sg",
    manufacturer: "Avigilon",
    model: "APP-200-4-SG",
    category: "nvr-recorder",
    tagline: "Avigilon APP-200-4-SG Alta Workstation Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-200-4-sg-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-3100-160-sfp",
    manufacturer: "Avigilon",
    model: "APP-3100-160-SFP",
    category: "nvr-recorder",
    tagline: "Avigilon APP-3100-160-SFP Alta rack-mounted Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-3100-160-sfp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-2100-160-sfp",
    manufacturer: "Avigilon",
    model: "APP-2100-160-SFP",
    category: "nvr-recorder",
    tagline: "Avigilon APP-2100-160-SFP Alta rack-mounted Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-2100-160-sfp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-2100-80-bt",
    manufacturer: "Avigilon",
    model: "APP-2100-80-BT",
    category: "nvr-recorder",
    tagline: "Avigilon APP-2100-80-BT Alta rack-mounted Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-2100-80-bt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-1100-24-bt",
    manufacturer: "Avigilon",
    model: "APP-1100-24-BT",
    category: "nvr-recorder",
    tagline: "Avigilon APP-1100-24-BT Alta Workstation Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-1100-24-bt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-600-16-dg",
    manufacturer: "Avigilon",
    model: "APP-600-16-DG",
    category: "nvr-recorder",
    tagline: "Avigilon APP-600-16-DG Alta Workstation Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-600-16-dg-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-600-8-dg",
    manufacturer: "Avigilon",
    model: "APP-600-8-DG",
    category: "nvr-recorder",
    tagline: "Avigilon APP-600-8-DG Alta Workstation Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-600-8-dg-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-15-0tb-hd-nvr-lpr",
    manufacturer: "Avigilon",
    model: "15.0TB-HD-NVR-LPR",
    category: "nvr-recorder",
    tagline: "Avigilon 15.0TB-HD-NVR-LPR - HD Network Video Recorder Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-15-0tb-hd-nvr-lpr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-2100-160-bt",
    manufacturer: "Avigilon",
    model: "APP-2100-160-BT",
    category: "nvr-recorder",
    tagline: "Avigilon APP-2100-160-BT Alta rack-mounted Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-2100-160-bt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-3100-240-sfp",
    manufacturer: "Avigilon",
    model: "APP-3100-240-SFP",
    category: "nvr-recorder",
    tagline: "Avigilon APP-3100-240-SFP Alta rack-mounted Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-3100-240-sfp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-3100-240-bt",
    manufacturer: "Avigilon",
    model: "APP-3100-240-BT",
    category: "nvr-recorder",
    tagline: "Avigilon APP-3100-240-BT Alta rack-mounted Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-3100-240-bt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-3100-160-bt",
    manufacturer: "Avigilon",
    model: "APP-3100-160-BT",
    category: "nvr-recorder",
    tagline: "Avigilon APP-3100-160-BT Alta rack-mounted Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-3100-160-bt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-3100-80-sfp",
    manufacturer: "Avigilon",
    model: "APP-3100-80-SFP",
    category: "nvr-recorder",
    tagline: "Avigilon APP-3100-80-SFP Alta rack-mounted Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-3100-80-sfp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-2100-80-sfp",
    manufacturer: "Avigilon",
    model: "APP-2100-80-SFP",
    category: "nvr-recorder",
    tagline: "Avigilon APP-2100-80-SFP Alta rack-mounted Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-2100-80-sfp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-app-3100-80-bt",
    manufacturer: "Avigilon",
    model: "APP-3100-80-BT",
    category: "nvr-recorder",
    tagline: "Avigilon APP-3100-80-BT Alta rack-mounted Cloud Connectors",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-app-3100-80-bt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-2-0tb-hd-nvrws",
    manufacturer: "Avigilon",
    model: "2.0TB-HD-NVRWS",
    category: "nvr-recorder",
    tagline: "Avigilon 2.0TB-HD-NVRWS network video recorder with 64 channels and 2 TB storage capacity",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-2-0tb-hd-nvrws-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-avigilon-5-0tb-hd-nvr-lpr",
    manufacturer: "Avigilon",
    model: "5.0TB-HD-NVR-LPR",
    category: "nvr-recorder",
    tagline: "Avigilon 5.0TB-HD-NVR-LPR 2U - HD Network Video Recorder Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-5-0tb-hd-nvr-lpr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-2-5tb-hd-nvr-lpr",
    manufacturer: "Avigilon",
    model: "2.5TB-HD-NVR-LPR",
    category: "nvr-recorder",
    tagline: "Avigilon 2.5TB-HD-NVR-LPR 2U HD network video recorder server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-2-5tb-hd-nvr-lpr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-hd-nvr3-std-36tb",
    manufacturer: "Avigilon",
    model: "HD-NVR3-STD-36TB",
    category: "nvr-recorder",
    tagline: "Avigilon HD-NVR3-STD-36TB 36 TB HD NVR Standard with Microsoft Windows Embedded Standard 7 and Avigi",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-hd-nvr3-std-36tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-avigilon-5-0tb-hd-nvr",
    manufacturer: "Avigilon",
    model: "5.0TB-HD-NVR",
    category: "nvr-recorder",
    tagline: "Avigilon 5.0TB-HD-NVR network video recorder with up to 96 camera channels and 5TB HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-5-0tb-hd-nvr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-10-0tb-hd-nvr-lpr",
    manufacturer: "Avigilon",
    model: "10.0TB-HD-NVR-LPR",
    category: "nvr-recorder",
    tagline: "Avigilon 10.0TB-HD-NVR-LPR - HD Network Video Recorder Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-10-0tb-hd-nvr-lpr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
];

const PART_5: NvrEntry[] = [
  {
    id: "ss-avigilon-10-0tb-hd-nvr",
    manufacturer: "Avigilon",
    model: "10.0TB-HD-NVR",
    category: "nvr-recorder",
    tagline: "Avigilon 10.0TB-HD-NVR network video recorder with up to 96 channels and 10TB HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-10-0tb-hd-nvr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":1},
  },
  {
    id: "ss-avigilon-2-5tb-hd-nvr",
    manufacturer: "Avigilon",
    model: "2.5TB-HD-NVR",
    category: "nvr-recorder",
    tagline: "Avigilon 2.5TB-HD-NVR network video recorder with up to 96 channels and 2.5TB HDD",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-2-5tb-hd-nvr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":1},
  },
  {
    id: "ss-avigilon-3-0tb-hd-nvrws",
    manufacturer: "Avigilon",
    model: "3.0TB-HD-NVRWS",
    category: "nvr-recorder",
    tagline: "Avigilon 3.0TB-HD-NVRWS network video recorder with 64 channels and 3 TB storage capacity",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-3-0tb-hd-nvrws-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-avigilon-500gb-hd-nvrws",
    manufacturer: "Avigilon",
    model: "500GB-HD-NVRWS",
    category: "nvr-recorder",
    tagline: "Avigilon 500GB-HD-NVRWS network video recorder with 64 camera channels",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-500gb-hd-nvrws-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-avigilon-15-0tb-hd-nvr-ec2",
    manufacturer: "Avigilon",
    model: "15.0TB-HD-NVR-EC2",
    category: "nvr-recorder",
    tagline: "Avigilon 15.0TB-HD-NVR-EC2 2U rack mount chassis",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/avigilon-15-0tb-hd-nvr-ec2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver00n0n2g",
    manufacturer: "American Dynamics",
    model: "ADVER00N0N2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER00N0N2G VideoEdge 2U NVR, 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver00n0n2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver00n0np16g",
    manufacturer: "American Dynamics",
    model: "ADVER00N0NP16G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER00N0NP16G VideoEdge 1U NVR, 16 PoE ports, 2 NIC, supports up to 32 IP cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver00n0np16g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"1U"},
  },
  {
    id: "ss-american-dynamics-adver08r0dj",
    manufacturer: "American Dynamics",
    model: "ADVER08R0DJ",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER08R0DJ VideoEdge Rack Mount NVR, 8 TB RAID 0, (2) 1 Gb NIC, (2) 10 Gb NIC, Re",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver08r0dj-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["0","1","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adved00n0n5h",
    manufacturer: "American Dynamics",
    model: "ADVED00N0N5H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED00N0N5H VideoEdge Desktop NVR, 0 TB JBOD, (2) 2.5 GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved00n0n5h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adver100r5n2h",
    manufacturer: "American Dynamics",
    model: "ADVER100R5N2H",
    category: "nvr-recorder",
    tagline: "VideoEdge Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver100r5n2h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-american-dynamics-adver00rn2j",
    manufacturer: "American Dynamics",
    model: "ADVER00RN2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER00RN2J VideoEdge 2U NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver00rn2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver00n0np16h",
    manufacturer: "American Dynamics",
    model: "ADVER00N0NP16H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER00N0NP16H VideoEdge 2U NVR, 0 TB JBOD or Software RAID, 16 PoE ports, (2) 2.5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver00n0np16h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adved00n0n5g",
    manufacturer: "American Dynamics",
    model: "ADVED00N0N5G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED00N0N5G VideoEdge Compact Desktop NVR, 2 NIC",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved00n0n5g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adver00rn2k",
    manufacturer: "American Dynamics",
    model: "ADVER00RN2K",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER00RN2K VideoEdge 2U HC RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver00rn2k-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver12r5n2g",
    manufacturer: "American Dynamics",
    model: "ADVER12R5N2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER12R5N2G VideoEdge 2U NVR, 12TB RAID 5 (18 Total), 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver12r5n2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5","JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver12n0np16g",
    manufacturer: "American Dynamics",
    model: "ADVER12N0NP16G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER12N0NP16G VideoEdge 1U NVR, 12 TB JBOD, 16 PoE ports, 2 NIC, supports up to 3",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver12n0np16g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"1U"},
  },
  {
    id: "ss-american-dynamics-adver18r5n2g",
    manufacturer: "American Dynamics",
    model: "ADVER18R5N2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER18R5N2G VideoEdge 2U NVR, 18TB RAID 5 (24 Total), 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver18r5n2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5","JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-advevirt",
    manufacturer: "American Dynamics",
    model: "ADVEVIRT",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVEVIRT Virtual VideoEdge NVR base license, 1 year SSA, no camera or analytics li",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-advevirt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-american-dynamics-adver36r5n2j",
    manufacturer: "American Dynamics",
    model: "ADVER36R5N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER36R5N2J VideoEdge 2U NVR, 36 TB RAID 5 (48 TB Raw)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver36r5n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver50r5n2g",
    manufacturer: "American Dynamics",
    model: "ADVER50R5N2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER50R5N2G VideoEdge 2U NVR, 50TB RAID 5 (60 Total), 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver50r5n2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5","JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver04n0np16g",
    manufacturer: "American Dynamics",
    model: "ADVER04N0NP16G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER04N0NP16G VideoEdge 1U NVR, 4 TB JBOD, 16 PoE ports, 2 NIC, supports up to 32",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver04n0np16g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"1U"},
  },
  {
    id: "ss-american-dynamics-adver00n0h2g",
    manufacturer: "American Dynamics",
    model: "ADVER00N0H2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER00N0H2G VideoEdge 2U Hybrid with 16 analog channels, 0TB storage, 2 NIC",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver00n0h2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver30r5n2g",
    manufacturer: "American Dynamics",
    model: "ADVER30R5N2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER30R5N2G VideoEdge 2U NVR, 30TB RAID 5 (36 Total), 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver30r5n2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5","JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver06n0np16g",
    manufacturer: "American Dynamics",
    model: "ADVER06N0NP16G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER06N0NP16G VideoEdge 1U NVR, 6 TB JBOD, 16 PoE ports, 2 NIC, supports up to 32",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver06n0np16g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"1U"},
  },
  {
    id: "ss-american-dynamics-adver00n0n2j",
    manufacturer: "American Dynamics",
    model: "ADVER00N0N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER00N0N2J VideoEdge 2U NVR, 0 TB, JBOD, (2) 2.5 GbE, (2) 1GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver00n0n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver16r5dj",
    manufacturer: "American Dynamics",
    model: "ADVER16R5DJ",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER16R5DJ VideoEdge Rack Mount NVR, 16 TB RAID 5 (24 total), (2) 1 Gb NIC, (2) 1",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver16r5dj-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1","5","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adver64r5dj",
    manufacturer: "American Dynamics",
    model: "ADVER64R5DJ",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER64R5DJ VideoEdge Rack Mount NVR, 64 TB RAID 5, (72 Total), (2) 1 Gb NIC, (2) ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver64r5dj-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1","5","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adver88r5dj",
    manufacturer: "American Dynamics",
    model: "ADVER88R5DJ",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER88R5DJ VideoEdge Rack Mount NVR, 88 TB RAID 5, (96 Total), (2) 1 GB NIC, (2) ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver88r5dj-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1","5","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adved04n0n5g",
    manufacturer: "American Dynamics",
    model: "ADVED04N0N5G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED04N0N5G VideoEdge Compact Desktop NVR, 4 TB JBOD, 2 NIC",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved04n0n5g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adver24r5n2j",
    manufacturer: "American Dynamics",
    model: "ADVER24R5N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER24R5N2J VideoEdge 2U NVR, 24 TB RAID 5 (32 TB Raw)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver24r5n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-advc-vevirt",
    manufacturer: "American Dynamics",
    model: "ADVC-VEVIRT",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVC-VEVIRT Virtual VideoEdge NVR base license, 1 year SSA, no camera or analytics",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-advc-vevirt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-american-dynamics-adved04n0n5h",
    manufacturer: "American Dynamics",
    model: "ADVED04N0N5H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED04N0N5H VideoEdge Desktop NVR, 4 TB JBOD, (2) 2.5 GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved04n0n5h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adver24n0n2j",
    manufacturer: "American Dynamics",
    model: "ADVER24N0N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER24N0N2J VideoEdge 2U NVR, 24 TB, JBOD, (2) 2.5 GbE, (2) 1GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver24n0n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver12r5n2j",
    manufacturer: "American Dynamics",
    model: "ADVER12R5N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER12R5N2J VideoEdge 2U NVR, 12 TB RAID 5 (16 TB Raw)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver12r5n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver12n0n2j",
    manufacturer: "American Dynamics",
    model: "ADVER12N0N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER12N0N2J VideoEdge 2U NVR, 12 TB, JBOD, (2) 2.5 GbE, (2) 1GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver12n0n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver200r6n2k",
    manufacturer: "American Dynamics",
    model: "ADVER200R6N2K",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER200R6N2K VideoEdge 2U HC RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver200r6n2k-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adved20n0n5h",
    manufacturer: "American Dynamics",
    model: "ADVED20N0N5H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED20N0N5H VideoEdge Desktop NVR, 20 TB JBOD, (2) 2.5 GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved20n0n5h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adver48n0np16h",
    manufacturer: "American Dynamics",
    model: "ADVER48N0NP16H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER48N0NP16H VideoEdge 2U NVR, 48 TB JBOD or Software RAID, 16 PoE ports, (2) 2.",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver48n0np16h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver60r5n2h",
    manufacturer: "American Dynamics",
    model: "ADVER60R5N2H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER60R5N2H VideoEdge 2U HC NVR, 60 TB, RAID5 (70 Total), 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver60r5n2h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-advecdrackit",
    manufacturer: "American Dynamics",
    model: "ADVECDRACKIT",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVECDRACKIT VideoEdge Compact Desktop Rack Mount Kit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-advecdrackit-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adver48r5n2j",
    manufacturer: "American Dynamics",
    model: "ADVER48R5N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER48R5N2J VideoEdge 2U NVR, 48 TB RAID 5 (60 TB Raw)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver48r5n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver60r5n2j",
    manufacturer: "American Dynamics",
    model: "ADVER60R5N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER60R5N2J VideoEdge 2U NVR, 60 TB RAID 5 (72 TB Raw)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver60r5n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adved24n0n5h",
    manufacturer: "American Dynamics",
    model: "ADVED24N0N5H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED24N0N5H VideoEdge Desktop NVR, 24 TB JBOD, (2) 2.5 GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved24n0n5h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adver12n0np16h",
    manufacturer: "American Dynamics",
    model: "ADVER12N0NP16H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER12N0NP16H VideoEdge 2U NVR, 12 TB JBOD or Software RAID, 16 PoE ports, (2) 2.",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver12n0np16h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-advec01",
    manufacturer: "American Dynamics",
    model: "ADVEC01",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVEC01 VideoEdge NVR Add-on 1 IP Cam license",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-advec01-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-american-dynamics-adver144r6n2k",
    manufacturer: "American Dynamics",
    model: "ADVER144R6N2K",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER144R6N2K VideoEdge 2U HC RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver144r6n2k-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver112r5n2j",
    manufacturer: "American Dynamics",
    model: "ADVER112R5N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER112R5N2J VideoEdge 2U NVR, 112 TB RAID 5 (128 TB Raw)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver112r5n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver80r5n2j",
    manufacturer: "American Dynamics",
    model: "ADVER80R5N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER80R5N2J VideoEdge 2U NVR, 80 TB RAID 5 (96 TB Raw)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver80r5n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adved12n0n5g",
    manufacturer: "American Dynamics",
    model: "ADVED12N0N5G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED12N0N5G VideoEdge Compact Desktop NVR, 12 TB JBOD, 2 NIC",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved12n0n5g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adved12n0n5h",
    manufacturer: "American Dynamics",
    model: "ADVED12N0N5H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED12N0N5H VideoEdge Desktop NVR, 12 TB JBOD, (2) 2.5 GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved12n0n5h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adved40n0n5h",
    manufacturer: "American Dynamics",
    model: "ADVED40N0N5H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED40N0N5H VideoEdge Desktop NVR, 40 TB JBOD, (2) 2.5 GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved40n0n5h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adver08n0np16h",
    manufacturer: "American Dynamics",
    model: "ADVER08N0NP16H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER08N0NP16H VideoEdge 2U NVR, 8 TB JBOD or Software RAID, 16 PoE ports, (2) 2.5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver08n0np16h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver36n0np16h",
    manufacturer: "American Dynamics",
    model: "ADVER36N0NP16H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER36N0NP16H VideoEdge 2U NVR, 36 TB JBOD or Software RAID, 16 PoE ports, (2) 2.",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver36n0np16h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver12tbhdk",
    manufacturer: "American Dynamics",
    model: "ADVER12TBHDK",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER12TBHDK VideoEdge 12 TB Hot Plug HDD Kit w/Tray (Compatible with *P16H & *N2J",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver12tbhdk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-american-dynamics-advc-vecam",
    manufacturer: "American Dynamics",
    model: "ADVC-VECAM",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVC-VECAM victor Professional Centrally Managed VideoEdge IP Camera Connection Li",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-advc-vecam-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-american-dynamics-advc-centlic",
    manufacturer: "American Dynamics",
    model: "ADVC-CENTLIC",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVC-CENTLIC victor Professional Central License Management for VideoEdge",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-advc-centlic-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-american-dynamics-adver36n0n2j",
    manufacturer: "American Dynamics",
    model: "ADVER36N0N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER36N0N2J VideoEdge 2U NVR, 36 TB, JBOD, (2) 2.5 GbE, (2) 1GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver36n0n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver48n0n2j",
    manufacturer: "American Dynamics",
    model: "ADVER48N0N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER48N0N2J VideoEdge 2U NVR, 48 TB, JBOD, (2) 2.5 GbE, (2) 1GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver48n0n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver16tbhchdk",
    manufacturer: "American Dynamics",
    model: "ADVER16TBHCHDK",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER16TBHCHDK VideoEdge 2U HC RAID NVR HDD Kits",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver16tbhchdk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver20tbhchdk",
    manufacturer: "American Dynamics",
    model: "ADVER20TBHCHDK",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER20TBHCHDK VideoEdge 2U HC RAID NVR HDD Kits",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver20tbhchdk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver96r5n2k",
    manufacturer: "American Dynamics",
    model: "ADVER96R5N2K",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER96R5N2K VideoEdge 2U HC RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver96r5n2k-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver112r5n2k",
    manufacturer: "American Dynamics",
    model: "ADVER112R5N2K",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER112R5N2K VideoEdge 2U HC RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver112r5n2k-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver128r6n2k",
    manufacturer: "American Dynamics",
    model: "ADVER128R6N2K",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER128R6N2K VideoEdge 2U HC RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver128r6n2k-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver160r6n2k",
    manufacturer: "American Dynamics",
    model: "ADVER160R6N2K",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER160R6N2K VideoEdge 2U HC RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver160r6n2k-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver180r6n2k",
    manufacturer: "American Dynamics",
    model: "ADVER180R6N2K",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER180R6N2K VideoEdge 2U HC RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver180r6n2k-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver16r5n2j",
    manufacturer: "American Dynamics",
    model: "ADVER16R5N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER16R5N2J VideoEdge 2U NVR, 16 TB RAID 5 (20 TB Raw)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver16r5n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver96r5n2j",
    manufacturer: "American Dynamics",
    model: "ADVER96R5N2J",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER96R5N2J VideoEdge 2U NVR, 96 TB RAID 5 (112 TB Raw)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver96r5n2j-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adved08n0n5h",
    manufacturer: "American Dynamics",
    model: "ADVED08N0N5H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED08N0N5H VideoEdge Desktop NVR, 8 TB JBOD, (2) 2.5 GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved08n0n5h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adved16n0n5h",
    manufacturer: "American Dynamics",
    model: "ADVED16N0N5H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED16N0N5H VideoEdge Desktop NVR, 16 TB JBOD, (2) 2.5 GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved16n0n5h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adved32n0n5h",
    manufacturer: "American Dynamics",
    model: "ADVED32N0N5H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED32N0N5H VideoEdge Desktop NVR, 32 TB JBOD, (2) 2.5 GbE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved32n0n5h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adver04n0np16h",
    manufacturer: "American Dynamics",
    model: "ADVER04N0NP16H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER04N0NP16H VideoEdge 2U NVR, 4 TB JBOD or Software RAID, 16 PoE ports, (2) 2.5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver04n0np16h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver24n0np16h",
    manufacturer: "American Dynamics",
    model: "ADVER24N0NP16H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER24N0NP16H VideoEdge 2U NVR, 24 TB JBOD or Software RAID, 16 PoE ports, (2) 2.",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver24n0np16h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver04tbhdk",
    manufacturer: "American Dynamics",
    model: "ADVER04TBHDK",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER04TBHDK VideoEdge 4 TB Hot Plug HDD Kit w/Tray (Compatible with *P16H & *R*N2",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver04tbhdk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-american-dynamics-adver08tbhdk",
    manufacturer: "American Dynamics",
    model: "ADVER08TBHDK",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER08TBHDK VideoEdge 8 TB Hot Plug HDD Kit w/Tray (Compatible with *P16H & *R*N2",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver08tbhdk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-american-dynamics-adver16tbhdk",
    manufacturer: "American Dynamics",
    model: "ADVER16TBHDK",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER16TBHDK VideoEdge 16 TB Hot Plug HDD Kit w/Tray (Compatible with *P16H & *N2J",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver16tbhdk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-american-dynamics-adver06tbtad",
    manufacturer: "American Dynamics",
    model: "ADVER06TBTAD",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER06TBTAD VideoEdge HDD Kit, Compatible with VideoEdge 1U, 2U or 3U NVR, 6 TB H",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver06tbtad-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"1U"},
  },
  {
    id: "ss-american-dynamics-adver18n0np16g",
    manufacturer: "American Dynamics",
    model: "ADVER18N0NP16G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER18N0NP16G VideoEdge 1U NVR, 18 TB JBOD, 16 PoE ports, 2 NIC, supports up to 3",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver18n0np16g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"poeInPorts":16,"raidLevels":["JBOD"],"formFactor":"1U"},
  },
  {
    id: "ss-american-dynamics-adved10n0n5g",
    manufacturer: "American Dynamics",
    model: "ADVED10N0N5G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED10N0N5G VideoEdge Compact Desktop NVR, 10 TB JBOD, 2 NIC",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved10n0n5g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adver30r5dj",
    manufacturer: "American Dynamics",
    model: "ADVER30R5DJ",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER30R5DJ VideoEdge Rack Mount NVR, 30 TB RAID 5 (40 total), (2) 1 Gb NIC, (2) 1",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver30r5dj-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1","5","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adve740hd08tbt",
    manufacturer: "American Dynamics",
    model: "ADVE740HD08TBT",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVE740HD08TBT VideoEdge Rack Mount NVR (R740), 8 TB Hot Plug HD Kit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adve740hd08tbt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adve740hd10tbi",
    manufacturer: "American Dynamics",
    model: "ADVE740HD10TBI",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVE740HD10TBI VideoEdge Rackmount NVR (R740), 10 TB Internal HD Kit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adve740hd10tbi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adver40r5dj",
    manufacturer: "American Dynamics",
    model: "ADVER40R5DJ",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER40R5DJ VideoEdge Rack Mount NVR, 40 TB RAID 5 (48 total), (2) 1 Gb NIC, (2) 1",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver40r5dj-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1","5","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adver50r5dj",
    manufacturer: "American Dynamics",
    model: "ADVER50R5DJ",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER50R5DJ VideoEdge Rack Mount NVR, 50 TB RAID 5 (60 total), (2) 1 Gb NIC, (2) 1",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver50r5dj-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1","5","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adver20n0n2g",
    manufacturer: "American Dynamics",
    model: "ADVER20N0N2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER20N0N2G VideoEdge 2U NVR, 20TB JBOD, 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver20n0n2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver70r5n2h",
    manufacturer: "American Dynamics",
    model: "ADVER70R5N2H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER70R5N2H VideoEdge 2U HC NVR, 70 TB, RAID5 (80 Total), 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver70r5n2h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adved06n0n5g",
    manufacturer: "American Dynamics",
    model: "ADVED06N0N5G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVED06N0N5G VideoEdge Compact Desktop NVR, 6 TB JBOD, 2 NIC",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adved06n0n5g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"desktop"},
  },
  {
    id: "ss-american-dynamics-adver90r5n2h",
    manufacturer: "American Dynamics",
    model: "ADVER90R5N2H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER90R5N2H VideoEdge 2U HC NVR, 90 TB, RAID5 (100 Total), 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver90r5n2h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver04tbtad",
    manufacturer: "American Dynamics",
    model: "ADVER04TBTAD",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER04TBTAD VideoEdge HDD Kit, Compatible with VideoEdge 1U, 2U or 3U NVR, 4 TB H",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver04tbtad-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"1U"},
  },
  {
    id: "ss-american-dynamics-adver140r5dj",
    manufacturer: "American Dynamics",
    model: "ADVER140R5DJ",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER140R5DJ VideoEdge Rack Mount NVR, 140 TB RAID 5, (160 total), (2) 1 Gb NIC, (",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver140r5dj-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1","5","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adver80r5n2h",
    manufacturer: "American Dynamics",
    model: "ADVER80R5N2H",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER80R5N2H VideoEdge 2U HC NVR, 80 TB, RAID5 (90 Total), 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver80r5n2h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver18r5h2g",
    manufacturer: "American Dynamics",
    model: "ADVER18R5H2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER18R5H2G VideoEdge 2U Hybrid with 16 analog channels, 18TB RAID 5 (24 Total), ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver18r5h2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5","JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adve740hd10tbt",
    manufacturer: "American Dynamics",
    model: "ADVE740HD10TBT",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVE740HD10TBT VideoEdge Rackmount NVR (R740), 10 TB Hot Plug HD Kit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adve740hd10tbt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adver100r5dj",
    manufacturer: "American Dynamics",
    model: "ADVER100R5DJ",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER100R5DJ VideoEdge Rack Mount NVR, 100 TB Raid 5, (120 total), (2) 1 Gb NIC, (",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver100r5dj-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1","5","JBOD"]},
  },
  {
    id: "ss-american-dynamics-adver10tbthc",
    manufacturer: "American Dynamics",
    model: "ADVER10TBTHC",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER10TBTHC VideoEdge 10TB NVR HD KIT with caddy",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver10tbthc-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-american-dynamics-adver18r5h3g",
    manufacturer: "American Dynamics",
    model: "ADVER18R5H3G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER18R5H3G VideoEdge 3U Hybrid with 32 analog channels, 18TB RAID 5 (24 Total), ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver18r5h3g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5","JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver10n0n2g",
    manufacturer: "American Dynamics",
    model: "ADVER10N0N2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER10N0N2G VideoEdge 2U NVR, 10TB JBOD, 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver10n0n2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver40r5n2g",
    manufacturer: "American Dynamics",
    model: "ADVER40R5N2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER40R5N2G VideoEdge 2U NVR, 40TB RAID 5 (50 Total), 4 NIC, Redundant PS",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver40r5n2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5","JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver10n0h2g",
    manufacturer: "American Dynamics",
    model: "ADVER10N0H2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER10N0H2G VideoEdge 2U Hybrid with 16 analog channels, 10TB JBOD, 2 NIC",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver10n0h2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver20n0h2g",
    manufacturer: "American Dynamics",
    model: "ADVER20N0H2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER20N0H2G VideoEdge 2U Hybrid with 16 analog channels, 20TB JBOD, 2 NIC",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver20n0h2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver10tbtad",
    manufacturer: "American Dynamics",
    model: "ADVER10TBTAD",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER10TBTAD VideoEdge HDD Kit, Compatible with VideoEdge 2U or 3U NVR, 10 TB Hot ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver10tbtad-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver10r0n2g",
    manufacturer: "American Dynamics",
    model: "ADVER10R0N2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER10R0N2G VideoEdge 2U NVR, 10TB RAID 0, 4 NIC, includes RAID controller and re",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver10r0n2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["0","JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver30r5h2g",
    manufacturer: "American Dynamics",
    model: "ADVER30R5H2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER30R5H2G VideoEdge 2U Hybrid with 16 analog channels, 30TB RAID 5 (36 Total), ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver30r5h2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5","JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver10n0h3g",
    manufacturer: "American Dynamics",
    model: "ADVER10N0H3G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER10N0H3G VideoEdge 3U Hybrid with 32 analog channels, 10TB JBOD, 2 NIC",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver10n0h3g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver40r5h2g",
    manufacturer: "American Dynamics",
    model: "ADVER40R5H2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER40R5H2G VideoEdge 2U Hybrid with 16 analog channels, 40TB RAID 5 (50 Total), ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver40r5h2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5","JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-american-dynamics-adver50r5h2g",
    manufacturer: "American Dynamics",
    model: "ADVER50R5H2G",
    category: "nvr-recorder",
    tagline: "American Dynamics ADVER50R5H2G VideoEdge 2U Hybrid with 16 analog channels, 50TB RAID 5 (60 Total), ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/american-dynamics-adver50r5h2g-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5","JBOD"],"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av800-0t2",
    manufacturer: "AV Costar",
    model: "AV800-0T2",
    category: "nvr-recorder",
    tagline: "Arecont Vision 8 or 16 channel Network Video Recorder with built-in PoE switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av800-0t2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-c800-2t",
    manufacturer: "AV Costar",
    model: "AV-C800-2T",
    category: "nvr-recorder",
    tagline: "ConteraCMR® NVR Appliance from AV Costar",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c800-2t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-c1600-4t",
    manufacturer: "AV Costar",
    model: "AV-C1600-4T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-C1600-4T 16 Port PoE NVR Appliance 4TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c1600-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-cn1600-8t",
    manufacturer: "AV Costar",
    model: "AV-CN1600-8T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN1600-8T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn1600-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av-cn1600-12t",
    manufacturer: "AV Costar",
    model: "AV-CN1600-12T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN1600-12T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn1600-12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av-c1600-12t",
    manufacturer: "AV Costar",
    model: "AV-C1600-12T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-C1600-12T 16 Port PoE NVR Appliance, Linux, 12TB (Licenses Not Included)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c1600-12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-c1600-2t",
    manufacturer: "AV Costar",
    model: "AV-C1600-2T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-C1600-2T 16 Port PoE NVR Appliance 2TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c1600-2t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-c800-12t",
    manufacturer: "AV Costar",
    model: "AV-C800-12T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-C800-12T 8 Port PoE NVR Appliance 12TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c800-12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-c800-4t",
    manufacturer: "AV Costar",
    model: "AV-C800-4T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-C800-4T 8 Port PoE NVR Appliance 4TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c800-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-cn800-8t",
    manufacturer: "AV Costar",
    model: "AV-CN800-8T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN800-8T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn800-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av-cn800-6t",
    manufacturer: "AV Costar",
    model: "AV-CN800-6T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN800-6T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn800-6t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av-c1600-16t",
    manufacturer: "AV Costar",
    model: "AV-C1600-16T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-C1600-16T 16 Port PoE NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c1600-16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-c1600-6t",
    manufacturer: "AV Costar",
    model: "AV-C1600-6T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-C1600-6T 16 Port PoE NVR Appliance 6TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c1600-6t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-c800-16t",
    manufacturer: "AV Costar",
    model: "AV-C800-16T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-C800-16T 8 Port PoE NVR Appliance 16TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c800-16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-c800-6t",
    manufacturer: "AV Costar",
    model: "AV-C800-6T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-C800-6T 8 Port PoE NVR Appliance 6TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c800-6t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-cn800-4t",
    manufacturer: "AV Costar",
    model: "AV-CN800-4T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN800-4T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn800-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av-c1600-8t",
    manufacturer: "AV Costar",
    model: "AV-C1600-8T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-C1600-8T 16 Port PoE NVR Appliance 8TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c1600-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-c800-8t",
    manufacturer: "AV Costar",
    model: "AV-C800-8T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-C800-8T 8 Port PoE NVR Appliance 8TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c800-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-cn800-2t",
    manufacturer: "AV Costar",
    model: "AV-CN800-2T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN800-2T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn800-2t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av-cn800-16t",
    manufacturer: "AV Costar",
    model: "AV-CN800-16T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN800-16T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn800-16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av-cn1600-20t",
    manufacturer: "AV Costar",
    model: "AV-CN1600-20T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN1600-20T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn1600-20t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av-cn1600-16t",
    manufacturer: "AV Costar",
    model: "AV-CN1600-16T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN1600-16T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn1600-16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av-cn800-12t",
    manufacturer: "AV Costar",
    model: "AV-CN800-12T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN800-12T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn800-12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av-cn1600-6t",
    manufacturer: "AV Costar",
    model: "AV-CN1600-6T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN1600-6T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn1600-6t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av-cn1600-4t",
    manufacturer: "AV Costar",
    model: "AV-CN1600-4T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CN1600-4T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cn1600-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2},
  },
  {
    id: "ss-av-costar-av1600-0t2",
    manufacturer: "AV Costar",
    model: "AV1600-0T2",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV1600-0T2 PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av1600-0t2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-cshpx128t",
    manufacturer: "AV Costar",
    model: "AV-CSHPX128T",
    category: "nvr-recorder",
    tagline: "AV CostarAV-CSHPX128T Cloud Managed Rack Mountable High Performance NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cshpx128t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cscdx16t",
    manufacturer: "AV Costar",
    model: "AV-CSCDX16T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCDX16T 64 Channel Cloud Managed Compact Desktop Network Video Recorder Server wi",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscdx16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":3,"formFactor":"desktop"},
  },
  {
    id: "ss-av-costar-av-cscdx20t",
    manufacturer: "AV Costar",
    model: "AV-CSCDX20T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCDX20T 64 Channel Cloud Managed Compact Desktop Network Video Recorder Server wi",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscdx20t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":3,"formFactor":"desktop"},
  },
  {
    id: "ss-av-costar-av-cshpx96t",
    manufacturer: "AV Costar",
    model: "AV-CSHPX96T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CSHPX96T Cloud Managed Rack Mountable High Performance NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cshpx96t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-ccds12t",
    manufacturer: "AV Costar",
    model: "AV-CCDS12T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CCDS12T ConteraCMR® Micro NVR Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-ccds12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":4},
  },
  {
    id: "ss-av-costar-av-cv-20t",
    manufacturer: "AV Costar",
    model: "AV-CV-20T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CV-20T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cv-20t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp16-8t",
    manufacturer: "AV Costar",
    model: "AV-CVP16-8T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP16-8T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp16-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-ccds48t",
    manufacturer: "AV Costar",
    model: "AV-CCDS48T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CCDS48T ConteraCMR® Micro NVR Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-ccds48t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":4},
  },
  {
    id: "ss-av-costar-av-ccds8t",
    manufacturer: "AV Costar",
    model: "AV-CCDS8T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CCDS8T ConteraCMR® Micro NVR Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-ccds8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":4},
  },
  {
    id: "ss-av-costar-av-ccds6t",
    manufacturer: "AV Costar",
    model: "AV-CCDS6T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CCDS6T ConteraCMR® Micro NVR Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-ccds6t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":4},
  },
  {
    id: "ss-av-costar-av-ccds64t",
    manufacturer: "AV Costar",
    model: "AV-CCDS64T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CCDS64T ConteraCMR® Micro NVR Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-ccds64t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":4},
  },
  {
    id: "ss-av-costar-av-ccds40t",
    manufacturer: "AV Costar",
    model: "AV-CCDS40T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CCDS40T ConteraCMR® Micro NVR Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-ccds40t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":4},
  },
  {
    id: "ss-av-costar-av-ccds32t",
    manufacturer: "AV Costar",
    model: "AV-CCDS32T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CCDS32T ConteraCMR® Micro NVR Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-ccds32t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":4},
  },
  {
    id: "ss-av-costar-av-ccds24t",
    manufacturer: "AV Costar",
    model: "AV-CCDS24T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CCDS24T ConteraCMR® Micro NVR Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-ccds24t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":4},
  },
  {
    id: "ss-av-costar-av-ccds18t",
    manufacturer: "AV Costar",
    model: "AV-CCDS18T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CCDS18T ConteraCMR® Micro NVR Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-ccds18t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":4},
  },
  {
    id: "ss-av-costar-av-ccds4t",
    manufacturer: "AV Costar",
    model: "AV-CCDS4T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CCDS4T ConteraCMR® Micro NVR Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-ccds4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":96,"hddBays":4},
  },
  {
    id: "ss-av-costar-av-cv-12t",
    manufacturer: "AV Costar",
    model: "AV-CV-12T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CV-12T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cv-12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp08-16t",
    manufacturer: "AV Costar",
    model: "AV-CVP08-16T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP08-16T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp08-16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp16-12t",
    manufacturer: "AV Costar",
    model: "AV-CVP16-12T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP16-12T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp16-12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp16-16t",
    manufacturer: "AV Costar",
    model: "AV-CVP16-16T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP16-16T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp16-16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cv-16t",
    manufacturer: "AV Costar",
    model: "AV-CV-16T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CV-16T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cv-16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cv-08t",
    manufacturer: "AV Costar",
    model: "AV-CV-08T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CV-08T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cv-08t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cv-06t",
    manufacturer: "AV Costar",
    model: "AV-CV-06T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CV-06T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cv-06t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cv-04t",
    manufacturer: "AV Costar",
    model: "AV-CV-04T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CV-04T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cv-04t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp08-12t",
    manufacturer: "AV Costar",
    model: "AV-CVP08-12T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP08-12T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp08-12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp08-8t",
    manufacturer: "AV Costar",
    model: "AV-CVP08-8T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP08-8T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp08-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp08-6t",
    manufacturer: "AV Costar",
    model: "AV-CVP08-6T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP08-6T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp08-6t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp08-4t",
    manufacturer: "AV Costar",
    model: "AV-CVP08-4T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP08-4T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp08-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp08-2t",
    manufacturer: "AV Costar",
    model: "AV-CVP08-2T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP08-2T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp08-2t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp16-20t",
    manufacturer: "AV Costar",
    model: "AV-CVP16-20T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP16-20T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp16-20t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp16-6t",
    manufacturer: "AV Costar",
    model: "AV-CVP16-6T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP16-6T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp16-6t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp16-4t",
    manufacturer: "AV Costar",
    model: "AV-CVP16-4T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP16-4T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp16-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp08-08t",
    manufacturer: "AV Costar",
    model: "AV-CVP08-08T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP08-08T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp08-08t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp16-06t",
    manufacturer: "AV Costar",
    model: "AV-CVP16-06T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP16-06T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp16-06t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp08-02t",
    manufacturer: "AV Costar",
    model: "AV-CVP08-02T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP08-02T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp08-02t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp08-06t",
    manufacturer: "AV Costar",
    model: "AV-CVP08-06T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP08-06T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp08-06t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp08-04t",
    manufacturer: "AV Costar",
    model: "AV-CVP08-04T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP08-04T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp08-04t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp16-04t",
    manufacturer: "AV Costar",
    model: "AV-CVP16-04T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP16-04T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp16-04t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av-cvp16-08t",
    manufacturer: "AV Costar",
    model: "AV-CVP16-08T",
    category: "nvr-recorder",
    tagline: "AV Costar AV-CVP16-08T Contera NVR Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/av-costar-av-cvp16-08t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":2,"formFactor":"1U"},
  },
  {
    id: "ss-av-costar-av1600-4t1",
    manufacturer: "AV Costar",
    model: "AV1600-4T1",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV1600-4T1 PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av1600-4t1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-av-costar-av1600-8t0",
    manufacturer: "AV Costar",
    model: "AV1600-8T0",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV1600-8T0 PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av1600-8t0-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-av-costar-av800-4t0",
    manufacturer: "AV Costar",
    model: "AV800-4T0",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV800-4T0 PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av800-4t0-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-cshpx80tr",
    manufacturer: "AV Costar",
    model: "AV-CSHPX80TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX80TR 80TB RAID5 NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx80tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av800-2t1",
    manufacturer: "AV Costar",
    model: "AV800-2T1",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV800-2T1 PoE NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av800-2t1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-cshpx64tr",
    manufacturer: "AV Costar",
    model: "AV-CSHPX64TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX64TR 64TB RAID5 NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx64tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cscx40tr",
    manufacturer: "AV Costar",
    model: "AV-CSCX40TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision unveils Contera Compact NVR server for traditional & cloud surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscx40tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-c1600-20t",
    manufacturer: "AV Costar",
    model: "AV-C1600-20T",
    category: "nvr-recorder",
    tagline: "Arecont Vision unveils Contera NVR appliance for traditional & cloud surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-c1600-20t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-av-costar-av-cscdx8t",
    manufacturer: "AV Costar",
    model: "AV-CSCDX8T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCDX8T Compact Desktop, Linux, 8TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscdx8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-av-costar-av-cscdx24t",
    manufacturer: "AV Costar",
    model: "AV-CSCDX24T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCDX24T Compact Desktop, Linux, 24TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscdx24t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-av-costar-av-cscdx18t",
    manufacturer: "AV Costar",
    model: "AV-CSCDX18T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCDX18T Compact Desktop, Linux, 18TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscdx18t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-av-costar-av-cscdx6t",
    manufacturer: "AV Costar",
    model: "AV-CSCDX6T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCDX6T Compact Desktop, Linux, 6TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscdx6t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-av-costar-av-cscdx12t",
    manufacturer: "AV Costar",
    model: "AV-CSCDX12T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCDX12T Compact Desktop, Linux, 12TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscdx12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-av-costar-av-cscdx4t",
    manufacturer: "AV Costar",
    model: "AV-CSCDX4T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCDX4T Compact Desktop, Linux, 4TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscdx4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-av-costar-av-cshpx24t",
    manufacturer: "AV Costar",
    model: "AV-CSHPX24T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX24T 2U Server, Windows, 24TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx24t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx48tr",
    manufacturer: "AV Costar",
    model: "AV-CSHPX48TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX48TR 2U Server, Windows, 48TB RAID5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx48tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cscx16tr",
    manufacturer: "AV Costar",
    model: "AV-CSCX16TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCX16TR 2U Compact Server, Windows, 16TB RAID5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscx16tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx16t",
    manufacturer: "AV Costar",
    model: "AV-CSHPX16T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX16T 2U Server, Windows, 16TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx24tr",
    manufacturer: "AV Costar",
    model: "AV-CSHPX24TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX24TR 2U Server, Windows, 24TB RAID5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx24tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx28tr",
    manufacturer: "AV Costar",
    model: "AV-CSHPX28TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX28TR 2U Server, Windows, 28TB RAID5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx28tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx48t",
    manufacturer: "AV Costar",
    model: "AV-CSHPX48T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX48T 2U Server, Windows, 48TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx48t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx64t",
    manufacturer: "AV Costar",
    model: "AV-CSHPX64T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX64T 2U Server, Windows, 64TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx64t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx30t",
    manufacturer: "AV Costar",
    model: "AV-CSHPX30T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX30T 2U Server, Windows, 30TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx30t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cscx12t",
    manufacturer: "AV Costar",
    model: "AV-CSCX12T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCX12T 2U Compact Server, Windows, 12TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscx12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cscx16t",
    manufacturer: "AV Costar",
    model: "AV-CSCX16T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCX16T 2U Compact Server, Windows, 16TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscx16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cscx24t",
    manufacturer: "AV Costar",
    model: "AV-CSCX24T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCX24T 2U Compact Server, Windows, 24TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscx24t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cscx24tr",
    manufacturer: "AV Costar",
    model: "AV-CSCX24TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCX24TR 2U Compact Server, Windows, 24TB RAID5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscx24tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx20t",
    manufacturer: "AV Costar",
    model: "AV-CSHPX20T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX20T 2U Server, Windows, 20TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx20t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx36t",
    manufacturer: "AV Costar",
    model: "AV-CSHPX36T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX36T 2U Server, Windows, 36TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx36t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx80t",
    manufacturer: "AV Costar",
    model: "AV-CSHPX80T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX80T 2U Server, Windows, 80TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx80t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cscx32t",
    manufacturer: "AV Costar",
    model: "AV-CSCX32T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCX32T 2U Compact Server, Windows, 32TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscx32t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cscx32tr",
    manufacturer: "AV Costar",
    model: "AV-CSCX32TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCX32TR 2U Compact Server, Windows, 32TB RAID5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscx32tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cscx40t",
    manufacturer: "AV Costar",
    model: "AV-CSCX40T",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSCX40T 2U Compact Server, Windows, 40TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cscx40t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx12tr",
    manufacturer: "AV Costar",
    model: "AV-CSHPX12TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX12TR 2U Server, Windows, 12TB RAID5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx12tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx20tr",
    manufacturer: "AV Costar",
    model: "AV-CSHPX20TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX20TR 2U Server, Windows, 20TB RAID5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx20tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-av-costar-av-cshpx36tr",
    manufacturer: "AV Costar",
    model: "AV-CSHPX36TR",
    category: "nvr-recorder",
    tagline: "Arecont Vision AV-CSHPX36TR 2U Server, Windows, 36TB RAID5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/arecont-vision-av-cshpx36tr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nvr116",
    manufacturer: "LILIN",
    model: "NVR116",
    category: "nvr-recorder",
    tagline: "LILIN NVR116 16 channel standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr116-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr5416e",
    manufacturer: "LILIN",
    model: "NVR5416E",
    category: "nvr-recorder",
    tagline: "LILIN NVR5416E 32 CH 1U 16 PoE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr5416e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-lilin-nvr5104e",
    manufacturer: "LILIN",
    model: "NVR5104E",
    category: "nvr-recorder",
    tagline: "Lilin NVR5104E 4 CH PoE 4K Standalone Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr5104e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-lilin-nvr5208e",
    manufacturer: "LILIN",
    model: "NVR5208E",
    category: "nvr-recorder",
    tagline: "Lilin NVR5208E 8 CH PoE 4K Standalone Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr5208e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-lilin-evr-2216e",
    manufacturer: "LILIN",
    model: "EVR-2216E",
    category: "nvr-recorder",
    tagline: "Lilin EVR-2216E 16ch POE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-evr-2216e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-nav16108b",
    manufacturer: "LILIN",
    model: "NAV16108B",
    category: "nvr-recorder",
    tagline: "Lilin NAV16108B NAV 108CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav16108b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":108,"hddBays":1,"onvif":true,"formFactor":"3U"},
  },
  {
    id: "ss-lilin-nav1108b",
    manufacturer: "LILIN",
    model: "NAV1108B",
    category: "nvr-recorder",
    tagline: "Lilin NAV1108B NAV 108 CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav1108b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":108,"hddBays":1,"onvif":true,"formFactor":"4U"},
  },
  {
    id: "ss-lilin-nav24072b",
    manufacturer: "LILIN",
    model: "NAV24072B",
    category: "nvr-recorder",
    tagline: "Lilin NAV24072B NAV 72CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav24072b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":72,"hddBays":1,"onvif":true,"formFactor":"4U"},
  },
  {
    id: "ss-lilin-nvr5416",
    manufacturer: "LILIN",
    model: "NVR5416",
    category: "nvr-recorder",
    tagline: "Lilin NVR5416 16 CH 4K Standalone Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr5416-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-lilin-nav24108b",
    manufacturer: "LILIN",
    model: "NAV24108B",
    category: "nvr-recorder",
    tagline: "Lilin NAV24108B NAV 108CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav24108b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":108,"hddBays":1,"onvif":true,"formFactor":"4U"},
  },
  {
    id: "ss-lilin-nav16072b",
    manufacturer: "LILIN",
    model: "NAV16072B",
    category: "nvr-recorder",
    tagline: "Lilin NAV16072B NAV 72 CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav16072b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":72,"hddBays":1,"onvif":true,"formFactor":"3U"},
  },
  {
    id: "ss-lilin-nav1072b",
    manufacturer: "LILIN",
    model: "NAV1072B",
    category: "nvr-recorder",
    tagline: "Lilin NAV1072B NAV 72CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav1072b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":72,"hddBays":1,"onvif":true,"formFactor":"3U"},
  },
  {
    id: "ss-lilin-nvr-109",
    manufacturer: "LILIN",
    model: "NVR-109",
    category: "nvr-recorder",
    tagline: "LILIN NVR-109 HD 1080P, 9-channel NVR, up to 12TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-109-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":9,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr-116",
    manufacturer: "LILIN",
    model: "NVR-116",
    category: "nvr-recorder",
    tagline: "LILIN NVR-116 standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-116-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-evr-2104e",
    manufacturer: "LILIN",
    model: "EVR-2104E",
    category: "nvr-recorder",
    tagline: "Lilin EVR-2104E 4ch POE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-evr-2104e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-evr-2208e",
    manufacturer: "LILIN",
    model: "EVR-2208E",
    category: "nvr-recorder",
    tagline: "Lilin EVR-2208E 8ch POE 4K NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-evr-2208e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-nvr-116d-0tb",
    manufacturer: "LILIN",
    model: "NVR-116D-0TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-116D-0TB 1080P Real-time Multi-touch 16 Channel Standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-116d-0tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr109",
    manufacturer: "LILIN",
    model: "NVR109",
    category: "nvr-recorder",
    tagline: "LILIN NVR109 1080P real-time multi-touch 9 channel standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr109-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":9,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr104",
    manufacturer: "LILIN",
    model: "NVR104",
    category: "nvr-recorder",
    tagline: "LILIN NVR104 1080P real-time multi-touch 4 channel standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr104-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr3216",
    manufacturer: "LILIN",
    model: "NVR3216",
    category: "nvr-recorder",
    tagline: "LILIN NVR3216 16 CH 5MP Standalone Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr3216-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-nvr400l",
    manufacturer: "LILIN",
    model: "NVR400L",
    category: "nvr-recorder",
    tagline: "LILIN NVR400L multi-touch standalone network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr400l-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr-109d-12tb",
    manufacturer: "LILIN",
    model: "NVR-109D-12TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-109D-12TB 9-channel standalone NVR Touch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-109d-12tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":9,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr-116d-12tb",
    manufacturer: "LILIN",
    model: "NVR-116D-12TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-116D-12TB 1080P real-time milti-touch 16 channel standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-116d-12tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nav24630",
    manufacturer: "LILIN",
    model: "NAV24630",
    category: "nvr-recorder",
    tagline: "LILIN NAV24630 network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav24630-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":36,"hddBays":1,"formFactor":"4U"},
  },
  {
    id: "ss-lilin-nvr3416",
    manufacturer: "LILIN",
    model: "NVR3416",
    category: "nvr-recorder",
    tagline: "LILIN NVR3416 16 CH 5MP Standalone Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr3416-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-nvr-116d-4tb",
    manufacturer: "LILIN",
    model: "NVR-116D-4TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-116D-4TB 1080P Real-time Multi-touch 16 Channel Standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-116d-4tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr3816",
    manufacturer: "LILIN",
    model: "NVR3816",
    category: "nvr-recorder",
    tagline: "LILIN NVR3816 16 CH 5MP Standalone Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr3816-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"],"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nvr-116d-6tb",
    manufacturer: "LILIN",
    model: "NVR-116D-6TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-116D-6TB 1080P Real-time Multi-touch 16 Channel Standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-116d-6tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nav08036",
    manufacturer: "LILIN",
    model: "NAV08036",
    category: "nvr-recorder",
    tagline: "LILIN NAV08036 NAV 36CH recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav08036-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":36,"hddBays":1,"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nvr404c",
    manufacturer: "LILIN",
    model: "NVR404C",
    category: "nvr-recorder",
    tagline: "LILIN NVR404C 1080P real-time multi-touch portable 4 channel standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr404c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr116d",
    manufacturer: "LILIN",
    model: "NVR116D",
    category: "nvr-recorder",
    tagline: "LILIN NVR116D 1080P real-time multi-touch 16 channel standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr116d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr-116d-2tb",
    manufacturer: "LILIN",
    model: "NVR-116D-2TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-116D-2TB 1080P Real-time Multi -touch 16 Channel Standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-116d-2tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nav16072",
    manufacturer: "LILIN",
    model: "NAV16072",
    category: "nvr-recorder",
    tagline: "LILIN NAV16072 NAV 72CH recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav16072-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":72,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-lilin-nav08108a",
    manufacturer: "LILIN",
    model: "NAV08108A",
    category: "nvr-recorder",
    tagline: "LILIN NAV08108A NAV 108CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav08108a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":108,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-lilin-nav16630",
    manufacturer: "LILIN",
    model: "NAV16630",
    category: "nvr-recorder",
    tagline: "LILIN NAV16630 network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav16630-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":36,"hddBays":1,"formFactor":"3U"},
  },
  {
    id: "ss-lilin-nav08108",
    manufacturer: "LILIN",
    model: "NAV08108",
    category: "nvr-recorder",
    tagline: "LILIN NAV08108 NAV 108CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav08108-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":108,"hddBays":1,"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nav24072e",
    manufacturer: "LILIN",
    model: "NAV24072E",
    category: "nvr-recorder",
    tagline: "LILIN NAV24072E 72 channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav24072e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":72,"hddBays":1,"formFactor":"4U"},
  },
  {
    id: "ss-lilin-nav16108",
    manufacturer: "LILIN",
    model: "NAV16108",
    category: "nvr-recorder",
    tagline: "LILIN NAV16108 NAV 108CH recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav16108-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":108,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-lilin-nav24108",
    manufacturer: "LILIN",
    model: "NAV24108",
    category: "nvr-recorder",
    tagline: "LILIN NAV24108 NAV 108CH recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav24108-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":108,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-lilin-nav2036a",
    manufacturer: "LILIN",
    model: "NAV2036A",
    category: "nvr-recorder",
    tagline: "LILIN NAV2036A NAV 36CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav2036a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":36,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-lilin-nav24072",
    manufacturer: "LILIN",
    model: "NAV24072",
    category: "nvr-recorder",
    tagline: "LILIN NAV24072 NAV 72CH recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav24072-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":72,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-lilin-nav08072",
    manufacturer: "LILIN",
    model: "NAV08072",
    category: "nvr-recorder",
    tagline: "LILIN NAV08072 NAV 72CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav08072-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":72,"hddBays":1,"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nav08036a",
    manufacturer: "LILIN",
    model: "NAV08036A",
    category: "nvr-recorder",
    tagline: "LILIN NAV08036A NAV 36CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav08036a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":36,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-lilin-nav08072a",
    manufacturer: "LILIN",
    model: "NAV08072A",
    category: "nvr-recorder",
    tagline: "LILIN NAV08072A NAV 72CH Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav08072a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":72,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-lilin-nav24108e",
    manufacturer: "LILIN",
    model: "NAV24108E",
    category: "nvr-recorder",
    tagline: "LILIN NAV24108E 108 channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav24108e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":108,"hddBays":1,"formFactor":"4U"},
  },
  {
    id: "ss-lilin-nav1108c",
    manufacturer: "LILIN",
    model: "NAV1108C",
    category: "nvr-recorder",
    tagline: "LILIN NAV1108C network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav1108c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":36,"hddBays":1,"formFactor":"4U"},
  },
  {
    id: "ss-lilin-nav16072e",
    manufacturer: "LILIN",
    model: "NAV16072E",
    category: "nvr-recorder",
    tagline: "LILIN NAV16072E 72 channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav16072e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":72,"hddBays":1,"formFactor":"3U"},
  },
  {
    id: "ss-lilin-nav16036",
    manufacturer: "LILIN",
    model: "NAV16036",
    category: "nvr-recorder",
    tagline: "LILIN NAV16036 NAV 36CH recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav16036-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":36,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-lilin-nav24036",
    manufacturer: "LILIN",
    model: "NAV24036",
    category: "nvr-recorder",
    tagline: "LILIN NAV24036 NAV 36CH recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav24036-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":36,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-lilin-nvr6116e-v",
    manufacturer: "LILIN",
    model: "NVR6116E-V",
    category: "nvr-recorder",
    tagline: "LILIN NVR6116E-V 16 channel PoE 4K standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr6116e-v-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-lilin-nvr5832s",
    manufacturer: "LILIN",
    model: "NVR5832S",
    category: "nvr-recorder",
    tagline: "LILIN NVR5832S 32CH 4K 2U 19”3.5”Swap Drive Bay Rackmount Standalone Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr5832s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264"],"raidLevels":["0"],"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nav16108e",
    manufacturer: "LILIN",
    model: "NAV16108E",
    category: "nvr-recorder",
    tagline: "LILIN NAV16108E 108 channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav16108e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":108,"hddBays":1,"formFactor":"3U"},
  },
  {
    id: "ss-lilin-nav08630",
    manufacturer: "LILIN",
    model: "NAV08630",
    category: "nvr-recorder",
    tagline: "LILIN NAV08630 network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav08630-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr6832e",
    manufacturer: "LILIN",
    model: "NVR6832E",
    category: "nvr-recorder",
    tagline: "LILIN NVR6832E 32 channel 4K 2U 19\" rackmount standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr6832e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nvr7832",
    manufacturer: "LILIN",
    model: "NVR7832",
    category: "nvr-recorder",
    tagline: "LILIN NVR7832 32 channel 4K 2U 19\" rackmount standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr7832-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nvr3416r",
    manufacturer: "LILIN",
    model: "NVR3416R",
    category: "nvr-recorder",
    tagline: "LILIN NVR3416R 16CH 5MP 19”1U Rackmount Standalone Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr3416r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"],"formFactor":"1U"},
  },
  {
    id: "ss-lilin-nvr51t4e",
    manufacturer: "LILIN",
    model: "NVR51T4E",
    category: "nvr-recorder",
    tagline: "LILIN NVR51T4E 4 CH PoE NVR for Temperature Measurement",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr51t4e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-lilin-nvr6208e",
    manufacturer: "LILIN",
    model: "NVR6208E",
    category: "nvr-recorder",
    tagline: "LILIN NVR6208E 8 channel PoE 4K standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr6208e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-lilin-nvr6832se",
    manufacturer: "LILIN",
    model: "NVR6832SE",
    category: "nvr-recorder",
    tagline: "LILIN NVR6832SE 32 channel 4K 2U 19\" rackmount standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr6832se-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nvr6108e-v",
    manufacturer: "LILIN",
    model: "NVR6108E-V",
    category: "nvr-recorder",
    tagline: "LILIN NVR6108E-V 8 channel PoE 4K standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr6108e-v-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-lilin-nvr200l",
    manufacturer: "LILIN",
    model: "NVR200L",
    category: "nvr-recorder",
    tagline: "LILIN NVR200L 16 channel multi-touch H.264 network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr200l-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-nvr6864e",
    manufacturer: "LILIN",
    model: "NVR6864E",
    category: "nvr-recorder",
    tagline: "LILIN NVR6864E 64 channel 4K 2U 19\" rackmount standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr6864e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nvr6216ae",
    manufacturer: "LILIN",
    model: "NVR6216AE",
    category: "nvr-recorder",
    tagline: "LILIN NVR6216AE 16 channel PoE 4K standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr6216ae-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr6104e-v",
    manufacturer: "LILIN",
    model: "NVR6104E-V",
    category: "nvr-recorder",
    tagline: "LILIN NVR6104E-V 4 channel PoE 4K standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr6104e-v-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-lilin-nvr2400",
    manufacturer: "LILIN",
    model: "NVR2400",
    category: "nvr-recorder",
    tagline: "LILIN new NVR series (NVR1400/2400) with RAID storage solutions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr2400-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr6104e",
    manufacturer: "LILIN",
    model: "NVR6104E",
    category: "nvr-recorder",
    tagline: "LILIN NVR6104E 4 channel PoE 4K standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr6104e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-lilin-nvr7864",
    manufacturer: "LILIN",
    model: "NVR7864",
    category: "nvr-recorder",
    tagline: "LILIN NVR7864 64 channel 4K 2U 19\" rackmount standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr7864-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"formFactor":"2U"},
  },
  {
    id: "ss-lilin-nvr6216e",
    manufacturer: "LILIN",
    model: "NVR6216E",
    category: "nvr-recorder",
    tagline: "LILIN NVR6216E 16 channel PoE 4K standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr6216e-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-lilin-nvr5832",
    manufacturer: "LILIN",
    model: "NVR5832",
    category: "nvr-recorder",
    tagline: "LILIN NVR5832 32 CH 4K Standalone Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr5832-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-nvr100l",
    manufacturer: "LILIN",
    model: "NVR100L",
    category: "nvr-recorder",
    tagline: "LILIN NVR100L 16 channel H.264 network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr100l-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-nvr6208ae",
    manufacturer: "LILIN",
    model: "NVR6208AE",
    category: "nvr-recorder",
    tagline: "LILIN NVR6208AE 8 channel PoE 4K standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr6208ae-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr-104",
    manufacturer: "LILIN",
    model: "NVR-104",
    category: "nvr-recorder",
    tagline: "LILIN NVR-104 1080P Real-time Multi-touch 16 Channel Standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-104-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr-109d-6tb",
    manufacturer: "LILIN",
    model: "NVR-109D-6TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-109D-6TB H.264 1080P standalone NVR Touch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-109d-6tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-nvr-116d-9tb",
    manufacturer: "LILIN",
    model: "NVR-116D-9TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-116D-6TB 1080P Real-time Multi-touch 16 Channel Standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-116d-9tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr-109d-2tb",
    manufacturer: "LILIN",
    model: "NVR-109D-2TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-109D-2TB H.264 1080P standalone NVR Touch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-109d-2tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-nvr-109d-4tb",
    manufacturer: "LILIN",
    model: "NVR-109D-4TB",
    category: "nvr-recorder",
    tagline: "LILIN NVR-109D-4TB H.264 1080P standalone NVR Touch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr-109d-4tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-lilin-nvr408m",
    manufacturer: "LILIN",
    model: "NVR408M",
    category: "nvr-recorder",
    tagline: "LILIN NVR408M real-time multi-touch vehicle standalone NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr408m-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-lilin-nvr1400",
    manufacturer: "LILIN",
    model: "NVR1400",
    category: "nvr-recorder",
    tagline: "Merit Lilin NVRs with RAID storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nvr1400-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-lilin-nav3025",
    manufacturer: "LILIN",
    model: "NAV3025",
    category: "nvr-recorder",
    tagline: "LILIN NAV3025 36 channel recorder with dual streaming decoding",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav3025-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":36,"hddBays":1},
  },
  {
    id: "ss-lilin-nav1072",
    manufacturer: "LILIN",
    model: "NAV1072",
    category: "nvr-recorder",
    tagline: "LILIN NAV1072 72 channel ONVIF profile recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav1072-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":72,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-lilin-nav1108",
    manufacturer: "LILIN",
    model: "NAV1108",
    category: "nvr-recorder",
    tagline: "LILIN NAV1108 108 channel dual streaming recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav1108-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":108,"hddBays":1},
  },
  {
    id: "ss-lilin-nav2036",
    manufacturer: "LILIN",
    model: "NAV2036",
    category: "nvr-recorder",
    tagline: "LILIN NAV2036 36 channel recorder with dual monitor support",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nav2036-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":36,"hddBays":1},
  },
  {
    id: "ss-lilin-nva1036",
    manufacturer: "LILIN",
    model: "NVA1036",
    category: "nvr-recorder",
    tagline: "LILIN NVA1036 36 channel ONVIF profile recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/lilin-nva1036-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":36,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-idis-dr-6332ps-s",
    manufacturer: "IDIS",
    model: "DR-6332PS-S",
    category: "nvr-recorder",
    tagline: "IDIS DR-6332PS-S DirectIP™ 6300 series H.265 4K recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6332ps-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-dr-2316p",
    manufacturer: "IDIS",
    model: "DR-2316P",
    category: "nvr-recorder",
    tagline: "IDIS DR-2316P DirectIP 2300 Series 16channel Full HD Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2316p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-idis-al-1112",
    manufacturer: "IDIS",
    model: "AL-1112",
    category: "nvr-recorder",
    tagline: "IDIS AL-1112 Alarm Box",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-al-1112-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-idis-dr-6308p-s",
    manufacturer: "IDIS",
    model: "DR-6308P-S",
    category: "nvr-recorder",
    tagline: "IDIS DR-6308P-S DirectIP™ 6300 series 8 channel full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6308p-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-dr-6232ps",
    manufacturer: "IDIS",
    model: "DR-6232PS",
    category: "nvr-recorder",
    tagline: "IDIS DR-6232PS 32-channel Full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6232ps-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-idis-dr-6316ps-s",
    manufacturer: "IDIS",
    model: "DR-6316PS-S",
    category: "nvr-recorder",
    tagline: "IDIS DR-6316PS-S DirectIP™ 6300 series 16 channel full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6316ps-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-dr-2308p",
    manufacturer: "IDIS",
    model: "DR-2308P",
    category: "nvr-recorder",
    tagline: "IDIS DR-2308P DirectIP 2300 Series 8-channel Full HD Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2308p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-idis-dr-8364",
    manufacturer: "IDIS",
    model: "DR-8364",
    category: "nvr-recorder",
    tagline: "The IDIS DirectIP DR-8364 NVR balances next-generation functionality with old-fashioned affordabilit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8364-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-ir-310d",
    manufacturer: "IDIS",
    model: "IR-310D",
    category: "nvr-recorder",
    tagline: "IDIS IR-310D 64 channel video management server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-ir-310d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-idis-ir-310",
    manufacturer: "IDIS",
    model: "IR-310",
    category: "nvr-recorder",
    tagline: "IDIS IR-310 64 channel recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-ir-310-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-idis-dr-6516p-a",
    manufacturer: "IDIS",
    model: "DR-6516P-A",
    category: "nvr-recorder",
    tagline: "IDIS DR-6516P-A 16 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6516p-a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-8364d",
    manufacturer: "IDIS",
    model: "DR-8364D",
    category: "nvr-recorder",
    tagline: "IDIS DR-8364D DirectIP 64 channel full HD real-time recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8364d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-dr-6232ps-s",
    manufacturer: "IDIS",
    model: "DR-6232PS-S",
    category: "nvr-recorder",
    tagline: "The IDIS DR-6232PS-S DirectIP NVR offers simplicity and affordability",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6232ps-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-idis-dr-8432d",
    manufacturer: "IDIS",
    model: "DR-8432D",
    category: "nvr-recorder",
    tagline: "IDIS DR-8432D DirectIP 8400 Series H.265 4K Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8432d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-idis-dr-8532",
    manufacturer: "IDIS",
    model: "DR-8532",
    category: "nvr-recorder",
    tagline: "IDIS DR-8532 32 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8532-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-dr-6532p-a",
    manufacturer: "IDIS",
    model: "DR-6532P-A",
    category: "nvr-recorder",
    tagline: "IDIS DR-6532P-A 32 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6532p-a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-tr-2508",
    manufacturer: "IDIS",
    model: "TR-2508",
    category: "nvr-recorder",
    tagline: "IDIS TR-2508 DirectCX 8channel H.265 Recorder / NDAA Compliant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-2508-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-8516",
    manufacturer: "IDIS",
    model: "DR-8516",
    category: "nvr-recorder",
    tagline: "IDIS DR-8516 16 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8516-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-tr-1508",
    manufacturer: "IDIS",
    model: "TR-1508",
    category: "nvr-recorder",
    tagline: "IDIS TR-1508 DirectCX 8channel H.265 Recorder / NDAA Compliant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-1508-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-8564d",
    manufacturer: "IDIS",
    model: "DR-8564D",
    category: "nvr-recorder",
    tagline: "IDIS DR-8564D 64 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8564d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-tr-4516r",
    manufacturer: "IDIS",
    model: "TR-4516R",
    category: "nvr-recorder",
    tagline: "IDIS TR-4516R DirectCX 16channel H.265 Recorder / NDAA Compliant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4516r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-tr-4616r",
    manufacturer: "IDIS",
    model: "TR-4616R",
    category: "nvr-recorder",
    tagline: "IDIS TR-4616R DirectCX 16channel H.265 Hybrid Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4616r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.265"],"raidLevels":["1"]},
  },
  {
    id: "ss-idis-dr-3516p",
    manufacturer: "IDIS",
    model: "DR-3516P",
    category: "nvr-recorder",
    tagline: "IDIS DR-3516P 16 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-3516p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-idis-dr-6516p",
    manufacturer: "IDIS",
    model: "DR-6516P",
    category: "nvr-recorder",
    tagline: "IDIS DR-6516P 16 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6516p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-tr-4516",
    manufacturer: "IDIS",
    model: "TR-4516",
    category: "nvr-recorder",
    tagline: "IDIS TR-4516 DirectCX 16channel H.265 Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4516-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-6332ps",
    manufacturer: "IDIS",
    model: "DR-6332PS",
    category: "nvr-recorder",
    tagline: "IDIS DR-6332PS DirectIP™ 6300 series H.265 4K recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6332ps-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-tr-1504",
    manufacturer: "IDIS",
    model: "TR-1504",
    category: "nvr-recorder",
    tagline: "IDIS TR-1504 DirectCX 4channel H.265 Recorder / NDAA Compliant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-1504-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-8532d",
    manufacturer: "IDIS",
    model: "DR-8532D",
    category: "nvr-recorder",
    tagline: "IDIS DR-8532D 32 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8532d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-tr-2604",
    manufacturer: "IDIS",
    model: "TR-2604",
    category: "nvr-recorder",
    tagline: "IDIS TR-2604 DirectCX 4channel H.265 Hybrid Recorder / NDAA Compliant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-2604-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-6216ps-s",
    manufacturer: "IDIS",
    model: "DR-6216PS-S",
    category: "nvr-recorder",
    tagline: "IDIS DR-6216PS-S 16-channel Full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6216ps-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-idis-dr-2508p-a",
    manufacturer: "IDIS",
    model: "DR-2508P-A",
    category: "nvr-recorder",
    tagline: "IDIS DR-2508P-A 8 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2508p-a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-idis-tr-2516",
    manufacturer: "IDIS",
    model: "TR-2516",
    category: "nvr-recorder",
    tagline: "IDIS TR-2516 DirectCX 16channel H.265 Recorder / NDAA Compliant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-2516-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-tr-2508p",
    manufacturer: "IDIS",
    model: "TR-2508P",
    category: "nvr-recorder",
    tagline: "IDIS TR-2508P DirectCX PoC 8 channel H.265 Recorder / NDAA Compliant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-2508p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-tr-4616",
    manufacturer: "IDIS",
    model: "TR-4616",
    category: "nvr-recorder",
    tagline: "IDIS TR-4616 DirectCX 16channel H.265 Hybrid Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-4616-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-6508p",
    manufacturer: "IDIS",
    model: "DR-6508P",
    category: "nvr-recorder",
    tagline: "IDIS DR-6508P 8 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6508p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-2516p-a",
    manufacturer: "IDIS",
    model: "DR-2516P-A",
    category: "nvr-recorder",
    tagline: "IDIS DR-2516P-A 16 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2516p-a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-idis-dr-6216ps",
    manufacturer: "IDIS",
    model: "DR-6216PS",
    category: "nvr-recorder",
    tagline: "IDIS DR-6216PS 16 channel full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6216ps-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-idis-dr-2504p-a",
    manufacturer: "IDIS",
    model: "DR-2504P-A",
    category: "nvr-recorder",
    tagline: "IDIS DR-2504P-A 4 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2504p-a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-2504p",
    manufacturer: "IDIS",
    model: "DR-2504P",
    category: "nvr-recorder",
    tagline: "IDIS DR-2504P 4 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2504p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-2504p-b",
    manufacturer: "IDIS",
    model: "DR-2504P-B",
    category: "nvr-recorder",
    tagline: "IDIS DR-2504P-B 4 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2504p-b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-2504p-c",
    manufacturer: "IDIS",
    model: "DR-2504P-C",
    category: "nvr-recorder",
    tagline: "IDIS DR-2504P-C 4 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2504p-c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-2508p",
    manufacturer: "IDIS",
    model: "DR-2508P",
    category: "nvr-recorder",
    tagline: "IDIS DR-2508P 8 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2508p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-tr-2608",
    manufacturer: "IDIS",
    model: "TR-2608",
    category: "nvr-recorder",
    tagline: "IDIS TR-2608 DirectCX 8channel H.265 Hybrid Recorder / NDAA Compliant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-2608-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-tr-2504",
    manufacturer: "IDIS",
    model: "TR-2504",
    category: "nvr-recorder",
    tagline: "IDIS TR-2504 DirectCX 4channel H.265 Recorder / NDAA Compliant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-2504-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-tr-2504p",
    manufacturer: "IDIS",
    model: "TR-2504P",
    category: "nvr-recorder",
    tagline: "IDIS TR-2504P DirectCX PoC 4 channel H.265 Recorder / NDAA Compliant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-2504p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-4208p",
    manufacturer: "IDIS",
    model: "DR-4208P",
    category: "nvr-recorder",
    tagline: "IDIS DR-4208P 8-channel Full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-4208p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-idis-ir-100",
    manufacturer: "IDIS",
    model: "IR-100",
    category: "nvr-recorder",
    tagline: "IDIS IR-100 IDIS Security Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-ir-100-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"],"formFactor":"4U"},
  },
  {
    id: "ss-idis-dr-4216p",
    manufacturer: "IDIS",
    model: "DR-4216P",
    category: "nvr-recorder",
    tagline: "IDIS DR-4216P 16-channel Full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-4216p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-idis-ir-300",
    manufacturer: "IDIS",
    model: "IR-300",
    category: "nvr-recorder",
    tagline: "IDIS IR-300 IDIS Security Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-ir-300-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"],"formFactor":"2U"},
  },
  {
    id: "ss-idis-dr-2208p",
    manufacturer: "IDIS",
    model: "DR-2208P",
    category: "nvr-recorder",
    tagline: "IDIS DR-2208P 8-channel Full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2208p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-idis-dr-6232p",
    manufacturer: "IDIS",
    model: "DR-6232P",
    category: "nvr-recorder",
    tagline: "IDIS DR-6232P 32-channel Full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6232p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-idis-dr-2216p",
    manufacturer: "IDIS",
    model: "DR-2216P",
    category: "nvr-recorder",
    tagline: "IDIS DR-2216P 16-channel Full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2216p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-idis-dr-2204p",
    manufacturer: "IDIS",
    model: "DR-2204P",
    category: "nvr-recorder",
    tagline: "IDIS DR-2204P 4-channel Full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2204p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-idis-dr-2304p",
    manufacturer: "IDIS",
    model: "DR-2304P",
    category: "nvr-recorder",
    tagline: "IDIS DR-2304P DirectIP 2300 Series 4-channel Full HD Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2304p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-idis-dv-1104",
    manufacturer: "IDIS",
    model: "DV-1104",
    category: "nvr-recorder",
    tagline: "IDIS DV-1104 Supports 4ch IP Camera",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dv-1104-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-idis-dr-8564",
    manufacturer: "IDIS",
    model: "DR-8564",
    category: "nvr-recorder",
    tagline: "IDIS DR-8564 64 IP channels 4K network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8564-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-dr-6216p",
    manufacturer: "IDIS",
    model: "DR-6216P",
    category: "nvr-recorder",
    tagline: "IDIS DR-6216P 16-channel Full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6216p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-idis-dr-6216p-s",
    manufacturer: "IDIS",
    model: "DR-6216P-S",
    category: "nvr-recorder",
    tagline: "IDIS DR-6216P-S 16-channel Full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6216p-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-idis-dr-6316ps",
    manufacturer: "IDIS",
    model: "DR-6316PS",
    category: "nvr-recorder",
    tagline: "IDIS DR-6316PS DirectIP™ 6300 series 16 channel full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6316ps-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-dr-1504p-a",
    manufacturer: "IDIS",
    model: "DR-1504P-A",
    category: "nvr-recorder",
    tagline: "IDIS DR-1504P-A 4 IP channels 4K PoE network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-1504p-a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-idis-dr-1508p-a",
    manufacturer: "IDIS",
    model: "DR-1508P-A",
    category: "nvr-recorder",
    tagline: "IDIS DR-1508P-A 8 IP channels 4K PoE network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-1508p-a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-idis-dr-1504p",
    manufacturer: "IDIS",
    model: "DR-1504P",
    category: "nvr-recorder",
    tagline: "IDIS DR-1504P 4 IP channels 4K PoE network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-1504p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-idis-dr-1508p",
    manufacturer: "IDIS",
    model: "DR-1508P",
    category: "nvr-recorder",
    tagline: "IDIS DR-1508P 8 IP channels 4K PoE network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-1508p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-idis-dr-6232p-s",
    manufacturer: "IDIS",
    model: "DR-6232P-S",
    category: "nvr-recorder",
    tagline: "IDIS DR-6232P-S 32-channel Full HD network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6232p-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-idis-dr-4316ps",
    manufacturer: "IDIS",
    model: "DR-4316PS",
    category: "nvr-recorder",
    tagline: "IDIS DR-4316PS DirectIP 4300 series 16-channel Full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-4316ps-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-idis-dr-6308p",
    manufacturer: "IDIS",
    model: "DR-6308P",
    category: "nvr-recorder",
    tagline: "IDIS DR-6308P DirectIP™ 6300 series 8 channel full HD recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-6308p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["1"],"onvif":true},
  },
  {
    id: "ss-idis-tr-2616",
    manufacturer: "IDIS",
    model: "TR-2616",
    category: "nvr-recorder",
    tagline: "IDIS TR-2616 DirectCX 16 channel H.265 Hybrid Recorder / NDAA Compliant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-tr-2616-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.265"]},
  },
  {
    id: "ss-idis-dr-4308p",
    manufacturer: "IDIS",
    model: "DR-4308P",
    category: "nvr-recorder",
    tagline: "IDIS DR-4308P DirectIP 4300 Series 8channel Full HD Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-4308p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-idis-dr-8364-f-d",
    manufacturer: "IDIS",
    model: "DR-8364(F)D",
    category: "nvr-recorder",
    tagline: "IDIS DR-8364(F)D DirectIP 8300 Series H.265 4K Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8364-f-d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-idis-dr-8432",
    manufacturer: "IDIS",
    model: "DR-8432",
    category: "nvr-recorder",
    tagline: "IDIS DR-8432 DirectIP 8400 Series H.265 4K Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8432-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-idis-dr-8364-f",
    manufacturer: "IDIS",
    model: "DR-8364(F)",
    category: "nvr-recorder",
    tagline: "IDIS DR-8364(F) DirectIP 8300 Series H.265 4K Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8364-f-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-idis-dr-1308p",
    manufacturer: "IDIS",
    model: "DR-1308P",
    category: "nvr-recorder",
    tagline: "IDIS DR-1308P 3.5’’ HDD 8ch DirectIP NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-1308p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-idis-dr-2404p",
    manufacturer: "IDIS",
    model: "DR-2404P",
    category: "nvr-recorder",
    tagline: "IDIS DR-2404P DirectIP™ 2400 Series H.265 4K Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-2404p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-idis-dr-8416",
    manufacturer: "IDIS",
    model: "DR-8416",
    category: "nvr-recorder",
    tagline: "IDIS DR-8416 DirectIP 8400 Series H.265 4K Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-8416-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-idis-dr-1204p",
    manufacturer: "IDIS",
    model: "DR-1204P",
    category: "nvr-recorder",
    tagline: "IDIS DR-1204P DirectIP 1200 Series 4 Channel Full HD Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-1204p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-idis-dr-1304p",
    manufacturer: "IDIS",
    model: "DR-1304P",
    category: "nvr-recorder",
    tagline: "IDIS DR-1304P 3.5’’ HDD 4ch DirectIP NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-1304p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-idis-dr-1304pc",
    manufacturer: "IDIS",
    model: "DR-1304PC",
    category: "nvr-recorder",
    tagline: "IDIS DR-1304PC 2.5’’ HDD 4ch Compact Type DirectIP NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/idis-dr-1304pc-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-surveon-emr9000-iscsi",
    manufacturer: "Surveon",
    model: "EMR9000 iSCSI",
    category: "nvr-recorder",
    tagline: "Surveon showcases its EMR Series - megapixel hardware RAID NVR solutions optimised with Milestone XP",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-emr9000-iscsi-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2132",
    manufacturer: "Surveon",
    model: "NVR2132",
    category: "nvr-recorder",
    tagline: "Surveon NVR2132 32 channel megapixel recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2132-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr1000-1032a",
    manufacturer: "Surveon",
    model: "NVR1000-1032A",
    category: "nvr-recorder",
    tagline: "Surveon NVR1000-1032A network video recorder with E-map monitoring and management",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr1000-1032a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2148",
    manufacturer: "Surveon",
    model: "NVR2148",
    category: "nvr-recorder",
    tagline: "Surveon NVR2148 48-channel megapixel recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2148-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":48,"hddBays":1},
  },
  {
    id: "ss-surveon-smr5012",
    manufacturer: "Surveon",
    model: "SMR5012",
    category: "nvr-recorder",
    tagline: "Surveon SMR5012 12 channel megapixel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr5012-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":12,"hddBays":1,"raidLevels":["5"]},
  },
  {
    id: "ss-surveon-nvr0500-10b16c",
    manufacturer: "Surveon",
    model: "NVR0500-10B16C",
    category: "nvr-recorder",
    tagline: "Surveon NVR0500-10B16C network video recorder with real time video analytics solutions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr0500-10b16c-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2048-36b",
    manufacturer: "Surveon",
    model: "NVR2048-36B",
    category: "nvr-recorder",
    tagline: "Surveon NVR2048-36B network video recorder with scheduled or continuous camera patrolling",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2048-36b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-smr2006",
    manufacturer: "Surveon",
    model: "SMR2006",
    category: "nvr-recorder",
    tagline: "Surveon SMR2006 6 channel megapixel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr2006-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":6,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-nvr2064-48b",
    manufacturer: "Surveon",
    model: "NVR2064-48B",
    category: "nvr-recorder",
    tagline: "Surveon NVR2064-48B network video recorder with pan, tilt, zoom operations",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2064-48b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr203224b",
    manufacturer: "Surveon",
    model: "NVR203224B",
    category: "nvr-recorder",
    tagline: "Surveon NVR203224B network video recorder with search over multiple cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr203224b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2025-24b",
    manufacturer: "Surveon",
    model: "NVR2025-24B",
    category: "nvr-recorder",
    tagline: "Surveon NVR2025-24B network video recorder with forbidden area and tampering detection",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2025-24b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2016-16b",
    manufacturer: "Surveon",
    model: "NVR2016-16B",
    category: "nvr-recorder",
    tagline: "Surveon NVR2016-16B network video recorder with intrusion detection",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2016-16b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-smr5020",
    manufacturer: "Surveon",
    model: "SMR5020",
    category: "nvr-recorder",
    tagline: "Surveon expands new SMR 5000 systems",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr5020-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":20,"hddBays":1},
  },
  {
    id: "ss-surveon-smr8040",
    manufacturer: "Surveon",
    model: "SMR8040",
    category: "nvr-recorder",
    tagline: "Surveon presents all in one SMR8000 NVR series with 40-channel full HD recording and hardware RAID",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr8040-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":40,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr3308a1-48",
    manufacturer: "Surveon",
    model: "NVR3308A1-48",
    category: "nvr-recorder",
    tagline: "Surveon NVR3308A1-48 megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr3308a1-48-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":48,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-smr2016",
    manufacturer: "Surveon",
    model: "SMR2016",
    category: "nvr-recorder",
    tagline: "Surveon SMR2016 16 channel megapixel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr2016-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-nvr3308a1-64",
    manufacturer: "Surveon",
    model: "NVR3308A1-64",
    category: "nvr-recorder",
    tagline: "Surveon NVR3308A1-64 megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr3308a1-64-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-smr3016",
    manufacturer: "Surveon",
    model: "SMR3016",
    category: "nvr-recorder",
    tagline: "Surveon to showcase megapixel SMR solution at IFSEC 2011",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr3016-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr3104p1-9",
    manufacturer: "Surveon",
    model: "NVR3104P1-9",
    category: "nvr-recorder",
    tagline: "Surveon NVR3104P1-9 megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr3104p1-9-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":9,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-nvr3104p1-16",
    manufacturer: "Surveon",
    model: "NVR3104P1-16",
    category: "nvr-recorder",
    tagline: "Surveon NVR3104P1-16 megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr3104p1-16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-nvr3308e1-16",
    manufacturer: "Surveon",
    model: "NVR3308E1-16",
    category: "nvr-recorder",
    tagline: "Surveon NVR3308E1-16 megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr3308e1-16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-nvr3308e1-24",
    manufacturer: "Surveon",
    model: "NVR3308E1-24",
    category: "nvr-recorder",
    tagline: "Surveon NVR3308E1-24 megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr3308e1-24-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-nvr3308e1-32",
    manufacturer: "Surveon",
    model: "NVR3308E1-32",
    category: "nvr-recorder",
    tagline: "Surveon NVR3308E1-32 megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr3308e1-32-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-nvr3308a1-24",
    manufacturer: "Surveon",
    model: "NVR3308A1-24",
    category: "nvr-recorder",
    tagline: "Surveon NVR3308A1-24 megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr3308a1-24-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-nvr3308a1-32",
    manufacturer: "Surveon",
    model: "NVR3308A1-32",
    category: "nvr-recorder",
    tagline: "Surveon NVR3308A1-32 megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr3308a1-32-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-smr2010",
    manufacturer: "Surveon",
    model: "SMR2010",
    category: "nvr-recorder",
    tagline: "Surveon SMR2010 10 channel megapixel network vide recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr2010-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":10,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-nvr3104p1-4",
    manufacturer: "Surveon",
    model: "NVR3104P1-4",
    category: "nvr-recorder",
    tagline: "Surveon NVR3104P1-4 megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr3104p1-4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-nvr3308a1-16",
    manufacturer: "Surveon",
    model: "NVR3308A1-16",
    category: "nvr-recorder",
    tagline: "Surveon NVR3308A1-16 megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr3308a1-16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-surveon-nvr2164",
    manufacturer: "Surveon",
    model: "NVR2164",
    category: "nvr-recorder",
    tagline: "Surveon NVR2164 64CH 1080P network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2164-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-surveon-smr2008",
    manufacturer: "Surveon",
    model: "SMR2008",
    category: "nvr-recorder",
    tagline: "Surveon SMR2008 network video recorder with intrusion and tampering detection",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr2008-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-smr5016",
    manufacturer: "Surveon",
    model: "SMR5016",
    category: "nvr-recorder",
    tagline: "Surveon SMR5016 16 channel megapixel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr5016-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"raidLevels":["5"]},
  },
  {
    id: "ss-surveon-smr8040u",
    manufacturer: "Surveon",
    model: "SMR8040U",
    category: "nvr-recorder",
    tagline: "Surveon presents SMR8000U RAID NVR series with 40-channel Full HD recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr8040u-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":40,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2000-12b",
    manufacturer: "Surveon",
    model: "NVR2000-12B",
    category: "nvr-recorder",
    tagline: "Surveon NVR2000-12B network video recorder with various video intelligence functions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2000-12b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2000-series",
    manufacturer: "Surveon",
    model: "NVR2000 Series",
    category: "nvr-recorder",
    tagline: "Surveon presents the latest upgrade of Enterprise Hardware RAID NVR2100 Series for scalable projects",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2000-series-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
];

const PART_6: NvrEntry[] = [
  {
    id: "ss-surveon-smr3025",
    manufacturer: "Surveon",
    model: "SMR3025",
    category: "nvr-recorder",
    tagline: "Surveon SMR3025 network video recorder with various investigation tools",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr3025-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2116",
    manufacturer: "Surveon",
    model: "NVR2116",
    category: "nvr-recorder",
    tagline: "Surveon NVR2116 enterprise megapixel RAID NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2116-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2000-ultimate",
    manufacturer: "Surveon",
    model: "NVR2000-Ultimate",
    category: "nvr-recorder",
    tagline: "Surveon Introduces high capacity, configuration and installation-free hardware RAID integrated recor",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2000-ultimate-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-smr5032",
    manufacturer: "Surveon",
    model: "SMR5032",
    category: "nvr-recorder",
    tagline: "Surveon expands line-up of Megapixel NVR solutions with the SMR series",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr5032-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-smr6032h",
    manufacturer: "Surveon",
    model: "SMR6032H",
    category: "nvr-recorder",
    tagline: "Surveon SMR6000H Hybrid-Megapixel RAID NVR features high performance and easy management",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr6032h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2000-16b",
    manufacturer: "Surveon",
    model: "NVR2000-16B",
    category: "nvr-recorder",
    tagline: "Surveon NVR2000-16B network video recorder with conditional recording/alert/notification",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2000-16b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2000-24b",
    manufacturer: "Surveon",
    model: "NVR2000-24B",
    category: "nvr-recorder",
    tagline: "Surveon NVR2000-24B network video recorder with video privacy mask",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2000-24b-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-surveon-nvr2125",
    manufacturer: "Surveon",
    model: "NVR2125",
    category: "nvr-recorder",
    tagline: "Surveon NVR2125 25 channel megapixel recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-nvr2125-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":25,"hddBays":1},
  },
  {
    id: "ss-surveon-smr4000u",
    manufacturer: "Surveon",
    model: "SMR4000U",
    category: "nvr-recorder",
    tagline: "Surveon new compact rackmount NVR with 20-channel full HD live view and recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/surveon-smr4000u-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":20,"hddBays":1},
  },
  {
    id: "ss-hanwha-vision-prp-5000h16",
    manufacturer: "Hanwha Vision",
    model: "PRP-5000H16",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin PRP-5000H16 128CH SSM Recording Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-prp-5000h16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":128,"hddBays":1},
  },
  {
    id: "ss-hanwha-vision-xrn-3210b2",
    manufacturer: "Hanwha Vision",
    model: "XRN-3210B2",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-3210B2 32CH network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-3210b2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-wrn-1610s",
    manufacturer: "Hanwha Vision",
    model: "WRN-1610S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin WRN-1610S 16 Channel WAVE PoE+ NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-wrn-1610s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-hanwha-vision-wrn-810s",
    manufacturer: "Hanwha Vision",
    model: "WRN-810S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin WRN-810S 8 Channel WAVE PoE+ NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-wrn-810s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-hanwha-vision-prn-6400db4",
    manufacturer: "Hanwha Vision",
    model: "PRN-6400DB4",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin PRN-6400DB4 64CH AI network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-prn-6400db4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-hanwha-vision-prn-6400b4",
    manufacturer: "Hanwha Vision",
    model: "PRN-6400B4",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin PRN-6400B4 64CH AI network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-prn-6400b4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-hanwha-vision-xrn-3210rb2",
    manufacturer: "Hanwha Vision",
    model: "XRN-3210RB2",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-3210RB2 32CH network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-3210rb2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"]},
  },
  {
    id: "ss-hanwha-vision-prn-3200b4",
    manufacturer: "Hanwha Vision",
    model: "PRN-3200B4",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin PRN-3200B4 32CH AI network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-prn-3200b4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-hanwha-vision-xrn-6410b4",
    manufacturer: "Hanwha Vision",
    model: "XRN-6410B4",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-6410B4 64CH 32MP NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-6410b4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"]},
  },
  {
    id: "ss-hanwha-vision-xrn-420s",
    manufacturer: "Hanwha Vision",
    model: "XRN-420S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-420S 4CH NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-420s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"poeInPorts":4},
  },
  {
    id: "ss-hanwha-vision-xrn-6410b2",
    manufacturer: "Hanwha Vision",
    model: "XRN-6410B2",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-6410B2 64CH network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-6410b2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-xrn-1610sa",
    manufacturer: "Hanwha Vision",
    model: "XRN-1610SA",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin America XRN-1610SA 16CH Network Video Recorder with PoE Switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-xrn-1610sa-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-qrn-430s",
    manufacturer: "Hanwha Vision",
    model: "QRN-430S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin QRN-430S 4CH NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-qrn-430s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"poeInPorts":4},
  },
  {
    id: "ss-hanwha-vision-qrn-1620s",
    manufacturer: "Hanwha Vision",
    model: "QRN-1620S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin QRN-1620S 16CH 8MP NVR with PoE switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-qrn-1620s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-xrn-6410rb2",
    manufacturer: "Hanwha Vision",
    model: "XRN-6410RB2",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-6410RB2 64CH network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-6410rb2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"]},
  },
  {
    id: "ss-hanwha-vision-prp-4000h8",
    manufacturer: "Hanwha Vision",
    model: "PRP-4000H8",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin PRP-4000H8 72CH SSM Recording Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-prp-4000h8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":72,"hddBays":1},
  },
  {
    id: "ss-hanwha-vision-wwt-p-3201w",
    manufacturer: "Hanwha Vision",
    model: "WWT-P-3201W",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin WWT-P-3201W Wisenet WAVE Client Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-wwt-p-3201w-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-hanwha-vision-xrn-2010a",
    manufacturer: "Hanwha Vision",
    model: "XRN-2010A",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin America XRN-2010A 32 Channel Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-xrn-2010a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-xrn-3010a",
    manufacturer: "Hanwha Vision",
    model: "XRN-3010A",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin America XRN-3010A 64 Channel Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-xrn-3010a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-xrn-1620b2",
    manufacturer: "Hanwha Vision",
    model: "XRN-1620B2",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-1620B2 16CH NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-1620b2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-taw-4000h16",
    manufacturer: "Hanwha Vision",
    model: "TAW-4000H16",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin TAW-4000H16 Transportation Monitoring System",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-taw-4000h16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-hanwha-vision-lrn-1610s",
    manufacturer: "Hanwha Vision",
    model: "LRN-1610S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin LRN-1610S 4CH 8M H.265 NVR with PoE Switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-lrn-1610s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"poeInPorts":16},
  },
  {
    id: "ss-hanwha-vision-wrt-p-5201l",
    manufacturer: "Hanwha Vision",
    model: "WRT-P-5201L",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin WRT-P-5201L Dual-purpose Wisenet WAVE Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-wrt-p-5201l-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-hanwha-vision-xrn-3210b4",
    manufacturer: "Hanwha Vision",
    model: "XRN-3210B4",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-3210B4 32CH 32MP NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-3210b4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"]},
  },
  {
    id: "ss-hanwha-vision-xrn-410s",
    manufacturer: "Hanwha Vision",
    model: "XRN-410S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin America XRN-410S 4CH network video recorder with PoE switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-xrn-410s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-xrn-2011a",
    manufacturer: "Hanwha Vision",
    model: "XRN-2011A",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-2011A 32CH 12M H.265 NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-2011a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"]},
  },
  {
    id: "ss-hanwha-vision-xrn-820s",
    manufacturer: "Hanwha Vision",
    model: "XRN-820S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-820S 8CH NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-820s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"poeInPorts":8},
  },
  {
    id: "ss-hanwha-vision-xrn-1620sb1",
    manufacturer: "Hanwha Vision",
    model: "XRN-1620SB1",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-1620SB1 16CH NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-1620sb1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"poeInPorts":16},
  },
  {
    id: "ss-hanwha-vision-wrt-p-5201w",
    manufacturer: "Hanwha Vision",
    model: "WRT-P-5201W",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin WRT-P-5201W Dual-purpose Wisenet WAVE Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-wrt-p-5201w-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-hanwha-vision-xrn-1610a",
    manufacturer: "Hanwha Vision",
    model: "XRN-1610A",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-1610A 16CH 12M H.265 NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-1610a-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-xrn-810s",
    manufacturer: "Hanwha Vision",
    model: "XRN-810S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin America XRN-810S 8CH Network Video Recorder with PoE Switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-america-xrn-810s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-lrn-810s",
    manufacturer: "Hanwha Vision",
    model: "LRN-810S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin LRN-810S 8CH 5MP NVR with PoE Switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-lrn-810s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"poeInPorts":8},
  },
  {
    id: "ss-hanwha-vision-xrn-6410db4",
    manufacturer: "Hanwha Vision",
    model: "XRN-6410DB4",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin XRN-6410DB4 64CH 32MP NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-xrn-6410db4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"]},
  },
  {
    id: "ss-hanwha-vision-wrt-p-3101w",
    manufacturer: "Hanwha Vision",
    model: "WRT-P-3101W",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin WRT-P-3101W Dual-purpose Wisenet WAVE Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-wrt-p-3101w-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-hanwha-vision-wrt-p-3101l",
    manufacturer: "Hanwha Vision",
    model: "WRT-P-3101L",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin WRT-P-3101L Dual-purpose Wisenet WAVE Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-wrt-p-3101l-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-hanwha-vision-lrn-410s",
    manufacturer: "Hanwha Vision",
    model: "LRN-410S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin LRN-410S 4CH 5MP NVR with PoE Switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-lrn-410s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"poeInPorts":4},
  },
  {
    id: "ss-hanwha-vision-qrn-420s",
    manufacturer: "Hanwha Vision",
    model: "QRN-420S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin QRN-420S 4CH 8MP NVR with PoE switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-qrn-420s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-hanwha-vision-qrn-820s",
    manufacturer: "Hanwha Vision",
    model: "QRN-820S",
    category: "nvr-recorder",
    tagline: "Hanwha Techwin QRN-820S 8CH 8MP NVR with PoE switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hanwha-techwin-qrn-820s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-milestone-ha-rr-340",
    manufacturer: "Milestone",
    model: "HA-RR-340",
    category: "nvr-recorder",
    tagline: "Milestone HA-RR-340 Slide Rack Rail kit for Husky 700R",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-ha-rr-340-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he1800r-384tb",
    manufacturer: "Milestone",
    model: "HE1800R-384TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1800R-384TB Husky IVO 1800 Rack mount 2U, WS19, 384TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1800r-384tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-ha-rr-3930",
    manufacturer: "Milestone",
    model: "HA-RR-3930",
    category: "nvr-recorder",
    tagline: "Milestone HA-RR-3930 Slide Rack Rail kit for Husky IVO 350R",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-ha-rr-3930-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he350r-32tb",
    manufacturer: "Milestone",
    model: "HE350R-32TB",
    category: "nvr-recorder",
    tagline: "Milestone HE350R-32TB Husky IVO 350 Rack mount, Win10, 32TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he350r-32tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he1000r-96tb",
    manufacturer: "Milestone",
    model: "HE1000R-96TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1000R-96TB Husky IVO 1000 Rack mount 2U, WS19, 96TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1000r-96tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he1000r-128tb",
    manufacturer: "Milestone",
    model: "HE1000R-128TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1000R-128TB Husky IVO 1000 Rack mount 2U, WS19, 128TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1000r-128tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he1000r-64tb",
    manufacturer: "Milestone",
    model: "HE1000R-64TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1000R-64TB Husky IVO 1000 Rack mount 2U, WS19, 64TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1000r-64tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-ha-rr-740",
    manufacturer: "Milestone",
    model: "HA-RR-740",
    category: "nvr-recorder",
    tagline: "Milestone HA-RR-740 PEC Static Rack Rail kit for Husky 1800R",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-ha-rr-740-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he700r-32tb",
    manufacturer: "Milestone",
    model: "HE700R-32TB",
    category: "nvr-recorder",
    tagline: "Milestone HE700R-32TB Husky IVO 700 Rack mount, Win10, 32TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he700r-32tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-ha-rr-540",
    manufacturer: "Milestone",
    model: "HA-RR-540",
    category: "nvr-recorder",
    tagline: "Milestone HA-RR-540 Slide Rack Rail kit for Husky 1000R",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-ha-rr-540-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he700r-16tb",
    manufacturer: "Milestone",
    model: "HE700R-16TB",
    category: "nvr-recorder",
    tagline: "Milestone HE700R-16TB Husky IVO 700 Rack mount, Win10, 16TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he700r-16tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he1800r-288tb",
    manufacturer: "Milestone",
    model: "HE1800R-288TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1800R-288TB Husky IVO 1800 Rack mount 2U, WS19, 288TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1800r-288tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he350r-16tb",
    manufacturer: "Milestone",
    model: "HE350R-16TB",
    category: "nvr-recorder",
    tagline: "Milestone HE350R-16TB Husky IVO 350 Rack mount, Win10, 16TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he350r-16tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he1800r-192tb",
    manufacturer: "Milestone",
    model: "HE1800R-192TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1800R-192TB Husky IVO 1800 Rack mount 2U, WS19, 192TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1800r-192tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he1800r-96tb",
    manufacturer: "Milestone",
    model: "HE1800R-96TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1800R-96TB Husky IVO 1800 Rack mount 2U, WS19, 96TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1800r-96tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he700r-64tb",
    manufacturer: "Milestone",
    model: "HE700R-64TB",
    category: "nvr-recorder",
    tagline: "Milestone HE700R-64TB Husky IVO 700 Rack mount, Win10, 64TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he700r-64tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he350r-8tb",
    manufacturer: "Milestone",
    model: "HE350R-8TB",
    category: "nvr-recorder",
    tagline: "Milestone HE350R-8TB Husky IVO 350 Rack mount, Win10, 8TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he350r-8tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he350t-8tb",
    manufacturer: "Milestone",
    model: "HE350T-8TB",
    category: "nvr-recorder",
    tagline: "Milestone HE350T-8TB Husky IVO 350 Tower, Win10, 8TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he350t-8tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he700r-48tb",
    manufacturer: "Milestone",
    model: "HE700R-48TB",
    category: "nvr-recorder",
    tagline: "Milestone HE700R-48TB Husky IVO 700 Rack mount, Win10, 48TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he700r-48tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he350r-24tb",
    manufacturer: "Milestone",
    model: "HE350R-24TB",
    category: "nvr-recorder",
    tagline: "Milestone HE350R-24TB Husky IVO 350 Rack mount, Win10, 24TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he350r-24tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he150d-4tb",
    manufacturer: "Milestone",
    model: "HE150D-4TB",
    category: "nvr-recorder",
    tagline: "Milestone HE150D-4TB Husky IVO 150 Desktop, Win10, 4TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he150d-4tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-milestone-he350r-4tb",
    manufacturer: "Milestone",
    model: "HE350R-4TB",
    category: "nvr-recorder",
    tagline: "Milestone HE350R-4TB Husky IVO 350 Rack mount, Win10, 4TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he350r-4tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he1800r-144tb",
    manufacturer: "Milestone",
    model: "HE1800R-144TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1800R-144TB Husky IVO 1800 Rack mount 2U, WS19, 144TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1800r-144tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he150d-16tb",
    manufacturer: "Milestone",
    model: "HE150D-16TB",
    category: "nvr-recorder",
    tagline: "Milestone HE150D-16TB Husky IVO 150 Desktop, Win10, 16TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he150d-16tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-milestone-he150d-8tb",
    manufacturer: "Milestone",
    model: "HE150D-8TB",
    category: "nvr-recorder",
    tagline: "Milestone HE150D-8TB Husky IVO 150 Desktop, Win10, 8TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he150d-8tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-milestone-he350t-16tb",
    manufacturer: "Milestone",
    model: "HE350T-16TB",
    category: "nvr-recorder",
    tagline: "Milestone HE350T-16TB Husky IVO 350 Tower, Win10, 16TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he350t-16tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he700r-8tb",
    manufacturer: "Milestone",
    model: "HE700R-8TB",
    category: "nvr-recorder",
    tagline: "Milestone HE700R-8TB Husky IVO 700 Rack mount, Win10, 8TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he700r-8tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he1800r-48tb",
    manufacturer: "Milestone",
    model: "HE1800R-48TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1800R-48TB Husky IVO 1800 Rack mount 2U, WS19, 48TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1800r-48tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he350t-24tb",
    manufacturer: "Milestone",
    model: "HE350T-24TB",
    category: "nvr-recorder",
    tagline: "Milestone HE350T-24TB Husky IVO 350 Tower, Win10, 24TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he350t-24tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he150d-2tb",
    manufacturer: "Milestone",
    model: "HE150D-2TB",
    category: "nvr-recorder",
    tagline: "Milestone HE150D-2TB Husky IVO 150 Desktop, Win10, 2TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he150d-2tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-milestone-he1000r-32tb",
    manufacturer: "Milestone",
    model: "HE1000R-32TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1000R-32TB Husky IVO 1000 Rack mount 2U, WS19, 32TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1000r-32tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he350t-32tb",
    manufacturer: "Milestone",
    model: "HE350T-32TB",
    category: "nvr-recorder",
    tagline: "Milestone HE350T-32TB Husky IVO 350 Tower, Win10, 32TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he350t-32tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-milestone-he1000r-16tb",
    manufacturer: "Milestone",
    model: "HE1000R-16TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1000R-16TB Husky IVO 1000 Rack mount 2U, WS19, 16TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1000r-16tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he150d-12tb",
    manufacturer: "Milestone",
    model: "HE150D-12TB",
    category: "nvr-recorder",
    tagline: "Milestone HE150D-12TB Husky IVO 150 Desktop, Win10, 12TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he150d-12tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-milestone-he1800r-24tb",
    manufacturer: "Milestone",
    model: "HE1800R-24TB",
    category: "nvr-recorder",
    tagline: "Milestone HE1800R-24TB Husky IVO 1800 Rack mount 2U, WS19, 24TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he1800r-24tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-milestone-he350t-4tb",
    manufacturer: "Milestone",
    model: "HE350T-4TB",
    category: "nvr-recorder",
    tagline: "Milestone HE350T-4TB Husky IVO 350 Tower, Win10, 4TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/milestone-he350t-4tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-vicon-veca-1u00n0-00",
    manufacturer: "Vicon",
    model: "VECA-1U00N0-00",
    category: "nvr-recorder",
    tagline: "Vicon VECA-1U00N0-00 1U rack mount client workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-veca-1u00n0-00-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-vicon-veca-mc00n0-00",
    manufacturer: "Vicon",
    model: "VECA-MC00N0-00",
    category: "nvr-recorder",
    tagline: "Vicon VECA-MC00N0-00 micro form factor client workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-veca-mc00n0-00-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-vicon-veca-sf00n0-00",
    manufacturer: "Vicon",
    model: "VECA-SF00N0-00",
    category: "nvr-recorder",
    tagline: "Vicon VECA-SF00N0-00 small form factor client workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-veca-sf00n0-00-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-vicon-vera-2u540r6-450",
    manufacturer: "Vicon",
    model: "VERA-2U540R6-450",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U540R6-450 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u540r6-450-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u220r5-180",
    manufacturer: "Vicon",
    model: "VERA-2U220R5-180",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U220R5-180 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u220r5-180-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-sf08n0-07",
    manufacturer: "Vicon",
    model: "VERA-SF08N0-07",
    category: "nvr-recorder",
    tagline: "Vicon VERA-SF08N0-07 small form factor network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-sf08n0-07-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-vicon-vera-sf16n0-14",
    manufacturer: "Vicon",
    model: "VERA-SF16N0-14",
    category: "nvr-recorder",
    tagline: "Vicon VERA-SF16N0-14 small form factor network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-sf16n0-14-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-vicon-vera-1u24n0-22",
    manufacturer: "Vicon",
    model: "VERA-1U24N0-22",
    category: "nvr-recorder",
    tagline: "Vicon VERA-1U24N0-22 1U rack mount network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-1u24n0-22-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-vicon-vera-2u160r5-126",
    manufacturer: "Vicon",
    model: "VERA-2U160R5-126",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U160R5-126 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u160r5-126-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-1u20n0-18",
    manufacturer: "Vicon",
    model: "VERA-1U20N0-18",
    category: "nvr-recorder",
    tagline: "Vicon VERA-1U20N0-18 1U rack mount network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-1u20n0-18-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-vicon-vera-1u80r5-54",
    manufacturer: "Vicon",
    model: "VERA-1U80R5-54",
    category: "nvr-recorder",
    tagline: "Vicon VERA-1U80R5-54 1U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-1u80r5-54-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-vicon-vera-2u140r5-108",
    manufacturer: "Vicon",
    model: "VERA-2U140R5-108",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U140R5-108 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u140r5-108-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u340r6-270",
    manufacturer: "Vicon",
    model: "VERA-2U340R6-270",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U340R6-270 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u340r6-270-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u180r5-144",
    manufacturer: "Vicon",
    model: "VERA-2U180R5-144",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U180R5-144 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u180r5-144-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-1u32n0-29",
    manufacturer: "Vicon",
    model: "VERA-1U32N0-29",
    category: "nvr-recorder",
    tagline: "Vicon VERA-1U32N0-29 1U rack mount network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-1u32n0-29-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-vicon-vera-1u48r5-32",
    manufacturer: "Vicon",
    model: "VERA-1U48R5-32",
    category: "nvr-recorder",
    tagline: "Vicon VERA-1U48R5-32 1U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-1u48r5-32-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"1U"},
  },
  {
    id: "ss-vicon-vera-1u64r5-43",
    manufacturer: "Vicon",
    model: "VERA-1U64R5-43",
    category: "nvr-recorder",
    tagline: "Vicon VERA-1U64R5-43 1U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-1u64r5-43-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-vicon-vera-2u84r5-65",
    manufacturer: "Vicon",
    model: "VERA-2U84R5-65",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U84R5-65 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u84r5-65-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u96r5-76",
    manufacturer: "Vicon",
    model: "VERA-2U96R5-76",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U96R5-76 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u96r5-76-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u200r5-162",
    manufacturer: "Vicon",
    model: "VERA-2U200R5-162",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U200R5-162 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u200r5-162-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u240r5-198",
    manufacturer: "Vicon",
    model: "VERA-2U240R5-198",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U240R5-198 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u240r5-198-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u280r6-216",
    manufacturer: "Vicon",
    model: "VERA-2U280R6-216",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U280R6-216 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u280r6-216-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u320r6-252",
    manufacturer: "Vicon",
    model: "VERA-2U320R6-252",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U320R6-252 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u320r6-252-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u360r6-288",
    manufacturer: "Vicon",
    model: "VERA-2U360R6-288",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U360R6-288 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u360r6-288-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u420r6-342",
    manufacturer: "Vicon",
    model: "VERA-2U420R6-342",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U420R6-342 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u420r6-342-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u520r6-432",
    manufacturer: "Vicon",
    model: "VERA-2U520R6-432",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U520R6-432 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u520r6-432-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u560r6-468",
    manufacturer: "Vicon",
    model: "VERA-2U560R6-468",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U560R6-468 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u560r6-468-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u120r5-90",
    manufacturer: "Vicon",
    model: "VERA-2U120R5-90",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U120R5-90 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u120r5-90-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u300r6-234",
    manufacturer: "Vicon",
    model: "VERA-2U300R6-234",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U300R6-234 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u300r6-234-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u380r6-306",
    manufacturer: "Vicon",
    model: "VERA-2U380R6-306",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U380R6-306 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u380r6-306-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u400r6-324",
    manufacturer: "Vicon",
    model: "VERA-2U400R6-324",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U400R6-324 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u400r6-324-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u440r6-360",
    manufacturer: "Vicon",
    model: "VERA-2U440R6-360",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U440R6-360 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u440r6-360-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u460r6-378",
    manufacturer: "Vicon",
    model: "VERA-2U460R6-378",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U460R6-378 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u460r6-378-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u480r6-396",
    manufacturer: "Vicon",
    model: "VERA-2U480R6-396",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U480R6-396 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u480r6-396-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u672r6-562",
    manufacturer: "Vicon",
    model: "VERA-2U672R6-562",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U672R6-562 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u672r6-562-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-vicon-vera-2u500r6-414",
    manufacturer: "Vicon",
    model: "VERA-2U500R6-414",
    category: "nvr-recorder",
    tagline: "Vicon VERA-2U500R6-414 2U rack mount RAID network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vicon-vera-2u500r6-414-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-qnap-vs-2308",
    manufacturer: "QNAP",
    model: "VS-2308",
    category: "nvr-recorder",
    tagline: "QNAP VS-2308 2-bay high performance NVR for SMB & SOHO",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/qnap-vs-2308-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-qnap-vs-4312",
    manufacturer: "QNAP",
    model: "VS-4312",
    category: "nvr-recorder",
    tagline: "QNAP VS-4312 4-bay high performance NVR for SMB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/qnap-vs-4312-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-qnap-vs-8348",
    manufacturer: "QNAP",
    model: "VS-8348",
    category: "nvr-recorder",
    tagline: "QNAP VS-8348 Ultra-high performance 8-bay NVR server for high-end SMBs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/qnap-vs-8348-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-qnap-vs-2304",
    manufacturer: "QNAP",
    model: "VS-2304",
    category: "nvr-recorder",
    tagline: "QNAP VS-2304 2-bay high performance NVR for SMB & SOHO",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/qnap-vs-2304-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-qnap-vs-6318",
    manufacturer: "QNAP",
    model: "VS-6318",
    category: "nvr-recorder",
    tagline: "QNAP VS-6318 6-bay high performance NVR for SMB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/qnap-vs-6318-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-qnap-vs-8324",
    manufacturer: "QNAP",
    model: "VS-8324",
    category: "nvr-recorder",
    tagline: "QNAP VS-8324 Ultra-high performance 8-bay NVR server for high-end SMBs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/qnap-vs-8324-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-qnap-vs-6336",
    manufacturer: "QNAP",
    model: "VS-6336",
    category: "nvr-recorder",
    tagline: "QNAP VS-6336 6-bay high performance NVR for SMB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/qnap-vs-6336-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-qnap-vs-4324",
    manufacturer: "QNAP",
    model: "VS-4324",
    category: "nvr-recorder",
    tagline: "QNAP VS-4324 4-bay high performance NVR for SMB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/qnap-vs-4324-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s1148-64-tb",
    manufacturer: "Axis Communications",
    model: "S1148 64 TB",
    category: "nvr-recorder",
    tagline: "Axis Communications S1148 64 TB Out-of-the box ready server for HD surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s1148-64-tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-camera-station-s1032-recorder",
    manufacturer: "Axis Communications",
    model: "AXIS Camera Station S1032 Recorder",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS Camera Station S1032 network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-camera-station-s1032-recorder-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-axis-communications-axis-companion-recorder-8ch-4-tb",
    manufacturer: "Axis Communications",
    model: "AXIS Companion Recorder 8CH 4 TB",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS Companion Recorder 8CH 4 TB network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-companion-recorder-8ch-4-tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-companion-recorder-4ch",
    manufacturer: "Axis Communications",
    model: "AXIS Companion Recorder 4CH",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS Companion Recorder 4CH network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-companion-recorder-4ch-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s1232-rack-32-tb",
    manufacturer: "Axis Communications",
    model: "S1232 Rack 32 TB",
    category: "nvr-recorder",
    tagline: "Axis Communications S1232 Rack 32 TB Recording Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s1232-rack-32-tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-camera-station-s1016-recorder",
    manufacturer: "Axis Communications",
    model: "AXIS Camera Station S1016 Recorder",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS Camera Station S1016 network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-camera-station-s1016-recorder-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-companion-recorder-8ch-2-tb",
    manufacturer: "Axis Communications",
    model: "AXIS Companion Recorder 8CH 2 TB",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS Companion Recorder 8CH 2 TB network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-companion-recorder-8ch-2-tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-s2208",
    manufacturer: "Axis Communications",
    model: "AXIS S2208",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS S2208 All-in-one recorder with integrated 8 channel PoE switch for high-def",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-s2208-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-s1232-tower-32-tb",
    manufacturer: "Axis Communications",
    model: "AXIS S1232 Tower 32 TB",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS S1232 Tower 32 TB Out-of-the-box ready recording servers",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-s1232-tower-32-tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s1232-rack-16-tb",
    manufacturer: "Axis Communications",
    model: "S1232 Rack 16 TB",
    category: "nvr-recorder",
    tagline: "Axis Communications S1232 Rack 16 TB Recording Server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s1232-rack-16-tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s1264-rack-144-tb",
    manufacturer: "Axis Communications",
    model: "S1264 Rack 144 TB",
    category: "nvr-recorder",
    tagline: "Axis Communications S1264 Rack 144 TB Recording server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s1264-rack-144-tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s1264-rack-64-tb",
    manufacturer: "Axis Communications",
    model: "S1264 Rack 64 TB",
    category: "nvr-recorder",
    tagline: "Axis Communications S1264 Rack 64 TB Recording server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s1264-rack-64-tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-s2216",
    manufacturer: "Axis Communications",
    model: "AXIS S2216",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS S2216 All-in-one Recorder With PoE Switch For UHD Surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-s2216-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s1132",
    manufacturer: "Axis Communications",
    model: "S1132",
    category: "nvr-recorder",
    tagline: "Axis Communications S1132 Out-of-the box ready server for HD surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s1132-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-s2212",
    manufacturer: "Axis Communications",
    model: "AXIS S2212",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS S2212 All-in-one Recorder With PoE Switch For UHD Surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-s2212-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-s2224",
    manufacturer: "Axis Communications",
    model: "AXIS S2224",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS S2224 All-in-one recorder with PoE switch for UHD surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-s2224-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-camera-station-s2208",
    manufacturer: "Axis Communications",
    model: "Camera Station S2208",
    category: "nvr-recorder",
    tagline: "Axis Communications Camera Station S2208 All-in-one recorder with integrated 8 channel PoE switch fo",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-camera-station-s2208-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s9101",
    manufacturer: "Axis Communications",
    model: "S9101",
    category: "nvr-recorder",
    tagline: "Axis Communications S9101 Optimal surveillance for server installations",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s9101-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s1264-rack-24-tb",
    manufacturer: "Axis Communications",
    model: "S1264 Rack 24 TB",
    category: "nvr-recorder",
    tagline: "Axis Communications S1264 Rack 24 TB Recording server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s1264-rack-24-tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-s1116-racked",
    manufacturer: "Axis Communications",
    model: "AXIS S1116 Racked",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS S1116 Racked Out-of-the-box ready recorder for high-definition surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-s1116-racked-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-s1132",
    manufacturer: "Axis Communications",
    model: "AXIS S1132",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS S1132 Out-of-the box ready server for high-definition surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-s1132-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s1116-racked",
    manufacturer: "Axis Communications",
    model: "S1116 Racked",
    category: "nvr-recorder",
    tagline: "Axis Communications S1116 Racked Out-of-the-box ready recorder for HD surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s1116-racked-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-camera-station-s2212",
    manufacturer: "Axis Communications",
    model: "Camera Station S2212",
    category: "nvr-recorder",
    tagline: "Axis Communications Camera Station S2212 All-in-one recorder with integrated 12 channel PoE switch f",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-camera-station-s2212-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":12,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-s1116-mt",
    manufacturer: "Axis Communications",
    model: "AXIS S1116 MT",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS S1116 MT Out-of-the-box ready recorder for high-definition surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-s1116-mt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s9201-mk-ll",
    manufacturer: "Axis Communications",
    model: "S9201 Mk ll",
    category: "nvr-recorder",
    tagline: "Axis Communications S9201 Mk ll All-in-one solution for optimal viewing",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s9201-mk-ll-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-camera-station-s2224",
    manufacturer: "Axis Communications",
    model: "Camera Station S2224",
    category: "nvr-recorder",
    tagline: "Axis Communications Camera Station S2224 All-in-one recorder with integrated 24 channel PoE switch f",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-camera-station-s2224-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s1148-140-tb",
    manufacturer: "Axis Communications",
    model: "S1148 140 TB",
    category: "nvr-recorder",
    tagline: "Axis Communications S1148 140 TB Out-of-the box ready server for HD surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s1148-140-tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s1148-24-tb",
    manufacturer: "Axis Communications",
    model: "S1148 24 TB",
    category: "nvr-recorder",
    tagline: "Axis Communications S1148 24 TB Out-of-the box ready server for HD surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s1148-24-tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-camera-station-s2216",
    manufacturer: "Axis Communications",
    model: "Camera Station S2216",
    category: "nvr-recorder",
    tagline: "Axis Communications Camera Station S2216 All-in-one recorder with integrated 16 channel PoE switch f",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-camera-station-s2216-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s1116-mt",
    manufacturer: "Axis Communications",
    model: "S1116 MT",
    category: "nvr-recorder",
    tagline: "Axis Communications S1116 MT Out-of-the-box ready recorder for HD surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s1116-mt-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-s9002-mk-ll",
    manufacturer: "Axis Communications",
    model: "S9002 Mk ll",
    category: "nvr-recorder",
    tagline: "Axis Communications S9002 Mk ll Effective 4K surveillance for server installations",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-s9002-mk-ll-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-axis-communications-axis-camera-station-s9001-desktop-terminal",
    manufacturer: "Axis Communications",
    model: "AXIS Camera Station S9001 Desktop Terminal",
    category: "nvr-recorder",
    tagline: "Axis Communications AXIS Camera Station S9001 Desktop Terminal for server installations",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/axis-communications-axis-camera-station-s9001-desktop-terminal-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-march-networks-8516-s-8516-r-16-channel",
    manufacturer: "March Networks",
    model: "8516 S & 8516 R - 16 Channel",
    category: "nvr-recorder",
    tagline: "March Networks 8516 S & 8516 R - 16 Channel hybrid NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-8516-s-and-8516-r-16-channel-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-march-networks-8532-s-8532-r-8732-r-32-channel",
    manufacturer: "March Networks",
    model: "8532 S, 8532 R & 8732 R - 32 Channel",
    category: "nvr-recorder",
    tagline: "March Networks 8532 S, 8532 R & 8732 R - 32 Channel hybrid NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-8532-s-8532-r-and-8732-r-32-channel-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-march-networks-x1232-r",
    manufacturer: "March Networks",
    model: "X1232 R",
    category: "nvr-recorder",
    tagline: "March Networks X1232 R 32 channel hybrid recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x1232-r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-march-networks-mn-8724v",
    manufacturer: "March Networks",
    model: "MN-8724V",
    category: "nvr-recorder",
    tagline: "High-Definition Video over Analogue Infrastructure with New March Networks 8724 V Tribrid NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-mn-8724v-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-march-networks-x1216-r",
    manufacturer: "March Networks",
    model: "X1216 R",
    category: "nvr-recorder",
    tagline: "March Networks X1216 R 16 channel hybrid recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x1216-r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-march-networks-x0404",
    manufacturer: "March Networks",
    model: "X0404",
    category: "nvr-recorder",
    tagline: "March Networks X0404 4 channel hybrid recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x0404-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-march-networks-8516-sr",
    manufacturer: "March Networks",
    model: "8516 SR",
    category: "nvr-recorder",
    tagline: "March Networks 8516 SR 16 channel stacked network video recorder with integrated RAID5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-8516-sr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"raidLevels":["5"]},
  },
  {
    id: "ss-march-networks-8508-s-8507-s-8-channel",
    manufacturer: "March Networks",
    model: "8508 S & 8507 S - 8 Channel",
    category: "nvr-recorder",
    tagline: "March Networks 8508 S & 8507 S - 8 Channel hybrid NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-8508-s-and-8507-s-8-channel-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-march-networks-9132-ip-recorder",
    manufacturer: "March Networks",
    model: "9132 IP Recorder",
    category: "nvr-recorder",
    tagline: "March Networks 9132 IP Recorder 32 channel HD IP recording platform",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-9132-ip-recorder-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-march-networks-8704-s-4-channel",
    manufacturer: "March Networks",
    model: "8704 S - 4 Channel",
    category: "nvr-recorder",
    tagline: "March Networks 8704 S - 4 Channel hybrid NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-8704-s-4-channel-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-march-networks-9264-ip-recorder",
    manufacturer: "March Networks",
    model: "9264 IP Recorder",
    category: "nvr-recorder",
    tagline: "March Networks 9264 IP Recorder 64 channels HD IP recording platform",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-9264-ip-recorder-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-march-networks-x1224-r",
    manufacturer: "March Networks",
    model: "X1224 R",
    category: "nvr-recorder",
    tagline: "March Networks X1224 R 24 channel hybrid recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x1224-r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-march-networks-x1216-s",
    manufacturer: "March Networks",
    model: "X1216 S",
    category: "nvr-recorder",
    tagline: "March Networks X1216 S 16 channel hybrid recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x1216-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-march-networks-x32",
    manufacturer: "March Networks",
    model: "X32",
    category: "nvr-recorder",
    tagline: "March Networks X32 32 channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x32-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-march-networks-x48",
    manufacturer: "March Networks",
    model: "X48",
    category: "nvr-recorder",
    tagline: "March Networks X48 48 channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x48-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":48,"hddBays":1},
  },
  {
    id: "ss-march-networks-x0408",
    manufacturer: "March Networks",
    model: "X0408",
    category: "nvr-recorder",
    tagline: "March Networks X0408 8 channel hybrid recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x0408-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-march-networks-ridesafe-gt-series-8-12-16-20-channel-hybrid-transit-nvr",
    manufacturer: "March Networks",
    model: "RideSafe GT Series 8/12/16/20-Channel Hybrid Transit NVR",
    category: "nvr-recorder",
    tagline: "March Networks RideSafe GT Series 8/12/16/20-Channel Hybrid Transit NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-ridesafe-gt-series-8-12-16-20-channel-hybrid-transit-nvr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":20,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-march-networks-x64",
    manufacturer: "March Networks",
    model: "X64",
    category: "nvr-recorder",
    tagline: "March Networks X64 64 channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x64-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-march-networks-6716",
    manufacturer: "March Networks",
    model: "6716",
    category: "nvr-recorder",
    tagline: "March Networks 6716 16 channel hybrid network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-6716-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-march-networks-x1264-r",
    manufacturer: "March Networks",
    model: "X1264 R",
    category: "nvr-recorder",
    tagline: "March Networks X1264 R 64 channel hybrid recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x1264-r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-march-networks-6732",
    manufacturer: "March Networks",
    model: "6732",
    category: "nvr-recorder",
    tagline: "March Networks 6732 32 channel hybrid network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-6732-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-march-networks-6708",
    manufacturer: "March Networks",
    model: "6708",
    category: "nvr-recorder",
    tagline: "March Networks 6708 8 channel hybrid network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-6708-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-march-networks-9248-ip-recorder",
    manufacturer: "March Networks",
    model: "9248 IP Recorder",
    category: "nvr-recorder",
    tagline: "March Networks 9248 IP Recorder 48 channel HD IP recording platform",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-9248-ip-recorder-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":48,"hddBays":1},
  },
  {
    id: "ss-march-networks-8716-p-16-channel-built-in-poe",
    manufacturer: "March Networks",
    model: "8716 P - 16 Channel (BUILT-IN PoE)",
    category: "nvr-recorder",
    tagline: "March Networks 8716 P - 16 Channel (BUILT-IN PoE) hybrid NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-8716-p-16-channel-built-in-poe-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-march-networks-x1232-s",
    manufacturer: "March Networks",
    model: "X1232 S",
    category: "nvr-recorder",
    tagline: "March Networks X1232 S 32 channel hybrid recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x1232-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-march-networks-6704-s",
    manufacturer: "March Networks",
    model: "6704 S",
    category: "nvr-recorder",
    tagline: "March Networks 6704 S 4 channel hybrid network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-6704-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-march-networks-8516-rr",
    manufacturer: "March Networks",
    model: "8516 RR",
    category: "nvr-recorder",
    tagline: "March Networks 8516 RR 16 channel rack mount network video recorder with integrated RAID5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-8516-rr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"raidLevels":["5"]},
  },
  {
    id: "ss-march-networks-x0412",
    manufacturer: "March Networks",
    model: "X0412",
    category: "nvr-recorder",
    tagline: "March Networks X0412 12 channel hybrid recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x0412-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":12,"hddBays":1},
  },
  {
    id: "ss-march-networks-x1224-s",
    manufacturer: "March Networks",
    model: "X1224 S",
    category: "nvr-recorder",
    tagline: "March Networks X1224 S 24 channel hybrid recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x1224-s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-march-networks-ridesafe-rt-series",
    manufacturer: "March Networks",
    model: "RideSafe RT Series",
    category: "nvr-recorder",
    tagline: "March Networks RideSafe RT Series 20 channels network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-ridesafe-rt-series-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":20,"hddBays":1},
  },
  {
    id: "ss-march-networks-x1248-r",
    manufacturer: "March Networks",
    model: "X1248 R",
    category: "nvr-recorder",
    tagline: "March Networks X1248 R 48 channel hybrid recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x1248-r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":48,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-march-networks-ridesafe-mt-series-ip-recorder",
    manufacturer: "March Networks",
    model: "RideSafe MT Series IP Recorder",
    category: "nvr-recorder",
    tagline: "March Networks RideSafe IP Recorders",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-ridesafe-mt-series-ip-recorders-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-march-networks-x-series-hybrid-recorders",
    manufacturer: "March Networks",
    model: "X-Series Hybrid Recorders",
    category: "nvr-recorder",
    tagline: "March Networks X-Series Hybrid Recorders",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/march-networks-x1264-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-wavestore-x424-32pu4-hr-4g-na-d11",
    manufacturer: "Wavestore",
    model: "X424-32PU4-HR-4G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore X424-32PU4-HR-4G-NA-D11 4U rack-mount NVR, 32TB storage, 1,200Mbps, HyperRAID and EcoStore",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-x424-32pu4-hr-4g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"4U"},
  },
  {
    id: "ss-wavestore-ws7-1t-16g-r2060-4m",
    manufacturer: "Wavestore",
    model: "WS7-1T-16G-R2060-4M",
    category: "nvr-recorder",
    tagline: "Wavestore WS7-1T-16G-R2060-4M Wavestore Client Workstation, 4-monitor capability, i7 processor, 16GB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-ws7-1t-16g-r2060-4m-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-wavestore-opal",
    manufacturer: "Wavestore",
    model: "Opal",
    category: "nvr-recorder",
    tagline: "Wavestore Opal Compact Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-opal-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-wavestore-v212-24pu4-hr-4g-na-d11",
    manufacturer: "Wavestore",
    model: "V212-24PU4-HR-4G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore V212-24PU4-HR-4G-NA-D11 2U rack-mount NVR, 24TB storage, 1,200Mbps, HyperRAID and EcoStore",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-v212-24pu4-hr-4g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-wavestore-e12-20pu2-nr-2g-na-s11",
    manufacturer: "Wavestore",
    model: "E12-20PU2-NR-2G-NA-S11",
    category: "nvr-recorder",
    tagline: "Wavestore E12-20PU2-NR-2G-NA-S11 1U rackmount NVR, 20TB storage, 300Mbps, EcoStore ready",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-e12-20pu2-nr-2g-na-s11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-wavestore-q14-40pu4-hr-4g-na-d11",
    manufacturer: "Wavestore",
    model: "Q14-40PU4-HR-4G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore Q14-40PU4-HR-4G-NA-D11 1U rack-mount NVR, 40TB storage, 1200Mbps, HyperRAID and EcoStore r",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-q14-40pu4-hr-4g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-wavestore-x424-240pu24-hr-8g-na-d11",
    manufacturer: "Wavestore",
    model: "X424-240PU24-HR-8G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore X424-240PU24-HR-8G-NA-D11 4U rack-mount NVR, 240TB storage, 2,400Mbps, HyperRAID and EcoSt",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-x424-240pu24-hr-8g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"4U"},
  },
  {
    id: "ss-wavestore-q14-4pu1-hr-4g-na-s11",
    manufacturer: "Wavestore",
    model: "Q14-4PU1-HR-4G-NA-S11",
    category: "nvr-recorder",
    tagline: "Wavestore Q14-4PU1-HR-4G-NA-S11 1U rack-mount NVR, 4TB storage, 1200Mbps, HyperRAID and EcoStore rea",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-q14-4pu1-hr-4g-na-s11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-wavestore-x424-80pu8-hr-6g-na-d11",
    manufacturer: "Wavestore",
    model: "X424-80PU8-HR-6G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore X424-80PU8-HR-6G-NA-D11 4U rack-mount NVR, 80TB storage, 1,800Mbps, HyperRAID and EcoStore",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-x424-80pu8-hr-6g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"4U"},
  },
  {
    id: "ss-wavestore-ac1-1pu1-nr-1g-na-s11",
    manufacturer: "Wavestore",
    model: "AC1-1PU1-NR-1G-NA-S11",
    category: "nvr-recorder",
    tagline: "Wavestore AC1-1PU1-NR-1G-NA-S11 compact desktop and VESA mount (bracket supplied) NVR, 1TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-ac1-1pu1-nr-1g-na-s11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true,"formFactor":"desktop"},
  },
  {
    id: "ss-wavestore-v212-120pu12-hr-4g-na-d11",
    manufacturer: "Wavestore",
    model: "V212-120PU12-HR-4G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore V212-120PU12-HR-4G-NA-D11 2U rack-mount NVR, 120TB storage, 1,200Mbps, HyperRAID and EcoSt",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-v212-120pu12-hr-4g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-wavestore-petablok",
    manufacturer: "Wavestore",
    model: "PetaBlok",
    category: "nvr-recorder",
    tagline: "Wavestore PetaBlok 254-channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-petablok-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":254,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-wavestore-ac1-2pu1-nr-1g-na-s11",
    manufacturer: "Wavestore",
    model: "AC1-2PU1-NR-1G-NA-S11",
    category: "nvr-recorder",
    tagline: "Wavestore AC1-2PU1-NR-1G-NA-S11 compact desktop and VESA mount (bracket supplied) NVR, 2TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-ac1-2pu1-nr-1g-na-s11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true,"formFactor":"desktop"},
  },
  {
    id: "ss-wavestore-e12-8pu1-nr-2g-na-s11",
    manufacturer: "Wavestore",
    model: "E12-8PU1-NR-2G-NA-S11",
    category: "nvr-recorder",
    tagline: "Wavestore E12-8PU1-NR-2G-NA-S11 1U rackmount NVR, 8TB storage, 300Mbps, EcoStore ready",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-e12-8pu1-nr-2g-na-s11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-wavestore-v212-60pu6-hr-4g-na-d11",
    manufacturer: "Wavestore",
    model: "V212-60PU6-HR-4G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore V212-60PU6-HR-4G-NA-D11 2U rack-mount NVR, 60TB storage, 1,200Mbps, HyperRAID and EcoStore",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-v212-60pu6-hr-4g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-wavestore-wr14-8gd1-nr-2g-na-s11",
    manufacturer: "Wavestore",
    model: "WR14-8GD1-NR-2G-NA-S11",
    category: "nvr-recorder",
    tagline: "Wavestore WR14-8GD1-NR-2G-NA-S11 1U rack-mount NVR, 8TB storage, single PSU",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-wr14-8gd1-nr-2g-na-s11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-wavestore-wr214-168gd14-r40-4g-na-d11",
    manufacturer: "Wavestore",
    model: "WR214-168GD14-R40-4G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore WR214-168GD14-R40-4G-NA-D11 2U rack-mount NVR, 168TB storage, RAID, dual PSU",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-wr214-168gd14-r40-4g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"],"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-wavestore-wr218-32gd4-r40-4g-na-d11",
    manufacturer: "Wavestore",
    model: "WR218-32GD4-R40-4G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore WR218-32GD4-R40-4G-NA-D11 2U rack-mount NVR, 32TB storage, RAID, dual PSU",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-wr218-32gd4-r40-4g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"],"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-wavestore-pt4-8pu1-nr-2g-na-s11",
    manufacturer: "Wavestore",
    model: "PT4-8PU1-NR-2G-NA-S11",
    category: "nvr-recorder",
    tagline: "Wavestore PT4-8PU1-NR-2G-NA-S11 Mini Tower NVR, 8TB Storage, 300Mbps, EcoStore Ready",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-pt4-8pu1-nr-2g-na-s11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-wavestore-pt4-40pu4-nr-2g-na-s11",
    manufacturer: "Wavestore",
    model: "PT4-40PU4-NR-2G-NA-S11",
    category: "nvr-recorder",
    tagline: "Wavestore PT4-40PU4-NR-2G-NA-S11 Mini Tower NVR, 40TB Storage, 300Mbps, EcoStore Ready",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-pt4-40pu4-nr-2g-na-s11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-wavestore-wr14-8gd1-nr-2g-na-d11",
    manufacturer: "Wavestore",
    model: "WR14-8GD1-NR-2G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore WR14-8GD1-NR-2G-NA-D11 1U rack-mount NVR, 8TB storage, dual PSU",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-wr14-8gd1-nr-2g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-wavestore-q14-20pu2-hr-4g-na-s11",
    manufacturer: "Wavestore",
    model: "Q14-20PU2-HR-4G-NA-S11",
    category: "nvr-recorder",
    tagline: "Wavestore Q14-20PU2-HR-4G-NA-S11 1U rack-mount NVR, 20TB storage, 1200Mbps, HyperRAID and EcoStore r",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-q14-20pu2-hr-4g-na-s11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-wavestore-wr214-72gd6-r40-4g-na-d11",
    manufacturer: "Wavestore",
    model: "WR214-72GD6-R40-4G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore WR214-72GD6-R40-4G-NA-D11 2U rack-mount NVR, 72TB storage, RAID, dual PSU",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-wr214-72gd6-r40-4g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"],"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-wavestore-wr218-96gd8-r40-4g-na-d11",
    manufacturer: "Wavestore",
    model: "WR218-96GD8-R40-4G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore WR218-96GD8-R40-4G-NA-D11 2U rack-mount NVR, 96TB storage, RAID, dual PSU",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-wr218-96gd8-r40-4g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"],"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-wavestore-e12-8pu1-nr-2g-16a-s11",
    manufacturer: "Wavestore",
    model: "E12-8PU1-NR-2G-16A-S11",
    category: "nvr-recorder",
    tagline: "Wavestore E12-8PU1-NR-2G-16A-S11 1U rackmount HVR, 8TB storage, 300Mbps, EcoStore ready",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-e12-8pu1-nr-2g-16a-s11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-wavestore-wr214-32gd4-r40-4g-na-d11",
    manufacturer: "Wavestore",
    model: "WR214-32GD4-R40-4G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore WR214-32GD4-R40-4G-NA-D11 2U rack-mount NVR, 32TB storage, RAID, dual PSU",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-wr214-32gd4-r40-4g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"],"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-wavestore-wr14-48gd4-nr-2g-na-d11",
    manufacturer: "Wavestore",
    model: "WR14-48GD4-NR-2G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore WR14-48GD4-NR-2G-NA-D11 1U rack-mount NVR, 40TB storage, dual PSU",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-wr14-48gd4-nr-2g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-wavestore-wr218-216gd18-r40-4g-na-d11",
    manufacturer: "Wavestore",
    model: "WR218-216GD18-R40-4G-NA-D11",
    category: "nvr-recorder",
    tagline: "Wavestore WR218-216GD18-R40-4G-NA-D11 2U rack-mount NVR, 216TB storage, RAID, dual PSU",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-wr218-216gd18-r40-4g-na-d11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"raidLevels":["5"],"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-wavestore-pt4-20pu2-nr-2g-na-s11",
    manufacturer: "Wavestore",
    model: "PT4-20PU2-NR-2G-NA-S11",
    category: "nvr-recorder",
    tagline: "Wavestore PT4-20PU2-NR-2G-NA-S11 Mini Tower NVR, 20TB Storage, 300Mbps, EcoStore Ready",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/wavestore-pt4-20pu2-nr-2g-na-s11-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"],"onvif":true},
  },
  {
    id: "ss-truvision-tvn-2116p-16t",
    manufacturer: "TruVision",
    model: "TVN-2116P-16T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2116P-16T 16TB 16 IP channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2116p-16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-4004-24-4t",
    manufacturer: "TruVision",
    model: "TVN-4004-24-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-4004-24-4T 24 channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-4004-24-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2132p-16t",
    manufacturer: "TruVision",
    model: "TVN-2132P-16T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2132P-16T 16TB 32 IP channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2132p-16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2016-4t",
    manufacturer: "TruVision",
    model: "TVN-2016-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2016-4T 16-channel 4TB IP camera network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2016-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-truvision-tve-400",
    manufacturer: "TruVision",
    model: "TVE-400",
    category: "nvr-recorder",
    tagline: "TruVision TVE-400 4 channel analogue to IP video encoder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tve-400-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvn-2132p-4t",
    manufacturer: "TruVision",
    model: "TVN-2132P-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2132P-4T 4TB 32 IP channels NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2132p-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2116-2t",
    manufacturer: "TruVision",
    model: "TVN-2116-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2116-2T 16-channel 2TB network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2116-2t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2008-8t",
    manufacturer: "TruVision",
    model: "TVN-2008-8T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2008-8T 8-channel 8TB IP camera network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2008-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2116-8t",
    manufacturer: "TruVision",
    model: "TVN-2116-8T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2116-8T 16 channels, 8TB Storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2116-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-5032-12t",
    manufacturer: "TruVision",
    model: "TVN-5032-12T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-5032-12T 32 channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-5032-12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2132p-12t",
    manufacturer: "TruVision",
    model: "TVN-2132P-12T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2132P-12T 12TB 32 IP channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2132p-12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2016-16t",
    manufacturer: "TruVision",
    model: "TVN-2016-16T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2016-16T 16-Ch IP Camera Network Video Recorder, 16TB Storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2016-16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2108-4t",
    manufacturer: "TruVision",
    model: "TVN-2108-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2108-4T 8-channel 4TB network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2108-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn5032",
    manufacturer: "TruVision",
    model: "TVN5032",
    category: "nvr-recorder",
    tagline: "Interlogix TruVision TVN5032 32 IP Channel Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn5032-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2116-4t",
    manufacturer: "TruVision",
    model: "TVN-2116-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2116-4T 16-channel 4TB network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2116-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2116p-12t",
    manufacturer: "TruVision",
    model: "TVN-2116P-12T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2116P-12T 12TB 16 IP channels NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2116p-12t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2132p-8t",
    manufacturer: "TruVision",
    model: "TVN-2132P-8T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2132P-8T 8TB 32 IP channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2132p-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2116p-8t",
    manufacturer: "TruVision",
    model: "TVN-2116P-8T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2116P-8T 8TB 16 IP channels NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2116p-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2116p-4t",
    manufacturer: "TruVision",
    model: "TVN-2116P-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2116P-4T 4TB 16 IP channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2116p-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2008-4t",
    manufacturer: "TruVision",
    model: "TVN-2008-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2008-4T 8-channel 4TB IP camera network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2008-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2108p-8t",
    manufacturer: "TruVision",
    model: "TVN-2108P-8T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2108P-8T 8-channel 8TB IP network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2108p-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2108-8t",
    manufacturer: "TruVision",
    model: "TVN-2108-8T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2108-8T 8-channel 8TB network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2108-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-5032-16t",
    manufacturer: "TruVision",
    model: "TVN-5032-16T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-5032-16T 16TB 32 IP channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-5032-16t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvn-2108-2t",
    manufacturer: "TruVision",
    model: "TVN-2108-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2108-2T 8-channel 2TB network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2108-2t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-5032-4t",
    manufacturer: "TruVision",
    model: "TVN-5032-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-5032-4T 4TB 32 IP channels NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-5032-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvn-5032-8t",
    manufacturer: "TruVision",
    model: "TVN-5032-8T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-5032-8T 8TB 32 IP channels NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-5032-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-truvision-tvn-2016-8t",
    manufacturer: "TruVision",
    model: "TVN-2016-8T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2016-8T 16-Ch IP Camera Network Video Recorder, 8TB Storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2016-8t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2008-2t",
    manufacturer: "TruVision",
    model: "TVN-2008-2T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2008-2T 8-Channel IP Camera Network Video Recorder, 2TB Storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2008-2t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-truvision-tvn-2108p-4t",
    manufacturer: "TruVision",
    model: "TVN-2108P-4T",
    category: "nvr-recorder",
    tagline: "TruVision TVN-2108P-4T 8-channel 4TB network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truvision-tvn-2108p-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-adpro-fasttrace-2-hybrid",
    manufacturer: "ADPRO",
    model: "FastTrace 2 Hybrid",
    category: "nvr-recorder",
    tagline: "Xtralis introduces its latest ADPRO FastTrace 2 video and audio transmission, recording and analysis",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-fasttrace-2-hybrid-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55500200",
    manufacturer: "ADPRO",
    model: "55500200",
    category: "nvr-recorder",
    tagline: "ADPRO 55500200 - 16 IP channel TX only FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comm",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55500200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55100100",
    manufacturer: "ADPRO",
    model: "55100100",
    category: "nvr-recorder",
    tagline: "ADPRO 55100100 - 8 channel TX only FastTrace 2 hybrid with 8 monitoreed I/P, 4 relay O/P, 1 comms. &",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55100100-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-53002001",
    manufacturer: "ADPRO",
    model: "53002001",
    category: "nvr-recorder",
    tagline: "ADPRO 53002001 - 4 channel 500 GB FastTrace 2 Lite with 8 monitored I/P , 4 Rela O/P , 1 comms. & No",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-53002001-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55000100",
    manufacturer: "ADPRO",
    model: "55000100",
    category: "nvr-recorder",
    tagline: "ADPRO 55000100 - 4 channel TX only FastTrace 2 hybrid with 8 monitored I/P. 4 relay o/P, 1 comms. & ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55000100-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55300200",
    manufacturer: "ADPRO",
    model: "55300200",
    category: "nvr-recorder",
    tagline: "ADPRO 55300200 - 16 channel TX only FastTrace 2 Hybrid with 20 monitored I/P 8 relay O/P, 1 comms & ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55300200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-fasttrace-2-hybrid-tx",
    manufacturer: "ADPRO",
    model: "FastTrace 2 Hybrid Tx",
    category: "nvr-recorder",
    tagline: "ADPRO FastTrace 2 Hybrid Tx network video and audio event recorder / transmitter",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-fasttrace-2-hybrid-tx-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55001100",
    manufacturer: "ADPRO",
    model: "55001100",
    category: "nvr-recorder",
    tagline: "ADPRO 55000100 - 4 channel 500 GB FastTrace 2 hybrid with 8 monitored I/P. 4 relay o/P, 1 comms. & N",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55001100-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55400100",
    manufacturer: "ADPRO",
    model: "55400100",
    category: "nvr-recorder",
    tagline: "ADPRO 55400100 - 8 IP channel TX only FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comms",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55400100-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55700200",
    manufacturer: "ADPRO",
    model: "55700200",
    category: "nvr-recorder",
    tagline: "ADPRO 55700200 - 8 channel / 8 IP channel TX only FastTrace 2 Hybrid with 20 monitored I/P, 8 relay ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55700200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55302200",
    manufacturer: "ADPRO",
    model: "55302200",
    category: "nvr-recorder",
    tagline: "ADPRO 55302200 - 16 channel 1 TB FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comms & no",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55302200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55200200",
    manufacturer: "ADPRO",
    model: "55200200",
    category: "nvr-recorder",
    tagline: "ADPRO 55200200 - 12 channel TX only FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comms &",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55200200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":12,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55403200",
    manufacturer: "ADPRO",
    model: "55403200",
    category: "nvr-recorder",
    tagline: "ADPRO 55403200 - 8 IP channel 2 TB FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comms & ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55403200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55201200",
    manufacturer: "ADPRO",
    model: "55201200",
    category: "nvr-recorder",
    tagline: "ADPRO 55201200 - 12 channel 500GB FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comms & n",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55201200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":12,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55302210",
    manufacturer: "ADPRO",
    model: "55302210",
    category: "nvr-recorder",
    tagline: "ADPRO 55302210 - 16 channel 1 TB FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comms & DT",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55302210-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55505200",
    manufacturer: "ADPRO",
    model: "55505200",
    category: "nvr-recorder",
    tagline: "ADPRO 55505200 - 16 IP Channel 4 TB FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comms &",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55505200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55509200",
    manufacturer: "ADPRO",
    model: "55509200",
    category: "nvr-recorder",
    tagline: "ADPRO 55509200 - 16 IP channel 8 TB FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comms &",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55509200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-fasttrace-2-lite",
    manufacturer: "ADPRO",
    model: "FastTrace 2 Lite",
    category: "nvr-recorder",
    tagline: "ADPRO FastTrace 2 Lite multi-site video security system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-fasttrace-2-lite-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55102100",
    manufacturer: "ADPRO",
    model: "55102100",
    category: "nvr-recorder",
    tagline: "ADPRO 55102100 - 8 channel 1 TB FastTrace 2 Hybrid with 8 monitored I/P, 4 comms relay O/P, 1 comms.",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55102100-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55703200",
    manufacturer: "ADPRO",
    model: "55703200",
    category: "nvr-recorder",
    tagline: "ADPRO 55703200 - 8 channel / 8 IP channel 2 TB FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55703200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55202200",
    manufacturer: "ADPRO",
    model: "55202200",
    category: "nvr-recorder",
    tagline: "ADPRO 55202200 - 12 channel 1 TB FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comms & no",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55202200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":12,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55503200",
    manufacturer: "ADPRO",
    model: "55503200",
    category: "nvr-recorder",
    tagline: "ADPRO 55503200 - 16 IP channel 2 TB FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comms &",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55503200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55301200",
    manufacturer: "ADPRO",
    model: "55301200",
    category: "nvr-recorder",
    tagline: "ADPRO 55301200 - 16 channel 500 GB FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P, 1 comms & ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55301200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55101100",
    manufacturer: "ADPRO",
    model: "55101100",
    category: "nvr-recorder",
    tagline: "ADPRO 55101100 - 8 channel 500 GB FastTrace 2 Hybrid with 8 monitored I/P, 4 relay O/P, 1 comms & no",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55101100-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55303200",
    manufacturer: "ADPRO",
    model: "55303200",
    category: "nvr-recorder",
    tagline: "ADPRO 55303200 - 16 channel 2 TB FastTrace 2 hybrid with 20 monitored I/P, 8 relay O/P, 1 comms & no",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55303200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55705200",
    manufacturer: "ADPRO",
    model: "55705200",
    category: "nvr-recorder",
    tagline: "ADPRO 55705200 - 8 channel / 8 IP channel 4 TB FastTrace 2 Hybrid with 20 monitored I/P, 8 relay O/P",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55705200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-adpro-55101110",
    manufacturer: "ADPRO",
    model: "55101110",
    category: "nvr-recorder",
    tagline: "ADPRO 55101110 - 8 channel 500 GB FastTrace 2 hybrid with 8 monitored I/P, 4 relay O/P, 1 comms. & D",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/adpro-55101110-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-ganz-nr8hl-4tb",
    manufacturer: "Ganz",
    model: "NR8HL/4TB",
    category: "nvr-recorder",
    tagline: "Ganz NR8HL/4TB 8 channel network video recorder with 4TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-nr8hl-4tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-ganz-zns-csr32nvr-6tb",
    manufacturer: "Ganz",
    model: "ZNS-CSR32NVR/6TB",
    category: "nvr-recorder",
    tagline: "Ganz ZNS-CSR32NVR/6TB network video recorder for demanding security applications",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-csr32nvr-6tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-ganz-nr8hl-2tb",
    manufacturer: "Ganz",
    model: "NR8HL/2TB",
    category: "nvr-recorder",
    tagline: "Ganz NR8HL/2TB 8 channel network video recorder with 2TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-nr8hl-2tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-ganz-nr4hl-2tb",
    manufacturer: "Ganz",
    model: "NR4HL/2TB",
    category: "nvr-recorder",
    tagline: "Ganz NR4HL/2TB 4 channel network video recorder with 2TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-nr4hl-2tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-ganz-zns-csr16nvr-4tb",
    manufacturer: "Ganz",
    model: "ZNS-CSR16NVR/4TB",
    category: "nvr-recorder",
    tagline: "Ganz ZNS-CSR16NVR/4TB network video recorder with H.264, MPEG-4, MJPEG support",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-csr16nvr-4tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-ganz-zns-csr32nvr-4tb",
    manufacturer: "Ganz",
    model: "ZNS-CSR32NVR/4TB",
    category: "nvr-recorder",
    tagline: "Ganz ZNS-CSR32NVR/4TB network video recorder with integrated recording and playback functions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-csr32nvr-4tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-ganz-zns-cstpc4",
    manufacturer: "Ganz",
    model: "ZNS-CSTPC4",
    category: "nvr-recorder",
    tagline: "Ganz ZNS-CSTPC4 network video recorder with display and recording functions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-cstpc4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-ganz-zns-csr32nvr-3tb",
    manufacturer: "Ganz",
    model: "ZNS-CSR32NVR/3TB",
    category: "nvr-recorder",
    tagline: "Ganz ZNS-CSR32NVR/3TB network video recorder with 32 real time video streams recording capability",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-csr32nvr-3tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-ganz-zns-csrs16nvr-2tb",
    manufacturer: "Ganz",
    model: "ZNS-CSRS16NVR/2TB",
    category: "nvr-recorder",
    tagline: "Ganz ZNS-CSRS16NVR/2TB network video recorder with open platform",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-csrs16nvr-2tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-ganz-zns-csr16nvr-3tb",
    manufacturer: "Ganz",
    model: "ZNS-CSR16NVR/3TB",
    category: "nvr-recorder",
    tagline: "Ganz ZNS-CSR16NVR/3TB network video recorder with multiple storage options",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-csr16nvr-3tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-ganz-nr4hl-1tb",
    manufacturer: "Ganz",
    model: "NR4HL/1TB",
    category: "nvr-recorder",
    tagline: "Ganz NR4HL/1TB 4 channel network video recorder with 1TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-nr4hl-1tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-ganz-c-mph04-ii-500",
    manufacturer: "Ganz",
    model: "C-MPH04-II/500",
    category: "nvr-recorder",
    tagline: "Ganz C-MPH04-II/500 4-channel H.264 network DVR with DVD writer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-c-mph04-ii-500-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-ganz-c-mph08-ii-1tb",
    manufacturer: "Ganz",
    model: "C-MPH08-II/1TB",
    category: "nvr-recorder",
    tagline: "Ganz C-MPH08-II/1TB 8-channel H.264 network DVR with DVD writer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-c-mph08-ii-1tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-ganz-c-mph16-ii-2tb",
    manufacturer: "Ganz",
    model: "C-MPH16-II/2TB",
    category: "nvr-recorder",
    tagline: "Ganz C-MPH16-II/2TB 16-channel H.264 network DVR with DVD writer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-c-mph16-ii-2tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-ganz-c-mph08-ii-500",
    manufacturer: "Ganz",
    model: "C-MPH08-II/500",
    category: "nvr-recorder",
    tagline: "C-MPH08-II/500 8-channel H.264 network DVR with DVD writer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-c-mph08-ii-500-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-ganz-c-mph16-ii-1tb",
    manufacturer: "Ganz",
    model: "C-MPH16-II/1TB",
    category: "nvr-recorder",
    tagline: "Ganz C-MPH16-II/1TB 16-channel H.264 network DVR with DVD writer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-c-mph16-ii-1tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-ganz-zns-cstpc8",
    manufacturer: "Ganz",
    model: "ZNS-CSTPC8",
    category: "nvr-recorder",
    tagline: "Ganz ZNS-CSTPC8 network video recorder with 1000 GB on board storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-cstpc8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-ganz-zns-cstpc16",
    manufacturer: "Ganz",
    model: "ZNS-CSTPC16",
    category: "nvr-recorder",
    tagline: "Ganz ZNS-CSTPC16 network video recorder for small to medium applications",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-cstpc16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-ganz-zns-cstspc16",
    manufacturer: "Ganz",
    model: "ZNS-CSTSPC16",
    category: "nvr-recorder",
    tagline: "CBC’s GANZ VSoIP GO - the smart & simple IP Video Management System for cost-effective surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-cstspc16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-ganz-zns-cstspc8",
    manufacturer: "Ganz",
    model: "ZNS-CSTSPC8",
    category: "nvr-recorder",
    tagline: "Ganz ZNS-CSTSPC8 network video recorder with multi camera display",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-cstspc8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-ganz-zns-cstspc4",
    manufacturer: "Ganz",
    model: "ZNS-CSTSPC4",
    category: "nvr-recorder",
    tagline: "Ganz ZNS-CSTSPC4 network video recorder with support for megapixel cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ganz-zns-cstspc4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-nvr-as-4000",
    manufacturer: "IndigoVision",
    model: "NVR-AS 4000",
    category: "nvr-recorder",
    tagline: "IndigoVision Compact NVR-AS 4000 network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-nvr-as-4000-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-platinum-client-workstation",
    manufacturer: "IndigoVision",
    model: "Platinum Client Workstation",
    category: "nvr-recorder",
    tagline: "IndigoVision Platinum Client Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-platinum-client-workstation-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-integra-16-12tb",
    manufacturer: "IndigoVision",
    model: "Integra 16 12TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Integra 16 12TB with 16 camera license",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-integra-16-12tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-ra2000",
    manufacturer: "IndigoVision",
    model: "RA2000",
    category: "nvr-recorder",
    tagline: "IndigoVision RA2000 NVR-AS 3000 with 4x hard disks RAID Array",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-ra2000-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-ra6000",
    manufacturer: "IndigoVision",
    model: "RA6000",
    category: "nvr-recorder",
    tagline: "IndigoVision RA6000 RAID Array unit with 4x hard disks",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-ra6000-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-enterprise-nvr-as-36tb",
    manufacturer: "IndigoVision",
    model: "Enterprise NVR-AS 36TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Enterprise NVR-AS 36TB 1U network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-enterprise-nvr-as-36tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-indigovision-integra-8-2tb",
    manufacturer: "IndigoVision",
    model: "Integra 8 2TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Integra 8 2TB with 8 camera license",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-integra-8-2tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-compact-nvr-as-12tb",
    manufacturer: "IndigoVision",
    model: "Compact NVR-AS 12TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Compact NVR-AS 12TB network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-compact-nvr-as-12tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-integra-8-4tb",
    manufacturer: "IndigoVision",
    model: "Integra 8 4TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Integra 8 4TB with 8 camera license",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-integra-8-4tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-hybrid-nvr-workstation",
    manufacturer: "IndigoVision",
    model: "Hybrid NVR Workstation",
    category: "nvr-recorder",
    tagline: "IndigoVision Hybrid NVR Workstation 8TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-hybrid-nvr-workstation-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-integra-24-24tb",
    manufacturer: "IndigoVision",
    model: "Integra 24 24TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Integra 24 24TB with 24 camera license",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-integra-24-24tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-compact-nvr-as-4tb",
    manufacturer: "IndigoVision",
    model: "Compact NVR-AS 4TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Compact NVR-AS 4TB network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-compact-nvr-as-4tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-compact-nvr-as-1tb",
    manufacturer: "IndigoVision",
    model: "Compact NVR-AS 1TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Compact NVR-AS 1TB network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-compact-nvr-as-1tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-enterprise-nvr-as-12tb",
    manufacturer: "IndigoVision",
    model: "Enterprise NVR-AS 12TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Enterprise NVR-AS 12TB 1U network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-enterprise-nvr-as-12tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-indigovision-enterprise-nvr-as-24tb",
    manufacturer: "IndigoVision",
    model: "Enterprise NVR-AS 24TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Enterprise NVR-AS 24TB 1U network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-enterprise-nvr-as-24tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-indigovision-rd1000",
    manufacturer: "IndigoVision",
    model: "RD1000",
    category: "nvr-recorder",
    tagline: "IndigoVision RD1000 compact NVR-AS 3000 Series with 1000 GB disc space",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-rd1000-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true},
  },
  {
    id: "ss-indigovision-integra-24-18tb",
    manufacturer: "IndigoVision",
    model: "Integra 24 18TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Integra 24 18TB with 24 camera license",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-integra-24-18tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-integra-view-mid-workstation",
    manufacturer: "IndigoVision",
    model: "Integra View Mid Workstation",
    category: "nvr-recorder",
    tagline: "IndigoVision Integra View Mid Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-integra-view-mid-workstation-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-integra-16-6tb",
    manufacturer: "IndigoVision",
    model: "Integra 16 6TB",
    category: "nvr-recorder",
    tagline: "IndigoVision Integra 16 6TB with 16 camera license",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-integra-16-6tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-indigovision-pro-client-workstation",
    manufacturer: "IndigoVision",
    model: "Pro Client Workstation",
    category: "nvr-recorder",
    tagline: "IndigoVision Pro Client Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-pro-client-workstation-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264","H.265","MJPEG"]},
  },
  {
    id: "ss-indigovision-mini-client-workstation",
    manufacturer: "IndigoVision",
    model: "Mini Client Workstation",
    category: "nvr-recorder",
    tagline: "IndigoVision Mini Client Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/indigovision-mini-client-workstation-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-uniview-unv-nvr301-08s4-lw",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-08S4-LW",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-08S4-LW 1 Hdd 8-Ch WIFI Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-08s4-lw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-uniview-unv-nvr301-08s3",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-08S3",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-08S3 8-ch Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-08s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-uniview-unv-nvr301-16s3-p8",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-16S3-P8",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-16S3-P8 16-ch Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-16s3-p8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-uniview-unv-nvr301-16b-lp8-iq",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-16B-LP8-IQ",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-16B-LP8-IQ 16-ch Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-16b-lp8-iq-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-uniview-unv-nvr301-16ls3-p8",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-16LS3-P8",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-16LS3-P8 16-ch Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-16ls3-p8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-uniview-unv-nvr301-08s3-p8",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-08S3-P8",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-08S3-P8 8-ch Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-08s3-p8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-uniview-unv-nvr301-04b-lp4-iq",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-04B-LP4-IQ",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-04B-LP4-IQ 1 HDD 4-ch 4 PoE 1U Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-04b-lp4-iq-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-uniview-unv-nvr301-16s3",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-16S3",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-16S3 16-ch Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-16s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-uniview-unv-nvr301-08ls3-p8",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-08LS3-P8",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-08LS3-P8 8-ch Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-08ls3-p8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-uniview-unv-nvr301-08b-p8-iq",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-08B-P8-IQ",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-08B-P8-IQ 8-ch Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-08b-p8-iq-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-uniview-unv-nvr301-04s3",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-04S3",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-04S3 4-ch Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-04s3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"]},
  },
  {
    id: "ss-uniview-unv-nvr301-04s3-p4",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-04S3-P4",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-04S3-P4 4-ch 4 PoE 1U Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-04s3-p4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"formFactor":"1U"},
  },
  {
    id: "ss-uniview-unv-nvr301-16b-iq",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-16B-IQ",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-16B-IQ 16-ch 1U Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-16b-iq-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-uniview-unv-nvr301-08b-iq",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-08B-IQ",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-08B-IQ 8-ch 1U Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-08b-iq-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-uniview-unv-nvr301-04ls3-p4",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-04LS3-P4",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-04LS3-P4 4-ch Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-04ls3-p4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-uniview-unv-nvr301-08b-lp8-iq",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-08B-LP8-IQ",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-08B-LP8-IQ 8-ch Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-08b-lp8-iq-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-uniview-unv-nvr301-04b-iq",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-04B-IQ",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-04B-IQ 4-ch 1U Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-04b-iq-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-uniview-unv-nvr301-04b-p4-iq",
    manufacturer: "Uniview (UNV)",
    model: "NVR301-04B-P4-IQ",
    category: "nvr-recorder",
    tagline: "Uniview (UNV) NVR301-04B-P4-IQ 1 HDD 4-ch 4 PoE 1U Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/uniview-unv-nvr301-04b-p4-iq-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true,"formFactor":"1U"},
  },
  {
    id: "ss-veracity-cstore8-2ud-nx-eu",
    manufacturer: "Veracity",
    model: "CSTORE8-2UD-NX-EU",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE8-2UD-NX-EU COLDSTORE 8-Bay 2U unit, embedded Nx Witness VMS, dual PSU & EU power cab",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore8-2ud-nx-eu-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-veracity-cstore8-2u-nx-eu",
    manufacturer: "Veracity",
    model: "CSTORE8-2U-NX-EU",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE8-2U-NX-EU COLDSTORE 8-Bay 2U unit, embedded Nx Witness VMS, single PSU & EU power ca",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore8-2u-nx-eu-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-veracity-cstore45-4u-nx-uk",
    manufacturer: "Veracity",
    model: "CSTORE45-4U-NX-UK",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE45-4U-NX-UK COLDSTORE 45-Bay 4U Colossus, embedded Nx Witness VMS, dual PSU & UK cabl",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore45-4u-nx-uk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"4U"},
  },
  {
    id: "ss-veracity-cstore45-4u-nx-eu",
    manufacturer: "Veracity",
    model: "CSTORE45-4U-NX-EU",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE45-4U-NX-EU COLDSTORE 45-Bay 4U Colossus, embedded Nx Witness VMS, dual PSU & EU cabl",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore45-4u-nx-eu-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"4U"},
  },
  {
    id: "ss-veracity-cstore8-2u-uk",
    manufacturer: "Veracity",
    model: "CSTORE8-2U-UK",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE8-2U-UK COLDSTORE 8-bay 2U unit, with UK power cables",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore8-2u-uk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-veracity-cstore15-3u-pro-nx-uk",
    manufacturer: "Veracity",
    model: "CSTORE15-3U-PRO-NX-UK",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE15-3U-PRO-NX-UK COLDSTORE 15-Bay 3U Pro, embedded Nx Witness VMS, dual PSU & UK power",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore15-3u-pro-nx-uk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"3U"},
  },
  {
    id: "ss-veracity-cstore8-2u-nx-uk",
    manufacturer: "Veracity",
    model: "CSTORE8-2U-NX-UK",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE8-2U-NX-UK COLDSTORE 8-Bay 2U unit, embedded Nx Witness VMS, single PSU & UK power ca",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore8-2u-nx-uk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-veracity-cstream-key",
    manufacturer: "Veracity",
    model: "CSTREAM-KEY",
    category: "nvr-recorder",
    tagline: "Veracity CSTREAM-KEY COLDSTREAM embedded NVR channel key",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstream-key-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-veracity-cstore15-3u-pro-nx-eu",
    manufacturer: "Veracity",
    model: "CSTORE15-3U-PRO-NX-EU",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE15-3U-PRO-NX-EU COLDSTORE 15-Bay 3U Pro, embedded Nx Witness VMS, dual PSU & EU power",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore15-3u-pro-nx-eu-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"3U"},
  },
  {
    id: "ss-veracity-cstore8-2ud-nx-uk",
    manufacturer: "Veracity",
    model: "CSTORE8-2UD-NX-UK",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE8-2UD-NX-UK COLDSTORE 8-Bay 2U unit, embedded Nx Witness VMS, dual PSU & UK power cab",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore8-2ud-nx-uk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-veracity-cstore8-2u-eu",
    manufacturer: "Veracity",
    model: "CSTORE8-2U-EU",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE8-2U-EU COLDSTORE 8-bay 2U unit, with EU power cables",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore8-2u-eu-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-veracity-cstore8-2u-us",
    manufacturer: "Veracity",
    model: "CSTORE8-2U-US",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE8-2U-US COLDSTORE 8-bay 2U unit, with USA power cables",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore8-2u-us-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"2U"},
  },
  {
    id: "ss-veracity-cstore45-4u-us",
    manufacturer: "Veracity",
    model: "CSTORE45-4U-US",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE45-4U-US 45-bay version of COLDSTORE® surveillance storage system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore45-4u-us-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"4U"},
  },
  {
    id: "ss-veracity-cstore45-4u-eu",
    manufacturer: "Veracity",
    model: "CSTORE45-4U-EU",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE45-4U-EU 45-bay version of COLDSTORE® surveillance storage system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore45-4u-eu-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"4U"},
  },
  {
    id: "ss-veracity-cstore15-3u-pro-us",
    manufacturer: "Veracity",
    model: "CSTORE15-3U-PRO-US",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE15-3U-PRO-US surveillance storage system - COLDSTORE 15-bay 3U Pro unit, with USA pow",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore15-3u-pro-us-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"3U"},
  },
  {
    id: "ss-veracity-cstore15-3u-pro-uk",
    manufacturer: "Veracity",
    model: "CSTORE15-3U-PRO-UK",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE15-3U-PRO-UK surveillance storage system - COLDSTORE 15-bay 3U Pro unit, with UK powe",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore15-3u-pro-uk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"3U"},
  },
  {
    id: "ss-veracity-cstore45-4u-uk",
    manufacturer: "Veracity",
    model: "CSTORE45-4U-UK",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE45-4U-UK 45-bay version of COLDSTORE® surveillance storage system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore45-4u-uk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"4U"},
  },
  {
    id: "ss-veracity-cstore15-3u-pro-eu",
    manufacturer: "Veracity",
    model: "CSTORE15-3U-PRO-EU",
    category: "nvr-recorder",
    tagline: "Veracity CSTORE15-3U-PRO-EU surveillance storage system - COLDSTORE 15-bay 3U Pro unit, with EU powe",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/veracity-cstore15-3u-pro-eu-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"onvif":true,"formFactor":"3U"},
  },
  {
    id: "ss-flir-systems-uss-mr16-g5-04tb",
    manufacturer: "FLIR Systems",
    model: "USS-MR16-G5-04TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-MR16-G5-04TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-mr16-g5-04tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-mr08pe02l",
    manufacturer: "FLIR Systems",
    model: "MR08PE02L",
    category: "nvr-recorder",
    tagline: "FLIR Systems MR08PE02L Meridian NVR 8 Channels 2TB POE Switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-mr08pe02l-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-flir-systems-uss-edge-g5-12tb",
    manufacturer: "FLIR Systems",
    model: "USS-EDGE-G5-12TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-EDGE-G5-12TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-edge-g5-12tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-uss-mr24-g5-16tb",
    manufacturer: "FLIR Systems",
    model: "USS-MR24-G5-16TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-MR24-G5-16TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-mr24-g5-16tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-uss-mr24-g5-08tb",
    manufacturer: "FLIR Systems",
    model: "USS-MR24-G5-08TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-MR24-G5-08TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-mr24-g5-08tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-uss-edge-g5-08tb",
    manufacturer: "FLIR Systems",
    model: "USS-EDGE-G5-08TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-EDGE-G5-08TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-edge-g5-08tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-uss-mr24-g5-12tb",
    manufacturer: "FLIR Systems",
    model: "USS-MR24-G5-12TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-MR24-G5-12TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-mr24-g5-12tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-uss-mr24-g5-20tb",
    manufacturer: "FLIR Systems",
    model: "USS-MR24-G5-20TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-MR24-G5-20TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-mr24-g5-20tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-uss-edge-g5-02tb",
    manufacturer: "FLIR Systems",
    model: "USS-EDGE-G5-02TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-EDGE-G5-02TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-edge-g5-02tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-uss-edge-g5-16tb",
    manufacturer: "FLIR Systems",
    model: "USS-EDGE-G5-16TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-EDGE-G5-16TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-edge-g5-16tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-uss-mr08-g5-02tb",
    manufacturer: "FLIR Systems",
    model: "USS-MR08-G5-02TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-MR08-G5-02TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-mr08-g5-02tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-uss-edge-g5-04tb",
    manufacturer: "FLIR Systems",
    model: "USS-EDGE-G5-04TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-EDGE-G5-04TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-edge-g5-04tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-uss-edge-g5-20tb",
    manufacturer: "FLIR Systems",
    model: "USS-EDGE-G5-20TB",
    category: "nvr-recorder",
    tagline: "FLIR Systems USS-EDGE-G5-20TB Compact IP Video Appliance with Built-in PoE",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-uss-edge-g5-20tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-flir-systems-mr16pe04l",
    manufacturer: "FLIR Systems",
    model: "MR16PE04L",
    category: "nvr-recorder",
    tagline: "FLIR Systems MR16PE04L Meridian NVR 16 Channels 4TB POE Switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-mr16pe04l-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-flir-systems-horizon",
    manufacturer: "FLIR Systems",
    model: "Horizon",
    category: "nvr-recorder",
    tagline: "FLIR Systems Horizon 24 Channels 18TB NVR Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-horizon-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1},
  },
  {
    id: "ss-flir-systems-mr24pe06l",
    manufacturer: "FLIR Systems",
    model: "MR24PE06L",
    category: "nvr-recorder",
    tagline: "FLIR Systems MR24PE06L Meridian NVR 24 channels 6TB POE Switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/flir-systems-mr24pe06l-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":24,"hddBays":1},
  },
  {
    id: "ss-promise-technology-a2600",
    manufacturer: "Promise Technology",
    model: "A2600",
    category: "nvr-recorder",
    tagline: "Promise Technology A2600 16 drives NVR storage appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a2600-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-a2200",
    manufacturer: "Promise Technology",
    model: "A2200",
    category: "nvr-recorder",
    tagline: "Promise Technology A2200 NVR storage appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a2200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-a7600",
    manufacturer: "Promise Technology",
    model: "A7600",
    category: "nvr-recorder",
    tagline: "Promise Technology A7600 Storage Solutions Designed for Surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a7600-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-a6800",
    manufacturer: "Promise Technology",
    model: "A6800",
    category: "nvr-recorder",
    tagline: "Promise Technology A6800 Extensive VMS Support",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a6800-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-a2330",
    manufacturer: "Promise Technology",
    model: "A2330",
    category: "nvr-recorder",
    tagline: "Promise Technology highlights commitment to training and partner ecosystem at ASIS 2016",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a2330-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-a3340d",
    manufacturer: "Promise Technology",
    model: "A3340d",
    category: "nvr-recorder",
    tagline: "Promise Technology A3340d 8GB NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a3340d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-a6600",
    manufacturer: "Promise Technology",
    model: "A6600",
    category: "nvr-recorder",
    tagline: "Promise Technology A6600 Storage Solutions Designed for Surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a6600-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-a3340",
    manufacturer: "Promise Technology",
    model: "A3340",
    category: "nvr-recorder",
    tagline: "Promise Technology A3340 8 drives NVR appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a3340-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-vess-black-a6120-ms",
    manufacturer: "Promise Technology",
    model: "Vess Black (A6120-MS)",
    category: "nvr-recorder",
    tagline: "Promise Technology’s Vess A-Series Network Video Recorders certified with Bosch Video Management Sys",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-vess-black-a6120-ms-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-promise-technology-a7800",
    manufacturer: "Promise Technology",
    model: "A7800",
    category: "nvr-recorder",
    tagline: "Promise Technology A7800 Storage Solutions Designed for Surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a7800-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-a3120-cv",
    manufacturer: "Promise Technology",
    model: "A3120-CV",
    category: "nvr-recorder",
    tagline: "Promise Technology A3120-CV Storage Appliance for SMB/small installation video surveillance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a3120-cv-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-a4800",
    manufacturer: "Promise Technology",
    model: "A4800",
    category: "nvr-recorder",
    tagline: "Promise Technology A4800 NVR Storage Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a4800-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-a4600",
    manufacturer: "Promise Technology",
    model: "A4600",
    category: "nvr-recorder",
    tagline: "Promise Technology A4600 NVR Storage Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-a4600-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-promise-technology-vess-blue-a6120-rs",
    manufacturer: "Promise Technology",
    model: "Vess Blue (A6120-RS)",
    category: "nvr-recorder",
    tagline: "Promise Technology Vess Blue (A6120-RS) 8GB RAM NVR designed for general recording purposes",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-vess-blue-a6120-rs-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-promise-technology-vess-orange-a6120-as",
    manufacturer: "Promise Technology",
    model: "Vess Orange (A6120-AS)",
    category: "nvr-recorder",
    tagline: "Promise Technology Vess Orange (A6120-AS) 16GB RAM NVR designed for running intelligent video analyt",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/promise-technology-vess-orange-a6120-as-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-eagle-eye-networks-contract-vault",
    manufacturer: "Eagle Eye Networks",
    model: "Contract Vault",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks Contract Vault - cloud system for recording and archiving important transactions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-contract-vault-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-cmvr-420",
    manufacturer: "Eagle Eye Networks",
    model: "CMVR 420",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks CMVR 420 Rack Cloud Managed Video Recorders (CMVRs)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-cmvr-420-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-cmvr-320",
    manufacturer: "Eagle Eye Networks",
    model: "CMVR 320",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks CMVR 320 Rack Cloud Managed Video Recorders (CMVRs)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-cmvr-320-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-cmvr-430",
    manufacturer: "Eagle Eye Networks",
    model: "CMVR 430",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks CMVR 430 supports 16 analogue cameras or 32 HD IP cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-cmvr-430-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-ds200",
    manufacturer: "Eagle Eye Networks",
    model: "DS200",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks DS200 local dual display surveillance station",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-ds200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-ds100",
    manufacturer: "Eagle Eye Networks",
    model: "DS100",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks DS100 local single display surveillance station",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-ds100-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-cmvr-520",
    manufacturer: "Eagle Eye Networks",
    model: "CMVR 520",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks CMVR 520 Rack Cloud Managed Video Recorders (CMVRs)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-cmvr-520-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-cmvr-620",
    manufacturer: "Eagle Eye Networks",
    model: "CMVR 620",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks CMVR 620 Rack Cloud Managed Video Recorders (CMVRs)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-cmvr-620-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-cmvr-820",
    manufacturer: "Eagle Eye Networks",
    model: "CMVR 820",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks CMVR 820 Rack Cloud Managed Video Recorders (CMVRs)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-cmvr-820-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-cmvr-225",
    manufacturer: "Eagle Eye Networks",
    model: "CMVR 225",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks CMVR 225 small form factor wall mount Cloud Managed Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-cmvr-225-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-cmvr-330",
    manufacturer: "Eagle Eye Networks",
    model: "CMVR 330",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks CMVR 330 supports 8 analogue cameras or 16 HD IP cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-cmvr-330-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-cmvr-224",
    manufacturer: "Eagle Eye Networks",
    model: "CMVR 224",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks CMVR 224 small wall mount Cloud Managed Video Recorders (CMVRs)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-cmvr-224-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-cmvr-325",
    manufacturer: "Eagle Eye Networks",
    model: "CMVR 325",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks CMVR 325 small form factor wall mount Cloud Managed Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-cmvr-325-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-eagle-eye-networks-cmvr-324",
    manufacturer: "Eagle Eye Networks",
    model: "CMVR 324",
    category: "nvr-recorder",
    tagline: "Eagle Eye Networks CMVR 324 small wall mount Cloud Managed Video Recorders (CMVRs)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/eagle-eye-networks-cmvr-324-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
];

const PART_7: NvrEntry[] = [
  {
    id: "ss-video-storage-solutions-vss-14sd",
    manufacturer: "Video Storage Solutions",
    model: "VSS-14SD",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-14SD 1U 4-Bay Rackmount Video Recording Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-14sd-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-video-storage-solutions-mshx8r",
    manufacturer: "Video Storage Solutions",
    model: "MSHX8R",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions MSHX8R 2U 12-Bay rackmount video recording appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-mshx8r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["5"],"formFactor":"2U"},
  },
  {
    id: "ss-video-storage-solutions-vss-14",
    manufacturer: "Video Storage Solutions",
    model: "VSS-14",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-14 1U 4-Bay rackmount video recording appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-14-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["0"],"formFactor":"1U"},
  },
  {
    id: "ss-video-storage-solutions-vss-218",
    manufacturer: "Video Storage Solutions",
    model: "VSS-218",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-218 2U 18-Bay rackmount video appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-218-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-video-storage-solutions-vss-28-210",
    manufacturer: "Video Storage Solutions",
    model: "VSS-28-210",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-28-210 2U 8-Bay rackmount video appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-28-210-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-video-storage-solutions-vss-214",
    manufacturer: "Video Storage Solutions",
    model: "VSS-214",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-214 2U 14-Bay rackmount video appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-214-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-video-storage-solutions-vss-226",
    manufacturer: "Video Storage Solutions",
    model: "VSS-226",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-226 2U 26-Bay rackmount video recording appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-226-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-video-storage-solutions-vss-212",
    manufacturer: "Video Storage Solutions",
    model: "VSS-212",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-212 2U 12-Bay rackmount video recording appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-212-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-video-storage-solutions-vss-12sd",
    manufacturer: "Video Storage Solutions",
    model: "VSS-12SD",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-12SD 1U 2-Bay short depth video recording appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-12sd-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-video-storage-solutions-vss-sf1",
    manufacturer: "Video Storage Solutions",
    model: "VSS-SF1",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-SF1 1-Bay small form video appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-sf1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-video-storage-solutions-vss-t1",
    manufacturer: "Video Storage Solutions",
    model: "VSS-T1",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-T1 1-Bay mini tower video recording appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-t1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-video-storage-solutions-vss-t5",
    manufacturer: "Video Storage Solutions",
    model: "VSS-T5",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-T5 5-Bay tower client viewing station",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-t5-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-video-storage-solutions-vss-t3",
    manufacturer: "Video Storage Solutions",
    model: "VSS-T3",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-T3 3-Bay tower video appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-t3-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-video-storage-solutions-vss-m1",
    manufacturer: "Video Storage Solutions",
    model: "VSS-M1",
    category: "nvr-recorder",
    tagline: "Video Storage Solutions VSS-M1 1-Bay micro video appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/video-storage-solutions-vss-m1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-gvd-m640",
    manufacturer: "GVD",
    model: "M640",
    category: "nvr-recorder",
    tagline: "GVD M600 Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m640-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-gvd-m200",
    manufacturer: "GVD",
    model: "M200",
    category: "nvr-recorder",
    tagline: "GVD M200 network video recorder with easy video export function",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m200-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-gvd-m940",
    manufacturer: "GVD",
    model: "M940",
    category: "nvr-recorder",
    tagline: "GVD M940 network video recorder with high performance RAID card",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m940-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-gvd-m350",
    manufacturer: "GVD",
    model: "M350",
    category: "nvr-recorder",
    tagline: "GVD new product debut in IFSEC 2011",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m350-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-gvd-m150",
    manufacturer: "GVD",
    model: "M150",
    category: "nvr-recorder",
    tagline: "GVD M150 network video recorder with enhanced video decoding",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m150-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-gvd-m100",
    manufacturer: "GVD",
    model: "M100",
    category: "nvr-recorder",
    tagline: "GVD M100 network video recorder with unsurpassed security operations",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m100-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-gvd-m90",
    manufacturer: "GVD",
    model: "M90",
    category: "nvr-recorder",
    tagline: "All-in-one solutions NVR M150 and M350",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m90-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-gvd-m155",
    manufacturer: "GVD",
    model: "M155",
    category: "nvr-recorder",
    tagline: "GVD M155 network video recorder with built-in web server for remote access",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m155-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-gvd-m840",
    manufacturer: "GVD",
    model: "M840",
    category: "nvr-recorder",
    tagline: "GVD M840 network video recorder with redundant power supply",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m840-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-gvd-m630",
    manufacturer: "GVD",
    model: "M630",
    category: "nvr-recorder",
    tagline: "GVD M630 network video recorder with redundant power supply",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m630-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-gvd-m830",
    manufacturer: "GVD",
    model: "M830",
    category: "nvr-recorder",
    tagline: "GVD M830 network video recorder with large data throughput for multiple megapixel cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m830-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-gvd-m620",
    manufacturer: "GVD",
    model: "M620",
    category: "nvr-recorder",
    tagline: "GVD M620 network video recorder for mission critical applications",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m620-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-gvd-m610",
    manufacturer: "GVD",
    model: "M610",
    category: "nvr-recorder",
    tagline: "GVD M610 network video recorder with unique Time Sector Engine (TSE) for best video read-write perfo",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gvd-m610-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-teleste-s-vmx-lite-professional",
    manufacturer: "Teleste",
    model: "S-VMX Lite Professional",
    category: "nvr-recorder",
    tagline: "Teleste S-VMX IP video management system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-s-vmx-lite-professional-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-teleste-s-vmx-lite",
    manufacturer: "Teleste",
    model: "S-VMX Lite",
    category: "nvr-recorder",
    tagline: "Teleste S-VMX Lite 16 channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-s-vmx-lite-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-teleste-snr520-2-2",
    manufacturer: "Teleste",
    model: "SNR520 – 2.2",
    category: "nvr-recorder",
    tagline: "Teleste SNR520 – 2.2 high capacity network video recorder with 8TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-snr520-2-2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-teleste-snr534-2-2",
    manufacturer: "Teleste",
    model: "SNR534 – 2.2",
    category: "nvr-recorder",
    tagline: "Teleste SNR534 – 2.2 high capacity network video recorder with 24TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-snr534-2-2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-teleste-snr211-2-2",
    manufacturer: "Teleste",
    model: "SNR211 – 2.2",
    category: "nvr-recorder",
    tagline: "Teleste SNR211 – 2.2 standard network video recorder with 2TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-snr211-2-2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-teleste-snr331-2-2",
    manufacturer: "Teleste",
    model: "SNR331 – 2.2",
    category: "nvr-recorder",
    tagline: "Teleste SNR331 – 2.2 professional network video recorder with 12TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-snr331-2-2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-teleste-snr530-2-2",
    manufacturer: "Teleste",
    model: "SNR530 – 2.2",
    category: "nvr-recorder",
    tagline: "Teleste SNR530 – 2.2 high capacity network video recorder with 12TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-snr530-2-2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-teleste-snr231-2-2",
    manufacturer: "Teleste",
    model: "SNR231 – 2.2",
    category: "nvr-recorder",
    tagline: "Teleste SNR231 – 2.2 standard network video recorder with 6TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-snr231-2-2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-teleste-snr311-2-2",
    manufacturer: "Teleste",
    model: "SNR311 – 2.2",
    category: "nvr-recorder",
    tagline: "Teleste SNR311 – 2.2 professional network video recorder with 4TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-snr311-2-2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-teleste-snr724-2-2",
    manufacturer: "Teleste",
    model: "SNR724 – 2.2",
    category: "nvr-recorder",
    tagline: "Teleste SNR724 – 2.2 high availability network video recorder with 16TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-snr724-2-2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-teleste-snr301-2-2",
    manufacturer: "Teleste",
    model: "SNR301 – 2.2",
    category: "nvr-recorder",
    tagline: "Teleste SNR301 – 2.2 standalone high availability network video recorder with 1TB storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-snr301-2-2-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-teleste-ses121-16",
    manufacturer: "Teleste",
    model: "SES121 – 16",
    category: "nvr-recorder",
    tagline: "Teleste SES121 – 16 system storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-ses121-16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-teleste-ses131-36",
    manufacturer: "Teleste",
    model: "SES131 – 36",
    category: "nvr-recorder",
    tagline: "Teleste SES131 – 36 system storage",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/teleste-ses131-36-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-vivotek-nr8401",
    manufacturer: "VIVOTEK",
    model: "NR8401",
    category: "nvr-recorder",
    tagline: "Vivotek NR8401 16-channel Linux embedded Network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vivotek-nr8401-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-vivotek-nd8321",
    manufacturer: "VIVOTEK",
    model: "ND8321",
    category: "nvr-recorder",
    tagline: "Vivotek ND8321 8 channel standalone desktop network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vivotek-nd8321-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-vivotek-nd8401",
    manufacturer: "VIVOTEK",
    model: "ND8401",
    category: "nvr-recorder",
    tagline: "Vivotek ND8401 16-channel HD local display network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vivotek-nd8401-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","MJPEG"]},
  },
  {
    id: "ss-vivotek-nd8422p",
    manufacturer: "VIVOTEK",
    model: "ND8422P",
    category: "nvr-recorder",
    tagline: "VIVOTEK ND8422P 16 channel standalone plug & play NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vivotek-nd8422p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-vivotek-nr9581",
    manufacturer: "VIVOTEK",
    model: "NR9581",
    category: "nvr-recorder",
    tagline: "VIVOTEK NR9581 32-channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vivotek-nr9581-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["0"],"onvif":true},
  },
  {
    id: "ss-vivotek-nr8201",
    manufacturer: "VIVOTEK",
    model: "NR8201",
    category: "nvr-recorder",
    tagline: "Vivotek NR8201 4 channel network video recorder with integrated firewall",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vivotek-nr8201-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-vivotek-nd9441p",
    manufacturer: "VIVOTEK",
    model: "ND9441P",
    category: "nvr-recorder",
    tagline: "VIVOTEK ND9441P 16-channel embedded plug and play NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vivotek-nd9441p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["0"],"onvif":true},
  },
  {
    id: "ss-vivotek-nd8322p",
    manufacturer: "VIVOTEK",
    model: "ND8322P",
    category: "nvr-recorder",
    tagline: "Vivotek ND8322P 8-channel network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vivotek-nd8322p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-vivotek-nd9441",
    manufacturer: "VIVOTEK",
    model: "ND9441",
    category: "nvr-recorder",
    tagline: "VIVOTEK ND9441 16-channel embedded NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vivotek-nd9441-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["0"],"onvif":true},
  },
  {
    id: "ss-vivotek-nr9681",
    manufacturer: "VIVOTEK",
    model: "NR9681",
    category: "nvr-recorder",
    tagline: "VIVOTEK NR9681 64-channel NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vivotek-nr9681-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.264","H.265"],"raidLevels":["0"],"onvif":true},
  },
  {
    id: "ss-vivotek-nd8301",
    manufacturer: "VIVOTEK",
    model: "ND8301",
    category: "nvr-recorder",
    tagline: "Vivotek ND8301 8-channel HD local display network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/vivotek-nd8301-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-bcdvideo-nvrbcd-24",
    manufacturer: "BCDVideo",
    model: "NVRBCD-24",
    category: "nvr-recorder",
    tagline: "BCDVideo NVRBCD-24 Intel® Core™ Processors (Kabylake-S), Cyber Hardened 1U Rackmount Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/bcdvideo-nvrbcd-24-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-bcdvideo-bcdt03-pws",
    manufacturer: "BCDVideo",
    model: "BCDT03-PWS",
    category: "nvr-recorder",
    tagline: "BCDVideo BCDT03-PWS professional 3-bay tower video workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/bcdvideo-bcdt03-pws-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-bcdvideo-bcdsf01-elws",
    manufacturer: "BCDVideo",
    model: "BCDSF01-ELWS",
    category: "nvr-recorder",
    tagline: "BCDVideo BCDSF01-ELWS entry level small form factor video workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/bcdvideo-bcdsf01-elws-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-bcdvideo-bcd102sd-pws",
    manufacturer: "BCDVideo",
    model: "BCD102SD-PWS",
    category: "nvr-recorder",
    tagline: "BCDVideo BCD102SD-PWS professional 1U 2-bay rackmount video workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/bcdvideo-bcd102sd-pws-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-bcdvideo-bcdm01-elws",
    manufacturer: "BCDVideo",
    model: "BCDM01-ELWS",
    category: "nvr-recorder",
    tagline: "BCDVideo BCDM01-ELWS Entry-Level Micro Video Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/bcdvideo-bcdm01-elws-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-bcdvideo-bcdt01-elws",
    manufacturer: "BCDVideo",
    model: "BCDT01-ELWS",
    category: "nvr-recorder",
    tagline: "BCDVideo BCDT01-ELWS Entry-Level Mini Tower Video Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/bcdvideo-bcdt01-elws-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-bcdvideo-bcdt05-ews",
    manufacturer: "BCDVideo",
    model: "BCDT05-EWS",
    category: "nvr-recorder",
    tagline: "BCDVideo BCDT05-EWS enterprise 5-bay tower video workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/bcdvideo-bcdt05-ews-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-bcdvideo-nvrbcd-8",
    manufacturer: "BCDVideo",
    model: "NVRBCD-8",
    category: "nvr-recorder",
    tagline: "BCDVideo NVRBCD-8 BCD, Intel® Core™ Processors (Kabylake-S), Cyber Appliance 1U Rackmount Appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/bcdvideo-nvrbcd-8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-bcdvideo-bcd208-ews",
    manufacturer: "BCDVideo",
    model: "BCD208-EWS",
    category: "nvr-recorder",
    tagline: "BCDVideo BCD208-EWS Enterprise 2U 8-Bay Rackmount Video Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/bcdvideo-bcd208-ews-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-bcdvideo-bcdt04-gw",
    manufacturer: "BCDVideo",
    model: "BCDT04-GW",
    category: "nvr-recorder",
    tagline: "BCDVideo BCDT04-GW 4-Bay Tower Workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/bcdvideo-bcdt04-gw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-salient-systems-powerpro-r",
    manufacturer: "Salient Systems",
    model: "PowerPro-R",
    category: "nvr-recorder",
    tagline: "Salient Systems PowerPro-R Hybrid NVR for analogue (max 32 channels) and IP cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/salient-systems-powerpro-r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"raidLevels":["1","5"],"formFactor":"2U"},
  },
  {
    id: "ss-salient-systems-powerpro",
    manufacturer: "Salient Systems",
    model: "POWERPRO",
    category: "nvr-recorder",
    tagline: "Salient Systems POWERPRO Hybrid NVR for analogue (max 32 channels) and IP cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/salient-systems-powerpro-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-salient-systems-powerplus",
    manufacturer: "Salient Systems",
    model: "PowerPlus",
    category: "nvr-recorder",
    tagline: "Salient Systems PowerPlus 2U rack-mount NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/salient-systems-powerplus-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-salient-systems-powerchoice-lp",
    manufacturer: "Salient Systems",
    model: "PowerChoice - LP",
    category: "nvr-recorder",
    tagline: "Salient Systems PowerChoice LP Hybrid NVR for analogue (max 32 channels) and IP cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/salient-systems-powerchoice-lp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-salient-systems-powerultra",
    manufacturer: "Salient Systems",
    model: "PowerUltra",
    category: "nvr-recorder",
    tagline: "Salient Systems PowerUltra 2U rack-mount NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/salient-systems-powerultra-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-salient-systems-powermicro",
    manufacturer: "Salient Systems",
    model: "POWERMICRO",
    category: "nvr-recorder",
    tagline: "Salient Systems POWERMICRO NVR for IP cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/salient-systems-powermicro-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-salient-systems-powerchoice",
    manufacturer: "Salient Systems",
    model: "PowerChoice",
    category: "nvr-recorder",
    tagline: "Salient Systems PowerChoice Hybrid NVR for analogue (max 32 channels) and IP cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/salient-systems-powerchoice-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1},
  },
  {
    id: "ss-salient-systems-powerpod",
    manufacturer: "Salient Systems",
    model: "PowerPod",
    category: "nvr-recorder",
    tagline: "Salient Systems PowerPod NVR for IP cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/salient-systems-powerpod-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-salient-systems-powerplatinum",
    manufacturer: "Salient Systems",
    model: "PowerPlatinum",
    category: "nvr-recorder",
    tagline: "Salient Systems PowerPlatinum 2U rack-mount enterprise level NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/salient-systems-powerplatinum-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-salient-systems-guardstation",
    manufacturer: "Salient Systems",
    model: "GuardStation",
    category: "nvr-recorder",
    tagline: "Salient Systems GuardStation Quad monitor client workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/salient-systems-guardstation-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-amag-powerpro-r",
    manufacturer: "AMAG",
    model: "PowerPro-R",
    category: "nvr-recorder",
    tagline: "AMAG PowerPro-R network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/amag-powerpro-r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"2U"},
  },
  {
    id: "ss-amag-powerpro",
    manufacturer: "AMAG",
    model: "PowerPro",
    category: "nvr-recorder",
    tagline: "AMAG PowerPro network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/amag-powerpro-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-amag-powerchoice",
    manufacturer: "AMAG",
    model: "PowerChoice",
    category: "nvr-recorder",
    tagline: "AMAG PowerChoice entry-level network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/amag-powerchoice-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-amag-powerchoice-lp",
    manufacturer: "AMAG",
    model: "PowerChoice LP",
    category: "nvr-recorder",
    tagline: "AMAG PowerChoice LP entry-level network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/amag-powerchoice-lp-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"1U"},
  },
  {
    id: "ss-amag-sgs-quad-h",
    manufacturer: "AMAG",
    model: "SGS-QUAD-H",
    category: "nvr-recorder",
    tagline: "AMAG SGS-QUAD-H video client workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/amag-sgs-quad-h-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-amag-sgs-quad-d",
    manufacturer: "AMAG",
    model: "SGS-QUAD-D",
    category: "nvr-recorder",
    tagline: "AMAG SGS-QUAD-D video client workstation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/amag-sgs-quad-d-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-amag-powermicro",
    manufacturer: "AMAG",
    model: "PowerMicro",
    category: "nvr-recorder",
    tagline: "AMAG PowerMicro ultra compact network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/amag-powermicro-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"formFactor":"desktop"},
  },
  {
    id: "ss-amag-sppd-2tb",
    manufacturer: "AMAG",
    model: "SPPD-2TB",
    category: "nvr-recorder",
    tagline: "AMAG SPPD-2TB ultra-compact network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/amag-sppd-2tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-amag-sppd-1tb",
    manufacturer: "AMAG",
    model: "SPPD-1TB",
    category: "nvr-recorder",
    tagline: "AMAG SPPD-1TB ultra-compact network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/amag-sppd-1tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-tyco-security-products-hrin-6408-18-sr",
    manufacturer: "Tyco Security Products",
    model: "HRIN-6408-18-SR",
    category: "nvr-recorder",
    tagline: "Tyco Security Products HRIN-6408-18-SR HOLIS Enterprise 64 Channel Embedded NVR, 8 SATA, RAID 5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/tyco-security-products-hrin-6408-18-sr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"raidLevels":["5"]},
  },
  {
    id: "ss-tyco-security-products-hrin-2808-18-sr",
    manufacturer: "Tyco Security Products",
    model: "HRIN-2808-18-SR",
    category: "nvr-recorder",
    tagline: "Tyco HRIN-2808-18-SR HOLIS Enterprise 28 Channel Embedded NVR, 8 SATA, RAID 5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/tyco-security-products-hrin-2808-18-sr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":28,"hddBays":1,"raidLevels":["5"]},
  },
  {
    id: "ss-tyco-security-products-hrn-16081s-r",
    manufacturer: "Tyco Security Products",
    model: "HRN-16081S-R",
    category: "nvr-recorder",
    tagline: "Tyco HRN-16081S-R HOLIS Pro H.265+/H.265 Embedded NVR, 16-ch, Gig Ethernet, 8 HDD Bays",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/tyco-security-products-hrn-16081s-r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.265+","H.265"]},
  },
  {
    id: "ss-tyco-security-products-hrn-32081s-r",
    manufacturer: "Tyco Security Products",
    model: "HRN-32081S-R",
    category: "nvr-recorder",
    tagline: "Tyco HRN-32081S-R HOLIS Pro H.265+/H.265 Embedded RAID NVR, 32-ch, 2-Gig Ethernet, 8 HDD Bays, Upto ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/tyco-security-products-hrn-32081s-r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.265+","H.265"]},
  },
  {
    id: "ss-tyco-security-products-hrin-1208-18-sr",
    manufacturer: "Tyco Security Products",
    model: "HRIN-1208-18-SR",
    category: "nvr-recorder",
    tagline: "Tyco HRIN-1208-18-SR HOLIS Enterprise 12 Channel Embedded NVR, 8 SATA, RAID 5, 0TB",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/tyco-security-products-hrin-1208-18-sr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":12,"hddBays":1,"raidLevels":["5"]},
  },
  {
    id: "ss-tyco-security-products-hrn-16022s",
    manufacturer: "Tyco Security Products",
    model: "HRN-16022S",
    category: "nvr-recorder",
    tagline: "Tyco HRN-16022S HOLIS Lite H.265+/H.265 Embedded NVR, 16-ch, Gig Ethernet, 2 HDD Bays",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/tyco-security-products-hrn-16022s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1,"codecs":["H.265+","H.265"]},
  },
  {
    id: "ss-tyco-security-products-hrin-4808-18-sr",
    manufacturer: "Tyco Security Products",
    model: "HRIN-4808-18-SR",
    category: "nvr-recorder",
    tagline: "Tyco Security Products HRIN-4808-18-SR HOLIS Enterprise 48 Channel Embedded NVR, 8 SATA, RAID 5",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/tyco-security-products-hrin-4808-18-sr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":48,"hddBays":1,"raidLevels":["5"]},
  },
  {
    id: "ss-tyco-security-products-hrn-64081s-r",
    manufacturer: "Tyco Security Products",
    model: "HRN-64081S-R",
    category: "nvr-recorder",
    tagline: "Tyco HRN-64081S-R HOLIS Pro H.265+/H.265 Embedded RAID NVR, 64-ch, 2-Gig Ethernet, 8 HDD Bays, Upto ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/tyco-security-products-hrn-64081s-r-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1,"codecs":["H.265+","H.265"]},
  },
  {
    id: "ss-tyco-security-products-hrn-08022s",
    manufacturer: "Tyco Security Products",
    model: "HRN-08022S",
    category: "nvr-recorder",
    tagline: "Tyco HRN-08022S HOLIS Lite H.265+/H.265 Embedded NVR, 8-ch, Gig Ethernet, 2 HDD Bays",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/tyco-security-products-hrn-08022s-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.265+","H.265"]},
  },
  {
    id: "ss-artec-gw2001",
    manufacturer: "artec",
    model: "GW2001",
    category: "nvr-recorder",
    tagline: "artec GW2001 Multieye-Hybrid GreenWatch recorder with 8 channels",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/artec-gw2001-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-artec-sw2000",
    manufacturer: "artec",
    model: "SW2000",
    category: "nvr-recorder",
    tagline: "artec SW2000 compact SmartWatch NVR recorder with 4 channels",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/artec-sw2000-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-artec-multieye-smartwatch-nvr",
    manufacturer: "artec",
    model: "MULTIEYE SmartWatch NVR",
    category: "nvr-recorder",
    tagline: "Compact MULTIEYE SmartWatch 4-channel network video recorder with 500 GB storage capacity",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/artec-multieye-smartwatch-nvr-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":4,"hddBays":1},
  },
  {
    id: "ss-artec-ng0404",
    manufacturer: "artec",
    model: "NG0404",
    category: "nvr-recorder",
    tagline: "artec NG0404 network video recorder with pre alarm, post alarm and suspicious alarm recording",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/artec-ng0404-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-siqura-i-nvr-compact-1000-8",
    manufacturer: "Siqura",
    model: "i-NVR+ Compact 1000-8",
    category: "nvr-recorder",
    tagline: "Siqura i-NVR+ Compact 1000-8 network video recorder with 8 inputs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/siqura-i-nvr-compact-1000-8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-siqura-i-nvr-compact-3000-16",
    manufacturer: "Siqura",
    model: "i-NVR+ Compact 3000-16",
    category: "nvr-recorder",
    tagline: "Siqura i-NVR+ Compact 3000-16 network video recorder with 16 inputs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/siqura-i-nvr-compact-3000-16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-siqura-i-nvr-compact-3000-32",
    manufacturer: "Siqura",
    model: "i-NVR+ Compact 3000-32",
    category: "nvr-recorder",
    tagline: "Siqura i-NVR+ Compact 3000-32 network video recorder with 32 inputs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/siqura-i-nvr-compact-3000-32-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-siqura-i-nvr-elite-24000-64",
    manufacturer: "Siqura",
    model: "i-NVR+ Elite 24000-64",
    category: "nvr-recorder",
    tagline: "Siqura i-NVR+ Elite 24000-64 network video recorder with 64 inputs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/siqura-i-nvr-elite-24000-64-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-siqura-i-nvr-elite-24000-16",
    manufacturer: "Siqura",
    model: "i-NVR+ Elite 24000-16",
    category: "nvr-recorder",
    tagline: "Siqura i-NVR+ Elite 24000-16 network video recorder with 16 inputs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/siqura-i-nvr-elite-24000-16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-siqura-snr-16000-64",
    manufacturer: "Siqura",
    model: "SNR 16000-64",
    category: "nvr-recorder",
    tagline: "Siqura Network Recorder 64-channel (1920 fps) RAID-5 network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/siqura-snr-16000-64-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":64,"hddBays":1},
  },
  {
    id: "ss-siqura-i-nvr-elite-24000-32",
    manufacturer: "Siqura",
    model: "i-NVR+ Elite 24000-32",
    category: "nvr-recorder",
    tagline: "Siqura i-NVR+ Elite 24000-32 network video recorder with 32 inputs",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/siqura-i-nvr-elite-24000-32-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-siqura-i-nvr-compact-500-8",
    manufacturer: "Siqura",
    model: "i-NVR+ Compact 500-8",
    category: "nvr-recorder",
    tagline: "Siqura i-NVR+ Compact 500-8 compact high-performance, intelligent NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/siqura-i-nvr-compact-500-8-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-verint-edgevr-300",
    manufacturer: "Verint",
    model: "EdgeVR 300",
    category: "nvr-recorder",
    tagline: "Verint advances security and investigation solutions for retail banks and financial institutions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verint-edgevr-300-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-verint-edgevr-50",
    manufacturer: "Verint",
    model: "EdgeVR 50",
    category: "nvr-recorder",
    tagline: "Verint EdgeVR 50 IP-based Nextiva network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verint-edgevr-50-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-verint-edgevr-80-poe",
    manufacturer: "Verint",
    model: "EdgeVR-80-POE",
    category: "nvr-recorder",
    tagline: "Verint EdgeVR-80-POE IP-based Nextiva network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verint-edgevr-80-poe-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-verint-edgevr-80",
    manufacturer: "Verint",
    model: "EdgeVR 80",
    category: "nvr-recorder",
    tagline: "Verint EdgeVR 80 IP-based Nextiva network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verint-edgevr-80-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"codecs":["H.264"]},
  },
  {
    id: "ss-verint-netdvr-ii-retail",
    manufacturer: "Verint",
    model: "NetDVR II Retail",
    category: "nvr-recorder",
    tagline: "Verint NetDVR II Retail - sophisticated recording of up to 16 analogue cameras on a highly scalable ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verint-netdvr-ii-retail-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-anviz-nms215-1",
    manufacturer: "Anviz",
    model: "NMS215-1",
    category: "nvr-recorder",
    tagline: "Anviz NMS215-1 4K H.265 One HDD Mini NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/anviz-nms215-1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-anviz-nts137-4",
    manufacturer: "Anviz",
    model: "NTS137-4",
    category: "nvr-recorder",
    tagline: "Anviz NTS137-4 32 channel Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/anviz-nts137-4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-anviz-nms115-1",
    manufacturer: "Anviz",
    model: "NMS115-1",
    category: "nvr-recorder",
    tagline: "Anviz NMS115-1 mini-storage Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/anviz-nms115-1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"],"onvif":true},
  },
  {
    id: "ss-anviz-nts237-4",
    manufacturer: "Anviz",
    model: "NTS237-4",
    category: "nvr-recorder",
    tagline: "Anviz NTS237-4 4K H.265 Four HDD NVR",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/anviz-nts237-4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":32,"hddBays":1,"codecs":["H.264","H.265"],"onvif":true},
  },
  {
    id: "ss-anviz-nms114-1",
    manufacturer: "Anviz",
    model: "NMS114-1-",
    category: "nvr-recorder",
    tagline: "Anviz NMS114-1 mini-storage Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/anviz-nms114-1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"],"onvif":true},
  },
  {
    id: "ss-anviz-nea114-1",
    manufacturer: "Anviz",
    model: "NEA114-1",
    category: "nvr-recorder",
    tagline: "Anviz NEA114-1 PoE Network Video Recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/anviz-nea114-1-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1,"codecs":["H.264"],"onvif":true},
  },
  {
    id: "ss-verkada-cc300-4tb-hw",
    manufacturer: "Verkada",
    model: "CC300-4TB-HW",
    category: "nvr-recorder",
    tagline: "Verkada Command Connector for Camera Integration & Cloud Management",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-cc300-4tb-hw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["10"]},
  },
  {
    id: "ss-verkada-cc700-16tb-hw",
    manufacturer: "Verkada",
    model: "CC700-16TB-HW",
    category: "nvr-recorder",
    tagline: "Verkada Command Connector CC700-16TB-HW 50 5MP channels, 16TB storage for 30 days' retention",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-cc700-16tb-hw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["10"]},
  },
  {
    id: "ss-verkada-cc500-8tb-hw",
    manufacturer: "Verkada",
    model: "CC500-8TB-HW",
    category: "nvr-recorder",
    tagline: "Verkada Command Connector CC500-8TB-HW 25 5MP channels, 8TB storage for 30 days' retention",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-cc500-8tb-hw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["10"]},
  },
  {
    id: "ss-verkada-cc300-8tb-hw",
    manufacturer: "Verkada",
    model: "CC300-8TB-HW",
    category: "nvr-recorder",
    tagline: "Verkada Command Connector CC300-8TB-HW 10 5MP channels, 8TB storage for 60 days' retention",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-cc300-8tb-hw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["10"]},
  },
  {
    id: "ss-verkada-cc500-16tb-hw",
    manufacturer: "Verkada",
    model: "CC500-16TB-HW",
    category: "nvr-recorder",
    tagline: "Verkada Command Connector CC500-16TB-HW 25 5MP channels, 16TB storage for 60 days' retention",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-cc500-16tb-hw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["10"]},
  },
  {
    id: "ss-verkada-cc700-32tb-hw",
    manufacturer: "Verkada",
    model: "CC700-32TB-HW",
    category: "nvr-recorder",
    tagline: "Verkada Command Connector CC700-32TB-HW 50 5MP channels, 32TB storage for 60 days' retention",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-cc700-32tb-hw-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["10"]},
  },
  {
    id: "ss-dallmeier-ips-10000",
    manufacturer: "Dallmeier",
    model: "IPS 10000",
    category: "nvr-recorder",
    tagline: "Dallmeier Smavia appliance IPS 10000",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dallmeier-ips-10000-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["6","JBOD"]},
  },
  {
    id: "ss-dallmeier-ips-2400",
    manufacturer: "Dallmeier",
    model: "IPS 2400",
    category: "nvr-recorder",
    tagline: "Dallmeier IPS 2400 SMAVIA",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dallmeier-ips-2400-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":8,"hddBays":1},
  },
  {
    id: "ss-dallmeier-workstation-rack-mount-4ru",
    manufacturer: "Dallmeier",
    model: "Workstation Rack-Mount 4RU",
    category: "nvr-recorder",
    tagline: "Dallmeier Workstation Rack-Mount 4RU 16GB DDR4 RAM",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dallmeier-workstation-rack-mount-4ru-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-dallmeier-workstation-tower",
    manufacturer: "Dallmeier",
    model: "Workstation Tower",
    category: "nvr-recorder",
    tagline: "Dallmeier Workstation Tower 16GB DDR4 RAM",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dallmeier-workstation-tower-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1,"raidLevels":["1"]},
  },
  {
    id: "ss-d-link-dnr-326",
    manufacturer: "D-Link",
    model: "DNR-326",
    category: "nvr-recorder",
    tagline: "D-Link DNR-326 network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/d-link-dnr-326-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-d-link-dns-722-4",
    manufacturer: "D-Link",
    model: "DNS-722-4",
    category: "nvr-recorder",
    tagline: "D-Link DNS-722-4 2-bay network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/d-link-dns-722-4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-d-link-dns-726-4",
    manufacturer: "D-Link",
    model: "DNS-726-4",
    category: "nvr-recorder",
    tagline: "D-Link DNS-726-4 2-bay network video recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/d-link-dns-726-4-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-geviscope-ip-se",
    manufacturer: "Geutebruck",
    model: "GeViScope-IP/SE+",
    category: "nvr-recorder",
    tagline: "Geutebruck GeViScope-IP/SE+ network video recorder suitable for direct recording of network cameras",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-geviscope-ip-se-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-net-porter",
    manufacturer: "Geutebruck",
    model: "net_porter",
    category: "nvr-recorder",
    tagline: "Geutebruck launch a new pure IP network-based NVR with integral PoE switch",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-net-porter-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-re-porter-ip-se",
    manufacturer: "Geutebruck",
    model: "re_porter-IP/SE+",
    category: "nvr-recorder",
    tagline: "Geutebruck re_porter-IP/SE+ network video recorder with with digital video matrix functionality base",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-re-porter-ip-se-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-geutebruck-gevistore-ip-16bay-2p",
    manufacturer: "Geutebruck",
    model: "GeViStore-IP/16Bay-2P",
    category: "nvr-recorder",
    tagline: "Latest 64-bit high-end IP enterprise NVR server and storage solution from Geutebruck",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/geutebruck-gevistore-ip-16bay-2p-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-sony-nsr-500",
    manufacturer: "Sony",
    model: "NSR-500",
    category: "nvr-recorder",
    tagline: "Sony NSR-500 network surveillance recorder with 16-channel full HD image capture",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/sony-nsr-500-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-sony-nsr500-4t",
    manufacturer: "Sony",
    model: "NSR500/4T",
    category: "nvr-recorder",
    tagline: "Sony NSR500/4T 16-channel 4TB full-HD network surveillance recording server",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/sony-nsr500-4t-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":16,"hddBays":1},
  },
  {
    id: "ss-sony-nsbk-dh05",
    manufacturer: "Sony",
    model: "NSBK-DH05",
    category: "nvr-recorder",
    tagline: "Sony NSBK-DH05 display acceleration board",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/sony-nsbk-dh05-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-sony-nsbk-cl05",
    manufacturer: "Sony",
    model: "NSBK-CL05",
    category: "nvr-recorder",
    tagline: "Sony NSBK-CL05 additional camera licence for NSR-500",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/sony-nsbk-cl05-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-pelco-dssrv2-240rd-eu",
    manufacturer: "Pelco",
    model: "DSSRV2-240RD-EU",
    category: "nvr-recorder",
    tagline: "Pelco DSSRV2-240RD-EU network video recorder with RAID configuration",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dssrv2-240rd-eu-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-pelco-dssrv2-240rd-uk",
    manufacturer: "Pelco",
    model: "DSSRV2-240RD-UK",
    category: "nvr-recorder",
    tagline: "Pelco DSSRV2-240RD-UK network video recorder with RAID configuration",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pelco-dssrv2-240rd-uk-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-genetec-omnicast-sv-pro",
    manufacturer: "Genetec",
    model: "Omnicast SV-PRO",
    category: "nvr-recorder",
    tagline: "Genetec Omnicast SV-PRO video surveillance and access control",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genetec-omnicast-sv-pro-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-genetec-omnicast-sv-16",
    manufacturer: "Genetec",
    model: "Omnicast SV-16",
    category: "nvr-recorder",
    tagline: "Genetec Omnicast SV-16 hybrid network security appliance",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/genetec-omnicast-sv-16-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
  {
    id: "ss-panasonic-wj-nd400-18tb",
    manufacturer: "Panasonic",
    model: "WJ-ND400/18TB",
    category: "nvr-recorder",
    tagline: "Panasonic WJ-ND400/18TB high performance network disk recorder",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/panasonic-wj-nd400-18tb-network-video-recorder-nvr-technical-details.html",
    specs: {"channels":0,"hddBays":1},
  },
];

export const SS_NVR_RECORDERS: NvrEntry[] = [
  ...PART_1, ...PART_2, ...PART_3, ...PART_4, ...PART_5, ...PART_6, ...PART_7,
];
